import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable/dist';
import * as VueCompositionApi from '@vue/composition-api';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
  /** Represents untyped JSON */
  JSON: any;
};

export type Activity = {
  __typename?: 'Activity';
  activityAdditions?: Maybe<Array<ActivityAddition>>;
  content: Scalars['String'];
  corporation?: Maybe<Corporation>;
  createdAt: Scalars['ISO8601Date'];
  deletable: Scalars['Boolean'];
  file?: Maybe<FileInfo>;
  id: Scalars['Int'];
  privacySetting: Scalars['Boolean'];
  status: Scalars['String'];
  statusCode: Scalars['Int'];
  updatedAt: Scalars['ISO8601Date'];
};

export type ActivityAddition = {
  __typename?: 'ActivityAddition';
  content?: Maybe<Array<Scalars['String']>>;
  dateValue?: Maybe<Scalars['ISO8601DateTime']>;
  itemType: AdditionItemType;
  schoolActivityAdditionId: Scalars['Int'];
  /** 時:分:秒を使うかどうか */
  shouldUseTime?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ActivityAdditionInput = {
  /** 値（日時） */
  dateValue?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** 項目タイプ */
  itemType: AdditionItemType;
  /** 学校活動記録追加項目ID */
  schoolActivityAdditionId: Scalars['Int'];
  /** 値（テキスト） */
  value?: InputMaybe<Scalars['String']>;
};

export type ActivityInput = {
  /** 学校追加項目 */
  additions?: InputMaybe<Array<ActivityAdditionInput>>;
  /** 内容 */
  content: Scalars['String'];
  /** 企業 */
  corporation?: InputMaybe<CorporationInput>;
  /** ファイル */
  file?: InputMaybe<FileInput>;
  /** 活動記録ID */
  id?: InputMaybe<Scalars['Int']>;
  /** 公開範囲 */
  privacySetting: Scalars['Boolean'];
  /** ステータス */
  statusCode: Scalars['Int'];
};

export type AdditionItem = {
  __typename?: 'AdditionItem';
  content: Scalars['String'];
  id: Scalars['Int'];
  title: Scalars['String'];
};

export enum AdditionItemType {
  /** 日付入力 */
  TypeDate = 'type_date',
  /** 複数選択リスト */
  TypeListMulti = 'type_list_multi',
  /** 単一選択リスト */
  TypeListSingle = 'type_list_single',
  /** テキスト入力 */
  TypeText = 'type_text'
}

export type Address = {
  __typename?: 'Address';
  address1: Scalars['String'];
  address2: Scalars['String'];
  address3: Scalars['String'];
  id: Scalars['Int'];
  postalCode: Scalars['Int'];
  prefectureCode: Scalars['String'];
};

export type AnonymousLike = {
  __typename?: 'AnonymousLike';
  checked: Scalars['Boolean'];
  id: Scalars['Int'];
  targetId: Scalars['Int'];
  type: LikeType;
};

export type AppInfo = {
  __typename?: 'AppInfo';
  /** レビューID */
  id?: Maybe<Scalars['Int']>;
  reviewRequestContent?: Maybe<Scalars['String']>;
  reviewRequestTitle?: Maybe<Scalars['String']>;
  showRequestReview: Scalars['Boolean'];
};

export type Article = {
  __typename?: 'Article';
  content: Scalars['String'];
  contentSummary: Scalars['String'];
  createdAt?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  imageUrl?: Maybe<Scalars['String']>;
  like?: Maybe<Scalars['Boolean']>;
  likeCount: Scalars['Int'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601Date']>;
};

export type BadgeNotice = {
  __typename?: 'BadgeNotice';
  /** バッジカウント */
  badgeCount?: Maybe<Scalars['Int']>;
  /** 未読のメッセージがあるか */
  message: Scalars['Boolean'];
  /** 新着の事務局お知らせがあるか */
  news: Scalars['Boolean'];
  /** 未読の学校掲示板があるか */
  noticeBoard: Scalars['Boolean'];
  /** 未対応のオファーがあるか */
  offer: Scalars['Boolean'];
};

export type Bookmark = {
  __typename?: 'Bookmark';
  checked: Scalars['Boolean'];
  corporation?: Maybe<Corporation>;
  feed?: Maybe<Post>;
  /** ブックマークID */
  id: Scalars['Int'];
  job?: Maybe<Job>;
  targetId: Scalars['Int'];
  type: BookmarkType;
};

export enum BookmarkType {
  /** 企業 */
  TypeCorporation = 'type_corporation',
  /** クロストーク */
  TypeCrossTalk = 'type_cross_talk',
  /** 文化制度 */
  TypeCulture = 'type_culture',
  /** 募集 */
  TypeJob = 'type_job',
  /** 学内掲示板 */
  TypeNoticeBoard = 'type_notice_board',
  /** 注目記事 */
  TypePost = 'type_post',
  /** 先輩の活躍 */
  TypeSenior = 'type_senior'
}

export type Career = {
  __typename?: 'Career';
  /** 企業名 */
  corporationName: Scalars['String'];
  /** 仕事内容 */
  description?: Maybe<Scalars['String']>;
  /** 雇用形態名 */
  employment?: Maybe<Scalars['String']>;
  /** 雇用形態 */
  employmentType?: Maybe<CareerEmploymentType>;
  /** 入社月 */
  enrollmentMonth?: Maybe<Scalars['Int']>;
  /** 入社年 */
  enrollmentYear?: Maybe<Scalars['Int']>;
  /** 勤続年数 */
  lengthOfService?: Maybe<Scalars['Int']>;
  /** 職種名 */
  occupation?: Maybe<Scalars['String']>;
  /** 退職月 */
  retirementMonth?: Maybe<Scalars['Int']>;
  /** 退職年 */
  retirementYear?: Maybe<Scalars['Int']>;
};

export enum CareerEmploymentType {
  /** 契約社員 */
  Contract = 'contract',
  /** インターン */
  Internship = 'internship',
  /** パート・アルバイト */
  PartTime = 'part_time',
  /** 正社員 */
  Regular = 'regular',
  /** 派遣社員 */
  Temporary = 'temporary'
}

export type CareerInput = {
  /** 仕事内容 */
  description: Scalars['String'];
  /** 雇用形態 */
  employmentType: CareerEmploymentType;
  /** 入社月 */
  enrollmentMonth: Scalars['Int'];
  /** 入社年 */
  enrollmentYear: Scalars['Int'];
  /** ID */
  id?: InputMaybe<Scalars['Int']>;
  /** 会社名 */
  name: Scalars['String'];
  /** 職種 */
  occupation?: InputMaybe<Scalars['String']>;
  /** 退職月 */
  retirementMonth?: InputMaybe<Scalars['Int']>;
  /** 退職年 */
  retirementYear?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of ChangeEmail */
export type ChangeEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

/** Autogenerated return type of ChangeEmail */
export type ChangeEmailPayload = {
  __typename?: 'ChangeEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of ChangeJobHuntingStatus */
export type ChangeJobHuntingStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  status: Scalars['Int'];
};

/** Autogenerated return type of ChangeJobHuntingStatus */
export type ChangeJobHuntingStatusPayload = {
  __typename?: 'ChangeJobHuntingStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of ChangeNotification */
export type ChangeNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  notification?: InputMaybe<NotificationInput>;
};

/** Autogenerated return type of ChangeNotification */
export type ChangeNotificationPayload = {
  __typename?: 'ChangeNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of ChangePassword */
export type ChangePasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  currentPassword: Scalars['String'];
  password: Scalars['String'];
};

/** Autogenerated return type of ChangePassword */
export type ChangePasswordPayload = {
  __typename?: 'ChangePasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type ChartPoint = {
  __typename?: 'ChartPoint';
  /** アクセス数 */
  count: Scalars['Int'];
  /** 日付 */
  date: Scalars['ISO8601Date'];
};

export type CityGroup = {
  __typename?: 'CityGroup';
  /** 市区町村リスト */
  cities: Array<KeyValue>;
  /** 都道府県ID */
  id: Scalars['Int'];
  /** 都道府県コード */
  prefectureCode: Scalars['String'];
  /** 市区町村名 */
  prefectureName: Scalars['String'];
};

export enum CompanyVisitEntry {
  /** 事前申請 */
  AdvanceApplication = 'advance_application',
  /** 自由応募 */
  FreeApplication = 'free_application'
}

/** Autogenerated input type of ConfirmMessageNotification */
export type ConfirmMessageNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 次のページにデータが存在するかどうか */
  hasNextPage: Scalars['Boolean'];
  /** メッセージルームID */
  roomId: Scalars['Int'];
};

/** Autogenerated return type of ConfirmMessageNotification */
export type ConfirmMessageNotificationPayload = {
  __typename?: 'ConfirmMessageNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  result: Scalars['Boolean'];
};

export type ContranctInfo = {
  __typename?: 'ContranctInfo';
  /** 契約終了日 */
  contractEndDate?: Maybe<Scalars['ISO8601Date']>;
  /** 更新判断基準(ラベル) */
  contractRenewalCriteriaLabel?: Maybe<Scalars['String']>;
  /** 更新上限(ラベル) */
  contractRenewalLimitLabel?: Maybe<Scalars['String']>;
  /** 契約の更新(ラベル) */
  contractRenewalTypeLabel?: Maybe<Scalars['String']>;
  /** 契約開始日 */
  contractStartDate?: Maybe<Scalars['ISO8601Date']>;
  /** 雇用形態(無期/有期) */
  contractTerm: Scalars['String'];
  /** 募集区分(正社員/契約社員/アルバイト) */
  contractType: Scalars['String'];
};

export type Corporation = {
  __typename?: 'Corporation';
  /** アクセス */
  access?: Maybe<Scalars['String']>;
  /** 追加項目 */
  additions?: Maybe<Array<AdditionItem>>;
  /** 住所 */
  address?: Maybe<Scalars['String']>;
  /** 関連企業 */
  affiliatedCompany?: Maybe<Scalars['String']>;
  /** 年間売上 */
  annualSales?: Maybe<Scalars['String']>;
  /** エリア一覧 */
  areas?: Maybe<Array<CorporationArea>>;
  /** ブックマーク */
  bookmark?: Maybe<Scalars['Boolean']>;
  /** 事業形態 */
  businessFormI18n?: Maybe<Scalars['String']>;
  /** 資本金 */
  capital?: Maybe<Scalars['String']>;
  /** 業種1 */
  category1?: Maybe<Industry>;
  /** 業種2 */
  category2?: Maybe<Industry>;
  /** 業種3 */
  category3?: Maybe<Industry>;
  /** 企業番号 */
  corporationNumber?: Maybe<Scalars['String']>;
  /** 青少年雇用情報 */
  corporationYouthEmploymentInfo?: Maybe<CorporationYouthEmploymentInfo>;
  /** 企業カバー画像URL */
  coverImageUrl?: Maybe<Scalars['String']>;
  /** カバー動画 */
  coverVideo?: Maybe<Video>;
  /** 作成日時 */
  createdAt?: Maybe<Scalars['ISO8601Date']>;
  /** 事業形態 */
  description?: Maybe<Scalars['String']>;
  /** 設立年月日 */
  establishmentDate?: Maybe<Scalars['String']>;
  /** FAX */
  fax?: Maybe<Scalars['String']>;
  /** 障がい者採用 */
  handicapAdoption?: Maybe<HandicapAdoption>;
  /** 寮・社宅 */
  housingAllowance?: Maybe<Scalars['String']>;
  /** 企業ID */
  id?: Maybe<Scalars['Int']>;
  /** 業種（※廃止） */
  industries?: Maybe<Array<Scalars['String']>>;
  /** 留学生採用 */
  internationalAdoption?: Maybe<InternationalAdoption>;
  /** フリープランフラグ */
  isFreePlan?: Maybe<Scalars['Boolean']>;
  /** 注目記事のいいね総数 */
  likeAll?: Maybe<Scalars['Int']>;
  /** 企業ロゴURL */
  logoUrl?: Maybe<Scalars['String']>;
  /** 企業メイン画像URL */
  mainImageUrl?: Maybe<Scalars['String']>;
  /** 社員 */
  members?: Maybe<Array<CorporationMember>>;
  /** メッセージ本文 */
  messageContent?: Maybe<Scalars['String']>;
  /** メッセージ代表者名 */
  messageImageUrl?: Maybe<Scalars['String']>;
  /** メッセージ代表者名 */
  messageName?: Maybe<Scalars['String']>;
  /** メッセージ動画 */
  messageVideo?: Maybe<Video>;
  /** 企業名 */
  name?: Maybe<Scalars['String']>;
  /** 企業名カナ */
  nameKana?: Maybe<Scalars['String']>;
  /** 従業員数 */
  numberOfEmployee?: Maybe<Scalars['String']>;
  /** 事業所数 */
  numberOfOffices?: Maybe<Scalars['Int']>;
  /** 経営理念 */
  philosophy?: Maybe<Scalars['String']>;
  /** 経営理念1画像URL */
  philosophyImage1Url?: Maybe<Scalars['String']>;
  /** 経営理念2画像URL */
  philosophyImage2Url?: Maybe<Scalars['String']>;
  /** 経営理念タイトル */
  philosophyTitle?: Maybe<Scalars['String']>;
  /** プラン */
  plan?: Maybe<Scalars['Int']>;
  /** 採用責任者 */
  recruiter?: Maybe<CorporationStaff>;
  /** 学校共有メモ */
  schoolMemo?: Maybe<Scalars['String']>;
  /** タグ。TODO_type: 現在使われていない＆整理対象 */
  tags?: Maybe<Array<Scalars['String']>>;
  /** TEL */
  tel?: Maybe<Scalars['String']>;
  /** 代表者名 */
  topManager?: Maybe<Scalars['String']>;
  /** 代表者名カナ */
  topManagerKana?: Maybe<Scalars['String']>;
  /** 代表者役職 */
  topManagerPosition?: Maybe<Scalars['String']>;
  /** 代表者卒業校 */
  topManagerSchool?: Maybe<Scalars['String']>;
  /** 更新日時 */
  updatedAt?: Maybe<Scalars['ISO8601Date']>;
  /** URL */
  url?: Maybe<Scalars['String']>;
  /** ビジョン */
  vision?: Maybe<Scalars['String']>;
  /** ビジョン画像1URL */
  visionImage1Url?: Maybe<Scalars['String']>;
  /** ビジョン画像2URL */
  visionImage2Url?: Maybe<Scalars['String']>;
  /** ビジョンタイトル */
  visionTitle?: Maybe<Scalars['String']>;
  /** 企業訪問設定 */
  visitReception?: Maybe<VisitReception>;
  /** 郵便番号 */
  zipCode?: Maybe<Scalars['String']>;
};

export type CorporationArea = {
  __typename?: 'CorporationArea';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  offices?: Maybe<Array<CorporationOffice>>;
};

export type CorporationEvent = {
  __typename?: 'CorporationEvent';
  /** 申込締切日 */
  closingDate?: Maybe<Scalars['ISO8601Date']>;
  /** 内容 */
  content?: Maybe<Scalars['String']>;
  /** 企業情報 */
  corporation: Corporation;
  /** 作成日時 */
  createdAt?: Maybe<Scalars['ISO8601Date']>;
  /** 実施日 */
  dates?: Maybe<Array<CorporationEventDate>>;
  /** エントリーフォーム設定 */
  entrySetting?: Maybe<EntrySetting>;
  /** 開催日 */
  eventDate?: Maybe<Scalars['ISO8601Date']>;
  /** 企業イベント日付ID */
  eventDateId?: Maybe<Scalars['Int']>;
  /** 企業イベントID */
  eventId: Scalars['Int'];
  /** 実施時刻テキスト */
  eventTimesText?: Maybe<Scalars['String']>;
  /** 申込方法 */
  howToApply?: Maybe<Scalars['String']>;
  /** ID */
  id: Scalars['Int'];
  /** 画像URL */
  imageUrl?: Maybe<Scalars['String']>;
  /** 開催方法 */
  meetingType?: Maybe<MeetingType>;
  /** 注意事項 */
  note?: Maybe<Scalars['String']>;
  /** 場所 */
  place?: Maybe<Scalars['String']>;
  /** 開催地 */
  prefecture?: Maybe<Scalars['String']>;
  /** 学校推薦フラグ */
  schoolEntry?: Maybe<Scalars['Boolean']>;
  /** 学校メモ */
  schoolMemo?: Maybe<Scalars['String']>;
  /** 担当者 */
  staff?: Maybe<CorporationStaff>;
  /** 実施時刻 */
  times?: Maybe<Array<CorporationEventTime>>;
  /** タイトル */
  title?: Maybe<Scalars['String']>;
  /** 更新日時 */
  updatedAt?: Maybe<Scalars['ISO8601Date']>;
  /** 持参物 */
  whatToBring?: Maybe<Scalars['String']>;
};

export type CorporationEventDate = {
  __typename?: 'CorporationEventDate';
  /** 締切日 */
  closingDate: Scalars['ISO8601Date'];
  /** 開催日 */
  eventDate: Scalars['ISO8601Date'];
  /** 開催日 */
  id: Scalars['Int'];
};

export type CorporationEventInternship = {
  __typename?: 'CorporationEventInternship';
  /** 申込締切日 */
  closingDate: Scalars['ISO8601Date'];
  /** 実施内容 */
  content?: Maybe<Scalars['String']>;
  /** 企業情報 */
  corporation?: Maybe<Corporation>;
  /** 作成日時 */
  createdAt?: Maybe<Scalars['ISO8601Date']>;
  /** 留学生の参加可否 */
  enableInternational?: Maybe<Scalars['Boolean']>;
  /** エントリーフォーム設定 */
  entrySetting?: Maybe<EntrySetting>;
  /** 集合場所 */
  firstMeetingPlace?: Maybe<Scalars['String']>;
  /** 休日 */
  holiday?: Maybe<Scalars['String']>;
  /** 申込方法 */
  howToApply?: Maybe<Scalars['String']>;
  /** 企業実習ID */
  id: Scalars['Int'];
  /** 画像 */
  imageUrl?: Maybe<Scalars['String']>;
  /** 実施日数 */
  internshipDays?: Maybe<Scalars['Int']>;
  /** 注意事項 */
  note?: Maybe<Scalars['String']>;
  /** 受入人数 */
  numberOfAccepted?: Maybe<Scalars['Int']>;
  /** 事業所 */
  office?: Maybe<CorporationOffice>;
  /** 実施期間開始 */
  periodFrom: Scalars['ISO8601Date'];
  /** 実施期間終了 */
  periodTo: Scalars['ISO8601Date'];
  /** 開催地 */
  prefecture?: Maybe<Scalars['String']>;
  /** 受入要件 */
  requirements?: Maybe<Scalars['String']>;
  /** 学校推薦フラグ */
  schoolEntry?: Maybe<Scalars['Boolean']>;
  /** 担当者 */
  staff?: Maybe<CorporationStaff>;
  /** スケジュール */
  timeSchedule?: Maybe<Scalars['String']>;
  /** タイトル */
  title?: Maybe<Scalars['String']>;
  /** 更新日時 */
  updatedAt?: Maybe<Scalars['ISO8601Date']>;
  /** 開催場所 */
  venue?: Maybe<Scalars['String']>;
  /** 持参物 */
  whatToBring?: Maybe<Scalars['String']>;
};

export type CorporationEventTime = {
  __typename?: 'CorporationEventTime';
  from: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  timeText?: Maybe<Scalars['String']>;
  to: Scalars['ISO8601Date'];
};

export type CorporationInput = {
  /** 企業ID */
  id?: InputMaybe<Scalars['Int']>;
  /** 企業名 */
  name?: InputMaybe<Scalars['String']>;
};

export type CorporationMember = {
  __typename?: 'CorporationMember';
  /** 先輩の活躍一覧 */
  articles?: Maybe<Array<Article>>;
  /** 所属企業 */
  corporation?: Maybe<Corporation>;
  /** 入社月 */
  enteringMonth?: Maybe<Scalars['String']>;
  /** 入社年 */
  enteringYear?: Maybe<Scalars['String']>;
  /** 注目記事一覧 */
  feeds?: Maybe<Array<Post>>;
  /** 企業社員ID */
  id: Scalars['Int'];
  /** 画像URL */
  imageUrl?: Maybe<Scalars['String']>;
  /** 社員名 */
  name: Scalars['String'];
  /** 社員名カナ */
  nameKana: Scalars['String'];
  /** 勤務先 */
  office?: Maybe<Scalars['String']>;
  /** 役職 */
  position?: Maybe<Scalars['String']>;
  /** ログインユーザーの卒業校フラグ */
  sameSchool: Scalars['Boolean'];
  /** 卒業学校ID */
  schoolId?: Maybe<Scalars['String']>;
  /** 卒業学校名 */
  schoolName?: Maybe<Scalars['String']>;
};

export type CorporationOffice = {
  __typename?: 'CorporationOffice';
  access?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  imageUrl?: Maybe<Scalars['String']>;
  imageUrl2?: Maybe<Scalars['String']>;
  imageUrl3?: Maybe<Scalars['String']>;
  imageUrl4?: Maybe<Scalars['String']>;
  imageUrl5?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  tel?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type CorporationStaff = {
  __typename?: 'CorporationStaff';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  imageUrl?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nameKana?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  tel?: Maybe<Scalars['String']>;
};

export type CorporationVisitEntryInput = {
  /** 企業ID */
  corporationId: Scalars['Int'];
};

/** 企業の年度ごとの採用情報 */
export type CorporationYearlyInfo = {
  __typename?: 'CorporationYearlyInfo';
  /** 女性新卒採用者数 */
  femaleNewGradsHired?: Maybe<Scalars['Int']>;
  /** 男性新卒採用者数 */
  maleNewGradsHired?: Maybe<Scalars['Int']>;
  /** 対象年度 */
  targetFiscalYear?: Maybe<Scalars['Int']>;
  /** 新卒採用者数 */
  totalNewGradsHired?: Maybe<Scalars['Int']>;
  /** 新卒離職者数 */
  totalNewGradsLeft?: Maybe<Scalars['Int']>;
};

/** 企業の青少年雇用情報 */
export type CorporationYouthEmploymentInfo = {
  __typename?: 'CorporationYouthEmploymentInfo';
  /** 平均年齢 */
  avgEmployeeAge?: Maybe<Scalars['Float']>;
  /** 平均勤続年数 */
  avgYearsOfService?: Maybe<Scalars['Float']>;
  /** キャリア相談制度の内容 */
  careerConsultingContent?: Maybe<Scalars['String']>;
  /** 年度ごとの採用情報 */
  corporationYearlyInfos?: Maybe<Array<CorporationYearlyInfo>>;
  /** 記入日時 */
  entryAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** 女性役員の割合 */
  femaleExecutives?: Maybe<Scalars['Float']>;
  /** 女性管理職の割合 */
  femaleManagers?: Maybe<Scalars['Float']>;
  /** 社内資格制度の内容 */
  inHouseCertificationContent?: Maybe<Scalars['String']>;
  /** キャリア相談制度の有無 */
  isCareerConsultingAvailable: Scalars['Boolean'];
  /** 社内資格制度の有無 */
  isInHouseCertificationAvailable: Scalars['Boolean'];
  /** メンター制度の有無 */
  isMentorSystemAvailable: Scalars['Boolean'];
  /** 自己啓発支援の有無 */
  isSelfDevSupportAvailable: Scalars['Boolean'];
  /** 研修制度の有無 */
  isTrainingAvailable: Scalars['Boolean'];
  /** メンター制度の内容 */
  mentorSystemContent?: Maybe<Scalars['String']>;
  /** 自己啓発支援の内容 */
  selfDevSupportContent?: Maybe<Scalars['String']>;
  /** 研修内容 */
  trainingContent?: Maybe<Scalars['String']>;
  /** 職場定着情報 */
  workplaceRetentions?: Maybe<Array<WorkplaceRetention>>;
};

/** Autogenerated input type of CreateActivity */
export type CreateActivityInput = {
  activity?: InputMaybe<ActivityInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateActivity */
export type CreateActivityPayload = {
  __typename?: 'CreateActivityPayload';
  activity?: Maybe<Activity>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateCorporationVisitEntry */
export type CreateCorporationVisitEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  entry?: InputMaybe<CorporationVisitEntryInput>;
};

/** Autogenerated return type of CreateCorporationVisitEntry */
export type CreateCorporationVisitEntryPayload = {
  __typename?: 'CreateCorporationVisitEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  entry?: Maybe<Entry>;
  error?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of CreateDiagnosis */
export type CreateDiagnosisInput = {
  /** 回答 */
  answers: Array<Scalars['Int']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 診断対象ユーザーID */
  userId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of CreateDiagnosis */
export type CreateDiagnosisPayload = {
  __typename?: 'CreateDiagnosisPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  diagnosis?: Maybe<Diagnosis>;
  error?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateInternshipEntry */
export type CreateInternshipEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  entry?: InputMaybe<InternshipEntryInput>;
};

/** Autogenerated return type of CreateInternshipEntry */
export type CreateInternshipEntryPayload = {
  __typename?: 'CreateInternshipEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  entry?: Maybe<Entry>;
  error?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of CreateJobEntry */
export type CreateJobEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  entry?: InputMaybe<JobEntryInput>;
};

/** Autogenerated return type of CreateJobEntry */
export type CreateJobEntryPayload = {
  __typename?: 'CreateJobEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  entry?: Maybe<Entry>;
  error?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of CreatePortfolio */
export type CreatePortfolioInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  portfolio?: InputMaybe<PortfolioInput>;
};

/** Autogenerated return type of CreatePortfolio */
export type CreatePortfolioPayload = {
  __typename?: 'CreatePortfolioPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  portfolio?: Maybe<Portfolio>;
};

/** Autogenerated input type of CreateSeminarEntry */
export type CreateSeminarEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  entry?: InputMaybe<SeminarEntryInput>;
};

/** Autogenerated return type of CreateSeminarEntry */
export type CreateSeminarEntryPayload = {
  __typename?: 'CreateSeminarEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  entry?: Maybe<Entry>;
  error?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of CreateSocialLink */
export type CreateSocialLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  idToken: Scalars['String'];
  provider: SocialProvider;
};

/** Autogenerated return type of CreateSocialLink */
export type CreateSocialLinkPayload = {
  __typename?: 'CreateSocialLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  socialLink?: Maybe<SocialLink>;
};

/** Autogenerated input type of DeleteActivity */
export type DeleteActivityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** Autogenerated return type of DeleteActivity */
export type DeleteActivityPayload = {
  __typename?: 'DeleteActivityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of DeletePortfolio */
export type DeletePortfolioInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** Autogenerated return type of DeletePortfolio */
export type DeletePortfolioPayload = {
  __typename?: 'DeletePortfolioPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of DeleteSocialLink */
export type DeleteSocialLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  provider: SocialProvider;
};

/** Autogenerated return type of DeleteSocialLink */
export type DeleteSocialLinkPayload = {
  __typename?: 'DeleteSocialLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  socialLink?: Maybe<SocialLink>;
};

export type Diagnosis = {
  __typename?: 'Diagnosis';
  /** キャリア */
  career?: Maybe<Array<Scalars['String']>>;
  /** 作成日時 */
  createdAt?: Maybe<Scalars['ISO8601Date']>;
  /** 説明 */
  description?: Maybe<Scalars['String']>;
  /** 適性診断ID */
  id?: Maybe<Scalars['Int']>;
  /** 診断対象者名 */
  name: Scalars['String'];
  /** 友好的・感覚的ポイント */
  pointCreative?: Maybe<Scalars['Int']>;
  /** 冒険的・独創的ポイント */
  pointFriendly?: Maybe<Scalars['Int']>;
  /** 論理的・理性的ポイント */
  pointLogical?: Maybe<Scalars['Int']>;
  /** 計画的・堅実的ポイント */
  pointPlanning?: Maybe<Scalars['Int']>;
  /** 依頼用トークン */
  shareToken?: Maybe<Scalars['String']>;
  /** 診断者ID */
  supporterId?: Maybe<Scalars['Int']>;
  /** 診断者名 */
  supporterName?: Maybe<Scalars['String']>;
  /** 傾向 */
  trend?: Maybe<Array<Scalars['String']>>;
  /** タイプ */
  type?: Maybe<Scalars['String']>;
  /** 診断対象者ID */
  userId?: Maybe<Scalars['Int']>;
};

export type Employment = {
  __typename?: 'Employment';
  /** コード値（※基本的にidではなくこっち使ってる） */
  code: Scalars['Int'];
  /** ID */
  id: Scalars['Int'];
  /** ラベル */
  label: Scalars['String'];
  /** 対象年度 */
  year?: Maybe<Scalars['String']>;
};

export type Entry = {
  __typename?: 'Entry';
  /** 企業情報 */
  corporation?: Maybe<Corporation>;
  /** 作成日時 */
  createdAt: Scalars['ISO8601Date'];
  /** 入社試験情報 */
  exam?: Maybe<CorporationEvent>;
  /** エントリーID */
  id?: Maybe<Scalars['Int']>;
  /** 企業実習情報 */
  internship?: Maybe<CorporationEventInternship>;
  /** 募集情報 */
  job?: Maybe<Job>;
  /** 説明会情報 */
  seminar?: Maybe<CorporationEvent>;
  /** 姉妹校名 */
  sister?: Maybe<Scalars['String']>;
  /** 更新日時 */
  updatedAt: Scalars['ISO8601Date'];
};

export type EntryAddition = {
  __typename?: 'EntryAddition';
  /** 入力形式 */
  additionType: EntryAdditionInputType;
  /** 説明文 */
  description?: Maybe<Scalars['String']>;
  /** 追加項目ID */
  id: Scalars['Int'];
  /** 選択形式での選択候補 */
  items?: Maybe<Array<Scalars['String']>>;
  /** 必須 */
  require: Scalars['Boolean'];
  /** 選択形式で自由入力欄を表示する */
  showMemo: Scalars['Boolean'];
  /** タイトル */
  title: Scalars['String'];
};

export type EntryAdditionInput = {
  /** 追加質問ID */
  additionId: Scalars['Int'];
  /** 回答 */
  answer: Scalars['String'];
  /** 質問 */
  question: Scalars['String'];
};

export enum EntryAdditionInputType {
  /** 複数選択リスト */
  TypeListMulti = 'type_list_multi',
  /** 単一選択リスト */
  TypeListSingle = 'type_list_single',
  /** テキスト入力 */
  TypeText = 'type_text'
}

export type EntrySetting = {
  __typename?: 'EntrySetting';
  /** 追加項目 */
  additions?: Maybe<Array<EntryAddition>>;
  id: Scalars['Int'];
  /** 個人情報保護方針URL */
  privacyPolicyUrl?: Maybe<Scalars['String']>;
  /** 希望勤務地（必須） */
  requireLocation: Scalars['Boolean'];
  /** 志望動機やご質問など（必須） */
  requireMemo: Scalars['Boolean'];
  /** 希望勤務地（表示） */
  showLocation: Scalars['Boolean'];
  /** 志望動機やご質問など（表示） */
  showMemo: Scalars['Boolean'];
};

export enum EventSort {
  /** 締切 */
  EventDeadline = 'event_deadline',
  /** 新着 */
  EventLatest = 'event_latest'
}

export type EveryonesPortfoliosProfile = {
  __typename?: 'EveryonesPortfoliosProfile';
  /** アバター */
  avatar?: Maybe<UserdataAvatar>;
  /** 卒業年 */
  graduationYear?: Maybe<Scalars['Int']>;
  /** 学校名 */
  schoolName?: Maybe<Scalars['String']>;
};

export enum FeedSortType {
  /** 新着 */
  Latest = 'latest',
  /** 人気 */
  Popular = 'popular'
}

export type FileInfo = {
  __typename?: 'FileInfo';
  contentType: Scalars['String'];
  data?: Maybe<Scalars['String']>;
  fileType?: Maybe<FileType>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  url: Scalars['String'];
};

export type FileInput = {
  /** コンテントタイプ */
  contentType: Scalars['String'];
  /** アップロード日 */
  data: Scalars['String'];
  /** ID */
  id?: InputMaybe<Scalars['String']>;
  /** ファイル名 */
  name: Scalars['String'];
};

export enum FileType {
  /** 活動記録 */
  TypeActivity = 'type_activity',
  /** メッセージ */
  TypeMessage = 'type_message',
  /** 活動記録 */
  TypePortfolio = 'type_portfolio'
}

export enum GraduationStatus {
  /** 中退 */
  DropOut = 'drop_out',
  /** 卒業 */
  Graduation = 'graduation'
}

export type HandicapAdoption = {
  __typename?: 'HandicapAdoption';
  proved?: Maybe<Scalars['Boolean']>;
  scheduled?: Maybe<Scalars['Boolean']>;
};

export type Hashtag = {
  __typename?: 'Hashtag';
  id: Scalars['Int'];
  name: Scalars['String'];
  tagType: TagType;
};

export type Industry = {
  __typename?: 'Industry';
  /** コード値（※基本的にidではなくこっち使ってる） */
  code: Scalars['Int'];
  /** ID */
  id: Scalars['Int'];
  /** ラベル */
  label: Scalars['String'];
};

export type InternationalAdoption = {
  __typename?: 'InternationalAdoption';
  proved?: Maybe<Scalars['Boolean']>;
  scheduled?: Maybe<Scalars['Boolean']>;
};

export type InternshipEntryInput = {
  /** 追加質問 */
  additions?: InputMaybe<Array<EntryAdditionInput>>;
  /** 企業実習ID */
  internshipId: Scalars['Int'];
  /** 公開資格・作品ID */
  licenseIds?: InputMaybe<Array<Scalars['Int']>>;
  /** 志望動機やご質問など */
  memo?: InputMaybe<Scalars['String']>;
  /** 公開するポートフォリオID */
  portfolioIds?: InputMaybe<Array<Scalars['Int']>>;
  /** 公開する自己PR */
  prIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type Job = {
  __typename?: 'Job';
  /** 追加項目 */
  additions?: Maybe<Array<AdditionItem>>;
  /** ブックマーク */
  bookmark?: Maybe<Scalars['Boolean']>;
  /** キャッチコピー */
  catchCopy?: Maybe<Scalars['String']>;
  /** 特徴1 */
  characteristics1?: Maybe<JobFeature>;
  /** 特徴2 */
  characteristics2?: Maybe<JobFeature>;
  /** 特徴3 */
  characteristics3?: Maybe<JobFeature>;
  /** 掲載終了日 */
  closeDate: Scalars['ISO8601Date'];
  /** 雇用契約内容 */
  contranctInfo?: Maybe<ContranctInfo>;
  /** 企業 */
  corporation: Corporation;
  /** 学校の企業番号 */
  corporationNo?: Maybe<Scalars['String']>;
  /** カバー画像 */
  coverImageUrl?: Maybe<Scalars['String']>;
  /** 詳細動画 */
  coverVideo?: Maybe<Video>;
  /** 作成日時 */
  createdAt: Scalars['ISO8601Date'];
  /** 控除 */
  deducting?: Maybe<Scalars['String']>;
  /** 仕事内容 */
  descWork?: Maybe<Scalars['String']>;
  /** 雇用区分 */
  employmentType?: Maybe<Employment>;
  /** 必要書類 */
  entryDocument?: Maybe<Scalars['String']>;
  /** エントリーフォーム設定 */
  entrySetting?: Maybe<EntrySetting>;
  /** 入社試験 */
  examination?: Maybe<CorporationEvent>;
  /** 入社試験 日付 */
  examinationDates?: Maybe<Array<CorporationEventDate>>;
  /** 入社試験 時間帯 */
  examinationTimes?: Maybe<Array<CorporationEventTime>>;
  /** 募集の特徴（TODO_type：使っていない。（おそらく期待通りの動きもしてない）） */
  features?: Maybe<Array<Tag>>;
  /** 祝日 */
  holiday?: Maybe<Scalars['String']>;
  /** 求人票ID */
  id: Scalars['Int'];
  /** 理念 */
  idealType?: Maybe<Scalars['String']>;
  /** 求人の分割表示 */
  jobPlanSeparates?: Maybe<Array<JobPlanSeparate>>;
  /** 求人の分割表示 */
  jobPlanSeparatesIndex?: Maybe<Array<JobPlanSeparate>>;
  /** 学校の求人票番号 */
  jobStatus?: Maybe<JobStatus>;
  /** 一覧動画 */
  listVideo?: Maybe<Video>;
  /** 勤務地 */
  locationCities?: Maybe<Scalars['String']>;
  /** 勤務地IDs */
  locationOffices?: Maybe<Array<CorporationOffice>>;
  /** 勤務地名 */
  locationText?: Maybe<Scalars['String']>;
  /** 採用予定人数 */
  numberOfRecruitment?: Maybe<Scalars['String']>;
  /** 職種ラベル */
  occupation?: Maybe<Occupation>;
  /** 職種（テキスト） */
  offer: Scalars['String'];
  /** 画像1 */
  plusImage1Url?: Maybe<Scalars['String']>;
  /** 画像2 */
  plusImage2Url?: Maybe<Scalars['String']>;
  /** 画像3 */
  plusImage3Url?: Maybe<Scalars['String']>;
  /** 試用期間 */
  probation?: Maybe<Scalars['String']>;
  /** 掲載日 */
  publicationDate: Scalars['ISO8601Date'];
  /** 応募資格 */
  qualification?: Maybe<Scalars['String']>;
  /** 採用担当者 */
  recruiter?: Maybe<CorporationStaff>;
  /** 給与 */
  salary?: Maybe<Scalars['String']>;
  /** 賞与 */
  salaryBonus?: Maybe<Scalars['String']>;
  /** 昇給 */
  salaryIncrease?: Maybe<Scalars['String']>;
  /** 採用の流れ */
  schedule?: Maybe<Scalars['String']>;
  /** 学校追加項目 */
  schoolAdditions?: Maybe<Array<AdditionItem>>;
  /** 学校推薦フラグ */
  schoolEntry: Scalars['Boolean'];
  /** 学校推薦フラグ */
  sisterJobInfo?: Maybe<SisterJobInfo>;
  /** 交通費 */
  transportation?: Maybe<Scalars['String']>;
  /** 交通費 補足 */
  transportationMemo?: Maybe<Scalars['String']>;
  /** 手当 */
  treatment?: Maybe<Scalars['String']>;
  /** 更新日時 */
  updatedAt: Scalars['ISO8601Date'];
  /** 休日 */
  vacation?: Maybe<Scalars['String']>;
  /** 公開範囲 */
  viewCondition?: Maybe<JobViewCondition>;
  /** 福利厚生 */
  welfare?: Maybe<Scalars['String']>;
  /** 勤務時間 */
  workingHours?: Maybe<Scalars['String']>;
};


export type JobCoverImageUrlArgs = {
  isFree?: InputMaybe<Scalars['Boolean']>;
};


export type JobCoverVideoArgs = {
  isFree?: InputMaybe<Scalars['Boolean']>;
};


export type JobJobPlanSeparatesIndexArgs = {
  includeLocationCityList?: InputMaybe<Scalars['Boolean']>;
};


export type JobListVideoArgs = {
  isFree?: InputMaybe<Scalars['Boolean']>;
};


export type JobPlusImage1UrlArgs = {
  isFree?: InputMaybe<Scalars['Boolean']>;
};


export type JobPlusImage2UrlArgs = {
  isFree?: InputMaybe<Scalars['Boolean']>;
};


export type JobPlusImage3UrlArgs = {
  isFree?: InputMaybe<Scalars['Boolean']>;
};

export type JobEntryInput = {
  /** 追加質問 */
  additions?: InputMaybe<Array<EntryAdditionInput>>;
  /** 入社試験日付ID */
  examDateId?: InputMaybe<Scalars['Int']>;
  /** 入社試験ID */
  examId?: InputMaybe<Scalars['Int']>;
  /** 入社試験時間帯ID */
  examTimeId?: InputMaybe<Scalars['Int']>;
  /** 求人ID */
  jobId: Scalars['Int'];
  /** 希望勤務地 */
  locations?: InputMaybe<Array<Scalars['Int']>>;
  /** 志望動機やご質問など */
  memo?: InputMaybe<Scalars['String']>;
  /** 公開するポートフォリオID */
  portfolioIds?: InputMaybe<Array<Scalars['Int']>>;
  /** 公開する自己PR */
  prIds?: InputMaybe<Array<Scalars['Int']>>;
  /** 応募姉妹校名 */
  sister?: InputMaybe<Scalars['String']>;
};

export type JobFeature = {
  __typename?: 'JobFeature';
  /** コード値（※基本的にidではなくこっち使ってる） */
  code: Scalars['Int'];
  /** ID */
  id: Scalars['Int'];
  /** ラベル */
  label: Scalars['String'];
  /** 短縮ラベル */
  shortLabel: Scalars['String'];
  /** 並び順 */
  viewOrder: Scalars['Int'];
};

export type JobHuntingStatus = {
  __typename?: 'JobHuntingStatus';
  id: Scalars['Int'];
  label: Scalars['String'];
  value: Scalars['Int'];
};

export type JobPlanSeparate = {
  __typename?: 'JobPlanSeparate';
  /** ID */
  id: Scalars['Int'];
  /** 勤務地リスト */
  locationCityList?: Maybe<Array<Scalars['String']>>;
  /** 都道府県リスト */
  locationPrefectureList?: Maybe<Array<Scalars['String']>>;
  /** 表示タイプ */
  premium: Scalars['Boolean'];
};

export enum JobSort {
  /** 締切 */
  Deadline = 'deadline',
  /** 新着 */
  Latest = 'latest',
  /** おすすめ */
  Recommend = 'recommend'
}

export type JobStatus = {
  __typename?: 'JobStatus';
  /** 企業ID */
  corporationId?: Maybe<Scalars['Int']>;
  /** ID */
  id: Scalars['Int'];
  /** 募集 */
  job?: Maybe<Job>;
  /** 求人票ID */
  jobId?: Maybe<Scalars['Int']>;
  /** 求人票番号 */
  jobNo?: Maybe<Scalars['String']>;
  /** 学校ID */
  schoolId?: Maybe<Scalars['Int']>;
  /** 募集情報メモ */
  schoolMemo?: Maybe<Scalars['String']>;
};

export enum JobViewCondition {
  /** 申請中 */
  ConditionApplication = 'condition_application',
  /** 終了 */
  ConditionEnd = 'condition_end',
  /** 未対応 */
  ConditionNull = 'condition_null',
  /** 準備中 */
  ConditionPreparation = 'condition_preparation',
  /** 非公開 */
  ConditionPrivate = 'condition_private',
  /** 公開 */
  ConditionPublic = 'condition_public'
}

export type KeyValue = {
  __typename?: 'KeyValue';
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type KeyValueGroup = {
  __typename?: 'KeyValueGroup';
  groupCode: Scalars['String'];
  groupName: Scalars['String'];
  keyValues: Array<KeyValue>;
};

export type License = {
  __typename?: 'License';
  /** 登録日時 */
  createdAt: Scalars['ISO8601Date'];
  /** ID */
  id: Scalars['Int'];
  /** 取得月 */
  month?: Maybe<Scalars['Int']>;
  /** 取得状況 */
  status?: Maybe<LicenseStatus>;
  /** 主な免許・資格名 */
  title: Scalars['String'];
  /** 更新日時 */
  updatedAt: Scalars['ISO8601Date'];
  /** 取得年 */
  year?: Maybe<Scalars['Int']>;
};

export type LicenseInput = {
  /** ID */
  id?: InputMaybe<Scalars['Int']>;
  /** 取得月 */
  month: Scalars['Int'];
  /** 免許・資格名 */
  name: Scalars['String'];
  /** 免許・資格名 */
  status: LicenseStatus;
  /** 取得年 */
  year: Scalars['Int'];
};

export enum LicenseStatus {
  /** 取得済み */
  Certified = 'certified',
  /** 取得見込み */
  Expected = 'expected'
}

export type Like = {
  __typename?: 'Like';
  checked: Scalars['Boolean'];
  /** いいねID */
  id: Scalars['Int'];
  targetId: Scalars['Int'];
  type: LikeType;
};

export enum LikeType {
  /** 社長の履歴書 */
  CeoStory = 'ceo_story',
  /** 就活タイムズ */
  Interview = 'interview',
  /** 先輩の活躍 */
  TypeActivity = 'type_activity',
  /** 注目記事 */
  TypePost = 'type_post',
  /** 自己PR（写真） */
  TypePrPhoto = 'type_pr_photo',
  /** 探究テーマ */
  TypeResearchTheme = 'type_research_theme'
}

export enum MeetingType {
  /** 会場＋WEB */
  TypeBoth = 'type_both',
  /** 会場 */
  TypeFaceToFace = 'type_face_to_face',
  /** WEB */
  TypeRemote = 'type_remote'
}

export type Message = {
  __typename?: 'Message';
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601Date'];
  files?: Maybe<Array<FileInfo>>;
  id: Scalars['Int'];
  myMessage: Scalars['Boolean'];
  senderType?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

/** The connection type for Message. */
export type MessageConnection = {
  __typename?: 'MessageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MessageEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Message>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** 総件数 */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type MessageEdge = {
  __typename?: 'MessageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Message>;
};

export type MessageForAction = {
  __typename?: 'MessageForAction';
  imageUrl?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type MessageRoom = {
  __typename?: 'MessageRoom';
  currentMessage?: Maybe<Message>;
  currentMessageId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  roomType?: Maybe<MessageRoomType>;
  userFrom: MessageUser;
  userTo: MessageUser;
};

export enum MessageRoomType {
  /** 企業 */
  TypeCorporation = 'type_corporation',
  /** 学校 */
  TypeSchool = 'type_school'
}

export type MessageUser = {
  __typename?: 'MessageUser';
  currentMessageId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nameSub?: Maybe<Scalars['String']>;
  userType: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  changeEmail?: Maybe<ChangeEmailPayload>;
  changeJobHuntingStatus?: Maybe<ChangeJobHuntingStatusPayload>;
  changeNotification?: Maybe<ChangeNotificationPayload>;
  changePassword?: Maybe<ChangePasswordPayload>;
  confirmMessageNotification?: Maybe<ConfirmMessageNotificationPayload>;
  createActivity?: Maybe<CreateActivityPayload>;
  createCorporationVisitEntry?: Maybe<CreateCorporationVisitEntryPayload>;
  createDiagnosis?: Maybe<CreateDiagnosisPayload>;
  createInternshipEntry?: Maybe<CreateInternshipEntryPayload>;
  createJobEntry?: Maybe<CreateJobEntryPayload>;
  createPortfolio?: Maybe<CreatePortfolioPayload>;
  createSeminarEntry?: Maybe<CreateSeminarEntryPayload>;
  createSocialLink?: Maybe<CreateSocialLinkPayload>;
  deleteActivity?: Maybe<DeleteActivityPayload>;
  deletePortfolio?: Maybe<DeletePortfolioPayload>;
  deleteSocialLink?: Maybe<DeleteSocialLinkPayload>;
  registerDeviceToken?: Maybe<RegisterDeviceTokenPayload>;
  registerUser?: Maybe<RegisterUserPayload>;
  rejectOffer?: Maybe<RejectOfferPayload>;
  requestDiagnosis?: Maybe<RequestDiagnosisPayload>;
  sendMessage?: Maybe<SendMessagePayload>;
  toggleAnonymousLike?: Maybe<ToggleAnonymousLikePayload>;
  toggleBookmark?: Maybe<ToggleBookmarkPayload>;
  toggleLike?: Maybe<ToggleLikePayload>;
  updateActivity?: Maybe<UpdateActivityPayload>;
  /** アバターを更新する */
  updateAvatar?: Maybe<UpdateUserdataAvatarPayload>;
  updateConditions?: Maybe<UpdateConditionsPayload>;
  updateCurrentMessage?: Maybe<UpdateCurrentMessagePayload>;
  updatePortfolio?: Maybe<UpdatePortfolioPayload>;
  updatePrText?: Maybe<UpdatePrTextPayload>;
  updateProfile?: Maybe<UpdateProfilePayload>;
  updateProfileStatus?: Maybe<UpdateProfileStatusPayload>;
  updateReviewStatus?: Maybe<UpdateReviewStatusPayload>;
  uploadRichContentFile?: Maybe<UploadRichContentFilePayload>;
};


export type MutationChangeEmailArgs = {
  input: ChangeEmailInput;
};


export type MutationChangeJobHuntingStatusArgs = {
  input: ChangeJobHuntingStatusInput;
};


export type MutationChangeNotificationArgs = {
  input: ChangeNotificationInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationConfirmMessageNotificationArgs = {
  input: ConfirmMessageNotificationInput;
};


export type MutationCreateActivityArgs = {
  input: CreateActivityInput;
};


export type MutationCreateCorporationVisitEntryArgs = {
  input: CreateCorporationVisitEntryInput;
};


export type MutationCreateDiagnosisArgs = {
  input: CreateDiagnosisInput;
};


export type MutationCreateInternshipEntryArgs = {
  input: CreateInternshipEntryInput;
};


export type MutationCreateJobEntryArgs = {
  input: CreateJobEntryInput;
};


export type MutationCreatePortfolioArgs = {
  input: CreatePortfolioInput;
};


export type MutationCreateSeminarEntryArgs = {
  input: CreateSeminarEntryInput;
};


export type MutationCreateSocialLinkArgs = {
  input: CreateSocialLinkInput;
};


export type MutationDeleteActivityArgs = {
  input: DeleteActivityInput;
};


export type MutationDeletePortfolioArgs = {
  input: DeletePortfolioInput;
};


export type MutationDeleteSocialLinkArgs = {
  input: DeleteSocialLinkInput;
};


export type MutationRegisterDeviceTokenArgs = {
  input: RegisterDeviceTokenInput;
};


export type MutationRegisterUserArgs = {
  input: RegisterUserInput;
};


export type MutationRejectOfferArgs = {
  input: RejectOfferInput;
};


export type MutationRequestDiagnosisArgs = {
  input: RequestDiagnosisInput;
};


export type MutationSendMessageArgs = {
  input: SendMessageInput;
};


export type MutationToggleAnonymousLikeArgs = {
  input: ToggleAnonymousLikeInput;
};


export type MutationToggleBookmarkArgs = {
  input: ToggleBookmarkInput;
};


export type MutationToggleLikeArgs = {
  input: ToggleLikeInput;
};


export type MutationUpdateActivityArgs = {
  input: UpdateActivityInput;
};


export type MutationUpdateAvatarArgs = {
  input: UpdateUserdataAvatarInput;
};


export type MutationUpdateConditionsArgs = {
  input: UpdateConditionsInput;
};


export type MutationUpdateCurrentMessageArgs = {
  input: UpdateCurrentMessageInput;
};


export type MutationUpdatePortfolioArgs = {
  input: UpdatePortfolioInput;
};


export type MutationUpdatePrTextArgs = {
  input: UpdatePrTextInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdateProfileStatusArgs = {
  input: UpdateProfileStatusInput;
};


export type MutationUpdateReviewStatusArgs = {
  input: UpdateReviewStatusInput;
};


export type MutationUploadRichContentFileArgs = {
  input: UploadRichContentFileInput;
};

export type NeedMore = {
  __typename?: 'NeedMore';
  /** ログインが必要かどうか */
  auth: Scalars['Boolean'];
};

export type NewNotice = {
  __typename?: 'NewNotice';
  /** 未読のメッセージがあるか */
  message: Scalars['Boolean'];
  /** 新着の事務局お知らせがあるか */
  news: Scalars['Boolean'];
  /** 未読の学校掲示板があるか */
  noticeBoard: Scalars['Boolean'];
  /** 未対応のオファーがあるか */
  offer: Scalars['Boolean'];
};

export type News = {
  __typename?: 'News';
  content: Scalars['String'];
  createdAt?: Maybe<Scalars['ISO8601Date']>;
  fileUrl: Scalars['String'];
  id: Scalars['Int'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601Date']>;
};

export type NoticeBoard = {
  __typename?: 'NoticeBoard';
  bookmark?: Maybe<Scalars['Boolean']>;
  catchcopy?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  contributor: Scalars['String'];
  createdAt: Scalars['ISO8601Date'];
  file?: Maybe<FileInfo>;
  id: Scalars['Int'];
  image?: Maybe<FileInfo>;
  imagePc?: Maybe<FileInfo>;
  imageSp?: Maybe<FileInfo>;
  isNew: Scalars['Boolean'];
  schoolCourse?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601Date'];
};

export type Notification = {
  __typename?: 'Notification';
  confirmedAt?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  imageUrl?: Maybe<Scalars['String']>;
  notifiedAt?: Maybe<Scalars['ISO8601Date']>;
  subTitle?: Maybe<Scalars['String']>;
  targetId: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  type: NotificationType;
};

export type NotificationInput = {
  /** フラグ */
  flag: Scalars['Boolean'];
  /** 通知タイプ */
  type: NotificationMethod;
};

export enum NotificationMethod {
  /** 企業 */
  TypeEmail = 'type_email',
  /** 学校 */
  TypePush = 'type_push'
}

export enum NotificationType {
  /** メッセージ */
  TypeMessage = 'type_message',
  /** 学校掲示板 */
  TypeNoticeBoard = 'type_notice_board',
  /** オファー */
  TypeOffer = 'type_offer',
  /** 事務局 */
  TypeSys = 'type_sys'
}

export type Occupation = {
  __typename?: 'Occupation';
  /** コード値（※基本的にidではなくこっち使ってる） */
  code: Scalars['Int'];
  /** ID */
  id: Scalars['Int'];
  /** ラベル */
  label: Scalars['String'];
};

export type Offer = {
  __typename?: 'Offer';
  confirmedDate?: Maybe<Scalars['ISO8601Date']>;
  content: Scalars['String'];
  corporation: Corporation;
  /** イベント */
  corporationEvent?: Maybe<CorporationEvent>;
  expiredDate: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  imageUrl?: Maybe<Scalars['String']>;
  /** 有効なオファー判定 */
  isValid?: Maybe<Scalars['Boolean']>;
  job?: Maybe<Job>;
  movieType?: Maybe<Scalars['String']>;
  movieUrl?: Maybe<Scalars['String']>;
  movieUrlLong?: Maybe<Scalars['String']>;
  offerDate: Scalars['ISO8601Date'];
  /** オファー区分（Enum） */
  offerType?: Maybe<OfferTypeEnum>;
  presentationType?: Maybe<Scalars['String']>;
  privilege?: Maybe<Scalars['String']>;
  privilegeTitle?: Maybe<Scalars['String']>;
  status: OfferStatus;
  /** オファーに対する応答日時 */
  studentResponsedAt?: Maybe<Scalars['ISO8601Date']>;
  title: Scalars['String'];
  /** 有効な説明会日程ID(説明会応募ページ遷移用) */
  validSeminarDateId?: Maybe<Scalars['Int']>;
};

export enum OfferStatus {
  /** 承認 */
  StatusAccept = 'status_accept',
  /** 辞退 */
  StatusDecline = 'status_decline',
  /** 未対応 */
  StatusDefault = 'status_default'
}

export enum OfferTypeEnum {
  /** 企業訪問 */
  CompanyVisit = 'company_visit',
  /** 企業実習 */
  Internship = 'internship',
  /** 求人 */
  Job = 'job',
  /** 説明会 */
  Seminar = 'seminar'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  /** 現在のページ位置 */
  currentPage?: Maybe<Scalars['Int']>;
  /** 1ページあたりの件数 */
  limitValue?: Maybe<Scalars['Int']>;
  /** 総件数 */
  totalCount?: Maybe<Scalars['Int']>;
  /** 合計ページ数 */
  totalPages?: Maybe<Scalars['Int']>;
};

export type PaginationCorporationEventInternships = {
  __typename?: 'PaginationCorporationEventInternships';
  /** 企業実習 */
  internships?: Maybe<Array<CorporationEventInternship>>;
  /** ページング情報 */
  pagination?: Maybe<Pagination>;
};

export type PaginationCorporationEvents = {
  __typename?: 'PaginationCorporationEvents';
  /** ページング情報 */
  pagination?: Maybe<Pagination>;
  /** 説明会 */
  seminars?: Maybe<Array<CorporationEvent>>;
};

export type PaginationCorporationMembers = {
  __typename?: 'PaginationCorporationMembers';
  /** 先輩 */
  graduateMembers?: Maybe<Array<CorporationMember>>;
  /** ページング情報 */
  pagination?: Maybe<Pagination>;
};

export type PaginationEveryonesPortfolios = {
  __typename?: 'PaginationEveryonesPortfolios';
  /** ポートフォリオ */
  everyonesPortfolios?: Maybe<Array<Portfolio>>;
  /** ページング情報 */
  pagination?: Maybe<Pagination>;
};

export type PaginationFeeds = {
  __typename?: 'PaginationFeeds';
  /** 注目記事 */
  feeds?: Maybe<Array<Post>>;
  /** ページング情報 */
  pagination?: Maybe<Pagination>;
};

export type PaginationJobs = {
  __typename?: 'PaginationJobs';
  /** 募集 */
  jobs?: Maybe<Array<Job>>;
  /** ページング情報 */
  pagination?: Maybe<Pagination>;
};

export type PaginationResearchThemes = {
  __typename?: 'PaginationResearchThemes';
  /** ページング情報 */
  pagination?: Maybe<Pagination>;
  /** 探求テーマ */
  researchThemes?: Maybe<Array<ResearchTheme>>;
};

export type PaginationSeniorArticles = {
  __typename?: 'PaginationSeniorArticles';
  /** ページング情報 */
  pagination?: Maybe<Pagination>;
  /** 先輩の声 */
  voiceBoards?: Maybe<Array<SeniorArticle>>;
};

export type PerformanceReference = {
  __typename?: 'PerformanceReference';
  /** 引用記事カバーイメージ */
  articleCoverImageUrl?: Maybe<Scalars['String']>;
  /** 引用記事ID */
  articleId?: Maybe<Scalars['String']>;
  /** 引用記事ロゴURL */
  articleLogoUrl?: Maybe<Scalars['String']>;
  /** 引用記事作成者名 */
  articleOwnerName?: Maybe<Scalars['String']>;
  /** 引用記事公開日 */
  articlePublishedDate?: Maybe<Scalars['ISO8601Date']>;
  /** 引用記事タイトル */
  articleTitle?: Maybe<Scalars['String']>;
  /** 引用記事タイプ */
  articleType?: Maybe<Scalars['String']>;
  /** 特別授業情報 */
  feed?: Maybe<Post>;
  /** ID */
  id?: Maybe<Scalars['Int']>;
  /** レポート型ポートフォリオ情報ID */
  performanceId?: Maybe<Scalars['String']>;
  /** 探求テーマ情報 */
  researchTheme?: Maybe<ResearchTheme>;
};

export type PerformanceReport = {
  __typename?: 'PerformanceReport';
  /** カバー画像URL */
  coverImageUrl?: Maybe<Scalars['String']>;
  /** カバータイプ */
  coverType?: Maybe<Scalars['String']>;
  /** カバー動画ID */
  coverVideoId?: Maybe<Scalars['String']>;
  /** カバー動画URL */
  coverVideoUrl?: Maybe<Scalars['String']>;
  /** ID */
  id?: Maybe<Scalars['Int']>;
  /** ポートフォリオID */
  performanceId?: Maybe<Scalars['String']>;
  /** リッチエディタ本文情報 */
  richContent?: Maybe<RichContent>;
};

export type PerformanceReportInput = {
  /** カバー画像 */
  coverImage?: InputMaybe<FileInput>;
  /** カバー画像削除フラグ */
  coverImageDelete?: InputMaybe<Scalars['Boolean']>;
  /** カバータイプ */
  coverType?: InputMaybe<Scalars['String']>;
  /** カバー動画URL */
  coverVideoUrl?: InputMaybe<Scalars['String']>;
  /** リッチコンテント */
  richContent?: InputMaybe<RichContentInput>;
};

export type PickupPosts = {
  __typename?: 'PickupPosts';
  id: Scalars['Int'];
  posts: Array<Post>;
  updatedAt?: Maybe<Scalars['ISO8601Date']>;
};

export type Portfolio = {
  __typename?: 'Portfolio';
  /** 匿名いいね一覧 */
  anonymousLikes?: Maybe<Array<PortfolioAnonymousLike>>;
  /** コメント数 */
  commentCount?: Maybe<Scalars['Int']>;
  /** コメント一覧 */
  comments?: Maybe<Array<PortfolioComment>>;
  /** 本文 */
  content?: Maybe<Scalars['String']>;
  /** 登録日時 */
  createdAt: Scalars['ISO8601Date'];
  /** ポートフォリオ日 */
  day?: Maybe<Scalars['Int']>;
  /** 添付ファイル情報 */
  fileInfo?: Maybe<FileInfo>;
  /** 添付ファイルURL */
  fileUrl?: Maybe<Scalars['String']>;
  /** ログインユーザーがいいねを押したかどうか */
  hasLikedByCurrentUser: Scalars['Boolean'];
  /** ID */
  id: Scalars['Int'];
  /** ポートフォリオ画像URL */
  imageUrl?: Maybe<Scalars['String']>;
  /** ポートフォリオ追加画像URL */
  imageUrls?: Maybe<Array<Scalars['String']>>;
  /** ポートフォリオ追加画像 */
  images?: Maybe<Array<FileInfo>>;
  /** ログインユーザーのポートフォリオであるか */
  isCurrentUserPortfolio: Scalars['Boolean'];
  /** リッチエディタを使用したレポート型のポートフォリオであるか */
  isReport: Scalars['Boolean'];
  /** いいね数 */
  likeCount?: Maybe<Scalars['Int']>;
  /** いいね一覧 */
  likes?: Maybe<Array<PortfolioLike>>;
  /** メインのレポート引用情報 */
  mainPerformanceReference?: Maybe<PerformanceReference>;
  /** ポートフォリオ月 */
  month?: Maybe<Scalars['Int']>;
  /** レポート引用情報 */
  performanceReferences?: Maybe<Array<PerformanceReference>>;
  /** レポート型ポートフォリオ情報 */
  performanceReport?: Maybe<PerformanceReport>;
  /** 公開設定 */
  privacySetting?: Maybe<PrivacySetting>;
  /** みんなのポートフォリオのプロフィール情報 */
  profile?: Maybe<EveryonesPortfoliosProfile>;
  /** タイトル */
  title: Scalars['String'];
  /** 更新日時 */
  updatedAt: Scalars['ISO8601Date'];
  /** URL */
  url?: Maybe<Scalars['String']>;
  /** ポートフォリオ年 */
  year?: Maybe<Scalars['Int']>;
};

export type PortfolioAnonymousLike = {
  __typename?: 'PortfolioAnonymousLike';
  createdAt: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  updatedAt: Scalars['ISO8601Date'];
};

export type PortfolioComment = {
  __typename?: 'PortfolioComment';
  comment: Scalars['String'];
  /** コメント者ロゴイメージ */
  commenterLogoUrl?: Maybe<Scalars['String']>;
  /** コメント者名 */
  commenterName?: Maybe<Scalars['String']>;
  corporation?: Maybe<Corporation>;
  createdAt: Scalars['ISO8601Date'];
  /** ポートフォリオへのコメントID */
  id: Scalars['Int'];
  school?: Maybe<School>;
  updatedAt: Scalars['ISO8601Date'];
};

export type PortfolioInput = {
  /** 説明 */
  content?: InputMaybe<Scalars['String']>;
  /** 添付ファイル */
  file?: InputMaybe<FileInput>;
  /** 添付ファイル削除フラグ */
  fileDelete?: InputMaybe<Scalars['Boolean']>;
  /** ポートフォリオID */
  id?: InputMaybe<Scalars['Int']>;
  /** 画像 */
  image?: InputMaybe<FileInput>;
  /** 複数画像 */
  images?: InputMaybe<Array<FileInput>>;
  /** レポート登録であるか */
  isReport?: InputMaybe<Scalars['Boolean']>;
  /** ポートフォリオ月 */
  month?: InputMaybe<Scalars['Int']>;
  /** 引用記事ids */
  performanceReferenceIds?: InputMaybe<Array<Scalars['Int']>>;
  /** レポート属性情報 */
  performanceReport?: InputMaybe<PerformanceReportInput>;
  /** 公開範囲 */
  privacySetting: PrivacySetting;
  /** タイトル */
  title: Scalars['String'];
  /** URL */
  url?: InputMaybe<Scalars['String']>;
  /** ポートフォリオ年 */
  year?: InputMaybe<Scalars['Int']>;
};

export type PortfolioLike = {
  __typename?: 'PortfolioLike';
  corporation?: Maybe<Corporation>;
  createdAt: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  school?: Maybe<Corporation>;
  updatedAt: Scalars['ISO8601Date'];
  /** ユーザーの属性 */
  userType?: Maybe<UserTypeEnum>;
};

export type Post = {
  __typename?: 'Post';
  author: Scalars['String'];
  authorImageUrl?: Maybe<Scalars['String']>;
  bookmark?: Maybe<Scalars['Boolean']>;
  bookmarkCount: Scalars['Int'];
  categories?: Maybe<Array<PostCategory>>;
  categoryId: Scalars['Int'];
  content: Scalars['String'];
  contentSummary: Scalars['String'];
  corporation: Corporation;
  createdAt?: Maybe<Scalars['ISO8601Date']>;
  feedId: Scalars['Int'];
  hashtags?: Maybe<Array<Hashtag>>;
  id: Scalars['Int'];
  imageFilename?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  imageUrl1?: Maybe<Scalars['String']>;
  imageUrl2?: Maybe<Scalars['String']>;
  like?: Maybe<Scalars['Boolean']>;
  likeCount: Scalars['Int'];
  members?: Maybe<Array<PostMember>>;
  messageForLike?: Maybe<MessageForAction>;
  postTag?: Maybe<Scalars['String']>;
  readAt?: Maybe<Scalars['ISO8601Date']>;
  richContent?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601Date']>;
  video?: Maybe<Video>;
};

export type PostCategory = {
  __typename?: 'PostCategory';
  corporations?: Maybe<Array<Corporation>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  imageFilename?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  lastPostedAt?: Maybe<Scalars['ISO8601Date']>;
  name: Scalars['String'];
  postCount?: Maybe<Scalars['Int']>;
};

export type PostMember = {
  __typename?: 'PostMember';
  id: Scalars['Int'];
  imageUrl?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  office?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
};

export type PrTextInput = {
  /** 自己PR内容1 */
  prContent1?: InputMaybe<Scalars['String']>;
  /** 自己PR内容2 */
  prContent2?: InputMaybe<Scalars['String']>;
  /** 自己PR内容3 */
  prContent3?: InputMaybe<Scalars['String']>;
  /** 自己PRタイトル1 */
  prTitle1?: InputMaybe<Scalars['String']>;
  /** 自己PRタイトル2 */
  prTitle2?: InputMaybe<Scalars['String']>;
  /** 自己PRタイトル3 */
  prTitle3?: InputMaybe<Scalars['String']>;
};

export enum PrivacySetting {
  /** 全体公開 */
  Global = 'global',
  /** 学校と学生と企業その他全体 */
  Open = 'open',
  /** 自分だけ */
  Private = 'private',
  /** 学校・自分 */
  School = 'school',
  /** 学校と学生 */
  SchoolStudent = 'school_student',
  /** 学校と学生と企業 */
  SchoolStudentCorporation = 'school_student_corporation'
}

export type ProfileInput = {
  /** 住所ふりがな */
  addressFurigana?: InputMaybe<Scalars['String']>;
  /** 番地以降 */
  addressOther?: InputMaybe<Scalars['String']>;
  /** 職歴 */
  careers?: InputMaybe<Array<CareerInput>>;
  /** 市区町村 */
  cityName?: InputMaybe<Scalars['String']>;
  /** クラスメイ */
  className?: InputMaybe<Scalars['String']>;
  /** 学科・コース */
  courseId?: InputMaybe<Scalars['Int']>;
  /** 生年月日 */
  dateOfBirth?: InputMaybe<Scalars['ISO8601Date']>;
  /** 入学月 */
  enrollmentMonth: Scalars['Int'];
  /** 入学年 */
  enrollmentYear: Scalars['Int'];
  /** 履歴書用写真 */
  file?: InputMaybe<FileInput>;
  /** 履歴書用写真削除フラグ */
  fileDelete?: InputMaybe<Scalars['Boolean']>;
  /** 名 */
  firstName: Scalars['String'];
  /** メイ */
  firstNameKana: Scalars['String'];
  /** 性別 */
  gender?: InputMaybe<Scalars['Int']>;
  /** 姓 */
  lastName: Scalars['String'];
  /** セイ */
  lastNameKana: Scalars['String'];
  /** 主な資格・免許 */
  licenses?: InputMaybe<Array<LicenseInput>>;
  /** 郵便番号 */
  postalCode?: InputMaybe<Scalars['String']>;
  /** 都道府県コード */
  prefectureCode?: InputMaybe<Scalars['String']>;
  /** 学歴 */
  schoolBackgrounds?: InputMaybe<Array<SchoolBackgroundInput>>;
  /** 学籍番号 */
  studentNo?: InputMaybe<Scalars['String']>;
  /** 担任 */
  teacherId?: InputMaybe<Scalars['Int']>;
  /** 電話番号 */
  tel?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  /** 企業単位の活動記録一覧を取得 */
  activities: Array<Activity>;
  /** 活動記録を取得 */
  activity?: Maybe<Activity>;
  /** 活動記録の企業を取得 */
  activityCorporation?: Maybe<Corporation>;
  /** 活動記録で登録のある企業一覧を取得 */
  activityCorporations?: Maybe<Array<Corporation>>;
  /** 住所情報を取得を取得 */
  addressFromPostalCode: Array<Address>;
  /** アプリ情報 */
  appInfo?: Maybe<AppInfo>;
  /** アバターのプリセット画像一覧 */
  avatarPresets?: Maybe<Array<Scalars['String']>>;
  /** ブックマークを取得 */
  bookmarks: Array<Bookmark>;
  /** 職歴一覧を取得 */
  careers: Array<Career>;
  /** 職種を取得 */
  categories: Array<KeyValue>;
  /** 業種名を取得 */
  categoryNames: Scalars['String'];
  /** 市区町村名を取得 */
  cityNames: Scalars['String'];
  /** 本登録トークン確認 */
  confirmationAccount?: Maybe<User>;
  /** 企業情報を取得 */
  corporation?: Maybe<Corporation>;
  /** 企業検討中数を取得 */
  corporationFavoriteLog?: Maybe<Array<ChartPoint>>;
  /** 指定期間内の企業検討中数を取得 */
  corporationFavoriteLogBetweenDates?: Maybe<Array<ChartPoint>>;
  /** 社員情報を取得 */
  corporationMember?: Maybe<CorporationMember>;
  /** 募集の特徴名を取得 */
  corporationTypeNames: Scalars['String'];
  /** 企業タイプを取得 */
  corporationTypes: Array<KeyValue>;
  /** 指定された企業の青少年雇用情報を取得 */
  corporationYouthEmploymentInfo?: Maybe<CorporationYouthEmploymentInfo>;
  /** 適性診断一覧を取得 */
  diagnoses?: Maybe<Array<Diagnosis>>;
  /** 適性診断情報を取得 */
  diagnosis?: Maybe<Diagnosis>;
  /** ファイルダウンロード */
  download?: Maybe<FileInfo>;
  /** みんなのポートフォリオを取得 */
  everyonesPortfolio?: Maybe<Portfolio>;
  /** フィードを取得 */
  feed?: Maybe<Post>;
  /** 注目記事カテゴリー一覧を取得 */
  feedCategories: Array<PostCategory>;
  /** 注目記事カテゴリーを取得 */
  feedCategory?: Maybe<PostCategory>;
  /** 認定注目記事カテゴリー一覧を取得 */
  feedCertificateCategories: Array<PostCategory>;
  /** 会社自慢注目記事カテゴリー一覧を取得 */
  feedCorporateCategories: Array<PostCategory>;
  /** 注目記事タグ一覧を取得 */
  feedHashtags: Array<Hashtag>;
  /** フィードを取得 */
  feeds: Array<Post>;
  /** OpenSearchで生成されるToken */
  getAnalyze: Array<Scalars['String']>;
  /** 求人件数（OpenSearch） */
  getTotalJobCount: Scalars['Int'];
  /** グループ分けした業種を取得 */
  groupIndustries: Array<KeyValueGroup>;
  /** 業種を取得 */
  industries: Array<KeyValue>;
  /** 業種に紐づく職種を取得 */
  industryCategories: Array<KeyValue>;
  /** 業種名を取得 */
  industryNames: Scalars['String'];
  /** 企業実習を取得 */
  internship?: Maybe<CorporationEventInternship>;
  /** 企業実習一覧を取得 */
  internships: Array<CorporationEventInternship>;
  /** 募集情報を取得 */
  job?: Maybe<Job>;
  /** 募集の特徴名を取得 */
  jobFeatureNames: Scalars['String'];
  /** 募集の特徴を取得 */
  jobFeatures: Array<KeyValue>;
  /** 募集情報一覧を取得 */
  jobs: Array<Job>;
  /** 主な免許・資格を取得 */
  license?: Maybe<License>;
  /** 主な免許・資格一覧を取得 */
  licenses: Array<License>;
  /** メッセージルーム情報を取得 */
  messageRoom?: Maybe<MessageRoom>;
  /** メッセージルーム一覧を取得 */
  messageRooms: Array<MessageRoom>;
  /** メッセージを取得 */
  messages?: Maybe<Array<Message>>;
  /** 適性診断情報を取得 */
  myDiagnosis?: Maybe<Diagnosis>;
  /** 企業実習を取得 */
  needMore?: Maybe<NeedMore>;
  /** お知らせ詳細を取得 */
  newsDetail?: Maybe<News>;
  /** お知らせ一覧を取得 */
  newsList: Array<News>;
  /** 全てのお知らせを既読にする */
  noticeAllRead?: Maybe<BadgeNotice>;
  /** 学内掲示板情報を取得 */
  noticeBoard?: Maybe<NoticeBoard>;
  /** 学内掲示板一覧を取得 */
  noticeBoards: Array<NoticeBoard>;
  /** 通知一覧を取得 */
  notifications: Array<Notification>;
  /** オファー情報を取得 */
  offer?: Maybe<Offer>;
  /** オファー一覧を取得 */
  offers: Array<Offer>;
  /** ページングでみんなのポートフォリオ一覧を取得 */
  paginationEveryonesPortfolios: PaginationEveryonesPortfolios;
  /** カーソルベースのページングにて注目記事を取得 */
  paginationFeeds: PaginationFeeds;
  /** カーソルベースのページングにて先輩一覧を取得 */
  paginationGraduateMembers: PaginationCorporationMembers;
  /** カーソルベースのページングにて企業実習一覧を取得 */
  paginationInternships: PaginationCorporationEventInternships;
  /** カーソルベースのページングにて募集情報一覧を取得 */
  paginationJobs: PaginationJobs;
  /** カーソルベースのページングにてメッセージを取得 */
  paginationMessages?: Maybe<MessageConnection>;
  /** カーソルベースのページングにて探求テーマを取得 */
  paginationResearchThemes: PaginationResearchThemes;
  /** カーソルベースのページングにて説明会一覧を取得 */
  paginationSeminars: PaginationCorporationEvents;
  /** カーソルベースのページングにて先輩記事一覧を取得 */
  paginationVoiceBoards: PaginationSeniorArticles;
  /** 事務局ピックアップ企業を取得 */
  pickupCorporations?: Maybe<Array<Corporation>>;
  /** ピックアップ記事を取得 */
  pickupFeeds: PickupPosts;
  /** ピックアップ募集情報一覧を取得 */
  pickupJobs: Array<Job>;
  /** ポートフォリオを取得 */
  portfolio?: Maybe<Portfolio>;
  /** ポートフォリオ一覧を取得 */
  portfolios: Array<Portfolio>;
  /** 都道府県ごとの市区町村を取得 */
  prefectureCities: Array<CityGroup>;
  /** 探求テーマを取得 */
  researchTheme?: Maybe<ResearchTheme>;
  /** 探究テーマカテゴリー一覧を取得 */
  researchThemeCategories: Array<ResearchThemeCategory>;
  /** 探究テーマカテゴリーを取得 */
  researchThemeCategory?: Maybe<ResearchThemeCategory>;
  /** 探求テーマを取得 */
  researchThemes: Array<ResearchTheme>;
  /** 履歴書を取得 */
  resume?: Maybe<Scalars['String']>;
  /** 履歴書アクセス数を取得 */
  resumeAccessLog?: Maybe<Array<ChartPoint>>;
  /** 指定期間内の履歴書アクセス数を取得 */
  resumeAccessLogBetweenDates?: Maybe<Array<ChartPoint>>;
  /** 履歴書の完成率を測るための項目を取得 */
  resumeCompleteStatus?: Maybe<ResumeCompleteStatus>;
  /** 学校情報を取得 */
  school?: Maybe<School>;
  /** 学校情報を学校コードから取得 */
  schoolByCode?: Maybe<School>;
  /** 学校一覧を取得 */
  schools?: Maybe<Array<School>>;
  /** 説明会情報を取得 */
  seminar?: Maybe<CorporationEvent>;
  /** 説明会情報を開催日IDから取得 */
  seminarByDateId?: Maybe<CorporationEvent>;
  /** 説明会一覧を取得 */
  seminars: Array<CorporationEvent>;
  /** ソーシャル連携の一覧を取得 */
  socialLinks?: Maybe<Array<SocialLink>>;
  /** ユーザー情報を取得 */
  user?: Maybe<User>;
  /** 新着があるかどうかを取得 */
  userNotice: BadgeNotice;
  /** 新着数を取得 */
  userNoticeCount?: Maybe<UserNoticeCount>;
  /** 掲載可能な企業情報を取得 */
  validcorporation?: Maybe<Corporation>;
  /** 先輩の声詳細 */
  voiceBoard?: Maybe<SeniorArticle>;
  /** 先輩の声一覧 */
  voiceBoards: Array<SeniorArticle>;
  /** 先輩の声一覧 */
  voiceBoardsAsVoice: Array<SeniorArticle>;
};


export type QueryActivitiesArgs = {
  activityId?: InputMaybe<Scalars['Int']>;
};


export type QueryActivityArgs = {
  id: Scalars['Int'];
};


export type QueryActivityCorporationArgs = {
  activityId: Scalars['Int'];
};


export type QueryAddressFromPostalCodeArgs = {
  postalCode: Scalars['String'];
};


export type QueryAppInfoArgs = {
  deviceToken: Scalars['String'];
  deviceType?: InputMaybe<Scalars['String']>;
};


export type QueryCategoriesArgs = {
  schoolId?: InputMaybe<Scalars['Int']>;
};


export type QueryCategoryNamesArgs = {
  categoryCodes: Array<Scalars['String']>;
};


export type QueryCityNamesArgs = {
  cityCodes: Array<Scalars['String']>;
  separator?: InputMaybe<Scalars['String']>;
};


export type QueryConfirmationAccountArgs = {
  confirmationToken: Scalars['String'];
};


export type QueryCorporationArgs = {
  id: Scalars['Int'];
};


export type QueryCorporationFavoriteLogBetweenDatesArgs = {
  from: Scalars['ISO8601Date'];
  to: Scalars['ISO8601Date'];
};


export type QueryCorporationMemberArgs = {
  id: Scalars['Int'];
};


export type QueryCorporationTypeNamesArgs = {
  corporationTypeCodes: Array<Scalars['String']>;
};


export type QueryCorporationTypesArgs = {
  schoolId?: InputMaybe<Scalars['Int']>;
};


export type QueryCorporationYouthEmploymentInfoArgs = {
  corporationId: Scalars['Int'];
};


export type QueryDiagnosisArgs = {
  id?: InputMaybe<Scalars['Int']>;
  other?: InputMaybe<Scalars['Boolean']>;
  requestId?: InputMaybe<Scalars['String']>;
};


export type QueryDownloadArgs = {
  id: Scalars['String'];
  type: FileType;
};


export type QueryEveryonesPortfolioArgs = {
  id: Scalars['Int'];
};


export type QueryFeedArgs = {
  id: Scalars['Int'];
};


export type QueryFeedCategoryArgs = {
  id: Scalars['Int'];
};


export type QueryFeedHashtagsArgs = {
  tagType?: InputMaybe<Scalars['Int']>;
};


export type QueryFeedsArgs = {
  conditions?: InputMaybe<SearchFeedInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAnalyzeArgs = {
  keyword: Scalars['String'];
};


export type QueryGetTotalJobCountArgs = {
  conditions?: InputMaybe<SearchJobInput>;
};


export type QueryGroupIndustriesArgs = {
  schoolId?: InputMaybe<Scalars['Int']>;
};


export type QueryIndustriesArgs = {
  schoolId?: InputMaybe<Scalars['Int']>;
};


export type QueryIndustryCategoriesArgs = {
  industryCodes: Array<Scalars['String']>;
  schoolId?: InputMaybe<Scalars['Int']>;
};


export type QueryIndustryNamesArgs = {
  industryCodes: Array<Scalars['String']>;
};


export type QueryInternshipArgs = {
  id: Scalars['Int'];
  isEntry?: InputMaybe<Scalars['Boolean']>;
};


export type QueryInternshipsArgs = {
  conditions?: InputMaybe<SearchEventInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryJobArgs = {
  id: Scalars['Int'];
  isEntry?: InputMaybe<Scalars['Boolean']>;
  isFree?: InputMaybe<Scalars['Boolean']>;
};


export type QueryJobFeatureNamesArgs = {
  jobFeatureCodes: Array<Scalars['String']>;
};


export type QueryJobsArgs = {
  conditions?: InputMaybe<SearchJobInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryLicenseArgs = {
  id: Scalars['Int'];
};


export type QueryMessageRoomArgs = {
  roomId: Scalars['Int'];
};


export type QueryMessagesArgs = {
  cursor?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  roomId: Scalars['Int'];
};


export type QueryNeedMoreArgs = {
  id: Scalars['Int'];
  isEntry?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNewsDetailArgs = {
  id: Scalars['Int'];
  smApp: Scalars['Boolean'];
};


export type QueryNewsListArgs = {
  smApp?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNoticeBoardArgs = {
  id: Scalars['Int'];
};


export type QueryOfferArgs = {
  id: Scalars['Int'];
};


export type QueryOffersArgs = {
  conditions?: InputMaybe<SearchOfferInput>;
};


export type QueryPaginationEveryonesPortfoliosArgs = {
  conditions?: InputMaybe<SearchEveryonesPortfolioInput>;
  isGetAggregate?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginationFeedsArgs = {
  conditions?: InputMaybe<SearchFeedInput>;
  isGetAggregate?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginationGraduateMembersArgs = {
  conditions?: InputMaybe<SearchGraduateMemberInput>;
  isGetAggregate?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginationInternshipsArgs = {
  conditions?: InputMaybe<SearchEventInput>;
  isGetAggregate?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginationJobsArgs = {
  conditions?: InputMaybe<SearchJobInput>;
  isDevMode?: InputMaybe<Scalars['Boolean']>;
  isGetAggregate?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginationMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  roomId: Scalars['Int'];
};


export type QueryPaginationResearchThemesArgs = {
  conditions?: InputMaybe<SearchResearchThemeInput>;
  isGetAggregate?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginationSeminarsArgs = {
  conditions?: InputMaybe<SearchEventInput>;
  isGetAggregate?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginationVoiceBoardsArgs = {
  isGetAggregate?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryPickupJobsArgs = {
  conditions?: InputMaybe<SearchJobInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryPortfolioArgs = {
  id: Scalars['Int'];
};


export type QueryPrefectureCitiesArgs = {
  prefectureCodes: Array<Scalars['String']>;
};


export type QueryResearchThemeArgs = {
  id: Scalars['Int'];
};


export type QueryResearchThemeCategoryArgs = {
  id: Scalars['Int'];
};


export type QueryResearchThemesArgs = {
  conditions?: InputMaybe<SearchResearchThemeInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryResumeAccessLogBetweenDatesArgs = {
  from: Scalars['ISO8601Date'];
  to: Scalars['ISO8601Date'];
};


export type QuerySchoolArgs = {
  id: Scalars['Int'];
};


export type QuerySchoolByCodeArgs = {
  code: Scalars['String'];
};


export type QuerySchoolsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  schoolType?: InputMaybe<SchoolType>;
};


export type QuerySeminarArgs = {
  id: Scalars['Int'];
  isEntry?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySeminarByDateIdArgs = {
  dateId: Scalars['Int'];
  isEntry?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySeminarsArgs = {
  conditions?: InputMaybe<SearchEventInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryUserArgs = {
  withLogin?: InputMaybe<Scalars['Boolean']>;
};


export type QueryValidcorporationArgs = {
  id: Scalars['Int'];
};


export type QueryVoiceBoardArgs = {
  id: Scalars['Int'];
};


export type QueryVoiceBoardsAsVoiceArgs = {
  id: Scalars['Int'];
};

/** Autogenerated input type of RegisterDeviceToken */
export type RegisterDeviceTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
  type: Scalars['String'];
};

/** Autogenerated return type of RegisterDeviceToken */
export type RegisterDeviceTokenPayload = {
  __typename?: 'RegisterDeviceTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of RegisterUser */
export type RegisterUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UserInput>;
};

/** Autogenerated return type of RegisterUser */
export type RegisterUserPayload = {
  __typename?: 'RegisterUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of RejectOffer */
export type RejectOfferInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  offerId: Scalars['Int'];
};

/** Autogenerated return type of RejectOffer */
export type RejectOfferPayload = {
  __typename?: 'RejectOfferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  offer?: Maybe<Offer>;
};

/** Autogenerated input type of RequestDiagnosis */
export type RequestDiagnosisInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Autogenerated return type of RequestDiagnosis */
export type RequestDiagnosisPayload = {
  __typename?: 'RequestDiagnosisPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['Boolean']>;
};

export type ResearchTheme = {
  __typename?: 'ResearchTheme';
  /** 承認日 */
  approvedAt?: Maybe<Scalars['ISO8601Date']>;
  /** 記者ID */
  authorId?: Maybe<Scalars['Int']>;
  /** カテゴリー */
  categories?: Maybe<Array<ResearchThemeCategory>>;
  /** エディタ本文 */
  content?: Maybe<Scalars['String']>;
  /** 企業情報 */
  corporation?: Maybe<Corporation>;
  /** カバー画像URL */
  coverImageUrl?: Maybe<Scalars['String']>;
  /** カバータイプ */
  coverType?: Maybe<Scalars['String']>;
  /** カバー動画ID */
  coverVideoId?: Maybe<Scalars['String']>;
  /** カバー動画URL */
  coverVideoUrl?: Maybe<Scalars['String']>;
  /** 作成日時 */
  createdAt?: Maybe<Scalars['ISO8601Date']>;
  /** タグ */
  hashtags?: Maybe<Array<Hashtag>>;
  /** id */
  id: Scalars['Int'];
  /** いいね済みか */
  like?: Maybe<Scalars['Boolean']>;
  /** いいね数 */
  likeCount?: Maybe<Scalars['Int']>;
  /** 作成元ID */
  ownerId?: Maybe<Scalars['Int']>;
  /** 作成者名 */
  ownerName?: Maybe<Scalars['String']>;
  /** 作成元タイプ */
  ownerType?: Maybe<Scalars['String']>;
  /** 探究テーマを元に作成されたポートフォリオ */
  portfolios?: Maybe<Array<Portfolio>>;
  /** リッチエディタ情報 */
  richContent?: Maybe<RichContent>;
  /** 学校情報 */
  school?: Maybe<School>;
  /** 公開状態 */
  status?: Maybe<ResearchThemeStatusEnum>;
  /** 公開状態ラベル */
  statusLabel?: Maybe<Scalars['String']>;
  /** タイトル */
  title?: Maybe<Scalars['String']>;
  /** 更新日時 */
  updatedAt?: Maybe<Scalars['ISO8601Date']>;
};

export type ResearchThemeCategory = {
  __typename?: 'ResearchThemeCategory';
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastPostedAt?: Maybe<Scalars['ISO8601Date']>;
  name: Scalars['String'];
  researchThemeCount?: Maybe<Scalars['Int']>;
};

export enum ResearchThemeSortType {
  /** 新着 */
  Latest = 'latest',
  /** 人気 */
  Popular = 'popular'
}

export enum ResearchThemeStatusEnum {
  /** 非公開 */
  Disable = 'disable',
  /** 下書き */
  Draft = 'draft',
  /** 有効 */
  Enable = 'enable',
  /** 修正依頼 */
  RevisionRequest = 'revision_request',
  /** 正常登録されなかったデータ */
  Temp = 'temp'
}

export type ResumeCompleteStatus = {
  __typename?: 'ResumeCompleteStatus';
  condition: Scalars['Boolean'];
  diagnosis: Scalars['Boolean'];
  diagnosisOfOthers: Scalars['Boolean'];
  portfolio: Scalars['Boolean'];
  pr: Scalars['Boolean'];
  profile: Scalars['Boolean'];
};

export enum ReviewStatus {
  /** レビューする */
  ReviewAccept = 'review_accept',
  /** 初期状態 */
  ReviewNone = 'review_none',
  /** また後で */
  ReviewPending = 'review_pending',
  /** レビューしない */
  ReviewReject = 'review_reject',
  /** レビュー依頼表示 */
  ReviewRequest = 'review_request'
}

export type RichContent = {
  __typename?: 'RichContent';
  /** エディタ本文 */
  content?: Maybe<Scalars['String']>;
  /** エディタ本文テキスト */
  contentPlainText?: Maybe<Scalars['String']>;
  /** 作成日時 */
  createdAt?: Maybe<Scalars['ISO8601Date']>;
  /** ID */
  id?: Maybe<Scalars['Int']>;
  /** 名前 */
  name?: Maybe<Scalars['String']>;
  /** レコードID */
  recordId?: Maybe<Scalars['Int']>;
  /** レコードタイプ */
  recordType?: Maybe<Scalars['Int']>;
  /** リッチエディタファイル情報 */
  richContentFiles?: Maybe<Array<RichContentFile>>;
  /** 更新日時 */
  updatedAt?: Maybe<Scalars['ISO8601Date']>;
};

export type RichContentFile = {
  __typename?: 'RichContentFile';
  /** 作成日時 */
  createdAt?: Maybe<Scalars['ISO8601Date']>;
  /** コンテントタイプ */
  fileContentType?: Maybe<Scalars['String']>;
  /** ファイル名 */
  fileFileName?: Maybe<Scalars['String']>;
  /** ファイルサイズ */
  fileFileSize?: Maybe<Scalars['String']>;
  /** ファイルアップロード日時 */
  fileUpdatedAt?: Maybe<Scalars['ISO8601Date']>;
  /** ID */
  id?: Maybe<Scalars['Int']>;
  /** リッチコンテントID */
  richContentId?: Maybe<Scalars['Int']>;
  /** 更新日時 */
  updatedAt?: Maybe<Scalars['ISO8601Date']>;
  /** ファイルURL */
  url?: Maybe<Scalars['String']>;
  /** uuid */
  uuid?: Maybe<Scalars['String']>;
};

export type RichContentInput = {
  /** リッチコンテント本文 */
  content?: InputMaybe<Scalars['JSON']>;
};

export type School = {
  __typename?: 'School';
  activityAdditions?: Maybe<Array<SchoolActivityAddition>>;
  activityStatuses?: Maybe<Array<SchoolActivityStatus>>;
  /** 業務委託の受付状態 */
  allowOutsourcing?: Maybe<Scalars['Boolean']>;
  allowPartTime?: Maybe<Scalars['Boolean']>;
  /** 企業訪問の応募設定 */
  companyVisitEntryType?: Maybe<CompanyVisitEntry>;
  courses?: Maybe<Array<SchoolCourse>>;
  groupName?: Maybe<Scalars['String']>;
  groupSchools?: Maybe<Array<School>>;
  id: Scalars['Int'];
  isBasicPlanOrMore?: Maybe<Scalars['Boolean']>;
  jobHuntingStatuses?: Maybe<Array<JobHuntingStatus>>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  official?: Maybe<Scalars['Boolean']>;
  plan?: Maybe<SchoolPlan>;
  schoolNumber?: Maybe<Scalars['String']>;
  schoolType?: Maybe<SchoolType>;
  teachers?: Maybe<Array<SchoolTeacher>>;
  useCertificate?: Maybe<Scalars['Boolean']>;
};

export type SchoolActivityAddition = {
  __typename?: 'SchoolActivityAddition';
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  itemType: AdditionItemType;
  items?: Maybe<Array<SchoolActivityAdditionItem>>;
  maxLength?: Maybe<Scalars['Int']>;
  require: Scalars['Boolean'];
  title: Scalars['String'];
  useTime?: Maybe<Scalars['Boolean']>;
};

export type SchoolActivityAdditionItem = {
  __typename?: 'SchoolActivityAdditionItem';
  id: Scalars['Int'];
  label: Scalars['String'];
  value: Scalars['String'];
};

export type SchoolActivityStatus = {
  __typename?: 'SchoolActivityStatus';
  defaultValue?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  label: Scalars['String'];
  value: Scalars['String'];
};

export type SchoolBackground = {
  __typename?: 'SchoolBackground';
  /** 学科・コース名 */
  courseName?: Maybe<Scalars['String']>;
  /** 入学月 */
  enrollmentMonth?: Maybe<Scalars['Int']>;
  /** 入学年 */
  enrollmentYear?: Maybe<Scalars['Int']>;
  /** 卒業月 */
  graduationMonth?: Maybe<Scalars['Int']>;
  /** 卒業ステータス */
  graduationStatus?: Maybe<GraduationStatus>;
  /** 卒業年 */
  graduationYear?: Maybe<Scalars['Int']>;
  /** ID */
  id: Scalars['Int'];
  /** 学校ID */
  schoolId?: Maybe<Scalars['Int']>;
  /** 学校名 */
  schoolName?: Maybe<Scalars['String']>;
  /** 学校タイプ */
  schoolType?: Maybe<SchoolType>;
};

export type SchoolBackgroundInput = {
  /** 学科・コース名 */
  courseName?: InputMaybe<Scalars['String']>;
  /** 入学月 */
  enrollmentMonth: Scalars['Int'];
  /** 入学年 */
  enrollmentYear: Scalars['Int'];
  /** 卒業月 */
  graduationMonth: Scalars['Int'];
  /** 卒業ステータス */
  graduationStatus: GraduationStatus;
  /** 卒業年 */
  graduationYear: Scalars['Int'];
  /** ID */
  id?: InputMaybe<Scalars['Int']>;
  /** 学校ID */
  schoolId: Scalars['Int'];
  /** 学校名 */
  schoolName?: InputMaybe<Scalars['String']>;
  /** 学校区分 */
  schoolType: SchoolType;
};

export type SchoolCourse = {
  __typename?: 'SchoolCourse';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum SchoolPlan {
  /** ベーシックプラン */
  Basic = 'basic',
  /** マスタープラン */
  Master = 'master',
  /** プラン未登録 */
  None = 'none',
  /** スタートプラン */
  Start = 'start'
}

export type SchoolTeacher = {
  __typename?: 'SchoolTeacher';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum SchoolType {
  /** 大学 */
  College = 'college',
  /** 大学院 */
  GraduateSchool = 'graduate_school',
  /** 高等学校・高等専修学校 */
  HighSchool = 'high_school',
  /** 短期大学 */
  JuniorCollege = 'junior_college',
  /** その他の学校（海外含む） */
  Other = 'other',
  /** 特別支援学校 */
  SpecialSupportSchool = 'special_support_school',
  /** - */
  Undefined = 'undefined',
  /** 専門学校・高等専門学校 */
  VocationalSchool = 'vocational_school'
}

export type SearchEventInput = {
  /** 企業ID */
  corporationId?: InputMaybe<Scalars['Int']>;
  /** 企業のタイプ */
  corporationTypes?: InputMaybe<Array<Scalars['String']>>;
  /** 開始日付 */
  from?: InputMaybe<Scalars['ISO8601Date']>;
  /** 業種 */
  industryCodes?: InputMaybe<Array<Scalars['String']>>;
  /** 求人票ID */
  jobId?: InputMaybe<Scalars['Int']>;
  /** フリーワード */
  keyword?: InputMaybe<Scalars['String']>;
  /** 開催地 */
  prefectures?: InputMaybe<Array<Scalars['String']>>;
  /** 並び順 */
  sort?: InputMaybe<EventSort>;
  /** 並び順 */
  sortDirection?: InputMaybe<SortDirection>;
  /** 終了日付 */
  to?: InputMaybe<Scalars['ISO8601Date']>;
  /** 締切日検索 */
  useClosingDate?: InputMaybe<Scalars['Boolean']>;
};

export type SearchEveryonesPortfolioInput = {
  /** キーワード */
  keyword?: InputMaybe<Scalars['String']>;
  /** 同じ学校のみ */
  onlySameSchool?: InputMaybe<Scalars['Boolean']>;
};

export type SearchFeedInput = {
  /** カテゴリーID */
  categoryId?: InputMaybe<Scalars['Int']>;
  /** 認定 */
  certificate?: InputMaybe<Scalars['String']>;
  /** 企業ID */
  corporationId?: InputMaybe<Scalars['Int']>;
  /** タグID */
  hashtagId?: InputMaybe<Scalars['Int']>;
  /** キーワード */
  keyword?: InputMaybe<Scalars['String']>;
  /** 並び順 */
  sortType?: InputMaybe<FeedSortType>;
};

export type SearchGraduateMemberInput = {
  /** キーワード */
  keyword?: InputMaybe<Scalars['String']>;
  /** 同じ学校の先輩のみ */
  onlySameSchool?: InputMaybe<Scalars['Boolean']>;
};

export type SearchJobInput = {
  /** 職種 */
  categoryCodes?: InputMaybe<Array<Scalars['String']>>;
  /** 市区町村 */
  cities?: InputMaybe<Array<Scalars['String']>>;
  /** 企業ID */
  corporationId?: InputMaybe<Scalars['Int']>;
  /** 企業のタイプ */
  corporationTypes?: InputMaybe<Array<Scalars['String']>>;
  /** 雇用形態 */
  employmentCodes?: InputMaybe<Array<Scalars['String']>>;
  /** 業種 */
  industryCodes?: InputMaybe<Array<Scalars['String']>>;
  /** 募集の特徴 */
  jobFeatures?: InputMaybe<Array<Scalars['String']>>;
  /** 求人票番号 */
  jobNo?: InputMaybe<Scalars['String']>;
  /** フリーワード */
  keyword?: InputMaybe<Scalars['String']>;
  /** 新着のみ */
  newArrival?: InputMaybe<Scalars['Boolean']>;
  /** 新着開始日時 */
  newArrivalFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** 都道府県 */
  prefectures?: InputMaybe<Array<Scalars['String']>>;
  /** グループ学校ID */
  schoolIds?: InputMaybe<Array<Scalars['Int']>>;
  /** 上級生の求人票 */
  showSeniorJob?: InputMaybe<Scalars['Boolean']>;
  /** 並び順 */
  sort?: InputMaybe<JobSort>;
  /** 並び順 */
  sortDirection?: InputMaybe<SortDirection>;
};

export type SearchOfferInput = {
  /** オファー送信日時（開始） */
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** 未確認のオファーのみ */
  unchecked?: InputMaybe<Scalars['Boolean']>;
};

export type SearchResearchThemeInput = {
  /** タグID */
  hashtagId?: InputMaybe<Scalars['Int']>;
  /** キーワード */
  keyword?: InputMaybe<Scalars['String']>;
  /** カテゴリーID */
  researchThemeCategoryId?: InputMaybe<Scalars['Int']>;
  /** 並び順 */
  sortType?: InputMaybe<ResearchThemeSortType>;
};

export type SeminarEntryInput = {
  /** 追加質問 */
  additions?: InputMaybe<Array<EntryAdditionInput>>;
  /** 入社試験日付ID */
  examDateId?: InputMaybe<Scalars['Int']>;
  /** 入社試験ID */
  examId?: InputMaybe<Scalars['Int']>;
  /** 入社試験時間帯ID */
  examTimeId?: InputMaybe<Scalars['Int']>;
  /** 公開資格・作品ID */
  licenseIds?: InputMaybe<Array<Scalars['Int']>>;
  /** 志望動機やご質問など */
  memo?: InputMaybe<Scalars['String']>;
  /** 公開するポートフォリオID */
  portfolioIds?: InputMaybe<Array<Scalars['Int']>>;
  /** 公開する自己PR */
  prIds?: InputMaybe<Array<Scalars['Int']>>;
  /** 説明会日付ID */
  seminarDateId: Scalars['Int'];
  /** 説明会ID */
  seminarId: Scalars['Int'];
  /** 説明会時間帯ID */
  seminarTimeId: Scalars['Int'];
};

/** Autogenerated input type of SendMessage */
export type SendMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  messageInput: SendMessagesInput;
};

/** Autogenerated return type of SendMessage */
export type SendMessagePayload = {
  __typename?: 'SendMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Message>;
};

export type SendMessagesInput = {
  /** メッセージ本文 */
  content?: InputMaybe<Scalars['String']>;
  /** 添付ファイル */
  files?: InputMaybe<Array<FileInput>>;
  /** メッセージルームID */
  roomId: Scalars['Int'];
};

export type SeniorArticle = {
  __typename?: 'SeniorArticle';
  content: Scalars['String'];
  contentSummary: Scalars['String'];
  contributor: Scalars['String'];
  corporationName?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601Date'];
  /** 入社月 */
  enteringMonth?: Maybe<Scalars['String']>;
  /** 入社年 */
  enteringYear?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** 画像URL */
  imageUrl?: Maybe<Scalars['String']>;
  /** 社員名 */
  name: Scalars['String'];
  /** 社員名カナ */
  nameKana: Scalars['String'];
  /** 勤務先 */
  office?: Maybe<Scalars['String']>;
  /** 役職 */
  position?: Maybe<Scalars['String']>;
  schoolCourse?: Maybe<Scalars['String']>;
  /** 卒業学校ID */
  schoolId?: Maybe<Scalars['String']>;
  /** 卒業学校名 */
  schoolName?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601Date'];
};

export type SisterJobInfo = {
  __typename?: 'SisterJobInfo';
  /** 求人先姉妹校 */
  sisterSchoolName: Scalars['String'];
  /** 姉妹校表示フラグ */
  sisterSchoolNameVisible: Scalars['Boolean'];
};

export type SocialLink = {
  __typename?: 'SocialLink';
  linked: Scalars['Boolean'];
  provider: SocialProvider;
};

export enum SocialProvider {
  /** Apple */
  Apple = 'apple',
  /** Google */
  Google = 'google',
  /** Microsoft */
  Microsoft = 'microsoft'
}

export enum SortDirection {
  /** 昇順 */
  Ascending = 'ascending',
  /** 降順 */
  Descending = 'descending'
}

export type Subscription = {
  __typename?: 'Subscription';
  /** 相手がメッセージを送るとメッセージ全件を取得する */
  newMessage: MessageConnection;
  /** 通知が増えると未読かどうかを取得する */
  newNotice: NewNotice;
};


export type SubscriptionNewMessageArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  messageRoomId: Scalars['Int'];
};


export type SubscriptionNewNoticeArgs = {
  userId: Scalars['Int'];
};

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['Int'];
  label: Scalars['String'];
  url: Scalars['String'];
};

export enum TagType {
  /** 特別授業 */
  Articles = 'articles',
  /** 職場見学 */
  Corporation = 'corporation',
  /** 研究テーマ */
  ResearchTheme = 'research_theme'
}

/** Autogenerated input type of ToggleAnonymousLike */
export type ToggleAnonymousLikeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  type?: InputMaybe<LikeType>;
  userId: Scalars['String'];
};

/** Autogenerated return type of ToggleAnonymousLike */
export type ToggleAnonymousLikePayload = {
  __typename?: 'ToggleAnonymousLikePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  like?: Maybe<AnonymousLike>;
};

/** Autogenerated input type of ToggleBookmark */
export type ToggleBookmarkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  type: BookmarkType;
};

/** Autogenerated return type of ToggleBookmark */
export type ToggleBookmarkPayload = {
  __typename?: 'ToggleBookmarkPayload';
  bookmark?: Maybe<Bookmark>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ToggleLike */
export type ToggleLikeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<LikeType>;
};

/** Autogenerated return type of ToggleLike */
export type ToggleLikePayload = {
  __typename?: 'ToggleLikePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  like?: Maybe<Like>;
};

/** Autogenerated input type of UpdateActivity */
export type UpdateActivityInput = {
  activity?: InputMaybe<ActivityInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateActivity */
export type UpdateActivityPayload = {
  __typename?: 'UpdateActivityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateConditions */
export type UpdateConditionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<UserConditionsInput>;
};

/** Autogenerated return type of UpdateConditions */
export type UpdateConditionsPayload = {
  __typename?: 'UpdateConditionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  condition?: Maybe<UserCondition>;
  error?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateCurrentMessage */
export type UpdateCurrentMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  messageId?: InputMaybe<Scalars['Int']>;
  roomId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of UpdateCurrentMessage */
export type UpdateCurrentMessagePayload = {
  __typename?: 'UpdateCurrentMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  room?: Maybe<MessageRoom>;
};

/** Autogenerated input type of UpdatePortfolio */
export type UpdatePortfolioInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  portfolio?: InputMaybe<PortfolioInput>;
};

/** Autogenerated return type of UpdatePortfolio */
export type UpdatePortfolioPayload = {
  __typename?: 'UpdatePortfolioPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  portfolio?: Maybe<Portfolio>;
};

/** Autogenerated input type of UpdatePrText */
export type UpdatePrTextInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  pr?: InputMaybe<PrTextInput>;
};

/** Autogenerated return type of UpdatePrText */
export type UpdatePrTextPayload = {
  __typename?: 'UpdatePrTextPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UpdateProfile */
export type UpdateProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<ProfileInput>;
};

/** Autogenerated return type of UpdateProfile */
export type UpdateProfilePayload = {
  __typename?: 'UpdateProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UpdateProfileStatus */
export type UpdateProfileStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of UpdateProfileStatus */
export type UpdateProfileStatusPayload = {
  __typename?: 'UpdateProfileStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UpdateReviewStatus */
export type UpdateReviewStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deviceToken: Scalars['String'];
  deviceType?: InputMaybe<Scalars['String']>;
  reviewStatus: ReviewStatus;
};

/** Autogenerated return type of UpdateReviewStatus */
export type UpdateReviewStatusPayload = {
  __typename?: 'UpdateReviewStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UpdateUserdataAvatar */
export type UpdateUserdataAvatarInput = {
  /** アバター更新用の入力 */
  avatar: UserdataAvatarInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateUserdataAvatar */
export type UpdateUserdataAvatarPayload = {
  __typename?: 'UpdateUserdataAvatarPayload';
  /** 更新されたアバター情報 */
  avatar?: Maybe<UserdataAvatar>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** エラーメッセージ */
  error?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UploadRichContentFile */
export type UploadRichContentFileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  file: FileInput;
};

/** Autogenerated return type of UploadRichContentFile */
export type UploadRichContentFilePayload = {
  __typename?: 'UploadRichContentFilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  richContentFile?: Maybe<RichContentFile>;
};

export type User = {
  __typename?: 'User';
  /** 志望条件 */
  condition: UserCondition;
  /** メールアドレス */
  email: Scalars['String'];
  /** メール通知 */
  emailNotification: Scalars['Boolean'];
  /** ID */
  id: Scalars['Int'];
  /** 就活状況ステータス */
  jobHuntingStatus: Scalars['Int'];
  /** 就活状況ステータスラベル */
  jobHuntingStatusLabel: Scalars['String'];
  /** プロフィール */
  profile: UserProfile;
  /** プッシュ通知 */
  pushNotification: Scalars['Boolean'];
  /** 学校 */
  school: School;
};

export type UserCondition = {
  __typename?: 'UserCondition';
  category1?: Maybe<Scalars['String']>;
  category1Code?: Maybe<Scalars['String']>;
  category2?: Maybe<Scalars['String']>;
  category2Code?: Maybe<Scalars['String']>;
  category3?: Maybe<Scalars['String']>;
  category3Code?: Maybe<Scalars['String']>;
  corporationType1?: Maybe<Scalars['String']>;
  corporationType1Code?: Maybe<Scalars['String']>;
  corporationType2?: Maybe<Scalars['String']>;
  corporationType2Code?: Maybe<Scalars['String']>;
  corporationType3?: Maybe<Scalars['String']>;
  corporationType3Code?: Maybe<Scalars['String']>;
  holiday0?: Maybe<Scalars['Boolean']>;
  holiday1?: Maybe<Scalars['Boolean']>;
  holiday2?: Maybe<Scalars['Boolean']>;
  holiday3?: Maybe<Scalars['Boolean']>;
  holiday4?: Maybe<Scalars['Boolean']>;
  holiday5?: Maybe<Scalars['Boolean']>;
  holiday6?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  industry1?: Maybe<Scalars['String']>;
  industry1Code?: Maybe<Scalars['String']>;
  industry2?: Maybe<Scalars['String']>;
  industry2Code?: Maybe<Scalars['String']>;
  industry3?: Maybe<Scalars['String']>;
  industry3Code?: Maybe<Scalars['String']>;
  jobFeature1?: Maybe<Scalars['String']>;
  jobFeature1Code?: Maybe<Scalars['String']>;
  jobFeature2?: Maybe<Scalars['String']>;
  jobFeature2Code?: Maybe<Scalars['String']>;
  jobFeature3?: Maybe<Scalars['String']>;
  jobFeature3Code?: Maybe<Scalars['String']>;
  location1?: Maybe<Scalars['String']>;
  location1Code?: Maybe<Scalars['String']>;
  location2?: Maybe<Scalars['String']>;
  location2Code?: Maybe<Scalars['String']>;
  location3?: Maybe<Scalars['String']>;
  location3Code?: Maybe<Scalars['String']>;
  monthlyIncome?: Maybe<Scalars['Int']>;
  workEndTime?: Maybe<Scalars['ISO8601DateTime']>;
  workStartTime?: Maybe<Scalars['ISO8601DateTime']>;
};

export type UserConditionsInput = {
  /** 職種1 */
  categoryCode1?: InputMaybe<Scalars['String']>;
  /** 職種2 */
  categoryCode2?: InputMaybe<Scalars['String']>;
  /** 職種3 */
  categoryCode3?: InputMaybe<Scalars['String']>;
  /** 企業のタイプ1 */
  corporationType1?: InputMaybe<Scalars['String']>;
  /** 企業のタイプ2 */
  corporationType2?: InputMaybe<Scalars['String']>;
  /** 企業のタイプ3 */
  corporationType3?: InputMaybe<Scalars['String']>;
  /** 希望休日（日） */
  holiday0?: InputMaybe<Scalars['Boolean']>;
  /** 希望休日（月） */
  holiday1?: InputMaybe<Scalars['Boolean']>;
  /** 希望休日（火） */
  holiday2?: InputMaybe<Scalars['Boolean']>;
  /** 希望休日（水） */
  holiday3?: InputMaybe<Scalars['Boolean']>;
  /** 希望休日（木） */
  holiday4?: InputMaybe<Scalars['Boolean']>;
  /** 希望休日（金） */
  holiday5?: InputMaybe<Scalars['Boolean']>;
  /** 希望休日（土） */
  holiday6?: InputMaybe<Scalars['Boolean']>;
  /** 業種1 */
  industryCode1?: InputMaybe<Scalars['String']>;
  /** 業種2 */
  industryCode2?: InputMaybe<Scalars['String']>;
  /** 業種3 */
  industryCode3?: InputMaybe<Scalars['String']>;
  /** 募集の特徴1 */
  jobFeature1?: InputMaybe<Scalars['String']>;
  /** 募集の特徴2 */
  jobFeature2?: InputMaybe<Scalars['String']>;
  /** 募集の特徴3 */
  jobFeature3?: InputMaybe<Scalars['String']>;
  /** 都道府県1 */
  location1?: InputMaybe<Scalars['String']>;
  /** 都道府県2 */
  location2?: InputMaybe<Scalars['String']>;
  /** 都道府県3 */
  location3?: InputMaybe<Scalars['String']>;
  /** 月収 */
  monthlyIncome?: InputMaybe<Scalars['Int']>;
  /** 希望勤務終了時刻 */
  workEndTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** 希望勤務開始時刻 */
  workStartTime?: InputMaybe<Scalars['ISO8601DateTime']>;
};

export type UserInput = {
  /** 番地移行 */
  address: Scalars['String'];
  /** 市区町村 */
  cityName: Scalars['String'];
  /** 学科・コース */
  courseId?: InputMaybe<Scalars['Int']>;
  /** 生年月日 */
  dateOfBirth: Scalars['ISO8601Date'];
  /** 入学月 */
  enrollmentMonth: Scalars['Int'];
  /** 入学年 */
  enrollmentYear: Scalars['Int'];
  /** 履歴書用写真 */
  file?: InputMaybe<FileInput>;
  /** 名 */
  firstName: Scalars['String'];
  /** メイ */
  firstNameKana: Scalars['String'];
  /** 性別 */
  gender?: InputMaybe<Scalars['Int']>;
  /** 卒業月 */
  graduationMonth: Scalars['Int'];
  /** 就学状況ステータス */
  graduationStatus: GraduationStatus;
  /** 卒業年 */
  graduationYear: Scalars['Int'];
  /** 就活状況 */
  jobHuntingStatus: Scalars['Int'];
  /** 姓 */
  lastName: Scalars['String'];
  /** セイ */
  lastNameKana: Scalars['String'];
  /** パスワード */
  password: Scalars['String'];
  /** 確認パスワード */
  passwordConfirmation: Scalars['String'];
  /** 郵便番号 */
  postalCode: Scalars['String'];
  /** 都道府県コード */
  prefectureCode: Scalars['String'];
  /** 学校ID */
  schoolId: Scalars['Int'];
  /** 学籍番号 */
  studentNo?: InputMaybe<Scalars['String']>;
  /** 電話番号 */
  tel: Scalars['String'];
  /** 認証トークン */
  token: Scalars['String'];
};

export type UserNoticeCount = {
  __typename?: 'UserNoticeCount';
  /** 新着注目記事数 */
  feed: Scalars['Int'];
  /** 新着求人数 */
  job: Scalars['Int'];
  /** 未読メッセージ数 */
  message: Scalars['Int'];
  /** 新着事務局お知らせ */
  news: Scalars['Int'];
  /** 未読学校掲示板数 */
  noticeBoard: Scalars['Int'];
  /** 未対応オファー数 */
  offer: Scalars['Int'];
};

export type UserProfile = {
  __typename?: 'UserProfile';
  /** 住所ふりがな */
  addressFurigana?: Maybe<Scalars['String']>;
  /** 以降の住所 */
  addressOther?: Maybe<Scalars['String']>;
  /** アバター情報 */
  avatar?: Maybe<UserdataAvatar>;
  /** 職歴 */
  careers?: Maybe<Array<Career>>;
  /** 市区町村 */
  cityName?: Maybe<Scalars['String']>;
  /** クラス名 */
  className?: Maybe<Scalars['String']>;
  /** 学部・学科ID */
  courseId?: Maybe<Scalars['Int']>;
  /** 学部・学科名 */
  courseName?: Maybe<Scalars['String']>;
  /** 登録日時 */
  createdAt?: Maybe<Scalars['ISO8601Date']>;
  /** 生年月日 */
  dateOfBirth?: Maybe<Scalars['ISO8601Date']>;
  /** 入学月 */
  enrollmentMonth?: Maybe<Scalars['Int']>;
  /** 入学年 */
  enrollmentYear?: Maybe<Scalars['Int']>;
  /** メイ */
  firstKana?: Maybe<Scalars['String']>;
  /** 名 */
  firstName?: Maybe<Scalars['String']>;
  /** 性別 */
  gender?: Maybe<Scalars['Int']>;
  /** 卒業月 */
  graduationMonth?: Maybe<Scalars['Int']>;
  /** 卒業状況 */
  graduationStatus?: Maybe<GraduationStatus>;
  /** 卒業年 */
  graduationYear?: Maybe<Scalars['Int']>;
  /** ID */
  id: Scalars['Int'];
  /** プロフィール画像URL */
  imageUrl?: Maybe<Scalars['String']>;
  /** 学校承認フラグ */
  isApproved?: Maybe<Scalars['Boolean']>;
  /** 履歴書公開フラグ */
  isPublic?: Maybe<Scalars['Boolean']>;
  /** セイ */
  lastKana?: Maybe<Scalars['String']>;
  /** 姓 */
  lastName?: Maybe<Scalars['String']>;
  /** 免許・資格 */
  licenses?: Maybe<Array<License>>;
  /** 郵便番号 */
  postalCode?: Maybe<Scalars['String']>;
  /** 自己PR本文1 */
  prContent1?: Maybe<Scalars['String']>;
  /** 自己PR本文2 */
  prContent2?: Maybe<Scalars['String']>;
  /** 自己PR本文3 */
  prContent3?: Maybe<Scalars['String']>;
  /** 自己PRタイトル1 */
  prTitle1?: Maybe<Scalars['String']>;
  /** 自己PRタイトル2 */
  prTitle2?: Maybe<Scalars['String']>;
  /** 自己PRタイトル3 */
  prTitle3?: Maybe<Scalars['String']>;
  /** 都道府県名 */
  prefecture?: Maybe<Scalars['String']>;
  /** 都道府県コード */
  prefectureCode?: Maybe<Scalars['String']>;
  /** 履歴書完成率 */
  resumeRate?: Maybe<Scalars['Int']>;
  /** 学歴 */
  schoolBackgrounds?: Maybe<Array<SchoolBackground>>;
  /** 学籍番号 */
  studentNo?: Maybe<Scalars['String']>;
  /** 担任ID */
  teacherId?: Maybe<Scalars['Int']>;
  /** 担任名 */
  teacherName?: Maybe<Scalars['String']>;
  /** 電話番号 */
  tel?: Maybe<Scalars['String']>;
  /** 更新日時 */
  updatedAt?: Maybe<Scalars['ISO8601Date']>;
};

/** ユーザータイプ（DBに値が存在する） */
export enum UserTypeEnum {
  /** 企業 */
  CorporationMaster = 'corporation_master',
  /** 学校 */
  SchoolMaster = 'school_master',
  /** 学生 */
  Student = 'student',
  /** 事務局 */
  SysAdmin = 'sys_admin'
}

export type UserdataAvatar = {
  __typename?: 'UserdataAvatar';
  /** アバター画像URL */
  avatarImageUrl?: Maybe<Scalars['String']>;
  /** アバター名 */
  avatarName?: Maybe<Scalars['String']>;
  /** ID */
  id: Scalars['Int'];
  /** ユーザーデータID */
  userdataId: Scalars['Int'];
};

/** アバター登録用の入力型 */
export type UserdataAvatarInput = {
  /** アバター画像 */
  avatarImage?: InputMaybe<FileInput>;
  /** アバター名 */
  avatarName?: InputMaybe<Scalars['String']>;
  /** アバターのプリセット画像のパス */
  avatarPresetPath?: InputMaybe<Scalars['String']>;
  /** ID */
  id?: InputMaybe<Scalars['Int']>;
  /** ユーザーデータID */
  userdataId: Scalars['Int'];
};

export type Video = {
  __typename?: 'Video';
  id: Scalars['Int'];
  videoId: Scalars['String'];
  videoTag?: Maybe<Scalars['String']>;
  videoType: Scalars['String'];
  videoUrl?: Maybe<Scalars['String']>;
};

/** 企業訪問情報 */
export type VisitReception = {
  __typename?: 'VisitReception';
  /** 事前連絡（要否） */
  visitReceptionRequired?: Maybe<Scalars['Boolean']>;
  /** 訪問可能時間（開始） */
  visitReceptionTimeFrom?: Maybe<Scalars['String']>;
  /** 訪問可能時間（終了） */
  visitReceptionTimeTo?: Maybe<Scalars['String']>;
  /** 訪問可能日（曜日） */
  visitReceptionWeekday?: Maybe<Array<Scalars['Boolean']>>;
};

/** 企業の職場定着情報 */
export type WorkplaceRetention = {
  __typename?: 'WorkplaceRetention';
  /** 月平均残業時間 */
  avgOvertimeHoursPerMonth?: Maybe<Scalars['Float']>;
  /** 年間有給取得日数 */
  avgPaidLeaveDays?: Maybe<Scalars['Float']>;
  /** 女性の出産数 */
  femaleNumberOfBirths?: Maybe<Scalars['Int']>;
  /** 女性育休取得者数 */
  femaleTakingChildcareLeave?: Maybe<Scalars['Int']>;
  /** 男性の子供の出生数 */
  maleNumberOfBirths?: Maybe<Scalars['Int']>;
  /** 男性育休取得者数 */
  maleTakingChildcareLeave?: Maybe<Scalars['Int']>;
  /** 対象年度 */
  targetFiscalYear?: Maybe<Scalars['Int']>;
};

export type ActivityAttributesFragment = { __typename?: 'Activity', id: number, content: string, statusCode: number, status: string, privacySetting: boolean, deletable: boolean, createdAt: any, updatedAt: any, file?: { __typename?: 'FileInfo', name: string, contentType: string, url: string } | null | undefined, activityAdditions?: Array<{ __typename?: 'ActivityAddition', schoolActivityAdditionId: number, itemType: AdditionItemType, value?: string | null | undefined, dateValue?: any | null | undefined, content?: Array<string> | null | undefined, title?: string | null | undefined, shouldUseTime?: boolean | null | undefined }> | null | undefined };

export type FindActivityQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FindActivityQuery = { __typename?: 'Query', activity?: { __typename?: 'Activity', id: number, content: string, statusCode: number, status: string, privacySetting: boolean, deletable: boolean, createdAt: any, updatedAt: any, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined, file?: { __typename?: 'FileInfo', name: string, contentType: string, url: string } | null | undefined, activityAdditions?: Array<{ __typename?: 'ActivityAddition', schoolActivityAdditionId: number, itemType: AdditionItemType, value?: string | null | undefined, dateValue?: any | null | undefined, content?: Array<string> | null | undefined, title?: string | null | undefined, shouldUseTime?: boolean | null | undefined }> | null | undefined } | null | undefined };

export type SearchActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchActivitiesQuery = { __typename?: 'Query', activities: Array<{ __typename?: 'Activity', id: number, content: string, statusCode: number, status: string, privacySetting: boolean, deletable: boolean, createdAt: any, updatedAt: any, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined, file?: { __typename?: 'FileInfo', name: string, contentType: string, url: string } | null | undefined, activityAdditions?: Array<{ __typename?: 'ActivityAddition', schoolActivityAdditionId: number, itemType: AdditionItemType, value?: string | null | undefined, dateValue?: any | null | undefined, content?: Array<string> | null | undefined, title?: string | null | undefined, shouldUseTime?: boolean | null | undefined }> | null | undefined }> };

export type SearchActivityCorporationsQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchActivityCorporationsQuery = { __typename?: 'Query', activityCorporations?: Array<{ __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined }> | null | undefined };

export type CorporationActivitiesQueryVariables = Exact<{
  activityId: Scalars['Int'];
}>;


export type CorporationActivitiesQuery = { __typename?: 'Query', activities: Array<{ __typename?: 'Activity', id: number, content: string, statusCode: number, status: string, privacySetting: boolean, deletable: boolean, createdAt: any, updatedAt: any, file?: { __typename?: 'FileInfo', name: string, contentType: string, url: string } | null | undefined, activityAdditions?: Array<{ __typename?: 'ActivityAddition', schoolActivityAdditionId: number, itemType: AdditionItemType, value?: string | null | undefined, dateValue?: any | null | undefined, content?: Array<string> | null | undefined, title?: string | null | undefined, shouldUseTime?: boolean | null | undefined }> | null | undefined }>, activityCorporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined } | null | undefined };

export type CreateActivityMutationVariables = Exact<{
  activity: ActivityInput;
}>;


export type CreateActivityMutation = { __typename?: 'Mutation', createActivity?: { __typename?: 'CreateActivityPayload', error?: string | null | undefined, activity?: { __typename?: 'Activity', id: number, content: string, statusCode: number, status: string, privacySetting: boolean, deletable: boolean, createdAt: any, updatedAt: any, file?: { __typename?: 'FileInfo', name: string, contentType: string, url: string } | null | undefined, activityAdditions?: Array<{ __typename?: 'ActivityAddition', schoolActivityAdditionId: number, itemType: AdditionItemType, value?: string | null | undefined, dateValue?: any | null | undefined, content?: Array<string> | null | undefined, title?: string | null | undefined, shouldUseTime?: boolean | null | undefined }> | null | undefined } | null | undefined } | null | undefined };

export type UpdateActivityMutationVariables = Exact<{
  activity: ActivityInput;
}>;


export type UpdateActivityMutation = { __typename?: 'Mutation', updateActivity?: { __typename?: 'UpdateActivityPayload', result?: string | null | undefined, error?: string | null | undefined } | null | undefined };

export type DeleteActivityMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteActivityMutation = { __typename?: 'Mutation', deleteActivity?: { __typename?: 'DeleteActivityPayload', result?: string | null | undefined, error?: string | null | undefined } | null | undefined };

export type BookmarkAttributesFragment = { __typename?: 'Bookmark', id: number, type: BookmarkType, targetId: number, checked: boolean };

export type SearchBookmarksQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchBookmarksQuery = { __typename?: 'Query', bookmarks: Array<{ __typename?: 'Bookmark', id: number, type: BookmarkType, targetId: number, checked: boolean, job?: { __typename?: 'Job', id: number, offer: string, catchCopy?: string | null | undefined, closeDate: any, plusImage1Url?: string | null | undefined, plusImage2Url?: string | null | undefined, plusImage3Url?: string | null | undefined, coverImageUrl?: string | null | undefined, bookmark?: boolean | null | undefined, createdAt: any, updatedAt: any, occupation?: { __typename?: 'Occupation', id: number, label: string } | null | undefined, employmentType?: { __typename?: 'Employment', id: number, label: string } | null | undefined, listVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, jobPlanSeparates?: Array<{ __typename?: 'JobPlanSeparate', id: number, premium: boolean, locationCityList?: Array<string> | null | undefined, locationPrefectureList?: Array<string> | null | undefined }> | null | undefined, characteristics1?: { __typename?: 'JobFeature', id: number, label: string } | null | undefined, characteristics2?: { __typename?: 'JobFeature', id: number, label: string } | null | undefined, characteristics3?: { __typename?: 'JobFeature', id: number, label: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, logoUrl?: string | null | undefined, address?: string | null | undefined, plan?: number | null | undefined, category1?: { __typename?: 'Industry', id: number, code: number, label: string } | null | undefined, category2?: { __typename?: 'Industry', id: number, code: number, label: string } | null | undefined, category3?: { __typename?: 'Industry', id: number, code: number, label: string } | null | undefined, handicapAdoption?: { __typename?: 'HandicapAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, internationalAdoption?: { __typename?: 'InternationalAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined } } | null | undefined, feed?: { __typename?: 'Post', id: number, feedId: number, title: string, content: string, contentSummary: string, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, imageUrl1?: string | null | undefined, imageUrl2?: string | null | undefined, author: string, authorImageUrl?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, bookmarkCount: number, like?: boolean | null | undefined, likeCount: number, readAt?: any | null | undefined, video?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, url?: string | null | undefined, address?: string | null | undefined }, members?: Array<{ __typename?: 'PostMember', id: number, name: string, office?: string | null | undefined, position?: string | null | undefined, imageUrl?: string | null | undefined }> | null | undefined, messageForLike?: { __typename?: 'MessageForAction', imageUrl?: string | null | undefined, message: string } | null | undefined } | null | undefined, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, description?: string | null | undefined, logoUrl?: string | null | undefined, address?: string | null | undefined, coverImageUrl?: string | null | undefined, mainImageUrl?: string | null | undefined, philosophyImage1Url?: string | null | undefined, philosophyImage2Url?: string | null | undefined, bookmark?: boolean | null | undefined } | null | undefined }> };

export type ToggleBookmarkMutationVariables = Exact<{
  type: BookmarkType;
  id: Scalars['Int'];
}>;


export type ToggleBookmarkMutation = { __typename?: 'Mutation', toggleBookmark?: { __typename?: 'ToggleBookmarkPayload', error?: string | null | undefined, bookmark?: { __typename?: 'Bookmark', id: number, type: BookmarkType, targetId: number, checked: boolean } | null | undefined } | null | undefined };

export type PrefectureCitiesQueryVariables = Exact<{
  prefectureCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type PrefectureCitiesQuery = { __typename?: 'Query', prefectureCities: Array<{ __typename?: 'CityGroup', prefectureCode: string, prefectureName: string, cities: Array<{ __typename?: 'KeyValue', key: string, value?: string | null | undefined }> }> };

export type CityNamesQueryVariables = Exact<{
  cityCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type CityNamesQuery = { __typename?: 'Query', cityNames: string };

export type KeyValueAttributesFragment = { __typename?: 'KeyValue', key: string, value?: string | null | undefined };

export type CodeListQueryVariables = Exact<{
  schoolId: Scalars['Int'];
}>;


export type CodeListQuery = { __typename?: 'Query', industries: Array<{ __typename?: 'KeyValue', key: string, value?: string | null | undefined }>, categories: Array<{ __typename?: 'KeyValue', key: string, value?: string | null | undefined }>, jobFeatures: Array<{ __typename?: 'KeyValue', key: string, value?: string | null | undefined }>, corporationTypes: Array<{ __typename?: 'KeyValue', key: string, value?: string | null | undefined }> };

export type IndustriesQueryVariables = Exact<{
  schoolId: Scalars['Int'];
}>;


export type IndustriesQuery = { __typename?: 'Query', industries: Array<{ __typename?: 'KeyValue', key: string, value?: string | null | undefined }> };

export type IndustryNamesQueryVariables = Exact<{
  industryCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type IndustryNamesQuery = { __typename?: 'Query', industryNames: string };

export type GroupIndustriesQueryVariables = Exact<{
  schoolId: Scalars['Int'];
}>;


export type GroupIndustriesQuery = { __typename?: 'Query', groupIndustries: Array<{ __typename?: 'KeyValueGroup', groupCode: string, groupName: string, keyValues: Array<{ __typename?: 'KeyValue', key: string, value?: string | null | undefined }> }> };

export type CategoriesQueryVariables = Exact<{
  schoolId: Scalars['Int'];
}>;


export type CategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'KeyValue', key: string, value?: string | null | undefined }> };

export type IndustryCategoriesQueryVariables = Exact<{
  schoolId: Scalars['Int'];
  industryCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type IndustryCategoriesQuery = { __typename?: 'Query', industryCategories: Array<{ __typename?: 'KeyValue', key: string, value?: string | null | undefined }> };

export type CategoryNamesQueryVariables = Exact<{
  categoryCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type CategoryNamesQuery = { __typename?: 'Query', categoryNames: string };

export type JobFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type JobFeaturesQuery = { __typename?: 'Query', jobFeatures: Array<{ __typename?: 'KeyValue', key: string, value?: string | null | undefined }> };

export type JobFeatureNamesQueryVariables = Exact<{
  jobFeatureCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type JobFeatureNamesQuery = { __typename?: 'Query', jobFeatureNames: string };

export type CorporationTypesQueryVariables = Exact<{
  schoolId: Scalars['Int'];
}>;


export type CorporationTypesQuery = { __typename?: 'Query', corporationTypes: Array<{ __typename?: 'KeyValue', key: string, value?: string | null | undefined }> };

export type CorporationTypeNamesQueryVariables = Exact<{
  corporationTypeCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type CorporationTypeNamesQuery = { __typename?: 'Query', corporationTypeNames: string };

export type CorporationMemberAttributesFragment = { __typename?: 'CorporationMember', id: number, name: string, nameKana: string, position?: string | null | undefined, office?: string | null | undefined, imageUrl?: string | null | undefined, schoolName?: string | null | undefined, sameSchool: boolean, enteringYear?: string | null | undefined };

export type CorporationOfficeAttributesFragment = { __typename?: 'CorporationOffice', id: number, name: string, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, imageUrl2?: string | null | undefined, imageUrl3?: string | null | undefined, imageUrl4?: string | null | undefined, imageUrl5?: string | null | undefined };

export type CorporationAreaAttributesFragment = { __typename?: 'CorporationArea', id: number, name?: string | null | undefined, offices?: Array<{ __typename?: 'CorporationOffice', id: number, name: string, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, imageUrl2?: string | null | undefined, imageUrl3?: string | null | undefined, imageUrl4?: string | null | undefined, imageUrl5?: string | null | undefined }> | null | undefined };

export type CorporationAttributesFragment = { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, businessFormI18n?: string | null | undefined, logoUrl?: string | null | undefined, coverImageUrl?: string | null | undefined, mainImageUrl?: string | null | undefined, url?: string | null | undefined, corporationNumber?: string | null | undefined, philosophyTitle?: string | null | undefined, philosophy?: string | null | undefined, philosophyImage1Url?: string | null | undefined, philosophyImage2Url?: string | null | undefined, visionTitle?: string | null | undefined, vision?: string | null | undefined, visionImage1Url?: string | null | undefined, visionImage2Url?: string | null | undefined, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, description?: string | null | undefined, topManager?: string | null | undefined, topManagerKana?: string | null | undefined, topManagerPosition?: string | null | undefined, topManagerSchool?: string | null | undefined, establishmentDate?: string | null | undefined, capital?: string | null | undefined, annualSales?: string | null | undefined, housingAllowance?: string | null | undefined, numberOfEmployee?: string | null | undefined, numberOfOffices?: number | null | undefined, affiliatedCompany?: string | null | undefined, plan?: number | null | undefined, messageContent?: string | null | undefined, messageName?: string | null | undefined, messageImageUrl?: string | null | undefined, schoolMemo?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, tags?: Array<string> | null | undefined, visitReception?: { __typename?: 'VisitReception', visitReceptionRequired?: boolean | null | undefined, visitReceptionTimeFrom?: string | null | undefined, visitReceptionTimeTo?: string | null | undefined, visitReceptionWeekday?: Array<boolean> | null | undefined } | null | undefined, handicapAdoption?: { __typename?: 'HandicapAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, internationalAdoption?: { __typename?: 'InternationalAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, coverVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, messageVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, recruiter?: { __typename?: 'CorporationStaff', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, tel?: string | null | undefined, email?: string | null | undefined, position?: string | null | undefined, message?: string | null | undefined, imageUrl?: string | null | undefined } | null | undefined, areas?: Array<{ __typename?: 'CorporationArea', id: number, name?: string | null | undefined, offices?: Array<{ __typename?: 'CorporationOffice', id: number, name: string, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, imageUrl2?: string | null | undefined, imageUrl3?: string | null | undefined, imageUrl4?: string | null | undefined, imageUrl5?: string | null | undefined }> | null | undefined }> | null | undefined, members?: Array<{ __typename?: 'CorporationMember', id: number, name: string, nameKana: string, position?: string | null | undefined, office?: string | null | undefined, imageUrl?: string | null | undefined, schoolName?: string | null | undefined, sameSchool: boolean, enteringYear?: string | null | undefined }> | null | undefined, additions?: Array<{ __typename?: 'AdditionItem', id: number, title: string, content: string }> | null | undefined };

export type ArticleAttributesFragment = { __typename?: 'Article', id: number, title: string, content: string, contentSummary: string, imageUrl?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, like?: boolean | null | undefined, likeCount: number };

export type CorporationTopAttributesFragment = { __typename?: 'Corporation', id?: number | null | undefined, coverImageUrl?: string | null | undefined, mainImageUrl?: string | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, description?: string | null | undefined, logoUrl?: string | null | undefined, messageContent?: string | null | undefined, messageImageUrl?: string | null | undefined, messageName?: string | null | undefined, philosophy?: string | null | undefined, philosophyTitle?: string | null | undefined, philosophyImage1Url?: string | null | undefined, philosophyImage2Url?: string | null | undefined, vision?: string | null | undefined, visionTitle?: string | null | undefined, visionImage1Url?: string | null | undefined, visionImage2Url?: string | null | undefined, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, url?: string | null | undefined, topManager?: string | null | undefined, topManagerPosition?: string | null | undefined, topManagerKana?: string | null | undefined, topManagerSchool?: string | null | undefined, establishmentDate?: string | null | undefined, capital?: string | null | undefined, annualSales?: string | null | undefined, numberOfOffices?: number | null | undefined, numberOfEmployee?: string | null | undefined, housingAllowance?: string | null | undefined, affiliatedCompany?: string | null | undefined, schoolMemo?: string | null | undefined, bookmark?: boolean | null | undefined, coverVideo?: { __typename?: 'Video', videoId: string, videoType: string } | null | undefined, messageVideo?: { __typename?: 'Video', videoId: string, videoType: string } | null | undefined, internationalAdoption?: { __typename?: 'InternationalAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, handicapAdoption?: { __typename?: 'HandicapAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, visitReception?: { __typename?: 'VisitReception', visitReceptionRequired?: boolean | null | undefined, visitReceptionTimeFrom?: string | null | undefined, visitReceptionWeekday?: Array<boolean> | null | undefined, visitReceptionTimeTo?: string | null | undefined } | null | undefined, areas?: Array<{ __typename?: 'CorporationArea', id: number, name?: string | null | undefined, offices?: Array<{ __typename?: 'CorporationOffice', id: number, name: string, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, imageUrl2?: string | null | undefined, imageUrl3?: string | null | undefined, imageUrl4?: string | null | undefined, imageUrl5?: string | null | undefined }> | null | undefined }> | null | undefined, additions?: Array<{ __typename?: 'AdditionItem', id: number, title: string, content: string }> | null | undefined, members?: Array<{ __typename?: 'CorporationMember', id: number, name: string, nameKana: string, position?: string | null | undefined, office?: string | null | undefined, imageUrl?: string | null | undefined, schoolName?: string | null | undefined, sameSchool: boolean, enteringYear?: string | null | undefined }> | null | undefined };

export type FindValidCorporationQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FindValidCorporationQuery = { __typename?: 'Query', validcorporation?: { __typename?: 'Corporation', plan?: number | null | undefined, id?: number | null | undefined, coverImageUrl?: string | null | undefined, mainImageUrl?: string | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, description?: string | null | undefined, logoUrl?: string | null | undefined, messageContent?: string | null | undefined, messageImageUrl?: string | null | undefined, messageName?: string | null | undefined, philosophy?: string | null | undefined, philosophyTitle?: string | null | undefined, philosophyImage1Url?: string | null | undefined, philosophyImage2Url?: string | null | undefined, vision?: string | null | undefined, visionTitle?: string | null | undefined, visionImage1Url?: string | null | undefined, visionImage2Url?: string | null | undefined, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, url?: string | null | undefined, topManager?: string | null | undefined, topManagerPosition?: string | null | undefined, topManagerKana?: string | null | undefined, topManagerSchool?: string | null | undefined, establishmentDate?: string | null | undefined, capital?: string | null | undefined, annualSales?: string | null | undefined, numberOfOffices?: number | null | undefined, numberOfEmployee?: string | null | undefined, housingAllowance?: string | null | undefined, affiliatedCompany?: string | null | undefined, schoolMemo?: string | null | undefined, bookmark?: boolean | null | undefined, coverVideo?: { __typename?: 'Video', videoId: string, videoType: string } | null | undefined, messageVideo?: { __typename?: 'Video', videoId: string, videoType: string } | null | undefined, internationalAdoption?: { __typename?: 'InternationalAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, handicapAdoption?: { __typename?: 'HandicapAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, visitReception?: { __typename?: 'VisitReception', visitReceptionRequired?: boolean | null | undefined, visitReceptionTimeFrom?: string | null | undefined, visitReceptionWeekday?: Array<boolean> | null | undefined, visitReceptionTimeTo?: string | null | undefined } | null | undefined, areas?: Array<{ __typename?: 'CorporationArea', id: number, name?: string | null | undefined, offices?: Array<{ __typename?: 'CorporationOffice', id: number, name: string, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, imageUrl2?: string | null | undefined, imageUrl3?: string | null | undefined, imageUrl4?: string | null | undefined, imageUrl5?: string | null | undefined }> | null | undefined }> | null | undefined, additions?: Array<{ __typename?: 'AdditionItem', id: number, title: string, content: string }> | null | undefined, members?: Array<{ __typename?: 'CorporationMember', id: number, name: string, nameKana: string, position?: string | null | undefined, office?: string | null | undefined, imageUrl?: string | null | undefined, schoolName?: string | null | undefined, sameSchool: boolean, enteringYear?: string | null | undefined }> | null | undefined } | null | undefined };

export type FindCorporationQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FindCorporationQuery = { __typename?: 'Query', corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, businessFormI18n?: string | null | undefined, logoUrl?: string | null | undefined, coverImageUrl?: string | null | undefined, mainImageUrl?: string | null | undefined, url?: string | null | undefined, corporationNumber?: string | null | undefined, philosophyTitle?: string | null | undefined, philosophy?: string | null | undefined, philosophyImage1Url?: string | null | undefined, philosophyImage2Url?: string | null | undefined, visionTitle?: string | null | undefined, vision?: string | null | undefined, visionImage1Url?: string | null | undefined, visionImage2Url?: string | null | undefined, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, description?: string | null | undefined, topManager?: string | null | undefined, topManagerKana?: string | null | undefined, topManagerPosition?: string | null | undefined, topManagerSchool?: string | null | undefined, establishmentDate?: string | null | undefined, capital?: string | null | undefined, annualSales?: string | null | undefined, housingAllowance?: string | null | undefined, numberOfEmployee?: string | null | undefined, numberOfOffices?: number | null | undefined, affiliatedCompany?: string | null | undefined, plan?: number | null | undefined, messageContent?: string | null | undefined, messageName?: string | null | undefined, messageImageUrl?: string | null | undefined, schoolMemo?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, tags?: Array<string> | null | undefined, visitReception?: { __typename?: 'VisitReception', visitReceptionRequired?: boolean | null | undefined, visitReceptionTimeFrom?: string | null | undefined, visitReceptionTimeTo?: string | null | undefined, visitReceptionWeekday?: Array<boolean> | null | undefined } | null | undefined, handicapAdoption?: { __typename?: 'HandicapAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, internationalAdoption?: { __typename?: 'InternationalAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, coverVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, messageVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, recruiter?: { __typename?: 'CorporationStaff', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, tel?: string | null | undefined, email?: string | null | undefined, position?: string | null | undefined, message?: string | null | undefined, imageUrl?: string | null | undefined } | null | undefined, areas?: Array<{ __typename?: 'CorporationArea', id: number, name?: string | null | undefined, offices?: Array<{ __typename?: 'CorporationOffice', id: number, name: string, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, imageUrl2?: string | null | undefined, imageUrl3?: string | null | undefined, imageUrl4?: string | null | undefined, imageUrl5?: string | null | undefined }> | null | undefined }> | null | undefined, members?: Array<{ __typename?: 'CorporationMember', id: number, name: string, nameKana: string, position?: string | null | undefined, office?: string | null | undefined, imageUrl?: string | null | undefined, schoolName?: string | null | undefined, sameSchool: boolean, enteringYear?: string | null | undefined }> | null | undefined, additions?: Array<{ __typename?: 'AdditionItem', id: number, title: string, content: string }> | null | undefined } | null | undefined };

export type FindCorporationVisitQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FindCorporationVisitQuery = { __typename?: 'Query', corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined } | null | undefined };

export type FindCorporationMemberQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FindCorporationMemberQuery = { __typename?: 'Query', corporationMember?: { __typename?: 'CorporationMember', id: number, name: string, nameKana: string, position?: string | null | undefined, office?: string | null | undefined, imageUrl?: string | null | undefined, schoolName?: string | null | undefined, sameSchool: boolean, enteringYear?: string | null | undefined, articles?: Array<{ __typename?: 'Article', id: number, title: string, content: string, contentSummary: string, imageUrl?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, like?: boolean | null | undefined, likeCount: number }> | null | undefined, feeds?: Array<{ __typename?: 'Post', id: number, feedId: number, title: string, content: string, contentSummary: string, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, imageUrl1?: string | null | undefined, imageUrl2?: string | null | undefined, author: string, authorImageUrl?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, bookmarkCount: number, like?: boolean | null | undefined, likeCount: number, readAt?: any | null | undefined, video?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, url?: string | null | undefined, address?: string | null | undefined }, members?: Array<{ __typename?: 'PostMember', id: number, name: string, office?: string | null | undefined, position?: string | null | undefined, imageUrl?: string | null | undefined }> | null | undefined, messageForLike?: { __typename?: 'MessageForAction', imageUrl?: string | null | undefined, message: string } | null | undefined }> | null | undefined } | null | undefined };

export type FindStandaloneCorporationMemberQueryVariables = Exact<{
  id: Scalars['Int'];
  corporationId: Scalars['Int'];
}>;


export type FindStandaloneCorporationMemberQuery = { __typename?: 'Query', corporationMember?: { __typename?: 'CorporationMember', id: number, name: string, nameKana: string, position?: string | null | undefined, office?: string | null | undefined, imageUrl?: string | null | undefined, schoolName?: string | null | undefined, sameSchool: boolean, enteringYear?: string | null | undefined, articles?: Array<{ __typename?: 'Article', id: number, title: string, content: string, contentSummary: string, imageUrl?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, like?: boolean | null | undefined, likeCount: number }> | null | undefined, feeds?: Array<{ __typename?: 'Post', id: number, feedId: number, title: string, content: string, contentSummary: string, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, imageUrl1?: string | null | undefined, imageUrl2?: string | null | undefined, author: string, authorImageUrl?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, bookmarkCount: number, like?: boolean | null | undefined, likeCount: number, readAt?: any | null | undefined, video?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, url?: string | null | undefined, address?: string | null | undefined }, members?: Array<{ __typename?: 'PostMember', id: number, name: string, office?: string | null | undefined, position?: string | null | undefined, imageUrl?: string | null | undefined }> | null | undefined, messageForLike?: { __typename?: 'MessageForAction', imageUrl?: string | null | undefined, message: string } | null | undefined }> | null | undefined } | null | undefined, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, businessFormI18n?: string | null | undefined, logoUrl?: string | null | undefined, coverImageUrl?: string | null | undefined, mainImageUrl?: string | null | undefined, url?: string | null | undefined, corporationNumber?: string | null | undefined, philosophyTitle?: string | null | undefined, philosophy?: string | null | undefined, philosophyImage1Url?: string | null | undefined, philosophyImage2Url?: string | null | undefined, visionTitle?: string | null | undefined, vision?: string | null | undefined, visionImage1Url?: string | null | undefined, visionImage2Url?: string | null | undefined, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, description?: string | null | undefined, topManager?: string | null | undefined, topManagerKana?: string | null | undefined, topManagerPosition?: string | null | undefined, topManagerSchool?: string | null | undefined, establishmentDate?: string | null | undefined, capital?: string | null | undefined, annualSales?: string | null | undefined, housingAllowance?: string | null | undefined, numberOfEmployee?: string | null | undefined, numberOfOffices?: number | null | undefined, affiliatedCompany?: string | null | undefined, plan?: number | null | undefined, messageContent?: string | null | undefined, messageName?: string | null | undefined, messageImageUrl?: string | null | undefined, schoolMemo?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, tags?: Array<string> | null | undefined, visitReception?: { __typename?: 'VisitReception', visitReceptionRequired?: boolean | null | undefined, visitReceptionTimeFrom?: string | null | undefined, visitReceptionTimeTo?: string | null | undefined, visitReceptionWeekday?: Array<boolean> | null | undefined } | null | undefined, handicapAdoption?: { __typename?: 'HandicapAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, internationalAdoption?: { __typename?: 'InternationalAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, coverVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, messageVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, recruiter?: { __typename?: 'CorporationStaff', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, tel?: string | null | undefined, email?: string | null | undefined, position?: string | null | undefined, message?: string | null | undefined, imageUrl?: string | null | undefined } | null | undefined, areas?: Array<{ __typename?: 'CorporationArea', id: number, name?: string | null | undefined, offices?: Array<{ __typename?: 'CorporationOffice', id: number, name: string, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, imageUrl2?: string | null | undefined, imageUrl3?: string | null | undefined, imageUrl4?: string | null | undefined, imageUrl5?: string | null | undefined }> | null | undefined }> | null | undefined, members?: Array<{ __typename?: 'CorporationMember', id: number, name: string, nameKana: string, position?: string | null | undefined, office?: string | null | undefined, imageUrl?: string | null | undefined, schoolName?: string | null | undefined, sameSchool: boolean, enteringYear?: string | null | undefined }> | null | undefined, additions?: Array<{ __typename?: 'AdditionItem', id: number, title: string, content: string }> | null | undefined } | null | undefined };

export type SearchSchoolGraduateMembersQueryVariables = Exact<{
  page: Scalars['Int'];
  limit: Scalars['Int'];
  isGetAggregate?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchSchoolGraduateMembersQuery = { __typename?: 'Query', paginationGraduateMembers: { __typename?: 'PaginationCorporationMembers', graduateMembers?: Array<{ __typename?: 'CorporationMember', id: number, name: string, nameKana: string, position?: string | null | undefined, office?: string | null | undefined, imageUrl?: string | null | undefined, schoolName?: string | null | undefined, sameSchool: boolean, enteringYear?: string | null | undefined, articles?: Array<{ __typename?: 'Article', id: number, title: string, content: string, imageUrl?: string | null | undefined, like?: boolean | null | undefined, likeCount: number }> | null | undefined, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined } | null | undefined }> | null | undefined, pagination?: { __typename?: 'Pagination', currentPage?: number | null | undefined, limitValue?: number | null | undefined, totalCount?: number | null | undefined, totalPages?: number | null | undefined } | null | undefined } };

export type CorporationDataQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CorporationDataQuery = { __typename?: 'Query', corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, businessFormI18n?: string | null | undefined, logoUrl?: string | null | undefined, coverImageUrl?: string | null | undefined, mainImageUrl?: string | null | undefined, url?: string | null | undefined, corporationNumber?: string | null | undefined, philosophyTitle?: string | null | undefined, philosophy?: string | null | undefined, philosophyImage1Url?: string | null | undefined, philosophyImage2Url?: string | null | undefined, visionTitle?: string | null | undefined, vision?: string | null | undefined, visionImage1Url?: string | null | undefined, visionImage2Url?: string | null | undefined, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, description?: string | null | undefined, topManager?: string | null | undefined, topManagerKana?: string | null | undefined, topManagerPosition?: string | null | undefined, topManagerSchool?: string | null | undefined, establishmentDate?: string | null | undefined, capital?: string | null | undefined, annualSales?: string | null | undefined, housingAllowance?: string | null | undefined, numberOfEmployee?: string | null | undefined, numberOfOffices?: number | null | undefined, affiliatedCompany?: string | null | undefined, plan?: number | null | undefined, messageContent?: string | null | undefined, messageName?: string | null | undefined, messageImageUrl?: string | null | undefined, schoolMemo?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, tags?: Array<string> | null | undefined, visitReception?: { __typename?: 'VisitReception', visitReceptionRequired?: boolean | null | undefined, visitReceptionTimeFrom?: string | null | undefined, visitReceptionTimeTo?: string | null | undefined, visitReceptionWeekday?: Array<boolean> | null | undefined } | null | undefined, handicapAdoption?: { __typename?: 'HandicapAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, internationalAdoption?: { __typename?: 'InternationalAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, coverVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, messageVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, recruiter?: { __typename?: 'CorporationStaff', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, tel?: string | null | undefined, email?: string | null | undefined, position?: string | null | undefined, message?: string | null | undefined, imageUrl?: string | null | undefined } | null | undefined, areas?: Array<{ __typename?: 'CorporationArea', id: number, name?: string | null | undefined, offices?: Array<{ __typename?: 'CorporationOffice', id: number, name: string, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, imageUrl2?: string | null | undefined, imageUrl3?: string | null | undefined, imageUrl4?: string | null | undefined, imageUrl5?: string | null | undefined }> | null | undefined }> | null | undefined, members?: Array<{ __typename?: 'CorporationMember', id: number, name: string, nameKana: string, position?: string | null | undefined, office?: string | null | undefined, imageUrl?: string | null | undefined, schoolName?: string | null | undefined, sameSchool: boolean, enteringYear?: string | null | undefined }> | null | undefined, additions?: Array<{ __typename?: 'AdditionItem', id: number, title: string, content: string }> | null | undefined } | null | undefined, jobs: Array<{ __typename?: 'Job', id: number, offer: string, catchCopy?: string | null | undefined, closeDate: any, plusImage1Url?: string | null | undefined, plusImage2Url?: string | null | undefined, plusImage3Url?: string | null | undefined, coverImageUrl?: string | null | undefined, bookmark?: boolean | null | undefined, createdAt: any, updatedAt: any, occupation?: { __typename?: 'Occupation', id: number, label: string } | null | undefined, employmentType?: { __typename?: 'Employment', id: number, label: string } | null | undefined, listVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, jobPlanSeparates?: Array<{ __typename?: 'JobPlanSeparate', id: number, premium: boolean, locationCityList?: Array<string> | null | undefined, locationPrefectureList?: Array<string> | null | undefined }> | null | undefined, characteristics1?: { __typename?: 'JobFeature', id: number, label: string } | null | undefined, characteristics2?: { __typename?: 'JobFeature', id: number, label: string } | null | undefined, characteristics3?: { __typename?: 'JobFeature', id: number, label: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, logoUrl?: string | null | undefined, address?: string | null | undefined, plan?: number | null | undefined, category1?: { __typename?: 'Industry', id: number, code: number, label: string } | null | undefined, category2?: { __typename?: 'Industry', id: number, code: number, label: string } | null | undefined, category3?: { __typename?: 'Industry', id: number, code: number, label: string } | null | undefined, handicapAdoption?: { __typename?: 'HandicapAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, internationalAdoption?: { __typename?: 'InternationalAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined } }>, feeds: Array<{ __typename?: 'Post', id: number, feedId: number, title: string, content: string, contentSummary: string, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, imageUrl1?: string | null | undefined, imageUrl2?: string | null | undefined, author: string, authorImageUrl?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, bookmarkCount: number, like?: boolean | null | undefined, likeCount: number, readAt?: any | null | undefined, video?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, url?: string | null | undefined, address?: string | null | undefined }, members?: Array<{ __typename?: 'PostMember', id: number, name: string, office?: string | null | undefined, position?: string | null | undefined, imageUrl?: string | null | undefined }> | null | undefined, messageForLike?: { __typename?: 'MessageForAction', imageUrl?: string | null | undefined, message: string } | null | undefined }>, internships: Array<{ __typename?: 'CorporationEventInternship', id: number, title?: string | null | undefined, content?: string | null | undefined, closingDate: any, numberOfAccepted?: number | null | undefined, enableInternational?: boolean | null | undefined, requirements?: string | null | undefined, periodFrom: any, periodTo: any, timeSchedule?: string | null | undefined, holiday?: string | null | undefined, firstMeetingPlace?: string | null | undefined, internshipDays?: number | null | undefined, whatToBring?: string | null | undefined, howToApply?: string | null | undefined, note?: string | null | undefined, imageUrl?: string | null | undefined, prefecture?: string | null | undefined, venue?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, schoolEntry?: boolean | null | undefined, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, address?: string | null | undefined } | null | undefined, office?: { __typename?: 'CorporationOffice', id: number, name: string, address?: string | null | undefined } | null | undefined, staff?: { __typename?: 'CorporationStaff', name?: string | null | undefined } | null | undefined }>, seminars: Array<{ __typename?: 'CorporationEvent', id: number, eventId: number, eventDateId?: number | null | undefined, title?: string | null | undefined, meetingType?: MeetingType | null | undefined, content?: string | null | undefined, place?: string | null | undefined, prefecture?: string | null | undefined, whatToBring?: string | null | undefined, howToApply?: string | null | undefined, note?: string | null | undefined, imageUrl?: string | null | undefined, eventDate?: any | null | undefined, closingDate?: any | null | undefined, eventTimesText?: string | null | undefined, schoolMemo?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, schoolEntry?: boolean | null | undefined, dates?: Array<{ __typename?: 'CorporationEventDate', id: number, eventDate: any, closingDate: any }> | null | undefined, times?: Array<{ __typename?: 'CorporationEventTime', id: number, from: any, to: any, timeText?: string | null | undefined }> | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, address?: string | null | undefined }, staff?: { __typename?: 'CorporationStaff', name?: string | null | undefined } | null | undefined }> };

export type CorporationDataWithJobIdQueryVariables = Exact<{
  id: Scalars['Int'];
  jobId?: InputMaybe<Scalars['Int']>;
}>;


export type CorporationDataWithJobIdQuery = { __typename?: 'Query', corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, businessFormI18n?: string | null | undefined, logoUrl?: string | null | undefined, coverImageUrl?: string | null | undefined, mainImageUrl?: string | null | undefined, url?: string | null | undefined, corporationNumber?: string | null | undefined, philosophyTitle?: string | null | undefined, philosophy?: string | null | undefined, philosophyImage1Url?: string | null | undefined, philosophyImage2Url?: string | null | undefined, visionTitle?: string | null | undefined, vision?: string | null | undefined, visionImage1Url?: string | null | undefined, visionImage2Url?: string | null | undefined, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, description?: string | null | undefined, topManager?: string | null | undefined, topManagerKana?: string | null | undefined, topManagerPosition?: string | null | undefined, topManagerSchool?: string | null | undefined, establishmentDate?: string | null | undefined, capital?: string | null | undefined, annualSales?: string | null | undefined, housingAllowance?: string | null | undefined, numberOfEmployee?: string | null | undefined, numberOfOffices?: number | null | undefined, affiliatedCompany?: string | null | undefined, plan?: number | null | undefined, messageContent?: string | null | undefined, messageName?: string | null | undefined, messageImageUrl?: string | null | undefined, schoolMemo?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, tags?: Array<string> | null | undefined, visitReception?: { __typename?: 'VisitReception', visitReceptionRequired?: boolean | null | undefined, visitReceptionTimeFrom?: string | null | undefined, visitReceptionTimeTo?: string | null | undefined, visitReceptionWeekday?: Array<boolean> | null | undefined } | null | undefined, handicapAdoption?: { __typename?: 'HandicapAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, internationalAdoption?: { __typename?: 'InternationalAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, coverVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, messageVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, recruiter?: { __typename?: 'CorporationStaff', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, tel?: string | null | undefined, email?: string | null | undefined, position?: string | null | undefined, message?: string | null | undefined, imageUrl?: string | null | undefined } | null | undefined, areas?: Array<{ __typename?: 'CorporationArea', id: number, name?: string | null | undefined, offices?: Array<{ __typename?: 'CorporationOffice', id: number, name: string, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, imageUrl2?: string | null | undefined, imageUrl3?: string | null | undefined, imageUrl4?: string | null | undefined, imageUrl5?: string | null | undefined }> | null | undefined }> | null | undefined, members?: Array<{ __typename?: 'CorporationMember', id: number, name: string, nameKana: string, position?: string | null | undefined, office?: string | null | undefined, imageUrl?: string | null | undefined, schoolName?: string | null | undefined, sameSchool: boolean, enteringYear?: string | null | undefined }> | null | undefined, additions?: Array<{ __typename?: 'AdditionItem', id: number, title: string, content: string }> | null | undefined } | null | undefined, jobs: Array<{ __typename?: 'Job', id: number, offer: string, catchCopy?: string | null | undefined, closeDate: any, plusImage1Url?: string | null | undefined, plusImage2Url?: string | null | undefined, plusImage3Url?: string | null | undefined, coverImageUrl?: string | null | undefined, bookmark?: boolean | null | undefined, createdAt: any, updatedAt: any, occupation?: { __typename?: 'Occupation', id: number, label: string } | null | undefined, employmentType?: { __typename?: 'Employment', id: number, label: string } | null | undefined, listVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, jobPlanSeparates?: Array<{ __typename?: 'JobPlanSeparate', id: number, premium: boolean, locationCityList?: Array<string> | null | undefined, locationPrefectureList?: Array<string> | null | undefined }> | null | undefined, characteristics1?: { __typename?: 'JobFeature', id: number, label: string } | null | undefined, characteristics2?: { __typename?: 'JobFeature', id: number, label: string } | null | undefined, characteristics3?: { __typename?: 'JobFeature', id: number, label: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, logoUrl?: string | null | undefined, address?: string | null | undefined, plan?: number | null | undefined, category1?: { __typename?: 'Industry', id: number, code: number, label: string } | null | undefined, category2?: { __typename?: 'Industry', id: number, code: number, label: string } | null | undefined, category3?: { __typename?: 'Industry', id: number, code: number, label: string } | null | undefined, handicapAdoption?: { __typename?: 'HandicapAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, internationalAdoption?: { __typename?: 'InternationalAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined } }>, feeds: Array<{ __typename?: 'Post', id: number, feedId: number, title: string, content: string, contentSummary: string, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, imageUrl1?: string | null | undefined, imageUrl2?: string | null | undefined, author: string, authorImageUrl?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, bookmarkCount: number, like?: boolean | null | undefined, likeCount: number, readAt?: any | null | undefined, video?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, url?: string | null | undefined, address?: string | null | undefined }, members?: Array<{ __typename?: 'PostMember', id: number, name: string, office?: string | null | undefined, position?: string | null | undefined, imageUrl?: string | null | undefined }> | null | undefined, messageForLike?: { __typename?: 'MessageForAction', imageUrl?: string | null | undefined, message: string } | null | undefined }>, internships: Array<{ __typename?: 'CorporationEventInternship', id: number, title?: string | null | undefined, content?: string | null | undefined, closingDate: any, numberOfAccepted?: number | null | undefined, enableInternational?: boolean | null | undefined, requirements?: string | null | undefined, periodFrom: any, periodTo: any, timeSchedule?: string | null | undefined, holiday?: string | null | undefined, firstMeetingPlace?: string | null | undefined, internshipDays?: number | null | undefined, whatToBring?: string | null | undefined, howToApply?: string | null | undefined, note?: string | null | undefined, imageUrl?: string | null | undefined, prefecture?: string | null | undefined, venue?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, schoolEntry?: boolean | null | undefined, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, address?: string | null | undefined } | null | undefined, office?: { __typename?: 'CorporationOffice', id: number, name: string, address?: string | null | undefined } | null | undefined, staff?: { __typename?: 'CorporationStaff', name?: string | null | undefined } | null | undefined }>, seminars: Array<{ __typename?: 'CorporationEvent', id: number, eventId: number, eventDateId?: number | null | undefined, title?: string | null | undefined, meetingType?: MeetingType | null | undefined, content?: string | null | undefined, place?: string | null | undefined, prefecture?: string | null | undefined, whatToBring?: string | null | undefined, howToApply?: string | null | undefined, note?: string | null | undefined, imageUrl?: string | null | undefined, eventDate?: any | null | undefined, closingDate?: any | null | undefined, eventTimesText?: string | null | undefined, schoolMemo?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, schoolEntry?: boolean | null | undefined, dates?: Array<{ __typename?: 'CorporationEventDate', id: number, eventDate: any, closingDate: any }> | null | undefined, times?: Array<{ __typename?: 'CorporationEventTime', id: number, from: any, to: any, timeText?: string | null | undefined }> | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, address?: string | null | undefined }, staff?: { __typename?: 'CorporationStaff', name?: string | null | undefined } | null | undefined }> };

export type PickupCorporationsQueryVariables = Exact<{ [key: string]: never; }>;


export type PickupCorporationsQuery = { __typename?: 'Query', pickupCorporations?: Array<{ __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined, vision?: string | null | undefined }> | null | undefined };

export type DiagnosisAttributesFragment = { __typename?: 'Diagnosis', id?: number | null | undefined, userId?: number | null | undefined, name: string, supporterId?: number | null | undefined, supporterName?: string | null | undefined, type?: string | null | undefined, description?: string | null | undefined, trend?: Array<string> | null | undefined, career?: Array<string> | null | undefined, pointLogical?: number | null | undefined, pointPlanning?: number | null | undefined, pointFriendly?: number | null | undefined, pointCreative?: number | null | undefined, shareToken?: string | null | undefined, createdAt?: any | null | undefined };

export type SearchDiagnosesQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchDiagnosesQuery = { __typename?: 'Query', diagnoses?: Array<{ __typename?: 'Diagnosis', id?: number | null | undefined, userId?: number | null | undefined, name: string, supporterId?: number | null | undefined, supporterName?: string | null | undefined, type?: string | null | undefined, description?: string | null | undefined, trend?: Array<string> | null | undefined, career?: Array<string> | null | undefined, pointLogical?: number | null | undefined, pointPlanning?: number | null | undefined, pointFriendly?: number | null | undefined, pointCreative?: number | null | undefined, shareToken?: string | null | undefined, createdAt?: any | null | undefined }> | null | undefined };

export type MyDiagnosisQueryVariables = Exact<{ [key: string]: never; }>;


export type MyDiagnosisQuery = { __typename?: 'Query', diagnosis?: { __typename?: 'Diagnosis', id?: number | null | undefined, userId?: number | null | undefined, name: string, supporterId?: number | null | undefined, supporterName?: string | null | undefined, type?: string | null | undefined, description?: string | null | undefined, trend?: Array<string> | null | undefined, career?: Array<string> | null | undefined, pointLogical?: number | null | undefined, pointPlanning?: number | null | undefined, pointFriendly?: number | null | undefined, pointCreative?: number | null | undefined, shareToken?: string | null | undefined, createdAt?: any | null | undefined } | null | undefined };

export type FindDiagnosisQueryVariables = Exact<{
  userId: Scalars['Int'];
  other?: InputMaybe<Scalars['Boolean']>;
}>;


export type FindDiagnosisQuery = { __typename?: 'Query', diagnosis?: { __typename?: 'Diagnosis', id?: number | null | undefined, userId?: number | null | undefined, name: string, supporterId?: number | null | undefined, supporterName?: string | null | undefined, type?: string | null | undefined, description?: string | null | undefined, trend?: Array<string> | null | undefined, career?: Array<string> | null | undefined, pointLogical?: number | null | undefined, pointPlanning?: number | null | undefined, pointFriendly?: number | null | undefined, pointCreative?: number | null | undefined, shareToken?: string | null | undefined, createdAt?: any | null | undefined } | null | undefined };

export type FindRequestDiagnosisQueryVariables = Exact<{
  requestId: Scalars['String'];
}>;


export type FindRequestDiagnosisQuery = { __typename?: 'Query', diagnosis?: { __typename?: 'Diagnosis', id?: number | null | undefined, userId?: number | null | undefined, name: string, supporterId?: number | null | undefined, supporterName?: string | null | undefined, type?: string | null | undefined, description?: string | null | undefined, trend?: Array<string> | null | undefined, career?: Array<string> | null | undefined, pointLogical?: number | null | undefined, pointPlanning?: number | null | undefined, pointFriendly?: number | null | undefined, pointCreative?: number | null | undefined, shareToken?: string | null | undefined, createdAt?: any | null | undefined } | null | undefined };

export type CreateDiagnosisMutationVariables = Exact<{
  answers: Array<Scalars['Int']> | Scalars['Int'];
  userId?: InputMaybe<Scalars['Int']>;
}>;


export type CreateDiagnosisMutation = { __typename?: 'Mutation', createDiagnosis?: { __typename?: 'CreateDiagnosisPayload', error?: string | null | undefined, diagnosis?: { __typename?: 'Diagnosis', id?: number | null | undefined, userId?: number | null | undefined, name: string, supporterId?: number | null | undefined, supporterName?: string | null | undefined, type?: string | null | undefined, description?: string | null | undefined, trend?: Array<string> | null | undefined, career?: Array<string> | null | undefined, pointLogical?: number | null | undefined, pointPlanning?: number | null | undefined, pointFriendly?: number | null | undefined, pointCreative?: number | null | undefined, shareToken?: string | null | undefined, createdAt?: any | null | undefined } | null | undefined } | null | undefined };

export type RequestDiagnosisMutationVariables = Exact<{
  message: Scalars['String'];
}>;


export type RequestDiagnosisMutation = { __typename?: 'Mutation', requestDiagnosis?: { __typename?: 'RequestDiagnosisPayload', result?: boolean | null | undefined, error?: string | null | undefined } | null | undefined };

export type DownloadQueryVariables = Exact<{
  type: FileType;
  id: Scalars['String'];
}>;


export type DownloadQuery = { __typename?: 'Query', download?: { __typename?: 'FileInfo', name: string, contentType: string, url: string, data?: string | null | undefined } | null | undefined };

export type EntrySettingAttributesFragment = { __typename?: 'EntrySetting', showMemo: boolean, requireMemo: boolean, showLocation: boolean, requireLocation: boolean, privacyPolicyUrl?: string | null | undefined, additions?: Array<{ __typename?: 'EntryAddition', id: number, title: string, description?: string | null | undefined, require: boolean, items?: Array<string> | null | undefined, showMemo: boolean, additionType: EntryAdditionInputType }> | null | undefined };

export type EntryAdditionAttributesFragment = { __typename?: 'EntryAddition', id: number, title: string, description?: string | null | undefined, require: boolean, items?: Array<string> | null | undefined, showMemo: boolean, additionType: EntryAdditionInputType };

export type JobEntryDataQueryVariables = Exact<{
  jobId: Scalars['Int'];
}>;


export type JobEntryDataQuery = { __typename?: 'Query', job?: { __typename?: 'Job', id: number, offer: string, schoolEntry: boolean, locationOffices?: Array<{ __typename?: 'CorporationOffice', id: number, name: string, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, imageUrl2?: string | null | undefined, imageUrl3?: string | null | undefined, imageUrl4?: string | null | undefined, imageUrl5?: string | null | undefined }> | null | undefined, employmentType?: { __typename?: 'Employment', id: number, label: string } | null | undefined, examination?: { __typename?: 'CorporationEvent', id: number } | null | undefined, examinationDates?: Array<{ __typename?: 'CorporationEventDate', id: number, eventDate: any, closingDate: any }> | null | undefined, examinationTimes?: Array<{ __typename?: 'CorporationEventTime', id: number, from: any, to: any, timeText?: string | null | undefined }> | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined }, sisterJobInfo?: { __typename?: 'SisterJobInfo', sisterSchoolName: string, sisterSchoolNameVisible: boolean } | null | undefined, entrySetting?: { __typename?: 'EntrySetting', showMemo: boolean, requireMemo: boolean, showLocation: boolean, requireLocation: boolean, privacyPolicyUrl?: string | null | undefined, additions?: Array<{ __typename?: 'EntryAddition', id: number, title: string, description?: string | null | undefined, require: boolean, items?: Array<string> | null | undefined, showMemo: boolean, additionType: EntryAdditionInputType }> | null | undefined } | null | undefined } | null | undefined, user?: { __typename?: 'User', id: number, email: string, pushNotification: boolean, emailNotification: boolean, jobHuntingStatus: number, jobHuntingStatusLabel: string, school: { __typename?: 'School', id: number, name: string, plan?: SchoolPlan | null | undefined, isBasicPlanOrMore?: boolean | null | undefined, schoolNumber?: string | null | undefined, useCertificate?: boolean | null | undefined, logoUrl?: string | null | undefined, official?: boolean | null | undefined, allowPartTime?: boolean | null | undefined, allowOutsourcing?: boolean | null | undefined, companyVisitEntryType?: CompanyVisitEntry | null | undefined, groupName?: string | null | undefined, courses?: Array<{ __typename?: 'SchoolCourse', id: number, name: string }> | null | undefined, teachers?: Array<{ __typename?: 'SchoolTeacher', id: number, name: string }> | null | undefined, activityAdditions?: Array<{ __typename?: 'SchoolActivityAddition', id: number, title: string, description?: string | null | undefined, require: boolean, itemType: AdditionItemType, maxLength?: number | null | undefined, useTime?: boolean | null | undefined, items?: Array<{ __typename?: 'SchoolActivityAdditionItem', id: number, value: string, label: string }> | null | undefined }> | null | undefined, activityStatuses?: Array<{ __typename?: 'SchoolActivityStatus', value: string, label: string, defaultValue?: string | null | undefined }> | null | undefined, jobHuntingStatuses?: Array<{ __typename?: 'JobHuntingStatus', id: number, value: number, label: string }> | null | undefined, groupSchools?: Array<{ __typename?: 'School', id: number, name: string }> | null | undefined }, profile: { __typename?: 'UserProfile', id: number, firstName?: string | null | undefined, lastName?: string | null | undefined, firstKana?: string | null | undefined, lastKana?: string | null | undefined, courseId?: number | null | undefined, courseName?: string | null | undefined, className?: string | null | undefined, studentNo?: string | null | undefined, teacherId?: number | null | undefined, teacherName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined, gender?: number | null | undefined, dateOfBirth?: any | null | undefined, postalCode?: string | null | undefined, prefectureCode?: string | null | undefined, prefecture?: string | null | undefined, cityName?: string | null | undefined, addressOther?: string | null | undefined, addressFurigana?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, prTitle1?: string | null | undefined, prContent1?: string | null | undefined, prTitle2?: string | null | undefined, prContent2?: string | null | undefined, prTitle3?: string | null | undefined, prContent3?: string | null | undefined, resumeRate?: number | null | undefined, isApproved?: boolean | null | undefined, isPublic?: boolean | null | undefined, createdAt?: any | null | undefined, licenses?: Array<{ __typename?: 'License', id: number, title: string, year?: number | null | undefined, month?: number | null | undefined, status?: LicenseStatus | null | undefined, createdAt: any, updatedAt: any }> | null | undefined, careers?: Array<{ __typename?: 'Career', corporationName: string, employment?: string | null | undefined, employmentType?: CareerEmploymentType | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, retirementYear?: number | null | undefined, retirementMonth?: number | null | undefined, lengthOfService?: number | null | undefined, occupation?: string | null | undefined, description?: string | null | undefined }> | null | undefined, schoolBackgrounds?: Array<{ __typename?: 'SchoolBackground', id: number, schoolId?: number | null | undefined, schoolType?: SchoolType | null | undefined, schoolName?: string | null | undefined, courseName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined }> | null | undefined }, condition: { __typename?: 'UserCondition', id: number, industry1Code?: string | null | undefined, industry1?: string | null | undefined, industry2Code?: string | null | undefined, industry2?: string | null | undefined, industry3Code?: string | null | undefined, industry3?: string | null | undefined, category1Code?: string | null | undefined, category1?: string | null | undefined, category2Code?: string | null | undefined, category2?: string | null | undefined, category3Code?: string | null | undefined, category3?: string | null | undefined, location1Code?: string | null | undefined, location1?: string | null | undefined, location2Code?: string | null | undefined, location2?: string | null | undefined, location3Code?: string | null | undefined, location3?: string | null | undefined, corporationType1Code?: string | null | undefined, corporationType1?: string | null | undefined, corporationType2Code?: string | null | undefined, corporationType2?: string | null | undefined, corporationType3Code?: string | null | undefined, corporationType3?: string | null | undefined, jobFeature1Code?: string | null | undefined, jobFeature1?: string | null | undefined, jobFeature2Code?: string | null | undefined, jobFeature2?: string | null | undefined, jobFeature3Code?: string | null | undefined, jobFeature3?: string | null | undefined, monthlyIncome?: number | null | undefined, holiday0?: boolean | null | undefined, holiday1?: boolean | null | undefined, holiday2?: boolean | null | undefined, holiday3?: boolean | null | undefined, holiday4?: boolean | null | undefined, holiday5?: boolean | null | undefined, holiday6?: boolean | null | undefined, workStartTime?: any | null | undefined, workEndTime?: any | null | undefined } } | null | undefined, portfolios: Array<{ __typename?: 'Portfolio', id: number, title: string, content?: string | null | undefined, year?: number | null | undefined, month?: number | null | undefined, url?: string | null | undefined, fileUrl?: string | null | undefined, imageUrl?: string | null | undefined, imageUrls?: Array<string> | null | undefined, privacySetting?: PrivacySetting | null | undefined, createdAt: any, updatedAt: any, likeCount?: number | null | undefined, commentCount?: number | null | undefined, fileInfo?: { __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, url: string, fileType?: FileType | null | undefined } | null | undefined, images?: Array<{ __typename?: 'FileInfo', id?: string | null | undefined, url: string, contentType: string, name: string }> | null | undefined, comments?: Array<{ __typename?: 'PortfolioComment', id: number, comment: string, createdAt: any, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined }> | null | undefined, likes?: Array<{ __typename?: 'PortfolioLike', id: number, createdAt: any, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined }> | null | undefined }>, licenses: Array<{ __typename?: 'License', id: number, title: string, year?: number | null | undefined, month?: number | null | undefined, status?: LicenseStatus | null | undefined, createdAt: any, updatedAt: any }>, careers: Array<{ __typename?: 'Career', corporationName: string, employment?: string | null | undefined, employmentType?: CareerEmploymentType | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, retirementYear?: number | null | undefined, retirementMonth?: number | null | undefined, lengthOfService?: number | null | undefined, occupation?: string | null | undefined, description?: string | null | undefined }> };

export type CreateJobEntryMutationVariables = Exact<{
  entry: JobEntryInput;
}>;


export type CreateJobEntryMutation = { __typename?: 'Mutation', createJobEntry?: { __typename?: 'CreateJobEntryPayload', result?: boolean | null | undefined, error?: string | null | undefined, entry?: { __typename?: 'Entry', id?: number | null | undefined, createdAt: any, updatedAt: any, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type CreateCorporationVisitEntryMutationVariables = Exact<{
  input: CreateCorporationVisitEntryInput;
}>;


export type CreateCorporationVisitEntryMutation = { __typename?: 'Mutation', createCorporationVisitEntry?: { __typename?: 'CreateCorporationVisitEntryPayload', result?: boolean | null | undefined, error?: string | null | undefined, entry?: { __typename?: 'Entry', id?: number | null | undefined } | null | undefined } | null | undefined };

export type FeedAttributesFragment = { __typename?: 'Post', id: number, feedId: number, title: string, content: string, contentSummary: string, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, imageUrl1?: string | null | undefined, imageUrl2?: string | null | undefined, author: string, authorImageUrl?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, bookmarkCount: number, like?: boolean | null | undefined, likeCount: number, readAt?: any | null | undefined, video?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, url?: string | null | undefined, address?: string | null | undefined }, members?: Array<{ __typename?: 'PostMember', id: number, name: string, office?: string | null | undefined, position?: string | null | undefined, imageUrl?: string | null | undefined }> | null | undefined, messageForLike?: { __typename?: 'MessageForAction', imageUrl?: string | null | undefined, message: string } | null | undefined };

export type FeedAttributesWithoutContentFragment = { __typename?: 'Post', id: number, feedId: number, title: string, contentSummary: string, imageUrl?: string | null | undefined, imageUrl1?: string | null | undefined, imageUrl2?: string | null | undefined, author: string, authorImageUrl?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, bookmarkCount: number, like?: boolean | null | undefined, likeCount: number, readAt?: any | null | undefined, postTag?: string | null | undefined, video?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, url?: string | null | undefined, address?: string | null | undefined }, members?: Array<{ __typename?: 'PostMember', id: number, name: string, office?: string | null | undefined, position?: string | null | undefined, imageUrl?: string | null | undefined }> | null | undefined, messageForLike?: { __typename?: 'MessageForAction', imageUrl?: string | null | undefined, message: string } | null | undefined, categories?: Array<{ __typename?: 'PostCategory', id: number, name: string }> | null | undefined };

export type FeedCategoryAttributesFragment = { __typename?: 'PostCategory', id: number, name: string, description?: string | null | undefined, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, postCount?: number | null | undefined, lastPostedAt?: any | null | undefined, corporations?: Array<{ __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined }> | null | undefined };

export type VoiceBoardAttributesFragment = { __typename?: 'SeniorArticle', id: number, title: string, content: string, imageUrl?: string | null | undefined, createdAt: any, updatedAt: any, contributor: string, schoolCourse?: string | null | undefined, enteringYear?: string | null | undefined, enteringMonth?: string | null | undefined, corporationName?: string | null | undefined };

export type SearchFeedsQueryVariables = Exact<{
  conditions: SearchFeedInput;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type SearchFeedsQuery = { __typename?: 'Query', feeds: Array<{ __typename?: 'Post', id: number, feedId: number, title: string, contentSummary: string, imageUrl?: string | null | undefined, imageUrl1?: string | null | undefined, imageUrl2?: string | null | undefined, author: string, authorImageUrl?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, bookmarkCount: number, like?: boolean | null | undefined, likeCount: number, readAt?: any | null | undefined, postTag?: string | null | undefined, video?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, url?: string | null | undefined, address?: string | null | undefined }, members?: Array<{ __typename?: 'PostMember', id: number, name: string, office?: string | null | undefined, position?: string | null | undefined, imageUrl?: string | null | undefined }> | null | undefined, messageForLike?: { __typename?: 'MessageForAction', imageUrl?: string | null | undefined, message: string } | null | undefined, categories?: Array<{ __typename?: 'PostCategory', id: number, name: string }> | null | undefined }> };

export type FeedTopDataQueryVariables = Exact<{
  latestFeedsLimit?: InputMaybe<Scalars['Int']>;
  popularFeedsLimit?: InputMaybe<Scalars['Int']>;
}>;


export type FeedTopDataQuery = { __typename?: 'Query', popularFeeds: Array<{ __typename?: 'Post', id: number, feedId: number, title: string, content: string, contentSummary: string, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, imageUrl1?: string | null | undefined, imageUrl2?: string | null | undefined, author: string, authorImageUrl?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, bookmarkCount: number, like?: boolean | null | undefined, likeCount: number, readAt?: any | null | undefined, video?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, url?: string | null | undefined, address?: string | null | undefined }, members?: Array<{ __typename?: 'PostMember', id: number, name: string, office?: string | null | undefined, position?: string | null | undefined, imageUrl?: string | null | undefined }> | null | undefined, messageForLike?: { __typename?: 'MessageForAction', imageUrl?: string | null | undefined, message: string } | null | undefined }>, latestFeeds: Array<{ __typename?: 'Post', id: number, feedId: number, title: string, content: string, contentSummary: string, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, imageUrl1?: string | null | undefined, imageUrl2?: string | null | undefined, author: string, authorImageUrl?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, bookmarkCount: number, like?: boolean | null | undefined, likeCount: number, readAt?: any | null | undefined, video?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, url?: string | null | undefined, address?: string | null | undefined }, members?: Array<{ __typename?: 'PostMember', id: number, name: string, office?: string | null | undefined, position?: string | null | undefined, imageUrl?: string | null | undefined }> | null | undefined, messageForLike?: { __typename?: 'MessageForAction', imageUrl?: string | null | undefined, message: string } | null | undefined }>, feedCategories: Array<{ __typename?: 'PostCategory', id: number, name: string, description?: string | null | undefined, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, postCount?: number | null | undefined, lastPostedAt?: any | null | undefined, corporations?: Array<{ __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined }> | null | undefined }> };

export type FeedCertificateTopDataQueryVariables = Exact<{
  latestFeedsLimit?: InputMaybe<Scalars['Int']>;
  popularFeedsLimit?: InputMaybe<Scalars['Int']>;
}>;


export type FeedCertificateTopDataQuery = { __typename?: 'Query', popularCertificateFeeds: Array<{ __typename?: 'Post', id: number, feedId: number, title: string, content: string, contentSummary: string, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, imageUrl1?: string | null | undefined, imageUrl2?: string | null | undefined, author: string, authorImageUrl?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, bookmarkCount: number, like?: boolean | null | undefined, likeCount: number, readAt?: any | null | undefined, video?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, url?: string | null | undefined, address?: string | null | undefined }, members?: Array<{ __typename?: 'PostMember', id: number, name: string, office?: string | null | undefined, position?: string | null | undefined, imageUrl?: string | null | undefined }> | null | undefined, messageForLike?: { __typename?: 'MessageForAction', imageUrl?: string | null | undefined, message: string } | null | undefined }>, latestCertificateFeeds: Array<{ __typename?: 'Post', id: number, feedId: number, title: string, content: string, contentSummary: string, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, imageUrl1?: string | null | undefined, imageUrl2?: string | null | undefined, author: string, authorImageUrl?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, bookmarkCount: number, like?: boolean | null | undefined, likeCount: number, readAt?: any | null | undefined, video?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, url?: string | null | undefined, address?: string | null | undefined }, members?: Array<{ __typename?: 'PostMember', id: number, name: string, office?: string | null | undefined, position?: string | null | undefined, imageUrl?: string | null | undefined }> | null | undefined, messageForLike?: { __typename?: 'MessageForAction', imageUrl?: string | null | undefined, message: string } | null | undefined }>, feedCertificateCategories: Array<{ __typename?: 'PostCategory', id: number, name: string, description?: string | null | undefined, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, postCount?: number | null | undefined, lastPostedAt?: any | null | undefined, corporations?: Array<{ __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined }> | null | undefined }> };

export type PopularCertificateFeedsDataQueryVariables = Exact<{
  popularFeedsLimit?: InputMaybe<Scalars['Int']>;
}>;


export type PopularCertificateFeedsDataQuery = { __typename?: 'Query', popularCertificateFeeds: Array<{ __typename?: 'Post', id: number, feedId: number, title: string, imageUrl?: string | null | undefined, createdAt?: any | null | undefined, bookmark?: boolean | null | undefined, bookmarkCount: number, like?: boolean | null | undefined, likeCount: number, readAt?: any | null | undefined, video?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined } }> };

export type FeedCorporationTopDataQueryVariables = Exact<{
  latestFeedsLimit?: InputMaybe<Scalars['Int']>;
  popularFeedsLimit?: InputMaybe<Scalars['Int']>;
}>;


export type FeedCorporationTopDataQuery = { __typename?: 'Query', popularCorporationFeeds: Array<{ __typename?: 'Post', id: number, feedId: number, title: string, content: string, contentSummary: string, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, imageUrl1?: string | null | undefined, imageUrl2?: string | null | undefined, author: string, authorImageUrl?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, bookmarkCount: number, like?: boolean | null | undefined, likeCount: number, readAt?: any | null | undefined, video?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, url?: string | null | undefined, address?: string | null | undefined }, members?: Array<{ __typename?: 'PostMember', id: number, name: string, office?: string | null | undefined, position?: string | null | undefined, imageUrl?: string | null | undefined }> | null | undefined, messageForLike?: { __typename?: 'MessageForAction', imageUrl?: string | null | undefined, message: string } | null | undefined }>, latestCorporationFeeds: Array<{ __typename?: 'Post', id: number, feedId: number, title: string, content: string, contentSummary: string, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, imageUrl1?: string | null | undefined, imageUrl2?: string | null | undefined, author: string, authorImageUrl?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, bookmarkCount: number, like?: boolean | null | undefined, likeCount: number, readAt?: any | null | undefined, video?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, url?: string | null | undefined, address?: string | null | undefined }, members?: Array<{ __typename?: 'PostMember', id: number, name: string, office?: string | null | undefined, position?: string | null | undefined, imageUrl?: string | null | undefined }> | null | undefined, messageForLike?: { __typename?: 'MessageForAction', imageUrl?: string | null | undefined, message: string } | null | undefined }>, feedCorporateCategories: Array<{ __typename?: 'PostCategory', id: number, name: string, description?: string | null | undefined, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, postCount?: number | null | undefined, lastPostedAt?: any | null | undefined, corporations?: Array<{ __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined }> | null | undefined }> };

export type CorporationFeedsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CorporationFeedsQuery = { __typename?: 'Query', feeds: Array<{ __typename?: 'Post', id: number, feedId: number, title: string, content: string, contentSummary: string, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, imageUrl1?: string | null | undefined, imageUrl2?: string | null | undefined, author: string, authorImageUrl?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, bookmarkCount: number, like?: boolean | null | undefined, likeCount: number, readAt?: any | null | undefined, video?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, url?: string | null | undefined, address?: string | null | undefined }, members?: Array<{ __typename?: 'PostMember', id: number, name: string, office?: string | null | undefined, position?: string | null | undefined, imageUrl?: string | null | undefined }> | null | undefined, messageForLike?: { __typename?: 'MessageForAction', imageUrl?: string | null | undefined, message: string } | null | undefined }> };

export type FindFeedQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FindFeedQuery = { __typename?: 'Query', feed?: { __typename?: 'Post', id: number, feedId: number, title: string, content: string, contentSummary: string, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, imageUrl1?: string | null | undefined, imageUrl2?: string | null | undefined, author: string, authorImageUrl?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, bookmarkCount: number, like?: boolean | null | undefined, likeCount: number, readAt?: any | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, url?: string | null | undefined, address?: string | null | undefined, members?: Array<{ __typename?: 'CorporationMember', id: number, name: string, office?: string | null | undefined, position?: string | null | undefined, imageUrl?: string | null | undefined }> | null | undefined }, video?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, members?: Array<{ __typename?: 'PostMember', id: number, name: string, office?: string | null | undefined, position?: string | null | undefined, imageUrl?: string | null | undefined }> | null | undefined, messageForLike?: { __typename?: 'MessageForAction', imageUrl?: string | null | undefined, message: string } | null | undefined } | null | undefined };

export type SearchFeedCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchFeedCategoriesQuery = { __typename?: 'Query', feedCategories: Array<{ __typename?: 'PostCategory', id: number, name: string, description?: string | null | undefined, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, postCount?: number | null | undefined, lastPostedAt?: any | null | undefined, corporations?: Array<{ __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined }> | null | undefined }> };

export type FindFeedCategoryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FindFeedCategoryQuery = { __typename?: 'Query', feedCategory?: { __typename?: 'PostCategory', id: number, name: string, description?: string | null | undefined, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, postCount?: number | null | undefined, lastPostedAt?: any | null | undefined, corporations?: Array<{ __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined }> | null | undefined } | null | undefined };

export type SearchPaginationFeedsQueryVariables = Exact<{
  conditions: SearchFeedInput;
  page: Scalars['Int'];
  limit: Scalars['Int'];
  isGetAggregate?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchPaginationFeedsQuery = { __typename?: 'Query', paginationFeeds: { __typename?: 'PaginationFeeds', feeds?: Array<{ __typename?: 'Post', id: number, feedId: number, title: string, content: string, contentSummary: string, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, imageUrl1?: string | null | undefined, imageUrl2?: string | null | undefined, author: string, authorImageUrl?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, bookmarkCount: number, like?: boolean | null | undefined, likeCount: number, readAt?: any | null | undefined, video?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, url?: string | null | undefined, address?: string | null | undefined }, members?: Array<{ __typename?: 'PostMember', id: number, name: string, office?: string | null | undefined, position?: string | null | undefined, imageUrl?: string | null | undefined }> | null | undefined, messageForLike?: { __typename?: 'MessageForAction', imageUrl?: string | null | undefined, message: string } | null | undefined }> | null | undefined, pagination?: { __typename?: 'Pagination', currentPage?: number | null | undefined, limitValue?: number | null | undefined, totalCount?: number | null | undefined, totalPages?: number | null | undefined } | null | undefined } };

export type SearchPaginationVoiceBoardsQueryVariables = Exact<{
  page: Scalars['Int'];
  limit: Scalars['Int'];
  isGetAggregate?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchPaginationVoiceBoardsQuery = { __typename?: 'Query', paginationVoiceBoards: { __typename?: 'PaginationSeniorArticles', voiceBoards?: Array<{ __typename?: 'SeniorArticle', id: number, title: string, content: string, imageUrl?: string | null | undefined, createdAt: any, updatedAt: any, contributor: string, schoolCourse?: string | null | undefined, enteringYear?: string | null | undefined, enteringMonth?: string | null | undefined, corporationName?: string | null | undefined }> | null | undefined, pagination?: { __typename?: 'Pagination', currentPage?: number | null | undefined, limitValue?: number | null | undefined, totalCount?: number | null | undefined, totalPages?: number | null | undefined } | null | undefined } };

export type FindVoiceBoardsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindVoiceBoardsQuery = { __typename?: 'Query', voiceBoards: Array<{ __typename?: 'SeniorArticle', id: number, title: string, content: string, imageUrl?: string | null | undefined, createdAt: any, updatedAt: any, contributor: string, schoolCourse?: string | null | undefined, enteringYear?: string | null | undefined, enteringMonth?: string | null | undefined, corporationName?: string | null | undefined }> };

export type FindVoiceBoardsAsVoiceQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FindVoiceBoardsAsVoiceQuery = { __typename?: 'Query', voiceBoardsAsVoice: Array<{ __typename?: 'SeniorArticle', id: number, title: string, content: string, imageUrl?: string | null | undefined, createdAt: any, updatedAt: any, contributor: string, schoolCourse?: string | null | undefined, enteringYear?: string | null | undefined, enteringMonth?: string | null | undefined, corporationName?: string | null | undefined }> };

export type FindVoiceBoardQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FindVoiceBoardQuery = { __typename?: 'Query', voiceBoard?: { __typename?: 'SeniorArticle', id: number, title: string, content: string, imageUrl?: string | null | undefined, createdAt: any, updatedAt: any, contributor: string, schoolCourse?: string | null | undefined, enteringYear?: string | null | undefined, enteringMonth?: string | null | undefined, corporationName?: string | null | undefined } | null | undefined };

export type CorporationEventInternshipAttributesFragment = { __typename?: 'CorporationEventInternship', id: number, title?: string | null | undefined, content?: string | null | undefined, closingDate: any, numberOfAccepted?: number | null | undefined, enableInternational?: boolean | null | undefined, requirements?: string | null | undefined, periodFrom: any, periodTo: any, timeSchedule?: string | null | undefined, holiday?: string | null | undefined, firstMeetingPlace?: string | null | undefined, internshipDays?: number | null | undefined, whatToBring?: string | null | undefined, howToApply?: string | null | undefined, note?: string | null | undefined, imageUrl?: string | null | undefined, prefecture?: string | null | undefined, venue?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, schoolEntry?: boolean | null | undefined, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, address?: string | null | undefined } | null | undefined, office?: { __typename?: 'CorporationOffice', id: number, name: string, address?: string | null | undefined } | null | undefined, staff?: { __typename?: 'CorporationStaff', name?: string | null | undefined } | null | undefined };

export type SearchInternshipsQueryVariables = Exact<{
  conditions: SearchEventInput;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type SearchInternshipsQuery = { __typename?: 'Query', internships: Array<{ __typename?: 'CorporationEventInternship', id: number, title?: string | null | undefined, content?: string | null | undefined, closingDate: any, numberOfAccepted?: number | null | undefined, enableInternational?: boolean | null | undefined, requirements?: string | null | undefined, periodFrom: any, periodTo: any, timeSchedule?: string | null | undefined, holiday?: string | null | undefined, firstMeetingPlace?: string | null | undefined, internshipDays?: number | null | undefined, whatToBring?: string | null | undefined, howToApply?: string | null | undefined, note?: string | null | undefined, imageUrl?: string | null | undefined, prefecture?: string | null | undefined, venue?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, schoolEntry?: boolean | null | undefined, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, logoUrl?: string | null | undefined, address?: string | null | undefined } | null | undefined, office?: { __typename?: 'CorporationOffice', id: number, name: string, address?: string | null | undefined } | null | undefined, staff?: { __typename?: 'CorporationStaff', name?: string | null | undefined } | null | undefined }> };

export type FindInternshipQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FindInternshipQuery = { __typename?: 'Query', internship?: { __typename?: 'CorporationEventInternship', id: number, title?: string | null | undefined, content?: string | null | undefined, closingDate: any, numberOfAccepted?: number | null | undefined, enableInternational?: boolean | null | undefined, requirements?: string | null | undefined, periodFrom: any, periodTo: any, timeSchedule?: string | null | undefined, holiday?: string | null | undefined, firstMeetingPlace?: string | null | undefined, internshipDays?: number | null | undefined, whatToBring?: string | null | undefined, howToApply?: string | null | undefined, note?: string | null | undefined, imageUrl?: string | null | undefined, prefecture?: string | null | undefined, venue?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, schoolEntry?: boolean | null | undefined, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, address?: string | null | undefined, nameKana?: string | null | undefined, businessFormI18n?: string | null | undefined, logoUrl?: string | null | undefined, coverImageUrl?: string | null | undefined, mainImageUrl?: string | null | undefined, url?: string | null | undefined, corporationNumber?: string | null | undefined, philosophyTitle?: string | null | undefined, philosophy?: string | null | undefined, philosophyImage1Url?: string | null | undefined, philosophyImage2Url?: string | null | undefined, visionTitle?: string | null | undefined, vision?: string | null | undefined, visionImage1Url?: string | null | undefined, visionImage2Url?: string | null | undefined, zipCode?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, description?: string | null | undefined, topManager?: string | null | undefined, topManagerKana?: string | null | undefined, topManagerPosition?: string | null | undefined, topManagerSchool?: string | null | undefined, establishmentDate?: string | null | undefined, capital?: string | null | undefined, annualSales?: string | null | undefined, housingAllowance?: string | null | undefined, numberOfEmployee?: string | null | undefined, numberOfOffices?: number | null | undefined, affiliatedCompany?: string | null | undefined, plan?: number | null | undefined, messageContent?: string | null | undefined, messageName?: string | null | undefined, messageImageUrl?: string | null | undefined, schoolMemo?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, tags?: Array<string> | null | undefined, visitReception?: { __typename?: 'VisitReception', visitReceptionRequired?: boolean | null | undefined, visitReceptionTimeFrom?: string | null | undefined, visitReceptionTimeTo?: string | null | undefined, visitReceptionWeekday?: Array<boolean> | null | undefined } | null | undefined, handicapAdoption?: { __typename?: 'HandicapAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, internationalAdoption?: { __typename?: 'InternationalAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, coverVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, messageVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, recruiter?: { __typename?: 'CorporationStaff', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, tel?: string | null | undefined, email?: string | null | undefined, position?: string | null | undefined, message?: string | null | undefined, imageUrl?: string | null | undefined } | null | undefined, areas?: Array<{ __typename?: 'CorporationArea', id: number, name?: string | null | undefined, offices?: Array<{ __typename?: 'CorporationOffice', id: number, name: string, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, imageUrl2?: string | null | undefined, imageUrl3?: string | null | undefined, imageUrl4?: string | null | undefined, imageUrl5?: string | null | undefined }> | null | undefined }> | null | undefined, members?: Array<{ __typename?: 'CorporationMember', id: number, name: string, nameKana: string, position?: string | null | undefined, office?: string | null | undefined, imageUrl?: string | null | undefined, schoolName?: string | null | undefined, sameSchool: boolean, enteringYear?: string | null | undefined }> | null | undefined, additions?: Array<{ __typename?: 'AdditionItem', id: number, title: string, content: string }> | null | undefined } | null | undefined, office?: { __typename?: 'CorporationOffice', id: number, name: string, address?: string | null | undefined } | null | undefined, staff?: { __typename?: 'CorporationStaff', name?: string | null | undefined } | null | undefined } | null | undefined };

export type FindInternshipWithNeedMoreQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FindInternshipWithNeedMoreQuery = { __typename?: 'Query', needMore?: { __typename?: 'NeedMore', auth: boolean } | null | undefined, internship?: { __typename?: 'CorporationEventInternship', id: number, title?: string | null | undefined, content?: string | null | undefined, closingDate: any, numberOfAccepted?: number | null | undefined, enableInternational?: boolean | null | undefined, requirements?: string | null | undefined, periodFrom: any, periodTo: any, timeSchedule?: string | null | undefined, holiday?: string | null | undefined, firstMeetingPlace?: string | null | undefined, internshipDays?: number | null | undefined, whatToBring?: string | null | undefined, howToApply?: string | null | undefined, note?: string | null | undefined, imageUrl?: string | null | undefined, prefecture?: string | null | undefined, venue?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, schoolEntry?: boolean | null | undefined, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, address?: string | null | undefined, nameKana?: string | null | undefined, businessFormI18n?: string | null | undefined, logoUrl?: string | null | undefined, coverImageUrl?: string | null | undefined, mainImageUrl?: string | null | undefined, url?: string | null | undefined, corporationNumber?: string | null | undefined, philosophyTitle?: string | null | undefined, philosophy?: string | null | undefined, philosophyImage1Url?: string | null | undefined, philosophyImage2Url?: string | null | undefined, visionTitle?: string | null | undefined, vision?: string | null | undefined, visionImage1Url?: string | null | undefined, visionImage2Url?: string | null | undefined, zipCode?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, description?: string | null | undefined, topManager?: string | null | undefined, topManagerKana?: string | null | undefined, topManagerPosition?: string | null | undefined, topManagerSchool?: string | null | undefined, establishmentDate?: string | null | undefined, capital?: string | null | undefined, annualSales?: string | null | undefined, housingAllowance?: string | null | undefined, numberOfEmployee?: string | null | undefined, numberOfOffices?: number | null | undefined, affiliatedCompany?: string | null | undefined, plan?: number | null | undefined, messageContent?: string | null | undefined, messageName?: string | null | undefined, messageImageUrl?: string | null | undefined, schoolMemo?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, tags?: Array<string> | null | undefined, visitReception?: { __typename?: 'VisitReception', visitReceptionRequired?: boolean | null | undefined, visitReceptionTimeFrom?: string | null | undefined, visitReceptionTimeTo?: string | null | undefined, visitReceptionWeekday?: Array<boolean> | null | undefined } | null | undefined, handicapAdoption?: { __typename?: 'HandicapAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, internationalAdoption?: { __typename?: 'InternationalAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, coverVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, messageVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, recruiter?: { __typename?: 'CorporationStaff', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, tel?: string | null | undefined, email?: string | null | undefined, position?: string | null | undefined, message?: string | null | undefined, imageUrl?: string | null | undefined } | null | undefined, areas?: Array<{ __typename?: 'CorporationArea', id: number, name?: string | null | undefined, offices?: Array<{ __typename?: 'CorporationOffice', id: number, name: string, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, imageUrl2?: string | null | undefined, imageUrl3?: string | null | undefined, imageUrl4?: string | null | undefined, imageUrl5?: string | null | undefined }> | null | undefined }> | null | undefined, members?: Array<{ __typename?: 'CorporationMember', id: number, name: string, nameKana: string, position?: string | null | undefined, office?: string | null | undefined, imageUrl?: string | null | undefined, schoolName?: string | null | undefined, sameSchool: boolean, enteringYear?: string | null | undefined }> | null | undefined, additions?: Array<{ __typename?: 'AdditionItem', id: number, title: string, content: string }> | null | undefined } | null | undefined, office?: { __typename?: 'CorporationOffice', id: number, name: string, address?: string | null | undefined } | null | undefined, staff?: { __typename?: 'CorporationStaff', name?: string | null | undefined } | null | undefined } | null | undefined };

export type CreateInternshipEntryMutationVariables = Exact<{
  entry: InternshipEntryInput;
}>;


export type CreateInternshipEntryMutation = { __typename?: 'Mutation', createInternshipEntry?: { __typename?: 'CreateInternshipEntryPayload', error?: string | null | undefined, entry?: { __typename?: 'Entry', corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type InternshipEntryDataQueryVariables = Exact<{
  internshipId: Scalars['Int'];
}>;


export type InternshipEntryDataQuery = { __typename?: 'Query', internship?: { __typename?: 'CorporationEventInternship', id: number, title?: string | null | undefined, content?: string | null | undefined, closingDate: any, numberOfAccepted?: number | null | undefined, enableInternational?: boolean | null | undefined, requirements?: string | null | undefined, periodFrom: any, periodTo: any, timeSchedule?: string | null | undefined, holiday?: string | null | undefined, firstMeetingPlace?: string | null | undefined, internshipDays?: number | null | undefined, whatToBring?: string | null | undefined, howToApply?: string | null | undefined, note?: string | null | undefined, imageUrl?: string | null | undefined, prefecture?: string | null | undefined, venue?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, schoolEntry?: boolean | null | undefined, entrySetting?: { __typename?: 'EntrySetting', showMemo: boolean, requireMemo: boolean, showLocation: boolean, requireLocation: boolean, privacyPolicyUrl?: string | null | undefined, additions?: Array<{ __typename?: 'EntryAddition', id: number, title: string, description?: string | null | undefined, require: boolean, items?: Array<string> | null | undefined, showMemo: boolean, additionType: EntryAdditionInputType }> | null | undefined } | null | undefined, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined, likeAll?: number | null | undefined, address?: string | null | undefined } | null | undefined, office?: { __typename?: 'CorporationOffice', id: number, name: string, address?: string | null | undefined } | null | undefined, staff?: { __typename?: 'CorporationStaff', name?: string | null | undefined } | null | undefined } | null | undefined, user?: { __typename?: 'User', id: number, email: string, pushNotification: boolean, emailNotification: boolean, jobHuntingStatus: number, jobHuntingStatusLabel: string, school: { __typename?: 'School', id: number, name: string, plan?: SchoolPlan | null | undefined, isBasicPlanOrMore?: boolean | null | undefined, schoolNumber?: string | null | undefined, useCertificate?: boolean | null | undefined, logoUrl?: string | null | undefined, official?: boolean | null | undefined, allowPartTime?: boolean | null | undefined, allowOutsourcing?: boolean | null | undefined, companyVisitEntryType?: CompanyVisitEntry | null | undefined, groupName?: string | null | undefined, courses?: Array<{ __typename?: 'SchoolCourse', id: number, name: string }> | null | undefined, teachers?: Array<{ __typename?: 'SchoolTeacher', id: number, name: string }> | null | undefined, activityAdditions?: Array<{ __typename?: 'SchoolActivityAddition', id: number, title: string, description?: string | null | undefined, require: boolean, itemType: AdditionItemType, maxLength?: number | null | undefined, useTime?: boolean | null | undefined, items?: Array<{ __typename?: 'SchoolActivityAdditionItem', id: number, value: string, label: string }> | null | undefined }> | null | undefined, activityStatuses?: Array<{ __typename?: 'SchoolActivityStatus', value: string, label: string, defaultValue?: string | null | undefined }> | null | undefined, jobHuntingStatuses?: Array<{ __typename?: 'JobHuntingStatus', id: number, value: number, label: string }> | null | undefined, groupSchools?: Array<{ __typename?: 'School', id: number, name: string }> | null | undefined }, profile: { __typename?: 'UserProfile', id: number, firstName?: string | null | undefined, lastName?: string | null | undefined, firstKana?: string | null | undefined, lastKana?: string | null | undefined, courseId?: number | null | undefined, courseName?: string | null | undefined, className?: string | null | undefined, studentNo?: string | null | undefined, teacherId?: number | null | undefined, teacherName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined, gender?: number | null | undefined, dateOfBirth?: any | null | undefined, postalCode?: string | null | undefined, prefectureCode?: string | null | undefined, prefecture?: string | null | undefined, cityName?: string | null | undefined, addressOther?: string | null | undefined, addressFurigana?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, prTitle1?: string | null | undefined, prContent1?: string | null | undefined, prTitle2?: string | null | undefined, prContent2?: string | null | undefined, prTitle3?: string | null | undefined, prContent3?: string | null | undefined, resumeRate?: number | null | undefined, isApproved?: boolean | null | undefined, isPublic?: boolean | null | undefined, createdAt?: any | null | undefined, licenses?: Array<{ __typename?: 'License', id: number, title: string, year?: number | null | undefined, month?: number | null | undefined, status?: LicenseStatus | null | undefined, createdAt: any, updatedAt: any }> | null | undefined, careers?: Array<{ __typename?: 'Career', corporationName: string, employment?: string | null | undefined, employmentType?: CareerEmploymentType | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, retirementYear?: number | null | undefined, retirementMonth?: number | null | undefined, lengthOfService?: number | null | undefined, occupation?: string | null | undefined, description?: string | null | undefined }> | null | undefined, schoolBackgrounds?: Array<{ __typename?: 'SchoolBackground', id: number, schoolId?: number | null | undefined, schoolType?: SchoolType | null | undefined, schoolName?: string | null | undefined, courseName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined }> | null | undefined }, condition: { __typename?: 'UserCondition', id: number, industry1Code?: string | null | undefined, industry1?: string | null | undefined, industry2Code?: string | null | undefined, industry2?: string | null | undefined, industry3Code?: string | null | undefined, industry3?: string | null | undefined, category1Code?: string | null | undefined, category1?: string | null | undefined, category2Code?: string | null | undefined, category2?: string | null | undefined, category3Code?: string | null | undefined, category3?: string | null | undefined, location1Code?: string | null | undefined, location1?: string | null | undefined, location2Code?: string | null | undefined, location2?: string | null | undefined, location3Code?: string | null | undefined, location3?: string | null | undefined, corporationType1Code?: string | null | undefined, corporationType1?: string | null | undefined, corporationType2Code?: string | null | undefined, corporationType2?: string | null | undefined, corporationType3Code?: string | null | undefined, corporationType3?: string | null | undefined, jobFeature1Code?: string | null | undefined, jobFeature1?: string | null | undefined, jobFeature2Code?: string | null | undefined, jobFeature2?: string | null | undefined, jobFeature3Code?: string | null | undefined, jobFeature3?: string | null | undefined, monthlyIncome?: number | null | undefined, holiday0?: boolean | null | undefined, holiday1?: boolean | null | undefined, holiday2?: boolean | null | undefined, holiday3?: boolean | null | undefined, holiday4?: boolean | null | undefined, holiday5?: boolean | null | undefined, holiday6?: boolean | null | undefined, workStartTime?: any | null | undefined, workEndTime?: any | null | undefined } } | null | undefined, portfolios: Array<{ __typename?: 'Portfolio', id: number, title: string, content?: string | null | undefined, year?: number | null | undefined, month?: number | null | undefined, url?: string | null | undefined, fileUrl?: string | null | undefined, imageUrl?: string | null | undefined, imageUrls?: Array<string> | null | undefined, privacySetting?: PrivacySetting | null | undefined, createdAt: any, updatedAt: any, likeCount?: number | null | undefined, commentCount?: number | null | undefined, fileInfo?: { __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, url: string, fileType?: FileType | null | undefined } | null | undefined, images?: Array<{ __typename?: 'FileInfo', id?: string | null | undefined, url: string, contentType: string, name: string }> | null | undefined, comments?: Array<{ __typename?: 'PortfolioComment', id: number, comment: string, createdAt: any, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined }> | null | undefined, likes?: Array<{ __typename?: 'PortfolioLike', id: number, createdAt: any, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined }> | null | undefined }>, licenses: Array<{ __typename?: 'License', id: number, title: string, year?: number | null | undefined, month?: number | null | undefined, status?: LicenseStatus | null | undefined, createdAt: any, updatedAt: any }>, careers: Array<{ __typename?: 'Career', corporationName: string, employment?: string | null | undefined, employmentType?: CareerEmploymentType | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, retirementYear?: number | null | undefined, retirementMonth?: number | null | undefined, lengthOfService?: number | null | undefined, occupation?: string | null | undefined, description?: string | null | undefined }> };

export type SearchPaginationInternshipsQueryVariables = Exact<{
  conditions: SearchEventInput;
  page: Scalars['Int'];
  limit: Scalars['Int'];
  isGetAggregate?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchPaginationInternshipsQuery = { __typename?: 'Query', paginationInternships: { __typename?: 'PaginationCorporationEventInternships', internships?: Array<{ __typename?: 'CorporationEventInternship', id: number, title?: string | null | undefined, content?: string | null | undefined, closingDate: any, numberOfAccepted?: number | null | undefined, enableInternational?: boolean | null | undefined, requirements?: string | null | undefined, periodFrom: any, periodTo: any, timeSchedule?: string | null | undefined, holiday?: string | null | undefined, firstMeetingPlace?: string | null | undefined, internshipDays?: number | null | undefined, whatToBring?: string | null | undefined, howToApply?: string | null | undefined, note?: string | null | undefined, imageUrl?: string | null | undefined, prefecture?: string | null | undefined, venue?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, schoolEntry?: boolean | null | undefined, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, address?: string | null | undefined } | null | undefined, office?: { __typename?: 'CorporationOffice', id: number, name: string, address?: string | null | undefined } | null | undefined, staff?: { __typename?: 'CorporationStaff', name?: string | null | undefined } | null | undefined }> | null | undefined, pagination?: { __typename?: 'Pagination', currentPage?: number | null | undefined, limitValue?: number | null | undefined, totalCount?: number | null | undefined, totalPages?: number | null | undefined } | null | undefined } };

export type JobDetailAttributesFragment = { __typename?: 'Job', id: number, schoolEntry: boolean, publicationDate: any, closeDate: any, catchCopy?: string | null | undefined, offer: string, descWork?: string | null | undefined, idealType?: string | null | undefined, qualification?: string | null | undefined, workingHours?: string | null | undefined, locationText?: string | null | undefined, locationCities?: string | null | undefined, holiday?: string | null | undefined, salary?: string | null | undefined, salaryIncrease?: string | null | undefined, salaryBonus?: string | null | undefined, treatment?: string | null | undefined, deducting?: string | null | undefined, vacation?: string | null | undefined, welfare?: string | null | undefined, schedule?: string | null | undefined, entryDocument?: string | null | undefined, numberOfRecruitment?: string | null | undefined, plusImage1Url?: string | null | undefined, plusImage2Url?: string | null | undefined, plusImage3Url?: string | null | undefined, coverImageUrl?: string | null | undefined, probation?: string | null | undefined, transportation?: string | null | undefined, transportationMemo?: string | null | undefined, corporationNo?: string | null | undefined, createdAt: any, updatedAt: any, bookmark?: boolean | null | undefined, sisterJobInfo?: { __typename?: 'SisterJobInfo', sisterSchoolName: string, sisterSchoolNameVisible: boolean } | null | undefined, jobStatus?: { __typename?: 'JobStatus', id: number, jobNo?: string | null | undefined, schoolMemo?: string | null | undefined } | null | undefined, locationOffices?: Array<{ __typename?: 'CorporationOffice', id: number, name: string, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, imageUrl2?: string | null | undefined, imageUrl3?: string | null | undefined, imageUrl4?: string | null | undefined, imageUrl5?: string | null | undefined }> | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, address?: string | null | undefined }, recruiter?: { __typename?: 'CorporationStaff', name?: string | null | undefined, nameKana?: string | null | undefined, tel?: string | null | undefined, email?: string | null | undefined, position?: string | null | undefined, message?: string | null | undefined, imageUrl?: string | null | undefined } | null | undefined, examination?: { __typename?: 'CorporationEvent', id: number } | null | undefined, examinationDates?: Array<{ __typename?: 'CorporationEventDate', id: number, eventDate: any, closingDate: any }> | null | undefined, examinationTimes?: Array<{ __typename?: 'CorporationEventTime', id: number, from: any, to: any, timeText?: string | null | undefined }> | null | undefined, additions?: Array<{ __typename?: 'AdditionItem', id: number, title: string, content: string }> | null | undefined, contranctInfo?: { __typename?: 'ContranctInfo', contractTerm: string, contractType: string, contractStartDate?: any | null | undefined, contractEndDate?: any | null | undefined, contractRenewalTypeLabel?: string | null | undefined, contractRenewalCriteriaLabel?: string | null | undefined, contractRenewalLimitLabel?: string | null | undefined } | null | undefined };

export type JobCardAttributesFragment = { __typename?: 'Job', id: number, offer: string, catchCopy?: string | null | undefined, closeDate: any, plusImage1Url?: string | null | undefined, plusImage2Url?: string | null | undefined, plusImage3Url?: string | null | undefined, coverImageUrl?: string | null | undefined, bookmark?: boolean | null | undefined, createdAt: any, updatedAt: any, occupation?: { __typename?: 'Occupation', id: number, label: string } | null | undefined, employmentType?: { __typename?: 'Employment', id: number, label: string } | null | undefined, listVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, jobPlanSeparates?: Array<{ __typename?: 'JobPlanSeparate', id: number, premium: boolean, locationCityList?: Array<string> | null | undefined, locationPrefectureList?: Array<string> | null | undefined }> | null | undefined, characteristics1?: { __typename?: 'JobFeature', id: number, label: string } | null | undefined, characteristics2?: { __typename?: 'JobFeature', id: number, label: string } | null | undefined, characteristics3?: { __typename?: 'JobFeature', id: number, label: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, logoUrl?: string | null | undefined, address?: string | null | undefined, plan?: number | null | undefined, category1?: { __typename?: 'Industry', id: number, code: number, label: string } | null | undefined, category2?: { __typename?: 'Industry', id: number, code: number, label: string } | null | undefined, category3?: { __typename?: 'Industry', id: number, code: number, label: string } | null | undefined, handicapAdoption?: { __typename?: 'HandicapAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, internationalAdoption?: { __typename?: 'InternationalAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined } };

export type FindJobDetailAttributesFragment = { __typename?: 'Job', id: number, bookmark?: boolean | null | undefined, coverImageUrl?: string | null | undefined, offer: string, catchCopy?: string | null | undefined, closeDate: any, numberOfRecruitment?: string | null | undefined, plusImage1Url?: string | null | undefined, plusImage2Url?: string | null | undefined, descWork?: string | null | undefined, idealType?: string | null | undefined, qualification?: string | null | undefined, locationText?: string | null | undefined, workingHours?: string | null | undefined, holiday?: string | null | undefined, vacation?: string | null | undefined, salary?: string | null | undefined, transportation?: string | null | undefined, transportationMemo?: string | null | undefined, treatment?: string | null | undefined, salaryIncrease?: string | null | undefined, salaryBonus?: string | null | undefined, welfare?: string | null | undefined, probation?: string | null | undefined, deducting?: string | null | undefined, entryDocument?: string | null | undefined, schedule?: string | null | undefined, corporationNo?: string | null | undefined, schoolEntry: boolean, jobStatus?: { __typename?: 'JobStatus', jobNo?: string | null | undefined, schoolMemo?: string | null | undefined } | null | undefined, sisterJobInfo?: { __typename?: 'SisterJobInfo', sisterSchoolName: string, sisterSchoolNameVisible: boolean } | null | undefined, occupation?: { __typename?: 'Occupation', id: number, label: string } | null | undefined, employmentType?: { __typename?: 'Employment', id: number, label: string } | null | undefined, contranctInfo?: { __typename?: 'ContranctInfo', contractTerm: string, contractType: string, contractStartDate?: any | null | undefined, contractEndDate?: any | null | undefined, contractRenewalTypeLabel?: string | null | undefined, contractRenewalCriteriaLabel?: string | null | undefined, contractRenewalLimitLabel?: string | null | undefined } | null | undefined, additions?: Array<{ __typename?: 'AdditionItem', id: number, title: string, content: string }> | null | undefined, recruiter?: { __typename?: 'CorporationStaff', imageUrl?: string | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, tel?: string | null | undefined, message?: string | null | undefined } | null | undefined, locationOffices?: Array<{ __typename?: 'CorporationOffice', id: number, name: string, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, imageUrl2?: string | null | undefined, imageUrl3?: string | null | undefined, imageUrl4?: string | null | undefined, imageUrl5?: string | null | undefined }> | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, businessFormI18n?: string | null | undefined, logoUrl?: string | null | undefined, coverImageUrl?: string | null | undefined, mainImageUrl?: string | null | undefined, url?: string | null | undefined, corporationNumber?: string | null | undefined, philosophyTitle?: string | null | undefined, philosophy?: string | null | undefined, philosophyImage1Url?: string | null | undefined, philosophyImage2Url?: string | null | undefined, visionTitle?: string | null | undefined, vision?: string | null | undefined, visionImage1Url?: string | null | undefined, visionImage2Url?: string | null | undefined, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, description?: string | null | undefined, topManager?: string | null | undefined, topManagerKana?: string | null | undefined, topManagerPosition?: string | null | undefined, topManagerSchool?: string | null | undefined, establishmentDate?: string | null | undefined, capital?: string | null | undefined, annualSales?: string | null | undefined, housingAllowance?: string | null | undefined, numberOfEmployee?: string | null | undefined, numberOfOffices?: number | null | undefined, affiliatedCompany?: string | null | undefined, plan?: number | null | undefined, messageContent?: string | null | undefined, messageName?: string | null | undefined, messageImageUrl?: string | null | undefined, schoolMemo?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, tags?: Array<string> | null | undefined, visitReception?: { __typename?: 'VisitReception', visitReceptionRequired?: boolean | null | undefined, visitReceptionTimeFrom?: string | null | undefined, visitReceptionTimeTo?: string | null | undefined, visitReceptionWeekday?: Array<boolean> | null | undefined } | null | undefined, handicapAdoption?: { __typename?: 'HandicapAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, internationalAdoption?: { __typename?: 'InternationalAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, coverVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, messageVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, recruiter?: { __typename?: 'CorporationStaff', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, tel?: string | null | undefined, email?: string | null | undefined, position?: string | null | undefined, message?: string | null | undefined, imageUrl?: string | null | undefined } | null | undefined, areas?: Array<{ __typename?: 'CorporationArea', id: number, name?: string | null | undefined, offices?: Array<{ __typename?: 'CorporationOffice', id: number, name: string, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, imageUrl2?: string | null | undefined, imageUrl3?: string | null | undefined, imageUrl4?: string | null | undefined, imageUrl5?: string | null | undefined }> | null | undefined }> | null | undefined, members?: Array<{ __typename?: 'CorporationMember', id: number, name: string, nameKana: string, position?: string | null | undefined, office?: string | null | undefined, imageUrl?: string | null | undefined, schoolName?: string | null | undefined, sameSchool: boolean, enteringYear?: string | null | undefined }> | null | undefined, additions?: Array<{ __typename?: 'AdditionItem', id: number, title: string, content: string }> | null | undefined }, coverVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, jobPlanSeparates?: Array<{ __typename?: 'JobPlanSeparate', premium: boolean, locationCityList?: Array<string> | null | undefined, locationPrefectureList?: Array<string> | null | undefined }> | null | undefined, schoolAdditions?: Array<{ __typename?: 'AdditionItem', title: string, content: string }> | null | undefined, examination?: { __typename?: 'CorporationEvent', id: number, eventId: number, title?: string | null | undefined, content?: string | null | undefined, place?: string | null | undefined, prefecture?: string | null | undefined, whatToBring?: string | null | undefined, howToApply?: string | null | undefined, note?: string | null | undefined, imageUrl?: string | null | undefined, eventTimesText?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, dates?: Array<{ __typename?: 'CorporationEventDate', id: number, eventDate: any, closingDate: any }> | null | undefined, times?: Array<{ __typename?: 'CorporationEventTime', id: number, from: any, to: any, timeText?: string | null | undefined }> | null | undefined, staff?: { __typename?: 'CorporationStaff', name?: string | null | undefined } | null | undefined } | null | undefined };

export type ExamAttributesFragment = { __typename?: 'CorporationEvent', id: number, eventId: number, title?: string | null | undefined, content?: string | null | undefined, place?: string | null | undefined, prefecture?: string | null | undefined, whatToBring?: string | null | undefined, howToApply?: string | null | undefined, note?: string | null | undefined, imageUrl?: string | null | undefined, eventTimesText?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, dates?: Array<{ __typename?: 'CorporationEventDate', id: number, eventDate: any, closingDate: any }> | null | undefined, times?: Array<{ __typename?: 'CorporationEventTime', id: number, from: any, to: any, timeText?: string | null | undefined }> | null | undefined, staff?: { __typename?: 'CorporationStaff', name?: string | null | undefined } | null | undefined };

export type SearchJobsQueryVariables = Exact<{
  conditions: SearchJobInput;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type SearchJobsQuery = { __typename?: 'Query', jobs: Array<{ __typename?: 'Job', id: number, offer: string, catchCopy?: string | null | undefined, closeDate: any, plusImage1Url?: string | null | undefined, plusImage2Url?: string | null | undefined, plusImage3Url?: string | null | undefined, coverImageUrl?: string | null | undefined, bookmark?: boolean | null | undefined, createdAt: any, updatedAt: any, occupation?: { __typename?: 'Occupation', id: number, label: string } | null | undefined, employmentType?: { __typename?: 'Employment', id: number, label: string } | null | undefined, listVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, jobPlanSeparates?: Array<{ __typename?: 'JobPlanSeparate', id: number, premium: boolean, locationCityList?: Array<string> | null | undefined, locationPrefectureList?: Array<string> | null | undefined }> | null | undefined, characteristics1?: { __typename?: 'JobFeature', id: number, label: string } | null | undefined, characteristics2?: { __typename?: 'JobFeature', id: number, label: string } | null | undefined, characteristics3?: { __typename?: 'JobFeature', id: number, label: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, logoUrl?: string | null | undefined, address?: string | null | undefined, plan?: number | null | undefined, category1?: { __typename?: 'Industry', id: number, code: number, label: string } | null | undefined, category2?: { __typename?: 'Industry', id: number, code: number, label: string } | null | undefined, category3?: { __typename?: 'Industry', id: number, code: number, label: string } | null | undefined, handicapAdoption?: { __typename?: 'HandicapAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, internationalAdoption?: { __typename?: 'InternationalAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined } }> };

export type SearchJobsCountQueryVariables = Exact<{
  conditions: SearchJobInput;
}>;


export type SearchJobsCountQuery = { __typename?: 'Query', getTotalJobCount: number };

export type SearchPickupJobsQueryVariables = Exact<{
  conditions: SearchJobInput;
}>;


export type SearchPickupJobsQuery = { __typename?: 'Query', pickupJobs: Array<{ __typename?: 'Job', id: number, offer: string, catchCopy?: string | null | undefined, closeDate: any, plusImage1Url?: string | null | undefined, plusImage2Url?: string | null | undefined, plusImage3Url?: string | null | undefined, coverImageUrl?: string | null | undefined, bookmark?: boolean | null | undefined, createdAt: any, updatedAt: any, occupation?: { __typename?: 'Occupation', id: number, label: string } | null | undefined, employmentType?: { __typename?: 'Employment', id: number, label: string } | null | undefined, listVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, jobPlanSeparates?: Array<{ __typename?: 'JobPlanSeparate', id: number, premium: boolean, locationCityList?: Array<string> | null | undefined, locationPrefectureList?: Array<string> | null | undefined }> | null | undefined, characteristics1?: { __typename?: 'JobFeature', id: number, label: string } | null | undefined, characteristics2?: { __typename?: 'JobFeature', id: number, label: string } | null | undefined, characteristics3?: { __typename?: 'JobFeature', id: number, label: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, logoUrl?: string | null | undefined, address?: string | null | undefined, plan?: number | null | undefined, category1?: { __typename?: 'Industry', id: number, code: number, label: string } | null | undefined, category2?: { __typename?: 'Industry', id: number, code: number, label: string } | null | undefined, category3?: { __typename?: 'Industry', id: number, code: number, label: string } | null | undefined, handicapAdoption?: { __typename?: 'HandicapAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, internationalAdoption?: { __typename?: 'InternationalAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined } }> };

export type SearchPaginationJobsQueryVariables = Exact<{
  conditions: SearchJobInput;
  page: Scalars['Int'];
  limit: Scalars['Int'];
  isGetAggregate?: InputMaybe<Scalars['Boolean']>;
  isDevMode?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchPaginationJobsQuery = { __typename?: 'Query', paginationJobs: { __typename?: 'PaginationJobs', jobs?: Array<{ __typename?: 'Job', id: number, offer: string, catchCopy?: string | null | undefined, closeDate: any, plusImage1Url?: string | null | undefined, plusImage2Url?: string | null | undefined, plusImage3Url?: string | null | undefined, coverImageUrl?: string | null | undefined, bookmark?: boolean | null | undefined, createdAt: any, updatedAt: any, occupation?: { __typename?: 'Occupation', id: number, label: string } | null | undefined, employmentType?: { __typename?: 'Employment', id: number, label: string } | null | undefined, listVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, jobPlanSeparates?: Array<{ __typename?: 'JobPlanSeparate', id: number, premium: boolean, locationCityList?: Array<string> | null | undefined, locationPrefectureList?: Array<string> | null | undefined }> | null | undefined, characteristics1?: { __typename?: 'JobFeature', id: number, label: string } | null | undefined, characteristics2?: { __typename?: 'JobFeature', id: number, label: string } | null | undefined, characteristics3?: { __typename?: 'JobFeature', id: number, label: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, logoUrl?: string | null | undefined, address?: string | null | undefined, plan?: number | null | undefined, category1?: { __typename?: 'Industry', id: number, code: number, label: string } | null | undefined, category2?: { __typename?: 'Industry', id: number, code: number, label: string } | null | undefined, category3?: { __typename?: 'Industry', id: number, code: number, label: string } | null | undefined, handicapAdoption?: { __typename?: 'HandicapAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, internationalAdoption?: { __typename?: 'InternationalAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined } }> | null | undefined, pagination?: { __typename?: 'Pagination', currentPage?: number | null | undefined, limitValue?: number | null | undefined, totalCount?: number | null | undefined, totalPages?: number | null | undefined } | null | undefined } };

export type FindJobQueryVariables = Exact<{
  id: Scalars['Int'];
  isFree: Scalars['Boolean'];
}>;


export type FindJobQuery = { __typename?: 'Query', job?: { __typename?: 'Job', id: number, bookmark?: boolean | null | undefined, coverImageUrl?: string | null | undefined, offer: string, catchCopy?: string | null | undefined, closeDate: any, numberOfRecruitment?: string | null | undefined, plusImage1Url?: string | null | undefined, plusImage2Url?: string | null | undefined, descWork?: string | null | undefined, idealType?: string | null | undefined, qualification?: string | null | undefined, locationText?: string | null | undefined, workingHours?: string | null | undefined, holiday?: string | null | undefined, vacation?: string | null | undefined, salary?: string | null | undefined, transportation?: string | null | undefined, transportationMemo?: string | null | undefined, treatment?: string | null | undefined, salaryIncrease?: string | null | undefined, salaryBonus?: string | null | undefined, welfare?: string | null | undefined, probation?: string | null | undefined, deducting?: string | null | undefined, entryDocument?: string | null | undefined, schedule?: string | null | undefined, corporationNo?: string | null | undefined, schoolEntry: boolean, jobStatus?: { __typename?: 'JobStatus', jobNo?: string | null | undefined, schoolMemo?: string | null | undefined } | null | undefined, sisterJobInfo?: { __typename?: 'SisterJobInfo', sisterSchoolName: string, sisterSchoolNameVisible: boolean } | null | undefined, occupation?: { __typename?: 'Occupation', id: number, label: string } | null | undefined, employmentType?: { __typename?: 'Employment', id: number, label: string } | null | undefined, contranctInfo?: { __typename?: 'ContranctInfo', contractTerm: string, contractType: string, contractStartDate?: any | null | undefined, contractEndDate?: any | null | undefined, contractRenewalTypeLabel?: string | null | undefined, contractRenewalCriteriaLabel?: string | null | undefined, contractRenewalLimitLabel?: string | null | undefined } | null | undefined, additions?: Array<{ __typename?: 'AdditionItem', id: number, title: string, content: string }> | null | undefined, recruiter?: { __typename?: 'CorporationStaff', imageUrl?: string | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, tel?: string | null | undefined, message?: string | null | undefined } | null | undefined, locationOffices?: Array<{ __typename?: 'CorporationOffice', id: number, name: string, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, imageUrl2?: string | null | undefined, imageUrl3?: string | null | undefined, imageUrl4?: string | null | undefined, imageUrl5?: string | null | undefined }> | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, businessFormI18n?: string | null | undefined, logoUrl?: string | null | undefined, coverImageUrl?: string | null | undefined, mainImageUrl?: string | null | undefined, url?: string | null | undefined, corporationNumber?: string | null | undefined, philosophyTitle?: string | null | undefined, philosophy?: string | null | undefined, philosophyImage1Url?: string | null | undefined, philosophyImage2Url?: string | null | undefined, visionTitle?: string | null | undefined, vision?: string | null | undefined, visionImage1Url?: string | null | undefined, visionImage2Url?: string | null | undefined, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, description?: string | null | undefined, topManager?: string | null | undefined, topManagerKana?: string | null | undefined, topManagerPosition?: string | null | undefined, topManagerSchool?: string | null | undefined, establishmentDate?: string | null | undefined, capital?: string | null | undefined, annualSales?: string | null | undefined, housingAllowance?: string | null | undefined, numberOfEmployee?: string | null | undefined, numberOfOffices?: number | null | undefined, affiliatedCompany?: string | null | undefined, plan?: number | null | undefined, messageContent?: string | null | undefined, messageName?: string | null | undefined, messageImageUrl?: string | null | undefined, schoolMemo?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, tags?: Array<string> | null | undefined, visitReception?: { __typename?: 'VisitReception', visitReceptionRequired?: boolean | null | undefined, visitReceptionTimeFrom?: string | null | undefined, visitReceptionTimeTo?: string | null | undefined, visitReceptionWeekday?: Array<boolean> | null | undefined } | null | undefined, handicapAdoption?: { __typename?: 'HandicapAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, internationalAdoption?: { __typename?: 'InternationalAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, coverVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, messageVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, recruiter?: { __typename?: 'CorporationStaff', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, tel?: string | null | undefined, email?: string | null | undefined, position?: string | null | undefined, message?: string | null | undefined, imageUrl?: string | null | undefined } | null | undefined, areas?: Array<{ __typename?: 'CorporationArea', id: number, name?: string | null | undefined, offices?: Array<{ __typename?: 'CorporationOffice', id: number, name: string, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, imageUrl2?: string | null | undefined, imageUrl3?: string | null | undefined, imageUrl4?: string | null | undefined, imageUrl5?: string | null | undefined }> | null | undefined }> | null | undefined, members?: Array<{ __typename?: 'CorporationMember', id: number, name: string, nameKana: string, position?: string | null | undefined, office?: string | null | undefined, imageUrl?: string | null | undefined, schoolName?: string | null | undefined, sameSchool: boolean, enteringYear?: string | null | undefined }> | null | undefined, additions?: Array<{ __typename?: 'AdditionItem', id: number, title: string, content: string }> | null | undefined }, coverVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, jobPlanSeparates?: Array<{ __typename?: 'JobPlanSeparate', premium: boolean, locationCityList?: Array<string> | null | undefined, locationPrefectureList?: Array<string> | null | undefined }> | null | undefined, schoolAdditions?: Array<{ __typename?: 'AdditionItem', title: string, content: string }> | null | undefined, examination?: { __typename?: 'CorporationEvent', id: number, eventId: number, title?: string | null | undefined, content?: string | null | undefined, place?: string | null | undefined, prefecture?: string | null | undefined, whatToBring?: string | null | undefined, howToApply?: string | null | undefined, note?: string | null | undefined, imageUrl?: string | null | undefined, eventTimesText?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, dates?: Array<{ __typename?: 'CorporationEventDate', id: number, eventDate: any, closingDate: any }> | null | undefined, times?: Array<{ __typename?: 'CorporationEventTime', id: number, from: any, to: any, timeText?: string | null | undefined }> | null | undefined, staff?: { __typename?: 'CorporationStaff', name?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type GetAnalyzeQueryVariables = Exact<{
  keyword: Scalars['String'];
}>;


export type GetAnalyzeQuery = { __typename?: 'Query', getAnalyze: Array<string> };

export type LikeAttributesFragment = { __typename?: 'Like', id: number, type: LikeType, targetId: number, checked: boolean };

export type ToggleLikeMutationVariables = Exact<{
  type: LikeType;
  id: Scalars['Int'];
}>;


export type ToggleLikeMutation = { __typename?: 'Mutation', toggleLike?: { __typename?: 'ToggleLikePayload', error?: string | null | undefined, like?: { __typename?: 'Like', id: number, type: LikeType, targetId: number, checked: boolean } | null | undefined } | null | undefined };

export type MessageUserAttributesFragment = { __typename?: 'MessageUser', id: number, userType: number, name: string, nameSub?: string | null | undefined, imageUrl?: string | null | undefined, currentMessageId?: number | null | undefined };

export type MessageAttributesFragment = { __typename?: 'Message', id: number, myMessage: boolean, senderType?: string | null | undefined, userName?: string | null | undefined, content?: string | null | undefined, createdAt: any, files?: Array<{ __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, fileType?: FileType | null | undefined, url: string }> | null | undefined };

export type SearchMessageRoomsQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchMessageRoomsQuery = { __typename?: 'Query', messageRooms: Array<{ __typename?: 'MessageRoom', id: number, roomType?: MessageRoomType | null | undefined, currentMessageId?: number | null | undefined, currentMessage?: { __typename?: 'Message', id: number, myMessage: boolean, senderType?: string | null | undefined, userName?: string | null | undefined, content?: string | null | undefined, createdAt: any, files?: Array<{ __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, fileType?: FileType | null | undefined, url: string }> | null | undefined } | null | undefined, userFrom: { __typename?: 'MessageUser', id: number, userType: number, name: string, nameSub?: string | null | undefined, imageUrl?: string | null | undefined, currentMessageId?: number | null | undefined }, userTo: { __typename?: 'MessageUser', id: number, userType: number, name: string, nameSub?: string | null | undefined, imageUrl?: string | null | undefined, currentMessageId?: number | null | undefined } }> };

export type FindMessageRoomQueryVariables = Exact<{
  roomId: Scalars['Int'];
}>;


export type FindMessageRoomQuery = { __typename?: 'Query', messageRoom?: { __typename?: 'MessageRoom', id: number, roomType?: MessageRoomType | null | undefined, currentMessageId?: number | null | undefined, currentMessage?: { __typename?: 'Message', id: number, myMessage: boolean, senderType?: string | null | undefined, userName?: string | null | undefined, content?: string | null | undefined, createdAt: any, files?: Array<{ __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, fileType?: FileType | null | undefined, url: string }> | null | undefined } | null | undefined, userFrom: { __typename?: 'MessageUser', id: number, userType: number, name: string, nameSub?: string | null | undefined, imageUrl?: string | null | undefined, currentMessageId?: number | null | undefined }, userTo: { __typename?: 'MessageUser', id: number, userType: number, name: string, nameSub?: string | null | undefined, imageUrl?: string | null | undefined, currentMessageId?: number | null | undefined } } | null | undefined };

export type SearchMessagesQueryVariables = Exact<{
  roomId: Scalars['Int'];
  cursor: Scalars['Int'];
}>;


export type SearchMessagesQuery = { __typename?: 'Query', messages?: Array<{ __typename?: 'Message', id: number, myMessage: boolean, senderType?: string | null | undefined, userName?: string | null | undefined, content?: string | null | undefined, createdAt: any, files?: Array<{ __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, fileType?: FileType | null | undefined, url: string }> | null | undefined }> | null | undefined };

export type SendMessageMutationVariables = Exact<{
  messageInput: SendMessagesInput;
}>;


export type SendMessageMutation = { __typename?: 'Mutation', sendMessage?: { __typename?: 'SendMessagePayload', error?: string | null | undefined, message?: { __typename?: 'Message', id: number, myMessage: boolean, senderType?: string | null | undefined, userName?: string | null | undefined, content?: string | null | undefined, createdAt: any, files?: Array<{ __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, fileType?: FileType | null | undefined, url: string }> | null | undefined } | null | undefined } | null | undefined };

export type UpdateCurrentMessageMutationVariables = Exact<{
  roomId: Scalars['Int'];
  messageId: Scalars['Int'];
}>;


export type UpdateCurrentMessageMutation = { __typename?: 'Mutation', updateCurrentMessage?: { __typename?: 'UpdateCurrentMessagePayload', error?: string | null | undefined, room?: { __typename?: 'MessageRoom', id: number, roomType?: MessageRoomType | null | undefined, currentMessageId?: number | null | undefined, currentMessage?: { __typename?: 'Message', id: number, myMessage: boolean, senderType?: string | null | undefined, userName?: string | null | undefined, content?: string | null | undefined, createdAt: any, files?: Array<{ __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, fileType?: FileType | null | undefined, url: string }> | null | undefined } | null | undefined, userFrom: { __typename?: 'MessageUser', id: number, userType: number, name: string, nameSub?: string | null | undefined, imageUrl?: string | null | undefined, currentMessageId?: number | null | undefined }, userTo: { __typename?: 'MessageUser', id: number, userType: number, name: string, nameSub?: string | null | undefined, imageUrl?: string | null | undefined, currentMessageId?: number | null | undefined } } | null | undefined } | null | undefined };

export type SearchPaginationMessagesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  roomId: Scalars['Int'];
}>;


export type SearchPaginationMessagesQuery = { __typename?: 'Query', paginationMessages?: { __typename?: 'MessageConnection', totalCount?: number | null | undefined, edges?: Array<{ __typename?: 'MessageEdge', cursor: string, node?: { __typename?: 'Message', id: number, myMessage: boolean, senderType?: string | null | undefined, userName?: string | null | undefined, content?: string | null | undefined, createdAt: any, files?: Array<{ __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, fileType?: FileType | null | undefined, url: string }> | null | undefined } | null | undefined } | null | undefined> | null | undefined, nodes?: Array<{ __typename?: 'Message', id: number, myMessage: boolean, senderType?: string | null | undefined, userName?: string | null | undefined, content?: string | null | undefined, createdAt: any, files?: Array<{ __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, fileType?: FileType | null | undefined, url: string }> | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasPreviousPage: boolean, hasNextPage: boolean } } | null | undefined };

export type NewMessageSubscriptionVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  messageRoomId: Scalars['Int'];
}>;


export type NewMessageSubscription = { __typename?: 'Subscription', newMessage: { __typename?: 'MessageConnection', totalCount?: number | null | undefined, edges?: Array<{ __typename?: 'MessageEdge', cursor: string, node?: { __typename?: 'Message', id: number, myMessage: boolean, senderType?: string | null | undefined, userName?: string | null | undefined, content?: string | null | undefined, createdAt: any, files?: Array<{ __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, fileType?: FileType | null | undefined, url: string }> | null | undefined } | null | undefined } | null | undefined> | null | undefined, nodes?: Array<{ __typename?: 'Message', id: number, myMessage: boolean, senderType?: string | null | undefined, userName?: string | null | undefined, content?: string | null | undefined, createdAt: any, files?: Array<{ __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, fileType?: FileType | null | undefined, url: string }> | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type NewsAttributesFragment = { __typename?: 'News', id: number, title: string, content: string, fileUrl: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined };

export type SearchNewsListQueryVariables = Exact<{
  smApp: Scalars['Boolean'];
}>;


export type SearchNewsListQuery = { __typename?: 'Query', newsList: Array<{ __typename?: 'News', id: number, title: string, content: string, fileUrl: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined }> };

export type FindNewsQueryVariables = Exact<{
  id: Scalars['Int'];
  smApp: Scalars['Boolean'];
}>;


export type FindNewsQuery = { __typename?: 'Query', newsDetail?: { __typename?: 'News', id: number, title: string, content: string, fileUrl: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined } | null | undefined };

export type NoticeBoardAttributesFragment = { __typename?: 'NoticeBoard', id: number, title: string, content: string, bookmark?: boolean | null | undefined, isNew: boolean, contributor: string, catchcopy?: string | null | undefined, schoolCourse?: string | null | undefined, createdAt: any, updatedAt: any, file?: { __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, url: string } | null | undefined, image?: { __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, url: string } | null | undefined };

export type SearchNoticeBoardsQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchNoticeBoardsQuery = { __typename?: 'Query', noticeBoards: Array<{ __typename?: 'NoticeBoard', id: number, title: string, content: string, bookmark?: boolean | null | undefined, isNew: boolean, contributor: string, catchcopy?: string | null | undefined, schoolCourse?: string | null | undefined, createdAt: any, updatedAt: any, file?: { __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, url: string } | null | undefined, image?: { __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, url: string } | null | undefined }> };

export type FindNoticeBoardQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FindNoticeBoardQuery = { __typename?: 'Query', noticeBoard?: { __typename?: 'NoticeBoard', id: number, title: string, content: string, bookmark?: boolean | null | undefined, isNew: boolean, contributor: string, catchcopy?: string | null | undefined, schoolCourse?: string | null | undefined, createdAt: any, updatedAt: any, file?: { __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, url: string } | null | undefined, image?: { __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, url: string } | null | undefined } | null | undefined };

export type NotificationAttributesFragment = { __typename?: 'Notification', id: number, type: NotificationType, targetId: number, title?: string | null | undefined, subTitle?: string | null | undefined, imageUrl?: string | null | undefined, notifiedAt?: any | null | undefined, confirmedAt?: any | null | undefined };

export type SearchNotificationQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchNotificationQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'Notification', id: number, type: NotificationType, targetId: number, title?: string | null | undefined, subTitle?: string | null | undefined, imageUrl?: string | null | undefined, notifiedAt?: any | null | undefined, confirmedAt?: any | null | undefined }> };

export type ClearNotificationQueryVariables = Exact<{ [key: string]: never; }>;


export type ClearNotificationQuery = { __typename?: 'Query', noticeAllRead?: { __typename?: 'BadgeNotice', news: boolean, message: boolean, offer: boolean, noticeBoard: boolean, badgeCount?: number | null | undefined } | null | undefined };

export type OfferAttributesFragment = { __typename?: 'Offer', id: number, isValid?: boolean | null | undefined, validSeminarDateId?: number | null | undefined, title: string, content: string, privilege?: string | null | undefined, privilegeTitle?: string | null | undefined, status: OfferStatus, offerDate: any, confirmedDate?: any | null | undefined, expiredDate: any, type?: OfferTypeEnum | null | undefined, corporationEvent?: { __typename?: 'CorporationEvent', id: number, title?: string | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, address?: string | null | undefined }, job?: { __typename?: 'Job', id: number, offer: string, viewCondition?: JobViewCondition | null | undefined, plusImage1Url?: string | null | undefined, plusImage2Url?: string | null | undefined, plusImage3Url?: string | null | undefined, coverImageUrl?: string | null | undefined, employmentType?: { __typename?: 'Employment', id: number, label: string } | null | undefined } | null | undefined };

export type SearchOffersQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchOffersQuery = { __typename?: 'Query', offers: Array<{ __typename?: 'Offer', studentResponsedAt?: any | null | undefined, id: number, isValid?: boolean | null | undefined, validSeminarDateId?: number | null | undefined, title: string, content: string, privilege?: string | null | undefined, privilegeTitle?: string | null | undefined, status: OfferStatus, offerDate: any, confirmedDate?: any | null | undefined, expiredDate: any, type?: OfferTypeEnum | null | undefined, corporationEvent?: { __typename?: 'CorporationEvent', id: number, title?: string | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, address?: string | null | undefined }, job?: { __typename?: 'Job', id: number, offer: string, viewCondition?: JobViewCondition | null | undefined, plusImage1Url?: string | null | undefined, plusImage2Url?: string | null | undefined, plusImage3Url?: string | null | undefined, coverImageUrl?: string | null | undefined, employmentType?: { __typename?: 'Employment', id: number, label: string } | null | undefined } | null | undefined }> };

export type FindOfferQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FindOfferQuery = { __typename?: 'Query', offer?: { __typename?: 'Offer', imageUrl?: string | null | undefined, movieUrl?: string | null | undefined, movieType?: string | null | undefined, presentationType?: string | null | undefined, movieUrlLong?: string | null | undefined, studentResponsedAt?: any | null | undefined, id: number, isValid?: boolean | null | undefined, validSeminarDateId?: number | null | undefined, title: string, content: string, privilege?: string | null | undefined, privilegeTitle?: string | null | undefined, status: OfferStatus, offerDate: any, confirmedDate?: any | null | undefined, expiredDate: any, type?: OfferTypeEnum | null | undefined, corporationEvent?: { __typename?: 'CorporationEvent', id: number, title?: string | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, address?: string | null | undefined }, job?: { __typename?: 'Job', id: number, offer: string, viewCondition?: JobViewCondition | null | undefined, plusImage1Url?: string | null | undefined, plusImage2Url?: string | null | undefined, plusImage3Url?: string | null | undefined, coverImageUrl?: string | null | undefined, employmentType?: { __typename?: 'Employment', id: number, label: string } | null | undefined } | null | undefined } | null | undefined };

export type RejectOfferMutationVariables = Exact<{
  offerId: Scalars['Int'];
}>;


export type RejectOfferMutation = { __typename?: 'Mutation', rejectOffer?: { __typename?: 'RejectOfferPayload', error?: string | null | undefined, offer?: { __typename?: 'Offer', id: number, isValid?: boolean | null | undefined, validSeminarDateId?: number | null | undefined, title: string, content: string, privilege?: string | null | undefined, privilegeTitle?: string | null | undefined, status: OfferStatus, offerDate: any, confirmedDate?: any | null | undefined, expiredDate: any, type?: OfferTypeEnum | null | undefined, corporationEvent?: { __typename?: 'CorporationEvent', id: number, title?: string | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, address?: string | null | undefined }, job?: { __typename?: 'Job', id: number, offer: string, viewCondition?: JobViewCondition | null | undefined, plusImage1Url?: string | null | undefined, plusImage2Url?: string | null | undefined, plusImage3Url?: string | null | undefined, coverImageUrl?: string | null | undefined, employmentType?: { __typename?: 'Employment', id: number, label: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type PortfolioAttributesFragment = { __typename?: 'Portfolio', id: number, title: string, content?: string | null | undefined, year?: number | null | undefined, month?: number | null | undefined, url?: string | null | undefined, fileUrl?: string | null | undefined, imageUrl?: string | null | undefined, imageUrls?: Array<string> | null | undefined, privacySetting?: PrivacySetting | null | undefined, createdAt: any, updatedAt: any, likeCount?: number | null | undefined, commentCount?: number | null | undefined, fileInfo?: { __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, url: string, fileType?: FileType | null | undefined } | null | undefined, images?: Array<{ __typename?: 'FileInfo', id?: string | null | undefined, url: string, contentType: string, name: string }> | null | undefined, comments?: Array<{ __typename?: 'PortfolioComment', id: number, comment: string, createdAt: any, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined }> | null | undefined, likes?: Array<{ __typename?: 'PortfolioLike', id: number, createdAt: any, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined }> | null | undefined };

export type SearchPortfoliosQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchPortfoliosQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', id: number, title: string, content?: string | null | undefined, year?: number | null | undefined, month?: number | null | undefined, url?: string | null | undefined, fileUrl?: string | null | undefined, imageUrl?: string | null | undefined, imageUrls?: Array<string> | null | undefined, privacySetting?: PrivacySetting | null | undefined, createdAt: any, updatedAt: any, likeCount?: number | null | undefined, commentCount?: number | null | undefined, fileInfo?: { __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, url: string, fileType?: FileType | null | undefined } | null | undefined, images?: Array<{ __typename?: 'FileInfo', id?: string | null | undefined, url: string, contentType: string, name: string }> | null | undefined, comments?: Array<{ __typename?: 'PortfolioComment', id: number, comment: string, createdAt: any, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined }> | null | undefined, likes?: Array<{ __typename?: 'PortfolioLike', id: number, createdAt: any, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined }> | null | undefined }> };

export type FindPortfolioQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FindPortfolioQuery = { __typename?: 'Query', portfolio?: { __typename?: 'Portfolio', id: number, title: string, content?: string | null | undefined, year?: number | null | undefined, month?: number | null | undefined, url?: string | null | undefined, fileUrl?: string | null | undefined, imageUrl?: string | null | undefined, imageUrls?: Array<string> | null | undefined, privacySetting?: PrivacySetting | null | undefined, createdAt: any, updatedAt: any, likeCount?: number | null | undefined, commentCount?: number | null | undefined, fileInfo?: { __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, url: string, fileType?: FileType | null | undefined } | null | undefined, images?: Array<{ __typename?: 'FileInfo', id?: string | null | undefined, url: string, contentType: string, name: string }> | null | undefined, comments?: Array<{ __typename?: 'PortfolioComment', id: number, comment: string, createdAt: any, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined }> | null | undefined, likes?: Array<{ __typename?: 'PortfolioLike', id: number, createdAt: any, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined }> | null | undefined } | null | undefined };

export type UpdatePortfolioMutationVariables = Exact<{
  portfolio: PortfolioInput;
}>;


export type UpdatePortfolioMutation = { __typename?: 'Mutation', updatePortfolio?: { __typename?: 'UpdatePortfolioPayload', error?: string | null | undefined, portfolio?: { __typename?: 'Portfolio', id: number, title: string, content?: string | null | undefined, year?: number | null | undefined, month?: number | null | undefined, url?: string | null | undefined, fileUrl?: string | null | undefined, imageUrl?: string | null | undefined, imageUrls?: Array<string> | null | undefined, privacySetting?: PrivacySetting | null | undefined, createdAt: any, updatedAt: any, likeCount?: number | null | undefined, commentCount?: number | null | undefined, fileInfo?: { __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, url: string, fileType?: FileType | null | undefined } | null | undefined, images?: Array<{ __typename?: 'FileInfo', id?: string | null | undefined, url: string, contentType: string, name: string }> | null | undefined, comments?: Array<{ __typename?: 'PortfolioComment', id: number, comment: string, createdAt: any, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined }> | null | undefined, likes?: Array<{ __typename?: 'PortfolioLike', id: number, createdAt: any, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined }> | null | undefined } | null | undefined } | null | undefined };

export type DeletePortfolioMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeletePortfolioMutation = { __typename?: 'Mutation', deletePortfolio?: { __typename?: 'DeletePortfolioPayload', result?: string | null | undefined, error?: string | null | undefined } | null | undefined };

export type AutocompleteSchoolListQueryVariables = Exact<{
  filter: Scalars['String'];
  schoolType: SchoolType;
  limit: Scalars['Int'];
}>;


export type AutocompleteSchoolListQuery = { __typename?: 'Query', schools?: Array<{ __typename?: 'School', id: number, name: string, official?: boolean | null | undefined }> | null | undefined };

export type SchoolsQueryVariables = Exact<{ [key: string]: never; }>;


export type SchoolsQuery = { __typename?: 'Query', schools?: Array<{ __typename?: 'School', id: number, name: string, official?: boolean | null | undefined }> | null | undefined };

export type FindSchoolQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FindSchoolQuery = { __typename?: 'Query', school?: { __typename?: 'School', id: number, name: string, plan?: SchoolPlan | null | undefined, isBasicPlanOrMore?: boolean | null | undefined, schoolNumber?: string | null | undefined, useCertificate?: boolean | null | undefined, logoUrl?: string | null | undefined, official?: boolean | null | undefined, allowPartTime?: boolean | null | undefined, allowOutsourcing?: boolean | null | undefined, companyVisitEntryType?: CompanyVisitEntry | null | undefined, groupName?: string | null | undefined, courses?: Array<{ __typename?: 'SchoolCourse', id: number, name: string }> | null | undefined, teachers?: Array<{ __typename?: 'SchoolTeacher', id: number, name: string }> | null | undefined, activityAdditions?: Array<{ __typename?: 'SchoolActivityAddition', id: number, title: string, description?: string | null | undefined, require: boolean, itemType: AdditionItemType, maxLength?: number | null | undefined, useTime?: boolean | null | undefined, items?: Array<{ __typename?: 'SchoolActivityAdditionItem', id: number, value: string, label: string }> | null | undefined }> | null | undefined, activityStatuses?: Array<{ __typename?: 'SchoolActivityStatus', value: string, label: string, defaultValue?: string | null | undefined }> | null | undefined, jobHuntingStatuses?: Array<{ __typename?: 'JobHuntingStatus', id: number, value: number, label: string }> | null | undefined, groupSchools?: Array<{ __typename?: 'School', id: number, name: string }> | null | undefined } | null | undefined };

export type SchoolByCodeQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type SchoolByCodeQuery = { __typename?: 'Query', schoolByCode?: { __typename?: 'School', id: number, name: string, official?: boolean | null | undefined, logoUrl?: string | null | undefined } | null | undefined };

export type SeminarAttributesFragment = { __typename?: 'CorporationEvent', id: number, eventId: number, eventDateId?: number | null | undefined, title?: string | null | undefined, meetingType?: MeetingType | null | undefined, content?: string | null | undefined, place?: string | null | undefined, prefecture?: string | null | undefined, whatToBring?: string | null | undefined, howToApply?: string | null | undefined, note?: string | null | undefined, imageUrl?: string | null | undefined, eventDate?: any | null | undefined, closingDate?: any | null | undefined, eventTimesText?: string | null | undefined, schoolMemo?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, schoolEntry?: boolean | null | undefined, dates?: Array<{ __typename?: 'CorporationEventDate', id: number, eventDate: any, closingDate: any }> | null | undefined, times?: Array<{ __typename?: 'CorporationEventTime', id: number, from: any, to: any, timeText?: string | null | undefined }> | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, address?: string | null | undefined }, staff?: { __typename?: 'CorporationStaff', name?: string | null | undefined } | null | undefined };

export type SearchSeminarsQueryVariables = Exact<{
  conditions: SearchEventInput;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type SearchSeminarsQuery = { __typename?: 'Query', seminars: Array<{ __typename?: 'CorporationEvent', id: number, eventId: number, eventDateId?: number | null | undefined, title?: string | null | undefined, meetingType?: MeetingType | null | undefined, content?: string | null | undefined, place?: string | null | undefined, prefecture?: string | null | undefined, whatToBring?: string | null | undefined, howToApply?: string | null | undefined, note?: string | null | undefined, imageUrl?: string | null | undefined, eventDate?: any | null | undefined, closingDate?: any | null | undefined, eventTimesText?: string | null | undefined, schoolMemo?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, schoolEntry?: boolean | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, address?: string | null | undefined, logoUrl?: string | null | undefined }, dates?: Array<{ __typename?: 'CorporationEventDate', id: number, eventDate: any, closingDate: any }> | null | undefined, times?: Array<{ __typename?: 'CorporationEventTime', id: number, from: any, to: any, timeText?: string | null | undefined }> | null | undefined, staff?: { __typename?: 'CorporationStaff', name?: string | null | undefined } | null | undefined }> };

export type FindSeminarQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FindSeminarQuery = { __typename?: 'Query', seminar?: { __typename?: 'CorporationEvent', id: number, eventId: number, eventDateId?: number | null | undefined, title?: string | null | undefined, meetingType?: MeetingType | null | undefined, content?: string | null | undefined, place?: string | null | undefined, prefecture?: string | null | undefined, whatToBring?: string | null | undefined, howToApply?: string | null | undefined, note?: string | null | undefined, imageUrl?: string | null | undefined, eventDate?: any | null | undefined, closingDate?: any | null | undefined, eventTimesText?: string | null | undefined, schoolMemo?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, schoolEntry?: boolean | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, address?: string | null | undefined, nameKana?: string | null | undefined, businessFormI18n?: string | null | undefined, logoUrl?: string | null | undefined, coverImageUrl?: string | null | undefined, mainImageUrl?: string | null | undefined, url?: string | null | undefined, corporationNumber?: string | null | undefined, philosophyTitle?: string | null | undefined, philosophy?: string | null | undefined, philosophyImage1Url?: string | null | undefined, philosophyImage2Url?: string | null | undefined, visionTitle?: string | null | undefined, vision?: string | null | undefined, visionImage1Url?: string | null | undefined, visionImage2Url?: string | null | undefined, zipCode?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, description?: string | null | undefined, topManager?: string | null | undefined, topManagerKana?: string | null | undefined, topManagerPosition?: string | null | undefined, topManagerSchool?: string | null | undefined, establishmentDate?: string | null | undefined, capital?: string | null | undefined, annualSales?: string | null | undefined, housingAllowance?: string | null | undefined, numberOfEmployee?: string | null | undefined, numberOfOffices?: number | null | undefined, affiliatedCompany?: string | null | undefined, plan?: number | null | undefined, messageContent?: string | null | undefined, messageName?: string | null | undefined, messageImageUrl?: string | null | undefined, schoolMemo?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, tags?: Array<string> | null | undefined, visitReception?: { __typename?: 'VisitReception', visitReceptionRequired?: boolean | null | undefined, visitReceptionTimeFrom?: string | null | undefined, visitReceptionTimeTo?: string | null | undefined, visitReceptionWeekday?: Array<boolean> | null | undefined } | null | undefined, handicapAdoption?: { __typename?: 'HandicapAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, internationalAdoption?: { __typename?: 'InternationalAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, coverVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, messageVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, recruiter?: { __typename?: 'CorporationStaff', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, tel?: string | null | undefined, email?: string | null | undefined, position?: string | null | undefined, message?: string | null | undefined, imageUrl?: string | null | undefined } | null | undefined, areas?: Array<{ __typename?: 'CorporationArea', id: number, name?: string | null | undefined, offices?: Array<{ __typename?: 'CorporationOffice', id: number, name: string, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, imageUrl2?: string | null | undefined, imageUrl3?: string | null | undefined, imageUrl4?: string | null | undefined, imageUrl5?: string | null | undefined }> | null | undefined }> | null | undefined, members?: Array<{ __typename?: 'CorporationMember', id: number, name: string, nameKana: string, position?: string | null | undefined, office?: string | null | undefined, imageUrl?: string | null | undefined, schoolName?: string | null | undefined, sameSchool: boolean, enteringYear?: string | null | undefined }> | null | undefined, additions?: Array<{ __typename?: 'AdditionItem', id: number, title: string, content: string }> | null | undefined }, dates?: Array<{ __typename?: 'CorporationEventDate', id: number, eventDate: any, closingDate: any }> | null | undefined, times?: Array<{ __typename?: 'CorporationEventTime', id: number, from: any, to: any, timeText?: string | null | undefined }> | null | undefined, staff?: { __typename?: 'CorporationStaff', name?: string | null | undefined } | null | undefined } | null | undefined };

export type FindSeminarByDateIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FindSeminarByDateIdQuery = { __typename?: 'Query', seminarByDateId?: { __typename?: 'CorporationEvent', id: number, eventId: number, eventDateId?: number | null | undefined, title?: string | null | undefined, meetingType?: MeetingType | null | undefined, content?: string | null | undefined, place?: string | null | undefined, prefecture?: string | null | undefined, whatToBring?: string | null | undefined, howToApply?: string | null | undefined, note?: string | null | undefined, imageUrl?: string | null | undefined, eventDate?: any | null | undefined, closingDate?: any | null | undefined, eventTimesText?: string | null | undefined, schoolMemo?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, schoolEntry?: boolean | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, address?: string | null | undefined, nameKana?: string | null | undefined, businessFormI18n?: string | null | undefined, logoUrl?: string | null | undefined, coverImageUrl?: string | null | undefined, mainImageUrl?: string | null | undefined, url?: string | null | undefined, corporationNumber?: string | null | undefined, philosophyTitle?: string | null | undefined, philosophy?: string | null | undefined, philosophyImage1Url?: string | null | undefined, philosophyImage2Url?: string | null | undefined, visionTitle?: string | null | undefined, vision?: string | null | undefined, visionImage1Url?: string | null | undefined, visionImage2Url?: string | null | undefined, zipCode?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, description?: string | null | undefined, topManager?: string | null | undefined, topManagerKana?: string | null | undefined, topManagerPosition?: string | null | undefined, topManagerSchool?: string | null | undefined, establishmentDate?: string | null | undefined, capital?: string | null | undefined, annualSales?: string | null | undefined, housingAllowance?: string | null | undefined, numberOfEmployee?: string | null | undefined, numberOfOffices?: number | null | undefined, affiliatedCompany?: string | null | undefined, plan?: number | null | undefined, messageContent?: string | null | undefined, messageName?: string | null | undefined, messageImageUrl?: string | null | undefined, schoolMemo?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, tags?: Array<string> | null | undefined, visitReception?: { __typename?: 'VisitReception', visitReceptionRequired?: boolean | null | undefined, visitReceptionTimeFrom?: string | null | undefined, visitReceptionTimeTo?: string | null | undefined, visitReceptionWeekday?: Array<boolean> | null | undefined } | null | undefined, handicapAdoption?: { __typename?: 'HandicapAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, internationalAdoption?: { __typename?: 'InternationalAdoption', proved?: boolean | null | undefined, scheduled?: boolean | null | undefined } | null | undefined, coverVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, messageVideo?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, recruiter?: { __typename?: 'CorporationStaff', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, tel?: string | null | undefined, email?: string | null | undefined, position?: string | null | undefined, message?: string | null | undefined, imageUrl?: string | null | undefined } | null | undefined, areas?: Array<{ __typename?: 'CorporationArea', id: number, name?: string | null | undefined, offices?: Array<{ __typename?: 'CorporationOffice', id: number, name: string, zipCode?: string | null | undefined, address?: string | null | undefined, access?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, imageUrl2?: string | null | undefined, imageUrl3?: string | null | undefined, imageUrl4?: string | null | undefined, imageUrl5?: string | null | undefined }> | null | undefined }> | null | undefined, members?: Array<{ __typename?: 'CorporationMember', id: number, name: string, nameKana: string, position?: string | null | undefined, office?: string | null | undefined, imageUrl?: string | null | undefined, schoolName?: string | null | undefined, sameSchool: boolean, enteringYear?: string | null | undefined }> | null | undefined, additions?: Array<{ __typename?: 'AdditionItem', id: number, title: string, content: string }> | null | undefined }, dates?: Array<{ __typename?: 'CorporationEventDate', id: number, eventDate: any, closingDate: any }> | null | undefined, times?: Array<{ __typename?: 'CorporationEventTime', id: number, from: any, to: any, timeText?: string | null | undefined }> | null | undefined, staff?: { __typename?: 'CorporationStaff', name?: string | null | undefined } | null | undefined } | null | undefined };

export type CreateSeminarEntryMutationVariables = Exact<{
  entry: SeminarEntryInput;
}>;


export type CreateSeminarEntryMutation = { __typename?: 'Mutation', createSeminarEntry?: { __typename?: 'CreateSeminarEntryPayload', error?: string | null | undefined, entry?: { __typename?: 'Entry', corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type SeminarEntryDataQueryVariables = Exact<{
  seminarDateId: Scalars['Int'];
}>;


export type SeminarEntryDataQuery = { __typename?: 'Query', seminar?: { __typename?: 'CorporationEvent', id: number, eventId: number, eventDateId?: number | null | undefined, title?: string | null | undefined, meetingType?: MeetingType | null | undefined, content?: string | null | undefined, place?: string | null | undefined, prefecture?: string | null | undefined, whatToBring?: string | null | undefined, howToApply?: string | null | undefined, note?: string | null | undefined, imageUrl?: string | null | undefined, eventDate?: any | null | undefined, closingDate?: any | null | undefined, eventTimesText?: string | null | undefined, schoolMemo?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, schoolEntry?: boolean | null | undefined, entrySetting?: { __typename?: 'EntrySetting', showMemo: boolean, requireMemo: boolean, showLocation: boolean, requireLocation: boolean, privacyPolicyUrl?: string | null | undefined, additions?: Array<{ __typename?: 'EntryAddition', id: number, title: string, description?: string | null | undefined, require: boolean, items?: Array<string> | null | undefined, showMemo: boolean, additionType: EntryAdditionInputType }> | null | undefined } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined, likeAll?: number | null | undefined, address?: string | null | undefined }, dates?: Array<{ __typename?: 'CorporationEventDate', id: number, eventDate: any, closingDate: any }> | null | undefined, times?: Array<{ __typename?: 'CorporationEventTime', id: number, from: any, to: any, timeText?: string | null | undefined }> | null | undefined, staff?: { __typename?: 'CorporationStaff', name?: string | null | undefined } | null | undefined } | null | undefined, user?: { __typename?: 'User', id: number, email: string, pushNotification: boolean, emailNotification: boolean, jobHuntingStatus: number, jobHuntingStatusLabel: string, school: { __typename?: 'School', id: number, name: string, plan?: SchoolPlan | null | undefined, isBasicPlanOrMore?: boolean | null | undefined, schoolNumber?: string | null | undefined, useCertificate?: boolean | null | undefined, logoUrl?: string | null | undefined, official?: boolean | null | undefined, allowPartTime?: boolean | null | undefined, allowOutsourcing?: boolean | null | undefined, companyVisitEntryType?: CompanyVisitEntry | null | undefined, groupName?: string | null | undefined, courses?: Array<{ __typename?: 'SchoolCourse', id: number, name: string }> | null | undefined, teachers?: Array<{ __typename?: 'SchoolTeacher', id: number, name: string }> | null | undefined, activityAdditions?: Array<{ __typename?: 'SchoolActivityAddition', id: number, title: string, description?: string | null | undefined, require: boolean, itemType: AdditionItemType, maxLength?: number | null | undefined, useTime?: boolean | null | undefined, items?: Array<{ __typename?: 'SchoolActivityAdditionItem', id: number, value: string, label: string }> | null | undefined }> | null | undefined, activityStatuses?: Array<{ __typename?: 'SchoolActivityStatus', value: string, label: string, defaultValue?: string | null | undefined }> | null | undefined, jobHuntingStatuses?: Array<{ __typename?: 'JobHuntingStatus', id: number, value: number, label: string }> | null | undefined, groupSchools?: Array<{ __typename?: 'School', id: number, name: string }> | null | undefined }, profile: { __typename?: 'UserProfile', id: number, firstName?: string | null | undefined, lastName?: string | null | undefined, firstKana?: string | null | undefined, lastKana?: string | null | undefined, courseId?: number | null | undefined, courseName?: string | null | undefined, className?: string | null | undefined, studentNo?: string | null | undefined, teacherId?: number | null | undefined, teacherName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined, gender?: number | null | undefined, dateOfBirth?: any | null | undefined, postalCode?: string | null | undefined, prefectureCode?: string | null | undefined, prefecture?: string | null | undefined, cityName?: string | null | undefined, addressOther?: string | null | undefined, addressFurigana?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, prTitle1?: string | null | undefined, prContent1?: string | null | undefined, prTitle2?: string | null | undefined, prContent2?: string | null | undefined, prTitle3?: string | null | undefined, prContent3?: string | null | undefined, resumeRate?: number | null | undefined, isApproved?: boolean | null | undefined, isPublic?: boolean | null | undefined, createdAt?: any | null | undefined, licenses?: Array<{ __typename?: 'License', id: number, title: string, year?: number | null | undefined, month?: number | null | undefined, status?: LicenseStatus | null | undefined, createdAt: any, updatedAt: any }> | null | undefined, careers?: Array<{ __typename?: 'Career', corporationName: string, employment?: string | null | undefined, employmentType?: CareerEmploymentType | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, retirementYear?: number | null | undefined, retirementMonth?: number | null | undefined, lengthOfService?: number | null | undefined, occupation?: string | null | undefined, description?: string | null | undefined }> | null | undefined, schoolBackgrounds?: Array<{ __typename?: 'SchoolBackground', id: number, schoolId?: number | null | undefined, schoolType?: SchoolType | null | undefined, schoolName?: string | null | undefined, courseName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined }> | null | undefined }, condition: { __typename?: 'UserCondition', id: number, industry1Code?: string | null | undefined, industry1?: string | null | undefined, industry2Code?: string | null | undefined, industry2?: string | null | undefined, industry3Code?: string | null | undefined, industry3?: string | null | undefined, category1Code?: string | null | undefined, category1?: string | null | undefined, category2Code?: string | null | undefined, category2?: string | null | undefined, category3Code?: string | null | undefined, category3?: string | null | undefined, location1Code?: string | null | undefined, location1?: string | null | undefined, location2Code?: string | null | undefined, location2?: string | null | undefined, location3Code?: string | null | undefined, location3?: string | null | undefined, corporationType1Code?: string | null | undefined, corporationType1?: string | null | undefined, corporationType2Code?: string | null | undefined, corporationType2?: string | null | undefined, corporationType3Code?: string | null | undefined, corporationType3?: string | null | undefined, jobFeature1Code?: string | null | undefined, jobFeature1?: string | null | undefined, jobFeature2Code?: string | null | undefined, jobFeature2?: string | null | undefined, jobFeature3Code?: string | null | undefined, jobFeature3?: string | null | undefined, monthlyIncome?: number | null | undefined, holiday0?: boolean | null | undefined, holiday1?: boolean | null | undefined, holiday2?: boolean | null | undefined, holiday3?: boolean | null | undefined, holiday4?: boolean | null | undefined, holiday5?: boolean | null | undefined, holiday6?: boolean | null | undefined, workStartTime?: any | null | undefined, workEndTime?: any | null | undefined } } | null | undefined, portfolios: Array<{ __typename?: 'Portfolio', id: number, title: string, content?: string | null | undefined, year?: number | null | undefined, month?: number | null | undefined, url?: string | null | undefined, fileUrl?: string | null | undefined, imageUrl?: string | null | undefined, imageUrls?: Array<string> | null | undefined, privacySetting?: PrivacySetting | null | undefined, createdAt: any, updatedAt: any, likeCount?: number | null | undefined, commentCount?: number | null | undefined, fileInfo?: { __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, url: string, fileType?: FileType | null | undefined } | null | undefined, images?: Array<{ __typename?: 'FileInfo', id?: string | null | undefined, url: string, contentType: string, name: string }> | null | undefined, comments?: Array<{ __typename?: 'PortfolioComment', id: number, comment: string, createdAt: any, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined }> | null | undefined, likes?: Array<{ __typename?: 'PortfolioLike', id: number, createdAt: any, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined }> | null | undefined }>, licenses: Array<{ __typename?: 'License', id: number, title: string, year?: number | null | undefined, month?: number | null | undefined, status?: LicenseStatus | null | undefined, createdAt: any, updatedAt: any }>, careers: Array<{ __typename?: 'Career', corporationName: string, employment?: string | null | undefined, employmentType?: CareerEmploymentType | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, retirementYear?: number | null | undefined, retirementMonth?: number | null | undefined, lengthOfService?: number | null | undefined, occupation?: string | null | undefined, description?: string | null | undefined }> };

export type SearchPaginationSeminarsQueryVariables = Exact<{
  conditions: SearchEventInput;
  page: Scalars['Int'];
  limit: Scalars['Int'];
  isGetAggregate?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchPaginationSeminarsQuery = { __typename?: 'Query', paginationSeminars: { __typename?: 'PaginationCorporationEvents', seminars?: Array<{ __typename?: 'CorporationEvent', id: number, eventId: number, eventDateId?: number | null | undefined, title?: string | null | undefined, meetingType?: MeetingType | null | undefined, content?: string | null | undefined, place?: string | null | undefined, prefecture?: string | null | undefined, whatToBring?: string | null | undefined, howToApply?: string | null | undefined, note?: string | null | undefined, imageUrl?: string | null | undefined, eventDate?: any | null | undefined, closingDate?: any | null | undefined, eventTimesText?: string | null | undefined, schoolMemo?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, schoolEntry?: boolean | null | undefined, dates?: Array<{ __typename?: 'CorporationEventDate', id: number, eventDate: any, closingDate: any }> | null | undefined, times?: Array<{ __typename?: 'CorporationEventTime', id: number, from: any, to: any, timeText?: string | null | undefined }> | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, likeAll?: number | null | undefined, address?: string | null | undefined }, staff?: { __typename?: 'CorporationStaff', name?: string | null | undefined } | null | undefined }> | null | undefined, pagination?: { __typename?: 'Pagination', currentPage?: number | null | undefined, limitValue?: number | null | undefined, totalCount?: number | null | undefined, totalPages?: number | null | undefined } | null | undefined } };

export type ChartPointAttributesFragment = { __typename?: 'ChartPoint', date: any, count: number };

export type MypageUserInfoQueryVariables = Exact<{
  schoolId: Scalars['Int'];
  newArrivalFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
}>;


export type MypageUserInfoQuery = { __typename?: 'Query', getTotalJobCount: number, user?: { __typename?: 'User', id: number, email: string, pushNotification: boolean, emailNotification: boolean, jobHuntingStatus: number, jobHuntingStatusLabel: string, school: { __typename?: 'School', id: number, name: string, plan?: SchoolPlan | null | undefined, isBasicPlanOrMore?: boolean | null | undefined, schoolNumber?: string | null | undefined, useCertificate?: boolean | null | undefined, logoUrl?: string | null | undefined, official?: boolean | null | undefined, allowPartTime?: boolean | null | undefined, allowOutsourcing?: boolean | null | undefined, companyVisitEntryType?: CompanyVisitEntry | null | undefined, groupName?: string | null | undefined, courses?: Array<{ __typename?: 'SchoolCourse', id: number, name: string }> | null | undefined, teachers?: Array<{ __typename?: 'SchoolTeacher', id: number, name: string }> | null | undefined, activityAdditions?: Array<{ __typename?: 'SchoolActivityAddition', id: number, title: string, description?: string | null | undefined, require: boolean, itemType: AdditionItemType, maxLength?: number | null | undefined, useTime?: boolean | null | undefined, items?: Array<{ __typename?: 'SchoolActivityAdditionItem', id: number, value: string, label: string }> | null | undefined }> | null | undefined, activityStatuses?: Array<{ __typename?: 'SchoolActivityStatus', value: string, label: string, defaultValue?: string | null | undefined }> | null | undefined, jobHuntingStatuses?: Array<{ __typename?: 'JobHuntingStatus', id: number, value: number, label: string }> | null | undefined, groupSchools?: Array<{ __typename?: 'School', id: number, name: string }> | null | undefined }, profile: { __typename?: 'UserProfile', id: number, firstName?: string | null | undefined, lastName?: string | null | undefined, firstKana?: string | null | undefined, lastKana?: string | null | undefined, courseId?: number | null | undefined, courseName?: string | null | undefined, className?: string | null | undefined, studentNo?: string | null | undefined, teacherId?: number | null | undefined, teacherName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined, gender?: number | null | undefined, dateOfBirth?: any | null | undefined, postalCode?: string | null | undefined, prefectureCode?: string | null | undefined, prefecture?: string | null | undefined, cityName?: string | null | undefined, addressOther?: string | null | undefined, addressFurigana?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, prTitle1?: string | null | undefined, prContent1?: string | null | undefined, prTitle2?: string | null | undefined, prContent2?: string | null | undefined, prTitle3?: string | null | undefined, prContent3?: string | null | undefined, resumeRate?: number | null | undefined, isApproved?: boolean | null | undefined, isPublic?: boolean | null | undefined, createdAt?: any | null | undefined, licenses?: Array<{ __typename?: 'License', id: number, title: string, year?: number | null | undefined, month?: number | null | undefined, status?: LicenseStatus | null | undefined, createdAt: any, updatedAt: any }> | null | undefined, careers?: Array<{ __typename?: 'Career', corporationName: string, employment?: string | null | undefined, employmentType?: CareerEmploymentType | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, retirementYear?: number | null | undefined, retirementMonth?: number | null | undefined, lengthOfService?: number | null | undefined, occupation?: string | null | undefined, description?: string | null | undefined }> | null | undefined, schoolBackgrounds?: Array<{ __typename?: 'SchoolBackground', id: number, schoolId?: number | null | undefined, schoolType?: SchoolType | null | undefined, schoolName?: string | null | undefined, courseName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined }> | null | undefined }, condition: { __typename?: 'UserCondition', id: number, industry1Code?: string | null | undefined, industry1?: string | null | undefined, industry2Code?: string | null | undefined, industry2?: string | null | undefined, industry3Code?: string | null | undefined, industry3?: string | null | undefined, category1Code?: string | null | undefined, category1?: string | null | undefined, category2Code?: string | null | undefined, category2?: string | null | undefined, category3Code?: string | null | undefined, category3?: string | null | undefined, location1Code?: string | null | undefined, location1?: string | null | undefined, location2Code?: string | null | undefined, location2?: string | null | undefined, location3Code?: string | null | undefined, location3?: string | null | undefined, corporationType1Code?: string | null | undefined, corporationType1?: string | null | undefined, corporationType2Code?: string | null | undefined, corporationType2?: string | null | undefined, corporationType3Code?: string | null | undefined, corporationType3?: string | null | undefined, jobFeature1Code?: string | null | undefined, jobFeature1?: string | null | undefined, jobFeature2Code?: string | null | undefined, jobFeature2?: string | null | undefined, jobFeature3Code?: string | null | undefined, jobFeature3?: string | null | undefined, monthlyIncome?: number | null | undefined, holiday0?: boolean | null | undefined, holiday1?: boolean | null | undefined, holiday2?: boolean | null | undefined, holiday3?: boolean | null | undefined, holiday4?: boolean | null | undefined, holiday5?: boolean | null | undefined, holiday6?: boolean | null | undefined, workStartTime?: any | null | undefined, workEndTime?: any | null | undefined } } | null | undefined, resumeCompleteStatus?: { __typename?: 'ResumeCompleteStatus', profile: boolean, condition: boolean, pr: boolean, portfolio: boolean, diagnosis: boolean, diagnosisOfOthers: boolean } | null | undefined, portfolios: Array<{ __typename?: 'Portfolio', id: number, title: string, content?: string | null | undefined, year?: number | null | undefined, month?: number | null | undefined, url?: string | null | undefined, fileUrl?: string | null | undefined, imageUrl?: string | null | undefined, imageUrls?: Array<string> | null | undefined, privacySetting?: PrivacySetting | null | undefined, createdAt: any, updatedAt: any, likeCount?: number | null | undefined, commentCount?: number | null | undefined, fileInfo?: { __typename?: 'FileInfo', id?: string | null | undefined, name: string, contentType: string, url: string, fileType?: FileType | null | undefined } | null | undefined, images?: Array<{ __typename?: 'FileInfo', id?: string | null | undefined, url: string, contentType: string, name: string }> | null | undefined, comments?: Array<{ __typename?: 'PortfolioComment', id: number, comment: string, createdAt: any, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined }> | null | undefined, likes?: Array<{ __typename?: 'PortfolioLike', id: number, createdAt: any, corporation?: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined }> | null | undefined }>, diagnoses?: Array<{ __typename?: 'Diagnosis', id?: number | null | undefined, userId?: number | null | undefined, name: string, supporterId?: number | null | undefined, supporterName?: string | null | undefined, type?: string | null | undefined, description?: string | null | undefined, trend?: Array<string> | null | undefined, career?: Array<string> | null | undefined, pointLogical?: number | null | undefined, pointPlanning?: number | null | undefined, pointFriendly?: number | null | undefined, pointCreative?: number | null | undefined, shareToken?: string | null | undefined, createdAt?: any | null | undefined }> | null | undefined, industries: Array<{ __typename?: 'KeyValue', key: string, value?: string | null | undefined }>, categories: Array<{ __typename?: 'KeyValue', key: string, value?: string | null | undefined }>, jobFeatures: Array<{ __typename?: 'KeyValue', key: string, value?: string | null | undefined }>, corporationTypes: Array<{ __typename?: 'KeyValue', key: string, value?: string | null | undefined }>, offers: Array<{ __typename?: 'Offer', id: number, isValid?: boolean | null | undefined, validSeminarDateId?: number | null | undefined, title: string, content: string, privilege?: string | null | undefined, privilegeTitle?: string | null | undefined, status: OfferStatus, offerDate: any, confirmedDate?: any | null | undefined, expiredDate: any, type?: OfferTypeEnum | null | undefined, corporationEvent?: { __typename?: 'CorporationEvent', id: number, title?: string | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, logoUrl?: string | null | undefined } } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, address?: string | null | undefined }, job?: { __typename?: 'Job', id: number, offer: string, viewCondition?: JobViewCondition | null | undefined, plusImage1Url?: string | null | undefined, plusImage2Url?: string | null | undefined, plusImage3Url?: string | null | undefined, coverImageUrl?: string | null | undefined, employmentType?: { __typename?: 'Employment', id: number, label: string } | null | undefined } | null | undefined }>, pickupFeeds: { __typename?: 'PickupPosts', id: number, updatedAt?: any | null | undefined, posts: Array<{ __typename?: 'Post', id: number, feedId: number, title: string, content: string, contentSummary: string, imageUrl?: string | null | undefined, imageFilename?: string | null | undefined, imageUrl1?: string | null | undefined, imageUrl2?: string | null | undefined, author: string, authorImageUrl?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, bookmark?: boolean | null | undefined, bookmarkCount: number, like?: boolean | null | undefined, likeCount: number, readAt?: any | null | undefined, video?: { __typename?: 'Video', id: number, videoType: string, videoId: string } | null | undefined, corporation: { __typename?: 'Corporation', id?: number | null | undefined, name?: string | null | undefined, nameKana?: string | null | undefined, logoUrl?: string | null | undefined, url?: string | null | undefined, address?: string | null | undefined }, members?: Array<{ __typename?: 'PostMember', id: number, name: string, office?: string | null | undefined, position?: string | null | undefined, imageUrl?: string | null | undefined }> | null | undefined, messageForLike?: { __typename?: 'MessageForAction', imageUrl?: string | null | undefined, message: string } | null | undefined }> } };

export type SignInUserQueryVariables = Exact<{ [key: string]: never; }>;


export type SignInUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: number, email: string, pushNotification: boolean, emailNotification: boolean, jobHuntingStatus: number, jobHuntingStatusLabel: string, school: { __typename?: 'School', id: number, name: string, plan?: SchoolPlan | null | undefined, isBasicPlanOrMore?: boolean | null | undefined, schoolNumber?: string | null | undefined, useCertificate?: boolean | null | undefined, logoUrl?: string | null | undefined, official?: boolean | null | undefined, allowPartTime?: boolean | null | undefined, allowOutsourcing?: boolean | null | undefined, companyVisitEntryType?: CompanyVisitEntry | null | undefined, groupName?: string | null | undefined, courses?: Array<{ __typename?: 'SchoolCourse', id: number, name: string }> | null | undefined, teachers?: Array<{ __typename?: 'SchoolTeacher', id: number, name: string }> | null | undefined, activityAdditions?: Array<{ __typename?: 'SchoolActivityAddition', id: number, title: string, description?: string | null | undefined, require: boolean, itemType: AdditionItemType, maxLength?: number | null | undefined, useTime?: boolean | null | undefined, items?: Array<{ __typename?: 'SchoolActivityAdditionItem', id: number, value: string, label: string }> | null | undefined }> | null | undefined, activityStatuses?: Array<{ __typename?: 'SchoolActivityStatus', value: string, label: string, defaultValue?: string | null | undefined }> | null | undefined, jobHuntingStatuses?: Array<{ __typename?: 'JobHuntingStatus', id: number, value: number, label: string }> | null | undefined, groupSchools?: Array<{ __typename?: 'School', id: number, name: string }> | null | undefined }, profile: { __typename?: 'UserProfile', id: number, firstName?: string | null | undefined, lastName?: string | null | undefined, firstKana?: string | null | undefined, lastKana?: string | null | undefined, courseId?: number | null | undefined, courseName?: string | null | undefined, className?: string | null | undefined, studentNo?: string | null | undefined, teacherId?: number | null | undefined, teacherName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined, gender?: number | null | undefined, dateOfBirth?: any | null | undefined, postalCode?: string | null | undefined, prefectureCode?: string | null | undefined, prefecture?: string | null | undefined, cityName?: string | null | undefined, addressOther?: string | null | undefined, addressFurigana?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, prTitle1?: string | null | undefined, prContent1?: string | null | undefined, prTitle2?: string | null | undefined, prContent2?: string | null | undefined, prTitle3?: string | null | undefined, prContent3?: string | null | undefined, resumeRate?: number | null | undefined, isApproved?: boolean | null | undefined, isPublic?: boolean | null | undefined, createdAt?: any | null | undefined, licenses?: Array<{ __typename?: 'License', id: number, title: string, year?: number | null | undefined, month?: number | null | undefined, status?: LicenseStatus | null | undefined, createdAt: any, updatedAt: any }> | null | undefined, careers?: Array<{ __typename?: 'Career', corporationName: string, employment?: string | null | undefined, employmentType?: CareerEmploymentType | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, retirementYear?: number | null | undefined, retirementMonth?: number | null | undefined, lengthOfService?: number | null | undefined, occupation?: string | null | undefined, description?: string | null | undefined }> | null | undefined, schoolBackgrounds?: Array<{ __typename?: 'SchoolBackground', id: number, schoolId?: number | null | undefined, schoolType?: SchoolType | null | undefined, schoolName?: string | null | undefined, courseName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined }> | null | undefined }, condition: { __typename?: 'UserCondition', id: number, industry1Code?: string | null | undefined, industry1?: string | null | undefined, industry2Code?: string | null | undefined, industry2?: string | null | undefined, industry3Code?: string | null | undefined, industry3?: string | null | undefined, category1Code?: string | null | undefined, category1?: string | null | undefined, category2Code?: string | null | undefined, category2?: string | null | undefined, category3Code?: string | null | undefined, category3?: string | null | undefined, location1Code?: string | null | undefined, location1?: string | null | undefined, location2Code?: string | null | undefined, location2?: string | null | undefined, location3Code?: string | null | undefined, location3?: string | null | undefined, corporationType1Code?: string | null | undefined, corporationType1?: string | null | undefined, corporationType2Code?: string | null | undefined, corporationType2?: string | null | undefined, corporationType3Code?: string | null | undefined, corporationType3?: string | null | undefined, jobFeature1Code?: string | null | undefined, jobFeature1?: string | null | undefined, jobFeature2Code?: string | null | undefined, jobFeature2?: string | null | undefined, jobFeature3Code?: string | null | undefined, jobFeature3?: string | null | undefined, monthlyIncome?: number | null | undefined, holiday0?: boolean | null | undefined, holiday1?: boolean | null | undefined, holiday2?: boolean | null | undefined, holiday3?: boolean | null | undefined, holiday4?: boolean | null | undefined, holiday5?: boolean | null | undefined, holiday6?: boolean | null | undefined, workStartTime?: any | null | undefined, workEndTime?: any | null | undefined } } | null | undefined };

export type ConfirmAccountQueryVariables = Exact<{
  confirmationToken: Scalars['String'];
}>;


export type ConfirmAccountQuery = { __typename?: 'Query', confirmationAccount?: { __typename?: 'User', id: number, email: string, pushNotification: boolean, emailNotification: boolean, jobHuntingStatus: number, jobHuntingStatusLabel: string, school: { __typename?: 'School', id: number, name: string, plan?: SchoolPlan | null | undefined, isBasicPlanOrMore?: boolean | null | undefined, schoolNumber?: string | null | undefined, useCertificate?: boolean | null | undefined, logoUrl?: string | null | undefined, official?: boolean | null | undefined, allowPartTime?: boolean | null | undefined, allowOutsourcing?: boolean | null | undefined, companyVisitEntryType?: CompanyVisitEntry | null | undefined, groupName?: string | null | undefined, courses?: Array<{ __typename?: 'SchoolCourse', id: number, name: string }> | null | undefined, teachers?: Array<{ __typename?: 'SchoolTeacher', id: number, name: string }> | null | undefined, activityAdditions?: Array<{ __typename?: 'SchoolActivityAddition', id: number, title: string, description?: string | null | undefined, require: boolean, itemType: AdditionItemType, maxLength?: number | null | undefined, useTime?: boolean | null | undefined, items?: Array<{ __typename?: 'SchoolActivityAdditionItem', id: number, value: string, label: string }> | null | undefined }> | null | undefined, activityStatuses?: Array<{ __typename?: 'SchoolActivityStatus', value: string, label: string, defaultValue?: string | null | undefined }> | null | undefined, jobHuntingStatuses?: Array<{ __typename?: 'JobHuntingStatus', id: number, value: number, label: string }> | null | undefined, groupSchools?: Array<{ __typename?: 'School', id: number, name: string }> | null | undefined }, profile: { __typename?: 'UserProfile', id: number, firstName?: string | null | undefined, lastName?: string | null | undefined, firstKana?: string | null | undefined, lastKana?: string | null | undefined, courseId?: number | null | undefined, courseName?: string | null | undefined, className?: string | null | undefined, studentNo?: string | null | undefined, teacherId?: number | null | undefined, teacherName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined, gender?: number | null | undefined, dateOfBirth?: any | null | undefined, postalCode?: string | null | undefined, prefectureCode?: string | null | undefined, prefecture?: string | null | undefined, cityName?: string | null | undefined, addressOther?: string | null | undefined, addressFurigana?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, prTitle1?: string | null | undefined, prContent1?: string | null | undefined, prTitle2?: string | null | undefined, prContent2?: string | null | undefined, prTitle3?: string | null | undefined, prContent3?: string | null | undefined, resumeRate?: number | null | undefined, isApproved?: boolean | null | undefined, isPublic?: boolean | null | undefined, createdAt?: any | null | undefined, licenses?: Array<{ __typename?: 'License', id: number, title: string, year?: number | null | undefined, month?: number | null | undefined, status?: LicenseStatus | null | undefined, createdAt: any, updatedAt: any }> | null | undefined, careers?: Array<{ __typename?: 'Career', corporationName: string, employment?: string | null | undefined, employmentType?: CareerEmploymentType | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, retirementYear?: number | null | undefined, retirementMonth?: number | null | undefined, lengthOfService?: number | null | undefined, occupation?: string | null | undefined, description?: string | null | undefined }> | null | undefined, schoolBackgrounds?: Array<{ __typename?: 'SchoolBackground', id: number, schoolId?: number | null | undefined, schoolType?: SchoolType | null | undefined, schoolName?: string | null | undefined, courseName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined }> | null | undefined }, condition: { __typename?: 'UserCondition', id: number, industry1Code?: string | null | undefined, industry1?: string | null | undefined, industry2Code?: string | null | undefined, industry2?: string | null | undefined, industry3Code?: string | null | undefined, industry3?: string | null | undefined, category1Code?: string | null | undefined, category1?: string | null | undefined, category2Code?: string | null | undefined, category2?: string | null | undefined, category3Code?: string | null | undefined, category3?: string | null | undefined, location1Code?: string | null | undefined, location1?: string | null | undefined, location2Code?: string | null | undefined, location2?: string | null | undefined, location3Code?: string | null | undefined, location3?: string | null | undefined, corporationType1Code?: string | null | undefined, corporationType1?: string | null | undefined, corporationType2Code?: string | null | undefined, corporationType2?: string | null | undefined, corporationType3Code?: string | null | undefined, corporationType3?: string | null | undefined, jobFeature1Code?: string | null | undefined, jobFeature1?: string | null | undefined, jobFeature2Code?: string | null | undefined, jobFeature2?: string | null | undefined, jobFeature3Code?: string | null | undefined, jobFeature3?: string | null | undefined, monthlyIncome?: number | null | undefined, holiday0?: boolean | null | undefined, holiday1?: boolean | null | undefined, holiday2?: boolean | null | undefined, holiday3?: boolean | null | undefined, holiday4?: boolean | null | undefined, holiday5?: boolean | null | undefined, holiday6?: boolean | null | undefined, workStartTime?: any | null | undefined, workEndTime?: any | null | undefined } } | null | undefined };

export type DownloadResumePdfQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadResumePdfQuery = { __typename?: 'Query', resume?: string | null | undefined };

export type UserAccessAnalyticsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserAccessAnalyticsQuery = { __typename?: 'Query', resumeAccessLog?: Array<{ __typename?: 'ChartPoint', date: any, count: number }> | null | undefined, corporationFavoriteLog?: Array<{ __typename?: 'ChartPoint', date: any, count: number }> | null | undefined };

export type UserNoticeCountQueryVariables = Exact<{ [key: string]: never; }>;


export type UserNoticeCountQuery = { __typename?: 'Query', userNoticeCount?: { __typename?: 'UserNoticeCount', news: number, message: number, offer: number, noticeBoard: number } | null | undefined };

export type ResumeCompleteStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type ResumeCompleteStatusQuery = { __typename?: 'Query', resumeCompleteStatus?: { __typename?: 'ResumeCompleteStatus', profile: boolean, condition: boolean, pr: boolean, portfolio: boolean, diagnosis: boolean, diagnosisOfOthers: boolean } | null | undefined };

export type ResumeAccessDataQueryVariables = Exact<{
  from: Scalars['ISO8601Date'];
  to: Scalars['ISO8601Date'];
}>;


export type ResumeAccessDataQuery = { __typename?: 'Query', resumeAccessLogBetweenDates?: Array<{ __typename?: 'ChartPoint', date: any, count: number }> | null | undefined, corporationFavoriteLogBetweenDates?: Array<{ __typename?: 'ChartPoint', date: any, count: number }> | null | undefined };

export type RegisterUserMutationVariables = Exact<{
  user: UserInput;
}>;


export type RegisterUserMutation = { __typename?: 'Mutation', registerUser?: { __typename?: 'RegisterUserPayload', error?: string | null | undefined, user?: { __typename?: 'User', id: number, email: string } | null | undefined } | null | undefined };

export type ChangeEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ChangeEmailMutation = { __typename?: 'Mutation', changeEmail?: { __typename?: 'ChangeEmailPayload', error?: string | null | undefined, user?: { __typename?: 'User', id: number, email: string } | null | undefined } | null | undefined };

export type ChangePasswordMutationVariables = Exact<{
  currentPassword: Scalars['String'];
  password: Scalars['String'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword?: { __typename?: 'ChangePasswordPayload', error?: string | null | undefined, user?: { __typename?: 'User', id: number, email: string } | null | undefined } | null | undefined };

export type ChangeJobHuntingStatusMutationVariables = Exact<{
  status: Scalars['Int'];
}>;


export type ChangeJobHuntingStatusMutation = { __typename?: 'Mutation', changeJobHuntingStatus?: { __typename?: 'ChangeJobHuntingStatusPayload', user?: { __typename?: 'User', id: number, email: string } | null | undefined } | null | undefined };

export type ChangeNotificationMutationVariables = Exact<{
  notification: NotificationInput;
}>;


export type ChangeNotificationMutation = { __typename?: 'Mutation', changeNotification?: { __typename?: 'ChangeNotificationPayload', error?: string | null | undefined, user?: { __typename?: 'User', id: number, email: string } | null | undefined } | null | undefined };

export type UpdateProfileMutationVariables = Exact<{
  profile: ProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'UpdateProfilePayload', error?: string | null | undefined, user?: { __typename?: 'User', id: number, email: string, pushNotification: boolean, emailNotification: boolean, jobHuntingStatus: number, jobHuntingStatusLabel: string, school: { __typename?: 'School', id: number, name: string, plan?: SchoolPlan | null | undefined, isBasicPlanOrMore?: boolean | null | undefined, schoolNumber?: string | null | undefined, useCertificate?: boolean | null | undefined, logoUrl?: string | null | undefined, official?: boolean | null | undefined, allowPartTime?: boolean | null | undefined, allowOutsourcing?: boolean | null | undefined, companyVisitEntryType?: CompanyVisitEntry | null | undefined, groupName?: string | null | undefined, courses?: Array<{ __typename?: 'SchoolCourse', id: number, name: string }> | null | undefined, teachers?: Array<{ __typename?: 'SchoolTeacher', id: number, name: string }> | null | undefined, activityAdditions?: Array<{ __typename?: 'SchoolActivityAddition', id: number, title: string, description?: string | null | undefined, require: boolean, itemType: AdditionItemType, maxLength?: number | null | undefined, useTime?: boolean | null | undefined, items?: Array<{ __typename?: 'SchoolActivityAdditionItem', id: number, value: string, label: string }> | null | undefined }> | null | undefined, activityStatuses?: Array<{ __typename?: 'SchoolActivityStatus', value: string, label: string, defaultValue?: string | null | undefined }> | null | undefined, jobHuntingStatuses?: Array<{ __typename?: 'JobHuntingStatus', id: number, value: number, label: string }> | null | undefined, groupSchools?: Array<{ __typename?: 'School', id: number, name: string }> | null | undefined }, profile: { __typename?: 'UserProfile', id: number, firstName?: string | null | undefined, lastName?: string | null | undefined, firstKana?: string | null | undefined, lastKana?: string | null | undefined, courseId?: number | null | undefined, courseName?: string | null | undefined, className?: string | null | undefined, studentNo?: string | null | undefined, teacherId?: number | null | undefined, teacherName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined, gender?: number | null | undefined, dateOfBirth?: any | null | undefined, postalCode?: string | null | undefined, prefectureCode?: string | null | undefined, prefecture?: string | null | undefined, cityName?: string | null | undefined, addressOther?: string | null | undefined, addressFurigana?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, prTitle1?: string | null | undefined, prContent1?: string | null | undefined, prTitle2?: string | null | undefined, prContent2?: string | null | undefined, prTitle3?: string | null | undefined, prContent3?: string | null | undefined, resumeRate?: number | null | undefined, isApproved?: boolean | null | undefined, isPublic?: boolean | null | undefined, createdAt?: any | null | undefined, licenses?: Array<{ __typename?: 'License', id: number, title: string, year?: number | null | undefined, month?: number | null | undefined, status?: LicenseStatus | null | undefined, createdAt: any, updatedAt: any }> | null | undefined, careers?: Array<{ __typename?: 'Career', corporationName: string, employment?: string | null | undefined, employmentType?: CareerEmploymentType | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, retirementYear?: number | null | undefined, retirementMonth?: number | null | undefined, lengthOfService?: number | null | undefined, occupation?: string | null | undefined, description?: string | null | undefined }> | null | undefined, schoolBackgrounds?: Array<{ __typename?: 'SchoolBackground', id: number, schoolId?: number | null | undefined, schoolType?: SchoolType | null | undefined, schoolName?: string | null | undefined, courseName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined }> | null | undefined }, condition: { __typename?: 'UserCondition', id: number, industry1Code?: string | null | undefined, industry1?: string | null | undefined, industry2Code?: string | null | undefined, industry2?: string | null | undefined, industry3Code?: string | null | undefined, industry3?: string | null | undefined, category1Code?: string | null | undefined, category1?: string | null | undefined, category2Code?: string | null | undefined, category2?: string | null | undefined, category3Code?: string | null | undefined, category3?: string | null | undefined, location1Code?: string | null | undefined, location1?: string | null | undefined, location2Code?: string | null | undefined, location2?: string | null | undefined, location3Code?: string | null | undefined, location3?: string | null | undefined, corporationType1Code?: string | null | undefined, corporationType1?: string | null | undefined, corporationType2Code?: string | null | undefined, corporationType2?: string | null | undefined, corporationType3Code?: string | null | undefined, corporationType3?: string | null | undefined, jobFeature1Code?: string | null | undefined, jobFeature1?: string | null | undefined, jobFeature2Code?: string | null | undefined, jobFeature2?: string | null | undefined, jobFeature3Code?: string | null | undefined, jobFeature3?: string | null | undefined, monthlyIncome?: number | null | undefined, holiday0?: boolean | null | undefined, holiday1?: boolean | null | undefined, holiday2?: boolean | null | undefined, holiday3?: boolean | null | undefined, holiday4?: boolean | null | undefined, holiday5?: boolean | null | undefined, holiday6?: boolean | null | undefined, workStartTime?: any | null | undefined, workEndTime?: any | null | undefined } } | null | undefined } | null | undefined };

export type UpdateProfileStatusMutationVariables = Exact<{
  status: Scalars['Boolean'];
}>;


export type UpdateProfileStatusMutation = { __typename?: 'Mutation', updateProfileStatus?: { __typename?: 'UpdateProfileStatusPayload', error?: string | null | undefined, user?: { __typename?: 'User', id: number, email: string, pushNotification: boolean, emailNotification: boolean, jobHuntingStatus: number, jobHuntingStatusLabel: string, school: { __typename?: 'School', id: number, name: string, plan?: SchoolPlan | null | undefined, isBasicPlanOrMore?: boolean | null | undefined, schoolNumber?: string | null | undefined, useCertificate?: boolean | null | undefined, logoUrl?: string | null | undefined, official?: boolean | null | undefined, allowPartTime?: boolean | null | undefined, allowOutsourcing?: boolean | null | undefined, companyVisitEntryType?: CompanyVisitEntry | null | undefined, groupName?: string | null | undefined, courses?: Array<{ __typename?: 'SchoolCourse', id: number, name: string }> | null | undefined, teachers?: Array<{ __typename?: 'SchoolTeacher', id: number, name: string }> | null | undefined, activityAdditions?: Array<{ __typename?: 'SchoolActivityAddition', id: number, title: string, description?: string | null | undefined, require: boolean, itemType: AdditionItemType, maxLength?: number | null | undefined, useTime?: boolean | null | undefined, items?: Array<{ __typename?: 'SchoolActivityAdditionItem', id: number, value: string, label: string }> | null | undefined }> | null | undefined, activityStatuses?: Array<{ __typename?: 'SchoolActivityStatus', value: string, label: string, defaultValue?: string | null | undefined }> | null | undefined, jobHuntingStatuses?: Array<{ __typename?: 'JobHuntingStatus', id: number, value: number, label: string }> | null | undefined, groupSchools?: Array<{ __typename?: 'School', id: number, name: string }> | null | undefined }, profile: { __typename?: 'UserProfile', id: number, firstName?: string | null | undefined, lastName?: string | null | undefined, firstKana?: string | null | undefined, lastKana?: string | null | undefined, courseId?: number | null | undefined, courseName?: string | null | undefined, className?: string | null | undefined, studentNo?: string | null | undefined, teacherId?: number | null | undefined, teacherName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined, gender?: number | null | undefined, dateOfBirth?: any | null | undefined, postalCode?: string | null | undefined, prefectureCode?: string | null | undefined, prefecture?: string | null | undefined, cityName?: string | null | undefined, addressOther?: string | null | undefined, addressFurigana?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, prTitle1?: string | null | undefined, prContent1?: string | null | undefined, prTitle2?: string | null | undefined, prContent2?: string | null | undefined, prTitle3?: string | null | undefined, prContent3?: string | null | undefined, resumeRate?: number | null | undefined, isApproved?: boolean | null | undefined, isPublic?: boolean | null | undefined, createdAt?: any | null | undefined, licenses?: Array<{ __typename?: 'License', id: number, title: string, year?: number | null | undefined, month?: number | null | undefined, status?: LicenseStatus | null | undefined, createdAt: any, updatedAt: any }> | null | undefined, careers?: Array<{ __typename?: 'Career', corporationName: string, employment?: string | null | undefined, employmentType?: CareerEmploymentType | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, retirementYear?: number | null | undefined, retirementMonth?: number | null | undefined, lengthOfService?: number | null | undefined, occupation?: string | null | undefined, description?: string | null | undefined }> | null | undefined, schoolBackgrounds?: Array<{ __typename?: 'SchoolBackground', id: number, schoolId?: number | null | undefined, schoolType?: SchoolType | null | undefined, schoolName?: string | null | undefined, courseName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined }> | null | undefined }, condition: { __typename?: 'UserCondition', id: number, industry1Code?: string | null | undefined, industry1?: string | null | undefined, industry2Code?: string | null | undefined, industry2?: string | null | undefined, industry3Code?: string | null | undefined, industry3?: string | null | undefined, category1Code?: string | null | undefined, category1?: string | null | undefined, category2Code?: string | null | undefined, category2?: string | null | undefined, category3Code?: string | null | undefined, category3?: string | null | undefined, location1Code?: string | null | undefined, location1?: string | null | undefined, location2Code?: string | null | undefined, location2?: string | null | undefined, location3Code?: string | null | undefined, location3?: string | null | undefined, corporationType1Code?: string | null | undefined, corporationType1?: string | null | undefined, corporationType2Code?: string | null | undefined, corporationType2?: string | null | undefined, corporationType3Code?: string | null | undefined, corporationType3?: string | null | undefined, jobFeature1Code?: string | null | undefined, jobFeature1?: string | null | undefined, jobFeature2Code?: string | null | undefined, jobFeature2?: string | null | undefined, jobFeature3Code?: string | null | undefined, jobFeature3?: string | null | undefined, monthlyIncome?: number | null | undefined, holiday0?: boolean | null | undefined, holiday1?: boolean | null | undefined, holiday2?: boolean | null | undefined, holiday3?: boolean | null | undefined, holiday4?: boolean | null | undefined, holiday5?: boolean | null | undefined, holiday6?: boolean | null | undefined, workStartTime?: any | null | undefined, workEndTime?: any | null | undefined } } | null | undefined } | null | undefined };

export type UpdatePrTextMutationVariables = Exact<{
  pr: PrTextInput;
}>;


export type UpdatePrTextMutation = { __typename?: 'Mutation', updatePrText?: { __typename?: 'UpdatePrTextPayload', error?: string | null | undefined, user?: { __typename?: 'User', id: number, email: string, pushNotification: boolean, emailNotification: boolean, jobHuntingStatus: number, jobHuntingStatusLabel: string, school: { __typename?: 'School', id: number, name: string, plan?: SchoolPlan | null | undefined, isBasicPlanOrMore?: boolean | null | undefined, schoolNumber?: string | null | undefined, useCertificate?: boolean | null | undefined, logoUrl?: string | null | undefined, official?: boolean | null | undefined, allowPartTime?: boolean | null | undefined, allowOutsourcing?: boolean | null | undefined, companyVisitEntryType?: CompanyVisitEntry | null | undefined, groupName?: string | null | undefined, courses?: Array<{ __typename?: 'SchoolCourse', id: number, name: string }> | null | undefined, teachers?: Array<{ __typename?: 'SchoolTeacher', id: number, name: string }> | null | undefined, activityAdditions?: Array<{ __typename?: 'SchoolActivityAddition', id: number, title: string, description?: string | null | undefined, require: boolean, itemType: AdditionItemType, maxLength?: number | null | undefined, useTime?: boolean | null | undefined, items?: Array<{ __typename?: 'SchoolActivityAdditionItem', id: number, value: string, label: string }> | null | undefined }> | null | undefined, activityStatuses?: Array<{ __typename?: 'SchoolActivityStatus', value: string, label: string, defaultValue?: string | null | undefined }> | null | undefined, jobHuntingStatuses?: Array<{ __typename?: 'JobHuntingStatus', id: number, value: number, label: string }> | null | undefined, groupSchools?: Array<{ __typename?: 'School', id: number, name: string }> | null | undefined }, profile: { __typename?: 'UserProfile', id: number, firstName?: string | null | undefined, lastName?: string | null | undefined, firstKana?: string | null | undefined, lastKana?: string | null | undefined, courseId?: number | null | undefined, courseName?: string | null | undefined, className?: string | null | undefined, studentNo?: string | null | undefined, teacherId?: number | null | undefined, teacherName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined, gender?: number | null | undefined, dateOfBirth?: any | null | undefined, postalCode?: string | null | undefined, prefectureCode?: string | null | undefined, prefecture?: string | null | undefined, cityName?: string | null | undefined, addressOther?: string | null | undefined, addressFurigana?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, prTitle1?: string | null | undefined, prContent1?: string | null | undefined, prTitle2?: string | null | undefined, prContent2?: string | null | undefined, prTitle3?: string | null | undefined, prContent3?: string | null | undefined, resumeRate?: number | null | undefined, isApproved?: boolean | null | undefined, isPublic?: boolean | null | undefined, createdAt?: any | null | undefined, licenses?: Array<{ __typename?: 'License', id: number, title: string, year?: number | null | undefined, month?: number | null | undefined, status?: LicenseStatus | null | undefined, createdAt: any, updatedAt: any }> | null | undefined, careers?: Array<{ __typename?: 'Career', corporationName: string, employment?: string | null | undefined, employmentType?: CareerEmploymentType | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, retirementYear?: number | null | undefined, retirementMonth?: number | null | undefined, lengthOfService?: number | null | undefined, occupation?: string | null | undefined, description?: string | null | undefined }> | null | undefined, schoolBackgrounds?: Array<{ __typename?: 'SchoolBackground', id: number, schoolId?: number | null | undefined, schoolType?: SchoolType | null | undefined, schoolName?: string | null | undefined, courseName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined }> | null | undefined }, condition: { __typename?: 'UserCondition', id: number, industry1Code?: string | null | undefined, industry1?: string | null | undefined, industry2Code?: string | null | undefined, industry2?: string | null | undefined, industry3Code?: string | null | undefined, industry3?: string | null | undefined, category1Code?: string | null | undefined, category1?: string | null | undefined, category2Code?: string | null | undefined, category2?: string | null | undefined, category3Code?: string | null | undefined, category3?: string | null | undefined, location1Code?: string | null | undefined, location1?: string | null | undefined, location2Code?: string | null | undefined, location2?: string | null | undefined, location3Code?: string | null | undefined, location3?: string | null | undefined, corporationType1Code?: string | null | undefined, corporationType1?: string | null | undefined, corporationType2Code?: string | null | undefined, corporationType2?: string | null | undefined, corporationType3Code?: string | null | undefined, corporationType3?: string | null | undefined, jobFeature1Code?: string | null | undefined, jobFeature1?: string | null | undefined, jobFeature2Code?: string | null | undefined, jobFeature2?: string | null | undefined, jobFeature3Code?: string | null | undefined, jobFeature3?: string | null | undefined, monthlyIncome?: number | null | undefined, holiday0?: boolean | null | undefined, holiday1?: boolean | null | undefined, holiday2?: boolean | null | undefined, holiday3?: boolean | null | undefined, holiday4?: boolean | null | undefined, holiday5?: boolean | null | undefined, holiday6?: boolean | null | undefined, workStartTime?: any | null | undefined, workEndTime?: any | null | undefined } } | null | undefined } | null | undefined };

export type UpdateConditionsMutationVariables = Exact<{
  condition: UserConditionsInput;
}>;


export type UpdateConditionsMutation = { __typename?: 'Mutation', updateConditions?: { __typename?: 'UpdateConditionsPayload', error?: string | null | undefined, condition?: { __typename?: 'UserCondition', id: number, industry1Code?: string | null | undefined, industry1?: string | null | undefined, industry2Code?: string | null | undefined, industry2?: string | null | undefined, industry3Code?: string | null | undefined, industry3?: string | null | undefined, category1Code?: string | null | undefined, category1?: string | null | undefined, category2Code?: string | null | undefined, category2?: string | null | undefined, category3Code?: string | null | undefined, category3?: string | null | undefined, location1Code?: string | null | undefined, location1?: string | null | undefined, location2Code?: string | null | undefined, location2?: string | null | undefined, location3Code?: string | null | undefined, location3?: string | null | undefined, corporationType1Code?: string | null | undefined, corporationType1?: string | null | undefined, corporationType2Code?: string | null | undefined, corporationType2?: string | null | undefined, corporationType3Code?: string | null | undefined, corporationType3?: string | null | undefined, jobFeature1Code?: string | null | undefined, jobFeature1?: string | null | undefined, jobFeature2Code?: string | null | undefined, jobFeature2?: string | null | undefined, jobFeature3Code?: string | null | undefined, jobFeature3?: string | null | undefined, monthlyIncome?: number | null | undefined, holiday0?: boolean | null | undefined, holiday1?: boolean | null | undefined, holiday2?: boolean | null | undefined, holiday3?: boolean | null | undefined, holiday4?: boolean | null | undefined, holiday5?: boolean | null | undefined, holiday6?: boolean | null | undefined, workStartTime?: any | null | undefined, workEndTime?: any | null | undefined } | null | undefined } | null | undefined };

export type UserNoticeQueryVariables = Exact<{ [key: string]: never; }>;


export type UserNoticeQuery = { __typename?: 'Query', userNotice: { __typename?: 'BadgeNotice', news: boolean, message: boolean, offer: boolean, noticeBoard: boolean, badgeCount?: number | null | undefined } };

export type NewNoticeSubscriptionVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type NewNoticeSubscription = { __typename?: 'Subscription', newNotice: { __typename?: 'NewNotice', message: boolean, news: boolean, noticeBoard: boolean, offer: boolean } };

export type RegisterDeviceTokenMutationVariables = Exact<{
  token: Scalars['String'];
  type: Scalars['String'];
}>;


export type RegisterDeviceTokenMutation = { __typename?: 'Mutation', registerDeviceToken?: { __typename?: 'RegisterDeviceTokenPayload', message?: string | null | undefined, user?: { __typename?: 'User', id: number, email: string } | null | undefined } | null | undefined };

export type UpdateReviewStatusMutationVariables = Exact<{
  deviceToken: Scalars['String'];
  reviewStatus: ReviewStatus;
  deviceType?: InputMaybe<Scalars['String']>;
}>;


export type UpdateReviewStatusMutation = { __typename?: 'Mutation', updateReviewStatus?: { __typename?: 'UpdateReviewStatusPayload', error?: string | null | undefined, user?: { __typename?: 'User', id: number, email: string } | null | undefined } | null | undefined };

export type AppInfoQueryVariables = Exact<{
  deviceToken: Scalars['String'];
  deviceType?: InputMaybe<Scalars['String']>;
}>;


export type AppInfoQuery = { __typename?: 'Query', appInfo?: { __typename?: 'AppInfo', id?: number | null | undefined, showRequestReview: boolean } | null | undefined };

export type SocialLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type SocialLinksQuery = { __typename?: 'Query', socialLinks?: Array<{ __typename?: 'SocialLink', provider: SocialProvider, linked: boolean }> | null | undefined };

export type CreateSocialLinkMutationVariables = Exact<{
  provider: SocialProvider;
  idToken: Scalars['String'];
}>;


export type CreateSocialLinkMutation = { __typename?: 'Mutation', createSocialLink?: { __typename?: 'CreateSocialLinkPayload', error?: string | null | undefined, socialLink?: { __typename?: 'SocialLink', provider: SocialProvider, linked: boolean } | null | undefined } | null | undefined };

export type DeleteSocialLinkMutationVariables = Exact<{
  provider: SocialProvider;
}>;


export type DeleteSocialLinkMutation = { __typename?: 'Mutation', deleteSocialLink?: { __typename?: 'DeleteSocialLinkPayload', error?: string | null | undefined, socialLink?: { __typename?: 'SocialLink', provider: SocialProvider, linked: boolean } | null | undefined } | null | undefined };

export type AddressAttributesFragment = { __typename?: 'Address', id: number, postalCode: number, prefectureCode: string, address1: string, address2: string, address3: string };

export type SearchAddressQueryVariables = Exact<{
  postalCode: Scalars['String'];
}>;


export type SearchAddressQuery = { __typename?: 'Query', addressFromPostalCode: Array<{ __typename?: 'Address', id: number, postalCode: number, prefectureCode: string, address1: string, address2: string, address3: string }> };

export type UserConditionAttributesFragment = { __typename?: 'UserCondition', id: number, industry1Code?: string | null | undefined, industry1?: string | null | undefined, industry2Code?: string | null | undefined, industry2?: string | null | undefined, industry3Code?: string | null | undefined, industry3?: string | null | undefined, category1Code?: string | null | undefined, category1?: string | null | undefined, category2Code?: string | null | undefined, category2?: string | null | undefined, category3Code?: string | null | undefined, category3?: string | null | undefined, location1Code?: string | null | undefined, location1?: string | null | undefined, location2Code?: string | null | undefined, location2?: string | null | undefined, location3Code?: string | null | undefined, location3?: string | null | undefined, corporationType1Code?: string | null | undefined, corporationType1?: string | null | undefined, corporationType2Code?: string | null | undefined, corporationType2?: string | null | undefined, corporationType3Code?: string | null | undefined, corporationType3?: string | null | undefined, jobFeature1Code?: string | null | undefined, jobFeature1?: string | null | undefined, jobFeature2Code?: string | null | undefined, jobFeature2?: string | null | undefined, jobFeature3Code?: string | null | undefined, jobFeature3?: string | null | undefined, monthlyIncome?: number | null | undefined, holiday0?: boolean | null | undefined, holiday1?: boolean | null | undefined, holiday2?: boolean | null | undefined, holiday3?: boolean | null | undefined, holiday4?: boolean | null | undefined, holiday5?: boolean | null | undefined, holiday6?: boolean | null | undefined, workStartTime?: any | null | undefined, workEndTime?: any | null | undefined };

export type UserAttributesFragment = { __typename?: 'User', id: number, email: string, pushNotification: boolean, emailNotification: boolean, jobHuntingStatus: number, jobHuntingStatusLabel: string, school: { __typename?: 'School', id: number, name: string, plan?: SchoolPlan | null | undefined, isBasicPlanOrMore?: boolean | null | undefined, schoolNumber?: string | null | undefined, useCertificate?: boolean | null | undefined, logoUrl?: string | null | undefined, official?: boolean | null | undefined, allowPartTime?: boolean | null | undefined, allowOutsourcing?: boolean | null | undefined, companyVisitEntryType?: CompanyVisitEntry | null | undefined, groupName?: string | null | undefined, courses?: Array<{ __typename?: 'SchoolCourse', id: number, name: string }> | null | undefined, teachers?: Array<{ __typename?: 'SchoolTeacher', id: number, name: string }> | null | undefined, activityAdditions?: Array<{ __typename?: 'SchoolActivityAddition', id: number, title: string, description?: string | null | undefined, require: boolean, itemType: AdditionItemType, maxLength?: number | null | undefined, useTime?: boolean | null | undefined, items?: Array<{ __typename?: 'SchoolActivityAdditionItem', id: number, value: string, label: string }> | null | undefined }> | null | undefined, activityStatuses?: Array<{ __typename?: 'SchoolActivityStatus', value: string, label: string, defaultValue?: string | null | undefined }> | null | undefined, jobHuntingStatuses?: Array<{ __typename?: 'JobHuntingStatus', id: number, value: number, label: string }> | null | undefined, groupSchools?: Array<{ __typename?: 'School', id: number, name: string }> | null | undefined }, profile: { __typename?: 'UserProfile', id: number, firstName?: string | null | undefined, lastName?: string | null | undefined, firstKana?: string | null | undefined, lastKana?: string | null | undefined, courseId?: number | null | undefined, courseName?: string | null | undefined, className?: string | null | undefined, studentNo?: string | null | undefined, teacherId?: number | null | undefined, teacherName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined, gender?: number | null | undefined, dateOfBirth?: any | null | undefined, postalCode?: string | null | undefined, prefectureCode?: string | null | undefined, prefecture?: string | null | undefined, cityName?: string | null | undefined, addressOther?: string | null | undefined, addressFurigana?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, prTitle1?: string | null | undefined, prContent1?: string | null | undefined, prTitle2?: string | null | undefined, prContent2?: string | null | undefined, prTitle3?: string | null | undefined, prContent3?: string | null | undefined, resumeRate?: number | null | undefined, isApproved?: boolean | null | undefined, isPublic?: boolean | null | undefined, createdAt?: any | null | undefined, licenses?: Array<{ __typename?: 'License', id: number, title: string, year?: number | null | undefined, month?: number | null | undefined, status?: LicenseStatus | null | undefined, createdAt: any, updatedAt: any }> | null | undefined, careers?: Array<{ __typename?: 'Career', corporationName: string, employment?: string | null | undefined, employmentType?: CareerEmploymentType | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, retirementYear?: number | null | undefined, retirementMonth?: number | null | undefined, lengthOfService?: number | null | undefined, occupation?: string | null | undefined, description?: string | null | undefined }> | null | undefined, schoolBackgrounds?: Array<{ __typename?: 'SchoolBackground', id: number, schoolId?: number | null | undefined, schoolType?: SchoolType | null | undefined, schoolName?: string | null | undefined, courseName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined }> | null | undefined }, condition: { __typename?: 'UserCondition', id: number, industry1Code?: string | null | undefined, industry1?: string | null | undefined, industry2Code?: string | null | undefined, industry2?: string | null | undefined, industry3Code?: string | null | undefined, industry3?: string | null | undefined, category1Code?: string | null | undefined, category1?: string | null | undefined, category2Code?: string | null | undefined, category2?: string | null | undefined, category3Code?: string | null | undefined, category3?: string | null | undefined, location1Code?: string | null | undefined, location1?: string | null | undefined, location2Code?: string | null | undefined, location2?: string | null | undefined, location3Code?: string | null | undefined, location3?: string | null | undefined, corporationType1Code?: string | null | undefined, corporationType1?: string | null | undefined, corporationType2Code?: string | null | undefined, corporationType2?: string | null | undefined, corporationType3Code?: string | null | undefined, corporationType3?: string | null | undefined, jobFeature1Code?: string | null | undefined, jobFeature1?: string | null | undefined, jobFeature2Code?: string | null | undefined, jobFeature2?: string | null | undefined, jobFeature3Code?: string | null | undefined, jobFeature3?: string | null | undefined, monthlyIncome?: number | null | undefined, holiday0?: boolean | null | undefined, holiday1?: boolean | null | undefined, holiday2?: boolean | null | undefined, holiday3?: boolean | null | undefined, holiday4?: boolean | null | undefined, holiday5?: boolean | null | undefined, holiday6?: boolean | null | undefined, workStartTime?: any | null | undefined, workEndTime?: any | null | undefined } };

export type UserProfileAttributesFragment = { __typename?: 'UserProfile', id: number, firstName?: string | null | undefined, lastName?: string | null | undefined, firstKana?: string | null | undefined, lastKana?: string | null | undefined, courseId?: number | null | undefined, courseName?: string | null | undefined, className?: string | null | undefined, studentNo?: string | null | undefined, teacherId?: number | null | undefined, teacherName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined, gender?: number | null | undefined, dateOfBirth?: any | null | undefined, postalCode?: string | null | undefined, prefectureCode?: string | null | undefined, prefecture?: string | null | undefined, cityName?: string | null | undefined, addressOther?: string | null | undefined, addressFurigana?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, prTitle1?: string | null | undefined, prContent1?: string | null | undefined, prTitle2?: string | null | undefined, prContent2?: string | null | undefined, prTitle3?: string | null | undefined, prContent3?: string | null | undefined, resumeRate?: number | null | undefined, isApproved?: boolean | null | undefined, isPublic?: boolean | null | undefined, createdAt?: any | null | undefined, licenses?: Array<{ __typename?: 'License', id: number, title: string, year?: number | null | undefined, month?: number | null | undefined, status?: LicenseStatus | null | undefined, createdAt: any, updatedAt: any }> | null | undefined, careers?: Array<{ __typename?: 'Career', corporationName: string, employment?: string | null | undefined, employmentType?: CareerEmploymentType | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, retirementYear?: number | null | undefined, retirementMonth?: number | null | undefined, lengthOfService?: number | null | undefined, occupation?: string | null | undefined, description?: string | null | undefined }> | null | undefined, schoolBackgrounds?: Array<{ __typename?: 'SchoolBackground', id: number, schoolId?: number | null | undefined, schoolType?: SchoolType | null | undefined, schoolName?: string | null | undefined, courseName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined }> | null | undefined };

export type LicenseAttributesFragment = { __typename?: 'License', id: number, title: string, year?: number | null | undefined, month?: number | null | undefined, status?: LicenseStatus | null | undefined, createdAt: any, updatedAt: any };

export type CareerAttributesFragment = { __typename?: 'Career', corporationName: string, employment?: string | null | undefined, employmentType?: CareerEmploymentType | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, retirementYear?: number | null | undefined, retirementMonth?: number | null | undefined, lengthOfService?: number | null | undefined, occupation?: string | null | undefined, description?: string | null | undefined };

export type SchoolBackgroundAttributesFragment = { __typename?: 'SchoolBackground', id: number, schoolId?: number | null | undefined, schoolType?: SchoolType | null | undefined, schoolName?: string | null | undefined, courseName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined };

export type SchoolAttributesFragment = { __typename?: 'School', id: number, name: string, plan?: SchoolPlan | null | undefined, isBasicPlanOrMore?: boolean | null | undefined, schoolNumber?: string | null | undefined, useCertificate?: boolean | null | undefined, logoUrl?: string | null | undefined, official?: boolean | null | undefined, allowPartTime?: boolean | null | undefined, allowOutsourcing?: boolean | null | undefined, companyVisitEntryType?: CompanyVisitEntry | null | undefined, groupName?: string | null | undefined, courses?: Array<{ __typename?: 'SchoolCourse', id: number, name: string }> | null | undefined, teachers?: Array<{ __typename?: 'SchoolTeacher', id: number, name: string }> | null | undefined, activityAdditions?: Array<{ __typename?: 'SchoolActivityAddition', id: number, title: string, description?: string | null | undefined, require: boolean, itemType: AdditionItemType, maxLength?: number | null | undefined, useTime?: boolean | null | undefined, items?: Array<{ __typename?: 'SchoolActivityAdditionItem', id: number, value: string, label: string }> | null | undefined }> | null | undefined, activityStatuses?: Array<{ __typename?: 'SchoolActivityStatus', value: string, label: string, defaultValue?: string | null | undefined }> | null | undefined, jobHuntingStatuses?: Array<{ __typename?: 'JobHuntingStatus', id: number, value: number, label: string }> | null | undefined, groupSchools?: Array<{ __typename?: 'School', id: number, name: string }> | null | undefined };

export const ActivityAttributesFragmentDoc = gql`
    fragment ActivityAttributes on Activity {
  id
  content
  statusCode
  status
  privacySetting
  deletable
  createdAt
  updatedAt
  file {
    name
    contentType
    url
  }
  activityAdditions {
    schoolActivityAdditionId
    itemType
    value
    dateValue
    content
    title
    shouldUseTime
  }
}
    `;
export const BookmarkAttributesFragmentDoc = gql`
    fragment BookmarkAttributes on Bookmark {
  id
  type
  targetId
  checked
}
    `;
export const KeyValueAttributesFragmentDoc = gql`
    fragment KeyValueAttributes on KeyValue {
  key
  value
}
    `;
export const ArticleAttributesFragmentDoc = gql`
    fragment ArticleAttributes on Article {
  id
  title
  content
  contentSummary
  imageUrl
  createdAt
  updatedAt
  like
  likeCount
}
    `;
export const CorporationOfficeAttributesFragmentDoc = gql`
    fragment CorporationOfficeAttributes on CorporationOffice {
  id
  name
  zipCode
  address
  access
  tel
  imageUrl
  imageUrl2
  imageUrl3
  imageUrl4
  imageUrl5
}
    `;
export const CorporationMemberAttributesFragmentDoc = gql`
    fragment CorporationMemberAttributes on CorporationMember {
  id
  name
  nameKana
  position
  office
  imageUrl
  schoolName
  sameSchool
  enteringYear
}
    `;
export const CorporationTopAttributesFragmentDoc = gql`
    fragment CorporationTopAttributes on Corporation {
  id
  coverVideo {
    videoId
    videoType
  }
  coverImageUrl
  mainImageUrl
  name
  nameKana
  description
  logoUrl
  messageContent
  messageVideo {
    videoId
    videoType
  }
  messageImageUrl
  messageName
  philosophy
  philosophyTitle
  philosophyImage1Url
  philosophyImage2Url
  vision
  visionTitle
  visionImage1Url
  visionImage2Url
  zipCode
  address
  access
  tel
  fax
  url
  topManager
  topManagerPosition
  topManager
  topManagerKana
  topManagerSchool
  description
  establishmentDate
  capital
  annualSales
  numberOfOffices
  numberOfEmployee
  housingAllowance
  internationalAdoption {
    proved
    scheduled
  }
  handicapAdoption {
    proved
    scheduled
  }
  affiliatedCompany
  visitReception {
    visitReceptionRequired
    visitReceptionTimeFrom
    visitReceptionWeekday
    visitReceptionTimeTo
  }
  schoolMemo
  areas {
    id
    name
    offices {
      ...CorporationOfficeAttributes
    }
  }
  additions {
    id
    title
    content
  }
  members {
    ...CorporationMemberAttributes
  }
  bookmark
}
    ${CorporationOfficeAttributesFragmentDoc}
${CorporationMemberAttributesFragmentDoc}`;
export const DiagnosisAttributesFragmentDoc = gql`
    fragment DiagnosisAttributes on Diagnosis {
  id
  userId
  name
  supporterId
  supporterName
  type
  description
  trend
  career
  pointLogical
  pointPlanning
  pointFriendly
  pointCreative
  shareToken
  createdAt
}
    `;
export const EntryAdditionAttributesFragmentDoc = gql`
    fragment EntryAdditionAttributes on EntryAddition {
  id
  title
  description
  require
  items
  showMemo
  additionType
}
    `;
export const EntrySettingAttributesFragmentDoc = gql`
    fragment EntrySettingAttributes on EntrySetting {
  showMemo
  requireMemo
  showLocation
  requireLocation
  privacyPolicyUrl
  additions {
    ...EntryAdditionAttributes
  }
}
    ${EntryAdditionAttributesFragmentDoc}`;
export const FeedAttributesFragmentDoc = gql`
    fragment FeedAttributes on Post {
  id
  feedId
  title
  content
  contentSummary
  imageUrl
  imageFilename
  imageUrl1
  imageUrl2
  author
  authorImageUrl
  createdAt
  updatedAt
  bookmark
  bookmarkCount
  like
  likeCount
  readAt
  video {
    id
    videoType
    videoId
  }
  corporation {
    id
    name
    nameKana
    logoUrl
    url
    address
  }
  members {
    id
    name
    office
    position
    imageUrl
  }
  messageForLike {
    imageUrl
    message
  }
}
    `;
export const FeedAttributesWithoutContentFragmentDoc = gql`
    fragment FeedAttributesWithoutContent on Post {
  id
  feedId
  title
  contentSummary
  imageUrl
  imageUrl1
  imageUrl2
  author
  authorImageUrl
  createdAt
  updatedAt
  bookmark
  bookmarkCount
  like
  likeCount
  readAt
  postTag
  video {
    id
    videoType
    videoId
  }
  corporation {
    id
    name
    nameKana
    logoUrl
    url
    address
  }
  members {
    id
    name
    office
    position
    imageUrl
  }
  messageForLike {
    imageUrl
    message
  }
  categories {
    id
    name
  }
}
    `;
export const FeedCategoryAttributesFragmentDoc = gql`
    fragment FeedCategoryAttributes on PostCategory {
  id
  name
  description
  imageUrl
  imageFilename
  postCount
  lastPostedAt
  corporations {
    id
    name
    logoUrl
  }
}
    `;
export const VoiceBoardAttributesFragmentDoc = gql`
    fragment VoiceBoardAttributes on SeniorArticle {
  id
  title
  content
  imageUrl
  createdAt
  updatedAt
  contributor
  schoolCourse
  enteringYear
  enteringMonth
  corporationName
}
    `;
export const CorporationEventInternshipAttributesFragmentDoc = gql`
    fragment CorporationEventInternshipAttributes on CorporationEventInternship {
  id
  title
  content
  closingDate
  numberOfAccepted
  enableInternational
  requirements
  periodFrom
  periodTo
  timeSchedule
  holiday
  firstMeetingPlace
  internshipDays
  whatToBring
  howToApply
  note
  imageUrl
  prefecture
  venue
  corporation {
    id
    name
    likeAll
    address
  }
  office {
    id
    name
    address
  }
  createdAt
  updatedAt
  staff {
    name
  }
  schoolEntry
}
    `;
export const JobDetailAttributesFragmentDoc = gql`
    fragment JobDetailAttributes on Job {
  id
  schoolEntry
  publicationDate
  closeDate
  catchCopy
  offer
  descWork
  idealType
  qualification
  workingHours
  locationText
  locationCities
  sisterJobInfo {
    sisterSchoolName
    sisterSchoolNameVisible
  }
  jobStatus {
    id
    jobNo
    schoolMemo
  }
  locationOffices {
    ...CorporationOfficeAttributes
  }
  holiday
  salary
  salaryIncrease
  salaryBonus
  treatment
  deducting
  vacation
  welfare
  schedule
  entryDocument
  numberOfRecruitment
  plusImage1Url
  plusImage2Url
  plusImage3Url
  coverImageUrl
  probation
  transportation
  transportationMemo
  corporationNo
  createdAt
  updatedAt
  corporation {
    id
    name
    likeAll
    address
  }
  recruiter {
    name
    nameKana
    tel
    email
    position
    message
    imageUrl
  }
  bookmark
  examination {
    id
  }
  examinationDates {
    id
    eventDate
    closingDate
  }
  examinationTimes {
    id
    from
    to
    timeText
  }
  additions {
    id
    title
    content
  }
  contranctInfo {
    contractTerm
    contractType
    contractStartDate
    contractEndDate
    contractRenewalTypeLabel
    contractRenewalCriteriaLabel
    contractRenewalLimitLabel
  }
}
    ${CorporationOfficeAttributesFragmentDoc}`;
export const JobCardAttributesFragmentDoc = gql`
    fragment JobCardAttributes on Job {
  id
  offer
  occupation {
    id
    label
  }
  employmentType {
    id
    label
  }
  catchCopy
  closeDate
  plusImage1Url
  plusImage2Url
  plusImage3Url
  coverImageUrl
  bookmark
  listVideo {
    id
    videoType
    videoId
  }
  createdAt
  updatedAt
  jobPlanSeparates: jobPlanSeparatesIndex(includeLocationCityList: false) {
    id
    premium
    locationCityList
    locationPrefectureList
  }
  characteristics1 {
    id
    label
  }
  characteristics2 {
    id
    label
  }
  characteristics3 {
    id
    label
  }
  corporation {
    id
    name
    likeAll
    logoUrl
    address
    plan
    category1 {
      id
      code
      label
    }
    category2 {
      id
      code
      label
    }
    category3 {
      id
      code
      label
    }
    handicapAdoption {
      proved
      scheduled
    }
    internationalAdoption {
      proved
      scheduled
    }
  }
}
    `;
export const CorporationAreaAttributesFragmentDoc = gql`
    fragment CorporationAreaAttributes on CorporationArea {
  id
  name
  offices {
    ...CorporationOfficeAttributes
  }
}
    ${CorporationOfficeAttributesFragmentDoc}`;
export const CorporationAttributesFragmentDoc = gql`
    fragment CorporationAttributes on Corporation {
  id
  name
  nameKana
  businessFormI18n
  logoUrl
  coverImageUrl
  mainImageUrl
  url
  corporationNumber
  philosophyTitle
  philosophy
  philosophyImage1Url
  philosophyImage2Url
  visionTitle
  vision
  visionImage1Url
  visionImage2Url
  visitReception {
    visitReceptionRequired
    visitReceptionTimeFrom
    visitReceptionTimeTo
    visitReceptionWeekday
  }
  zipCode
  address
  access
  tel
  fax
  description
  topManager
  topManagerKana
  topManagerPosition
  topManagerSchool
  establishmentDate
  capital
  annualSales
  housingAllowance
  handicapAdoption {
    proved
    scheduled
  }
  internationalAdoption {
    proved
    scheduled
  }
  numberOfEmployee
  numberOfOffices
  affiliatedCompany
  plan
  coverVideo {
    id
    videoType
    videoId
  }
  messageVideo {
    id
    videoType
    videoId
  }
  messageContent
  messageName
  messageImageUrl
  schoolMemo
  createdAt
  updatedAt
  bookmark
  tags
  recruiter {
    id
    name
    nameKana
    tel
    email
    position
    message
    imageUrl
  }
  areas {
    ...CorporationAreaAttributes
  }
  members {
    ...CorporationMemberAttributes
  }
  additions {
    id
    title
    content
  }
}
    ${CorporationAreaAttributesFragmentDoc}
${CorporationMemberAttributesFragmentDoc}`;
export const ExamAttributesFragmentDoc = gql`
    fragment ExamAttributes on CorporationEvent {
  id
  eventId
  title
  content
  place
  prefecture
  whatToBring
  howToApply
  note
  imageUrl
  eventTimesText
  createdAt
  updatedAt
  dates {
    id
    eventDate
    closingDate
  }
  times {
    id
    from
    to
    timeText
  }
  staff {
    name
  }
}
    `;
export const FindJobDetailAttributesFragmentDoc = gql`
    fragment FindJobDetailAttributes on Job {
  id
  bookmark
  coverImageUrl(isFree: $isFree)
  offer
  catchCopy
  jobStatus {
    jobNo
    schoolMemo
  }
  closeDate
  sisterJobInfo {
    sisterSchoolName
    sisterSchoolNameVisible
  }
  numberOfRecruitment
  plusImage1Url(isFree: $isFree)
  plusImage2Url(isFree: $isFree)
  descWork
  idealType
  occupation {
    id
    label
  }
  employmentType {
    id
    label
  }
  contranctInfo {
    contractTerm
    contractType
    contractStartDate
    contractEndDate
    contractRenewalTypeLabel
    contractRenewalCriteriaLabel
    contractRenewalLimitLabel
  }
  qualification
  locationText
  workingHours
  holiday
  vacation
  salary
  transportation
  transportationMemo
  treatment
  salaryIncrease
  salaryBonus
  welfare
  probation
  deducting
  additions {
    id
    title
    content
  }
  entryDocument
  schedule
  recruiter {
    imageUrl
    name
    nameKana
    tel
    message
  }
  corporationNo
  schoolEntry
  locationOffices {
    ...CorporationOfficeAttributes
  }
  corporation {
    ...CorporationAttributes
  }
  coverVideo(isFree: $isFree) {
    id
    videoType
    videoId
  }
  jobPlanSeparates: jobPlanSeparatesIndex(includeLocationCityList: true) {
    premium
    locationCityList
    locationPrefectureList
  }
  schoolAdditions {
    title
    content
  }
  examination {
    ...ExamAttributes
  }
}
    ${CorporationOfficeAttributesFragmentDoc}
${CorporationAttributesFragmentDoc}
${ExamAttributesFragmentDoc}`;
export const LikeAttributesFragmentDoc = gql`
    fragment LikeAttributes on Like {
  id
  type
  targetId
  checked
}
    `;
export const MessageUserAttributesFragmentDoc = gql`
    fragment MessageUserAttributes on MessageUser {
  id
  userType
  name
  nameSub
  imageUrl
  currentMessageId
}
    `;
export const MessageAttributesFragmentDoc = gql`
    fragment MessageAttributes on Message {
  id
  myMessage
  senderType
  userName
  content
  createdAt
  files {
    id
    name
    contentType
    fileType
    url
  }
}
    `;
export const NewsAttributesFragmentDoc = gql`
    fragment NewsAttributes on News {
  id
  title
  content
  fileUrl
  createdAt
  updatedAt
}
    `;
export const NoticeBoardAttributesFragmentDoc = gql`
    fragment NoticeBoardAttributes on NoticeBoard {
  id
  title
  content
  file {
    id
    name
    contentType
    url
  }
  bookmark
  isNew
  contributor
  catchcopy
  image {
    id
    name
    contentType
    url
  }
  schoolCourse
  createdAt
  updatedAt
}
    `;
export const NotificationAttributesFragmentDoc = gql`
    fragment NotificationAttributes on Notification {
  id
  type
  targetId
  title
  subTitle
  imageUrl
  notifiedAt
  confirmedAt
}
    `;
export const OfferAttributesFragmentDoc = gql`
    fragment OfferAttributes on Offer {
  id
  type: offerType
  isValid
  validSeminarDateId
  corporationEvent {
    id
    title
    corporation {
      id
      name
      logoUrl
    }
  }
  title
  content
  privilege
  privilegeTitle
  status
  offerDate
  confirmedDate
  expiredDate
  corporation {
    id
    name
    nameKana
    logoUrl
    address
  }
  job {
    id
    offer
    employmentType {
      id
      label
    }
    viewCondition
    plusImage1Url
    plusImage2Url
    plusImage3Url
    coverImageUrl
  }
}
    `;
export const PortfolioAttributesFragmentDoc = gql`
    fragment PortfolioAttributes on Portfolio {
  id
  title
  content
  year
  month
  url
  fileUrl
  fileInfo {
    id
    name
    contentType
    url
    fileType
  }
  imageUrl
  imageUrls
  images {
    id
    url
    contentType
    name
  }
  privacySetting
  createdAt
  updatedAt
  likeCount
  commentCount
  comments {
    id
    corporation {
      id
      name
      logoUrl
    }
    comment
    createdAt
  }
  likes {
    id
    corporation {
      id
      name
      logoUrl
    }
    createdAt
  }
}
    `;
export const SeminarAttributesFragmentDoc = gql`
    fragment SeminarAttributes on CorporationEvent {
  id
  eventId
  eventDateId
  title
  meetingType
  content
  place
  prefecture
  whatToBring
  howToApply
  note
  imageUrl
  eventDate
  closingDate
  eventTimesText
  schoolMemo
  createdAt
  updatedAt
  dates {
    id
    eventDate
    closingDate
  }
  times {
    id
    from
    to
    timeText
  }
  corporation {
    id
    name
    likeAll
    address
  }
  staff {
    name
  }
  schoolEntry
}
    `;
export const ChartPointAttributesFragmentDoc = gql`
    fragment ChartPointAttributes on ChartPoint {
  date
  count
}
    `;
export const AddressAttributesFragmentDoc = gql`
    fragment AddressAttributes on Address {
  id
  postalCode
  prefectureCode
  address1
  address2
  address3
}
    `;
export const SchoolAttributesFragmentDoc = gql`
    fragment SchoolAttributes on School {
  id
  name
  plan
  isBasicPlanOrMore
  schoolNumber
  useCertificate
  logoUrl
  official
  allowPartTime
  allowOutsourcing
  companyVisitEntryType
  courses {
    id
    name
  }
  teachers {
    id
    name
  }
  activityAdditions {
    id
    title
    description
    require
    itemType
    maxLength
    useTime
    items {
      id
      value
      label
    }
  }
  activityStatuses {
    value
    label
    defaultValue
  }
  jobHuntingStatuses {
    id
    value
    label
  }
  groupName
  groupSchools {
    id
    name
  }
}
    `;
export const LicenseAttributesFragmentDoc = gql`
    fragment LicenseAttributes on License {
  id
  title
  year
  month
  status
  createdAt
  updatedAt
}
    `;
export const CareerAttributesFragmentDoc = gql`
    fragment CareerAttributes on Career {
  corporationName
  employment
  employmentType
  enrollmentYear
  enrollmentMonth
  retirementYear
  retirementMonth
  lengthOfService
  occupation
  description
}
    `;
export const SchoolBackgroundAttributesFragmentDoc = gql`
    fragment SchoolBackgroundAttributes on SchoolBackground {
  id
  schoolId
  schoolType
  schoolName
  courseName
  enrollmentYear
  enrollmentMonth
  graduationYear
  graduationMonth
  graduationStatus
}
    `;
export const UserProfileAttributesFragmentDoc = gql`
    fragment UserProfileAttributes on UserProfile {
  id
  firstName
  lastName
  firstKana
  lastKana
  courseId
  courseName
  className
  studentNo
  teacherId
  teacherName
  enrollmentYear
  enrollmentMonth
  graduationYear
  graduationMonth
  graduationStatus
  gender
  dateOfBirth
  postalCode
  prefectureCode
  prefecture
  cityName
  addressOther
  addressFurigana
  tel
  imageUrl
  prTitle1
  prContent1
  prTitle2
  prContent2
  prTitle3
  prContent3
  resumeRate
  isApproved
  isPublic
  createdAt
  licenses {
    ...LicenseAttributes
  }
  careers {
    ...CareerAttributes
  }
  schoolBackgrounds {
    ...SchoolBackgroundAttributes
  }
}
    ${LicenseAttributesFragmentDoc}
${CareerAttributesFragmentDoc}
${SchoolBackgroundAttributesFragmentDoc}`;
export const UserConditionAttributesFragmentDoc = gql`
    fragment UserConditionAttributes on UserCondition {
  id
  industry1Code
  industry1
  industry2Code
  industry2
  industry3Code
  industry3
  category1Code
  category1
  category2Code
  category2
  category3Code
  category3
  location1Code
  location1
  location2Code
  location2
  location3Code
  location3
  corporationType1Code
  corporationType1
  corporationType2Code
  corporationType2
  corporationType3Code
  corporationType3
  jobFeature1Code
  jobFeature1
  jobFeature2Code
  jobFeature2
  jobFeature3Code
  jobFeature3
  monthlyIncome
  holiday0
  holiday1
  holiday2
  holiday3
  holiday4
  holiday5
  holiday6
  workStartTime
  workEndTime
}
    `;
export const UserAttributesFragmentDoc = gql`
    fragment UserAttributes on User {
  id
  email
  pushNotification
  emailNotification
  jobHuntingStatus
  jobHuntingStatusLabel
  school {
    ...SchoolAttributes
  }
  profile {
    ...UserProfileAttributes
  }
  condition {
    ...UserConditionAttributes
  }
}
    ${SchoolAttributesFragmentDoc}
${UserProfileAttributesFragmentDoc}
${UserConditionAttributesFragmentDoc}`;
export const FindActivityDocument = gql`
    query FindActivity($id: Int!) {
  activity(id: $id) {
    ...ActivityAttributes
    corporation {
      id
      name
      logoUrl
    }
  }
}
    ${ActivityAttributesFragmentDoc}`;

/**
 * __useFindActivityQuery__
 *
 * To run a query within a Vue component, call `useFindActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindActivityQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindActivityQuery({
 *   id: // value for 'id'
 * });
 */
export function useFindActivityQuery(variables: FindActivityQueryVariables | VueCompositionApi.Ref<FindActivityQueryVariables> | ReactiveFunction<FindActivityQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindActivityQuery, FindActivityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindActivityQuery, FindActivityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindActivityQuery, FindActivityQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindActivityQuery, FindActivityQueryVariables>(FindActivityDocument, variables, options);
}
export type FindActivityQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindActivityQuery, FindActivityQueryVariables>;
export const SearchActivitiesDocument = gql`
    query SearchActivities {
  activities {
    ...ActivityAttributes
    corporation {
      id
      name
      logoUrl
    }
  }
}
    ${ActivityAttributesFragmentDoc}`;

/**
 * __useSearchActivitiesQuery__
 *
 * To run a query within a Vue component, call `useSearchActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchActivitiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchActivitiesQuery();
 */
export function useSearchActivitiesQuery(options: VueApolloComposable.UseQueryOptions<SearchActivitiesQuery, SearchActivitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchActivitiesQuery, SearchActivitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchActivitiesQuery, SearchActivitiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchActivitiesQuery, SearchActivitiesQueryVariables>(SearchActivitiesDocument, {}, options);
}
export type SearchActivitiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchActivitiesQuery, SearchActivitiesQueryVariables>;
export const SearchActivityCorporationsDocument = gql`
    query SearchActivityCorporations {
  activityCorporations {
    id
    name
  }
}
    `;

/**
 * __useSearchActivityCorporationsQuery__
 *
 * To run a query within a Vue component, call `useSearchActivityCorporationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchActivityCorporationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchActivityCorporationsQuery();
 */
export function useSearchActivityCorporationsQuery(options: VueApolloComposable.UseQueryOptions<SearchActivityCorporationsQuery, SearchActivityCorporationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchActivityCorporationsQuery, SearchActivityCorporationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchActivityCorporationsQuery, SearchActivityCorporationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchActivityCorporationsQuery, SearchActivityCorporationsQueryVariables>(SearchActivityCorporationsDocument, {}, options);
}
export type SearchActivityCorporationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchActivityCorporationsQuery, SearchActivityCorporationsQueryVariables>;
export const CorporationActivitiesDocument = gql`
    query CorporationActivities($activityId: Int!) {
  activities(activityId: $activityId) {
    ...ActivityAttributes
  }
  activityCorporation(activityId: $activityId) {
    id
    name
  }
}
    ${ActivityAttributesFragmentDoc}`;

/**
 * __useCorporationActivitiesQuery__
 *
 * To run a query within a Vue component, call `useCorporationActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorporationActivitiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCorporationActivitiesQuery({
 *   activityId: // value for 'activityId'
 * });
 */
export function useCorporationActivitiesQuery(variables: CorporationActivitiesQueryVariables | VueCompositionApi.Ref<CorporationActivitiesQueryVariables> | ReactiveFunction<CorporationActivitiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<CorporationActivitiesQuery, CorporationActivitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CorporationActivitiesQuery, CorporationActivitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CorporationActivitiesQuery, CorporationActivitiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CorporationActivitiesQuery, CorporationActivitiesQueryVariables>(CorporationActivitiesDocument, variables, options);
}
export type CorporationActivitiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CorporationActivitiesQuery, CorporationActivitiesQueryVariables>;
export const CreateActivityDocument = gql`
    mutation CreateActivity($activity: ActivityInput!) {
  createActivity(input: {activity: $activity}) {
    activity {
      ...ActivityAttributes
    }
    error
  }
}
    ${ActivityAttributesFragmentDoc}`;

/**
 * __useCreateActivityMutation__
 *
 * To run a mutation, you first call `useCreateActivityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateActivityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateActivityMutation({
 *   variables: {
 *     activity: // value for 'activity'
 *   },
 * });
 */
export function useCreateActivityMutation(options: VueApolloComposable.UseMutationOptions<CreateActivityMutation, CreateActivityMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateActivityMutation, CreateActivityMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateActivityMutation, CreateActivityMutationVariables>(CreateActivityDocument, options);
}
export type CreateActivityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateActivityMutation, CreateActivityMutationVariables>;
export const UpdateActivityDocument = gql`
    mutation UpdateActivity($activity: ActivityInput!) {
  updateActivity(input: {activity: $activity}) {
    result
    error
  }
}
    `;

/**
 * __useUpdateActivityMutation__
 *
 * To run a mutation, you first call `useUpdateActivityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateActivityMutation({
 *   variables: {
 *     activity: // value for 'activity'
 *   },
 * });
 */
export function useUpdateActivityMutation(options: VueApolloComposable.UseMutationOptions<UpdateActivityMutation, UpdateActivityMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateActivityMutation, UpdateActivityMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateActivityMutation, UpdateActivityMutationVariables>(UpdateActivityDocument, options);
}
export type UpdateActivityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateActivityMutation, UpdateActivityMutationVariables>;
export const DeleteActivityDocument = gql`
    mutation DeleteActivity($id: Int!) {
  deleteActivity(input: {id: $id}) {
    result
    error
  }
}
    `;

/**
 * __useDeleteActivityMutation__
 *
 * To run a mutation, you first call `useDeleteActivityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActivityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteActivityMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteActivityMutation(options: VueApolloComposable.UseMutationOptions<DeleteActivityMutation, DeleteActivityMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteActivityMutation, DeleteActivityMutationVariables>>) {
  return VueApolloComposable.useMutation<DeleteActivityMutation, DeleteActivityMutationVariables>(DeleteActivityDocument, options);
}
export type DeleteActivityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteActivityMutation, DeleteActivityMutationVariables>;
export const SearchBookmarksDocument = gql`
    query SearchBookmarks {
  bookmarks {
    ...BookmarkAttributes
    job {
      ...JobCardAttributes
    }
    feed {
      ...FeedAttributes
    }
    corporation {
      id
      name
      description
      logoUrl
      address
      coverImageUrl
      mainImageUrl
      philosophyImage1Url
      philosophyImage2Url
      bookmark
    }
  }
}
    ${BookmarkAttributesFragmentDoc}
${JobCardAttributesFragmentDoc}
${FeedAttributesFragmentDoc}`;

/**
 * __useSearchBookmarksQuery__
 *
 * To run a query within a Vue component, call `useSearchBookmarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBookmarksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchBookmarksQuery();
 */
export function useSearchBookmarksQuery(options: VueApolloComposable.UseQueryOptions<SearchBookmarksQuery, SearchBookmarksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchBookmarksQuery, SearchBookmarksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchBookmarksQuery, SearchBookmarksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchBookmarksQuery, SearchBookmarksQueryVariables>(SearchBookmarksDocument, {}, options);
}
export type SearchBookmarksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchBookmarksQuery, SearchBookmarksQueryVariables>;
export const ToggleBookmarkDocument = gql`
    mutation ToggleBookmark($type: BookmarkType!, $id: Int!) {
  toggleBookmark(input: {type: $type, id: $id}) {
    bookmark {
      ...BookmarkAttributes
    }
    error
  }
}
    ${BookmarkAttributesFragmentDoc}`;

/**
 * __useToggleBookmarkMutation__
 *
 * To run a mutation, you first call `useToggleBookmarkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useToggleBookmarkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useToggleBookmarkMutation({
 *   variables: {
 *     type: // value for 'type'
 *     id: // value for 'id'
 *   },
 * });
 */
export function useToggleBookmarkMutation(options: VueApolloComposable.UseMutationOptions<ToggleBookmarkMutation, ToggleBookmarkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ToggleBookmarkMutation, ToggleBookmarkMutationVariables>>) {
  return VueApolloComposable.useMutation<ToggleBookmarkMutation, ToggleBookmarkMutationVariables>(ToggleBookmarkDocument, options);
}
export type ToggleBookmarkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ToggleBookmarkMutation, ToggleBookmarkMutationVariables>;
export const PrefectureCitiesDocument = gql`
    query PrefectureCities($prefectureCodes: [String!]!) {
  prefectureCities(prefectureCodes: $prefectureCodes) {
    cities {
      ...KeyValueAttributes
    }
    prefectureCode
    prefectureName
  }
}
    ${KeyValueAttributesFragmentDoc}`;

/**
 * __usePrefectureCitiesQuery__
 *
 * To run a query within a Vue component, call `usePrefectureCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrefectureCitiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePrefectureCitiesQuery({
 *   prefectureCodes: // value for 'prefectureCodes'
 * });
 */
export function usePrefectureCitiesQuery(variables: PrefectureCitiesQueryVariables | VueCompositionApi.Ref<PrefectureCitiesQueryVariables> | ReactiveFunction<PrefectureCitiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<PrefectureCitiesQuery, PrefectureCitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PrefectureCitiesQuery, PrefectureCitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PrefectureCitiesQuery, PrefectureCitiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PrefectureCitiesQuery, PrefectureCitiesQueryVariables>(PrefectureCitiesDocument, variables, options);
}
export type PrefectureCitiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PrefectureCitiesQuery, PrefectureCitiesQueryVariables>;
export const CityNamesDocument = gql`
    query CityNames($cityCodes: [String!]!) {
  cityNames(cityCodes: $cityCodes)
}
    `;

/**
 * __useCityNamesQuery__
 *
 * To run a query within a Vue component, call `useCityNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCityNamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCityNamesQuery({
 *   cityCodes: // value for 'cityCodes'
 * });
 */
export function useCityNamesQuery(variables: CityNamesQueryVariables | VueCompositionApi.Ref<CityNamesQueryVariables> | ReactiveFunction<CityNamesQueryVariables>, options: VueApolloComposable.UseQueryOptions<CityNamesQuery, CityNamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CityNamesQuery, CityNamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CityNamesQuery, CityNamesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CityNamesQuery, CityNamesQueryVariables>(CityNamesDocument, variables, options);
}
export type CityNamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CityNamesQuery, CityNamesQueryVariables>;
export const CodeListDocument = gql`
    query CodeList($schoolId: Int!) {
  industries(schoolId: $schoolId) {
    ...KeyValueAttributes
  }
  categories(schoolId: $schoolId) {
    ...KeyValueAttributes
  }
  jobFeatures {
    ...KeyValueAttributes
  }
  corporationTypes {
    ...KeyValueAttributes
  }
}
    ${KeyValueAttributesFragmentDoc}`;

/**
 * __useCodeListQuery__
 *
 * To run a query within a Vue component, call `useCodeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCodeListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCodeListQuery({
 *   schoolId: // value for 'schoolId'
 * });
 */
export function useCodeListQuery(variables: CodeListQueryVariables | VueCompositionApi.Ref<CodeListQueryVariables> | ReactiveFunction<CodeListQueryVariables>, options: VueApolloComposable.UseQueryOptions<CodeListQuery, CodeListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CodeListQuery, CodeListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CodeListQuery, CodeListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CodeListQuery, CodeListQueryVariables>(CodeListDocument, variables, options);
}
export type CodeListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CodeListQuery, CodeListQueryVariables>;
export const IndustriesDocument = gql`
    query Industries($schoolId: Int!) {
  industries(schoolId: $schoolId) {
    ...KeyValueAttributes
  }
}
    ${KeyValueAttributesFragmentDoc}`;

/**
 * __useIndustriesQuery__
 *
 * To run a query within a Vue component, call `useIndustriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndustriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useIndustriesQuery({
 *   schoolId: // value for 'schoolId'
 * });
 */
export function useIndustriesQuery(variables: IndustriesQueryVariables | VueCompositionApi.Ref<IndustriesQueryVariables> | ReactiveFunction<IndustriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<IndustriesQuery, IndustriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IndustriesQuery, IndustriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IndustriesQuery, IndustriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IndustriesQuery, IndustriesQueryVariables>(IndustriesDocument, variables, options);
}
export type IndustriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IndustriesQuery, IndustriesQueryVariables>;
export const IndustryNamesDocument = gql`
    query IndustryNames($industryCodes: [String!]!) {
  industryNames(industryCodes: $industryCodes)
}
    `;

/**
 * __useIndustryNamesQuery__
 *
 * To run a query within a Vue component, call `useIndustryNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndustryNamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useIndustryNamesQuery({
 *   industryCodes: // value for 'industryCodes'
 * });
 */
export function useIndustryNamesQuery(variables: IndustryNamesQueryVariables | VueCompositionApi.Ref<IndustryNamesQueryVariables> | ReactiveFunction<IndustryNamesQueryVariables>, options: VueApolloComposable.UseQueryOptions<IndustryNamesQuery, IndustryNamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IndustryNamesQuery, IndustryNamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IndustryNamesQuery, IndustryNamesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IndustryNamesQuery, IndustryNamesQueryVariables>(IndustryNamesDocument, variables, options);
}
export type IndustryNamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IndustryNamesQuery, IndustryNamesQueryVariables>;
export const GroupIndustriesDocument = gql`
    query GroupIndustries($schoolId: Int!) {
  groupIndustries(schoolId: $schoolId) {
    groupCode
    groupName
    keyValues {
      key
      value
    }
  }
}
    `;

/**
 * __useGroupIndustriesQuery__
 *
 * To run a query within a Vue component, call `useGroupIndustriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupIndustriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGroupIndustriesQuery({
 *   schoolId: // value for 'schoolId'
 * });
 */
export function useGroupIndustriesQuery(variables: GroupIndustriesQueryVariables | VueCompositionApi.Ref<GroupIndustriesQueryVariables> | ReactiveFunction<GroupIndustriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GroupIndustriesQuery, GroupIndustriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GroupIndustriesQuery, GroupIndustriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GroupIndustriesQuery, GroupIndustriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GroupIndustriesQuery, GroupIndustriesQueryVariables>(GroupIndustriesDocument, variables, options);
}
export type GroupIndustriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GroupIndustriesQuery, GroupIndustriesQueryVariables>;
export const CategoriesDocument = gql`
    query Categories($schoolId: Int!) {
  categories(schoolId: $schoolId) {
    ...KeyValueAttributes
  }
}
    ${KeyValueAttributesFragmentDoc}`;

/**
 * __useCategoriesQuery__
 *
 * To run a query within a Vue component, call `useCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCategoriesQuery({
 *   schoolId: // value for 'schoolId'
 * });
 */
export function useCategoriesQuery(variables: CategoriesQueryVariables | VueCompositionApi.Ref<CategoriesQueryVariables> | ReactiveFunction<CategoriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<CategoriesQuery, CategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CategoriesQuery, CategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CategoriesQuery, CategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, variables, options);
}
export type CategoriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CategoriesQuery, CategoriesQueryVariables>;
export const IndustryCategoriesDocument = gql`
    query IndustryCategories($schoolId: Int!, $industryCodes: [String!]!) {
  industryCategories(schoolId: $schoolId, industryCodes: $industryCodes) {
    ...KeyValueAttributes
  }
}
    ${KeyValueAttributesFragmentDoc}`;

/**
 * __useIndustryCategoriesQuery__
 *
 * To run a query within a Vue component, call `useIndustryCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndustryCategoriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useIndustryCategoriesQuery({
 *   schoolId: // value for 'schoolId'
 *   industryCodes: // value for 'industryCodes'
 * });
 */
export function useIndustryCategoriesQuery(variables: IndustryCategoriesQueryVariables | VueCompositionApi.Ref<IndustryCategoriesQueryVariables> | ReactiveFunction<IndustryCategoriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<IndustryCategoriesQuery, IndustryCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IndustryCategoriesQuery, IndustryCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IndustryCategoriesQuery, IndustryCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IndustryCategoriesQuery, IndustryCategoriesQueryVariables>(IndustryCategoriesDocument, variables, options);
}
export type IndustryCategoriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IndustryCategoriesQuery, IndustryCategoriesQueryVariables>;
export const CategoryNamesDocument = gql`
    query CategoryNames($categoryCodes: [String!]!) {
  categoryNames(categoryCodes: $categoryCodes)
}
    `;

/**
 * __useCategoryNamesQuery__
 *
 * To run a query within a Vue component, call `useCategoryNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryNamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCategoryNamesQuery({
 *   categoryCodes: // value for 'categoryCodes'
 * });
 */
export function useCategoryNamesQuery(variables: CategoryNamesQueryVariables | VueCompositionApi.Ref<CategoryNamesQueryVariables> | ReactiveFunction<CategoryNamesQueryVariables>, options: VueApolloComposable.UseQueryOptions<CategoryNamesQuery, CategoryNamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CategoryNamesQuery, CategoryNamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CategoryNamesQuery, CategoryNamesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CategoryNamesQuery, CategoryNamesQueryVariables>(CategoryNamesDocument, variables, options);
}
export type CategoryNamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CategoryNamesQuery, CategoryNamesQueryVariables>;
export const JobFeaturesDocument = gql`
    query JobFeatures {
  jobFeatures {
    ...KeyValueAttributes
  }
}
    ${KeyValueAttributesFragmentDoc}`;

/**
 * __useJobFeaturesQuery__
 *
 * To run a query within a Vue component, call `useJobFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobFeaturesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useJobFeaturesQuery();
 */
export function useJobFeaturesQuery(options: VueApolloComposable.UseQueryOptions<JobFeaturesQuery, JobFeaturesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<JobFeaturesQuery, JobFeaturesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<JobFeaturesQuery, JobFeaturesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<JobFeaturesQuery, JobFeaturesQueryVariables>(JobFeaturesDocument, {}, options);
}
export type JobFeaturesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<JobFeaturesQuery, JobFeaturesQueryVariables>;
export const JobFeatureNamesDocument = gql`
    query JobFeatureNames($jobFeatureCodes: [String!]!) {
  jobFeatureNames(jobFeatureCodes: $jobFeatureCodes)
}
    `;

/**
 * __useJobFeatureNamesQuery__
 *
 * To run a query within a Vue component, call `useJobFeatureNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobFeatureNamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useJobFeatureNamesQuery({
 *   jobFeatureCodes: // value for 'jobFeatureCodes'
 * });
 */
export function useJobFeatureNamesQuery(variables: JobFeatureNamesQueryVariables | VueCompositionApi.Ref<JobFeatureNamesQueryVariables> | ReactiveFunction<JobFeatureNamesQueryVariables>, options: VueApolloComposable.UseQueryOptions<JobFeatureNamesQuery, JobFeatureNamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<JobFeatureNamesQuery, JobFeatureNamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<JobFeatureNamesQuery, JobFeatureNamesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<JobFeatureNamesQuery, JobFeatureNamesQueryVariables>(JobFeatureNamesDocument, variables, options);
}
export type JobFeatureNamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<JobFeatureNamesQuery, JobFeatureNamesQueryVariables>;
export const CorporationTypesDocument = gql`
    query CorporationTypes($schoolId: Int!) {
  corporationTypes(schoolId: $schoolId) {
    ...KeyValueAttributes
  }
}
    ${KeyValueAttributesFragmentDoc}`;

/**
 * __useCorporationTypesQuery__
 *
 * To run a query within a Vue component, call `useCorporationTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorporationTypesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCorporationTypesQuery({
 *   schoolId: // value for 'schoolId'
 * });
 */
export function useCorporationTypesQuery(variables: CorporationTypesQueryVariables | VueCompositionApi.Ref<CorporationTypesQueryVariables> | ReactiveFunction<CorporationTypesQueryVariables>, options: VueApolloComposable.UseQueryOptions<CorporationTypesQuery, CorporationTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CorporationTypesQuery, CorporationTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CorporationTypesQuery, CorporationTypesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CorporationTypesQuery, CorporationTypesQueryVariables>(CorporationTypesDocument, variables, options);
}
export type CorporationTypesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CorporationTypesQuery, CorporationTypesQueryVariables>;
export const CorporationTypeNamesDocument = gql`
    query CorporationTypeNames($corporationTypeCodes: [String!]!) {
  corporationTypeNames(corporationTypeCodes: $corporationTypeCodes)
}
    `;

/**
 * __useCorporationTypeNamesQuery__
 *
 * To run a query within a Vue component, call `useCorporationTypeNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorporationTypeNamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCorporationTypeNamesQuery({
 *   corporationTypeCodes: // value for 'corporationTypeCodes'
 * });
 */
export function useCorporationTypeNamesQuery(variables: CorporationTypeNamesQueryVariables | VueCompositionApi.Ref<CorporationTypeNamesQueryVariables> | ReactiveFunction<CorporationTypeNamesQueryVariables>, options: VueApolloComposable.UseQueryOptions<CorporationTypeNamesQuery, CorporationTypeNamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CorporationTypeNamesQuery, CorporationTypeNamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CorporationTypeNamesQuery, CorporationTypeNamesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CorporationTypeNamesQuery, CorporationTypeNamesQueryVariables>(CorporationTypeNamesDocument, variables, options);
}
export type CorporationTypeNamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CorporationTypeNamesQuery, CorporationTypeNamesQueryVariables>;
export const FindValidCorporationDocument = gql`
    query FindValidCorporation($id: Int!) {
  validcorporation(id: $id) {
    plan
    ...CorporationTopAttributes
  }
}
    ${CorporationTopAttributesFragmentDoc}`;

/**
 * __useFindValidCorporationQuery__
 *
 * To run a query within a Vue component, call `useFindValidCorporationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindValidCorporationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindValidCorporationQuery({
 *   id: // value for 'id'
 * });
 */
export function useFindValidCorporationQuery(variables: FindValidCorporationQueryVariables | VueCompositionApi.Ref<FindValidCorporationQueryVariables> | ReactiveFunction<FindValidCorporationQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindValidCorporationQuery, FindValidCorporationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindValidCorporationQuery, FindValidCorporationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindValidCorporationQuery, FindValidCorporationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindValidCorporationQuery, FindValidCorporationQueryVariables>(FindValidCorporationDocument, variables, options);
}
export type FindValidCorporationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindValidCorporationQuery, FindValidCorporationQueryVariables>;
export const FindCorporationDocument = gql`
    query FindCorporation($id: Int!) {
  corporation(id: $id) {
    ...CorporationAttributes
  }
}
    ${CorporationAttributesFragmentDoc}`;

/**
 * __useFindCorporationQuery__
 *
 * To run a query within a Vue component, call `useFindCorporationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCorporationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindCorporationQuery({
 *   id: // value for 'id'
 * });
 */
export function useFindCorporationQuery(variables: FindCorporationQueryVariables | VueCompositionApi.Ref<FindCorporationQueryVariables> | ReactiveFunction<FindCorporationQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindCorporationQuery, FindCorporationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindCorporationQuery, FindCorporationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindCorporationQuery, FindCorporationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindCorporationQuery, FindCorporationQueryVariables>(FindCorporationDocument, variables, options);
}
export type FindCorporationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindCorporationQuery, FindCorporationQueryVariables>;
export const FindCorporationVisitDocument = gql`
    query FindCorporationVisit($id: Int!) {
  corporation(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useFindCorporationVisitQuery__
 *
 * To run a query within a Vue component, call `useFindCorporationVisitQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCorporationVisitQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindCorporationVisitQuery({
 *   id: // value for 'id'
 * });
 */
export function useFindCorporationVisitQuery(variables: FindCorporationVisitQueryVariables | VueCompositionApi.Ref<FindCorporationVisitQueryVariables> | ReactiveFunction<FindCorporationVisitQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindCorporationVisitQuery, FindCorporationVisitQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindCorporationVisitQuery, FindCorporationVisitQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindCorporationVisitQuery, FindCorporationVisitQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindCorporationVisitQuery, FindCorporationVisitQueryVariables>(FindCorporationVisitDocument, variables, options);
}
export type FindCorporationVisitQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindCorporationVisitQuery, FindCorporationVisitQueryVariables>;
export const FindCorporationMemberDocument = gql`
    query FindCorporationMember($id: Int!) {
  corporationMember(id: $id) {
    ...CorporationMemberAttributes
    articles {
      ...ArticleAttributes
    }
    feeds {
      ...FeedAttributes
    }
  }
}
    ${CorporationMemberAttributesFragmentDoc}
${ArticleAttributesFragmentDoc}
${FeedAttributesFragmentDoc}`;

/**
 * __useFindCorporationMemberQuery__
 *
 * To run a query within a Vue component, call `useFindCorporationMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCorporationMemberQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindCorporationMemberQuery({
 *   id: // value for 'id'
 * });
 */
export function useFindCorporationMemberQuery(variables: FindCorporationMemberQueryVariables | VueCompositionApi.Ref<FindCorporationMemberQueryVariables> | ReactiveFunction<FindCorporationMemberQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindCorporationMemberQuery, FindCorporationMemberQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindCorporationMemberQuery, FindCorporationMemberQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindCorporationMemberQuery, FindCorporationMemberQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindCorporationMemberQuery, FindCorporationMemberQueryVariables>(FindCorporationMemberDocument, variables, options);
}
export type FindCorporationMemberQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindCorporationMemberQuery, FindCorporationMemberQueryVariables>;
export const FindStandaloneCorporationMemberDocument = gql`
    query FindStandaloneCorporationMember($id: Int!, $corporationId: Int!) {
  corporationMember(id: $id) {
    ...CorporationMemberAttributes
    articles {
      ...ArticleAttributes
    }
    feeds {
      ...FeedAttributes
    }
  }
  corporation(id: $corporationId) {
    ...CorporationAttributes
  }
}
    ${CorporationMemberAttributesFragmentDoc}
${ArticleAttributesFragmentDoc}
${FeedAttributesFragmentDoc}
${CorporationAttributesFragmentDoc}`;

/**
 * __useFindStandaloneCorporationMemberQuery__
 *
 * To run a query within a Vue component, call `useFindStandaloneCorporationMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindStandaloneCorporationMemberQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindStandaloneCorporationMemberQuery({
 *   id: // value for 'id'
 *   corporationId: // value for 'corporationId'
 * });
 */
export function useFindStandaloneCorporationMemberQuery(variables: FindStandaloneCorporationMemberQueryVariables | VueCompositionApi.Ref<FindStandaloneCorporationMemberQueryVariables> | ReactiveFunction<FindStandaloneCorporationMemberQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindStandaloneCorporationMemberQuery, FindStandaloneCorporationMemberQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindStandaloneCorporationMemberQuery, FindStandaloneCorporationMemberQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindStandaloneCorporationMemberQuery, FindStandaloneCorporationMemberQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindStandaloneCorporationMemberQuery, FindStandaloneCorporationMemberQueryVariables>(FindStandaloneCorporationMemberDocument, variables, options);
}
export type FindStandaloneCorporationMemberQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindStandaloneCorporationMemberQuery, FindStandaloneCorporationMemberQueryVariables>;
export const SearchSchoolGraduateMembersDocument = gql`
    query SearchSchoolGraduateMembers($page: Int!, $limit: Int!, $isGetAggregate: Boolean) {
  paginationGraduateMembers(
    page: $page
    limit: $limit
    isGetAggregate: $isGetAggregate
  ) {
    graduateMembers {
      id
      name
      nameKana
      position
      office
      imageUrl
      schoolName
      sameSchool
      enteringYear
      articles {
        id
        title
        content
        imageUrl
        like
        likeCount
      }
      corporation {
        id
        name
      }
    }
    pagination {
      currentPage
      limitValue
      totalCount
      totalPages
    }
  }
}
    `;

/**
 * __useSearchSchoolGraduateMembersQuery__
 *
 * To run a query within a Vue component, call `useSearchSchoolGraduateMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSchoolGraduateMembersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchSchoolGraduateMembersQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 *   isGetAggregate: // value for 'isGetAggregate'
 * });
 */
export function useSearchSchoolGraduateMembersQuery(variables: SearchSchoolGraduateMembersQueryVariables | VueCompositionApi.Ref<SearchSchoolGraduateMembersQueryVariables> | ReactiveFunction<SearchSchoolGraduateMembersQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchSchoolGraduateMembersQuery, SearchSchoolGraduateMembersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchSchoolGraduateMembersQuery, SearchSchoolGraduateMembersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchSchoolGraduateMembersQuery, SearchSchoolGraduateMembersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchSchoolGraduateMembersQuery, SearchSchoolGraduateMembersQueryVariables>(SearchSchoolGraduateMembersDocument, variables, options);
}
export type SearchSchoolGraduateMembersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchSchoolGraduateMembersQuery, SearchSchoolGraduateMembersQueryVariables>;
export const CorporationDataDocument = gql`
    query CorporationData($id: Int!) {
  corporation(id: $id) {
    ...CorporationAttributes
  }
  jobs(conditions: {corporationId: $id}) {
    ...JobCardAttributes
  }
  feeds(conditions: {corporationId: $id}) {
    ...FeedAttributes
  }
  internships(conditions: {corporationId: $id}) {
    ...CorporationEventInternshipAttributes
  }
  seminars(conditions: {corporationId: $id}) {
    ...SeminarAttributes
  }
}
    ${CorporationAttributesFragmentDoc}
${JobCardAttributesFragmentDoc}
${FeedAttributesFragmentDoc}
${CorporationEventInternshipAttributesFragmentDoc}
${SeminarAttributesFragmentDoc}`;

/**
 * __useCorporationDataQuery__
 *
 * To run a query within a Vue component, call `useCorporationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorporationDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCorporationDataQuery({
 *   id: // value for 'id'
 * });
 */
export function useCorporationDataQuery(variables: CorporationDataQueryVariables | VueCompositionApi.Ref<CorporationDataQueryVariables> | ReactiveFunction<CorporationDataQueryVariables>, options: VueApolloComposable.UseQueryOptions<CorporationDataQuery, CorporationDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CorporationDataQuery, CorporationDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CorporationDataQuery, CorporationDataQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CorporationDataQuery, CorporationDataQueryVariables>(CorporationDataDocument, variables, options);
}
export type CorporationDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CorporationDataQuery, CorporationDataQueryVariables>;
export const CorporationDataWithJobIdDocument = gql`
    query CorporationDataWithJobId($id: Int!, $jobId: Int) {
  corporation(id: $id) {
    ...CorporationAttributes
  }
  jobs(conditions: {corporationId: $id}) {
    ...JobCardAttributes
  }
  feeds(conditions: {corporationId: $id}) {
    ...FeedAttributes
  }
  internships(conditions: {corporationId: $id}) {
    ...CorporationEventInternshipAttributes
  }
  seminars(conditions: {corporationId: $id, jobId: $jobId}) {
    ...SeminarAttributes
  }
}
    ${CorporationAttributesFragmentDoc}
${JobCardAttributesFragmentDoc}
${FeedAttributesFragmentDoc}
${CorporationEventInternshipAttributesFragmentDoc}
${SeminarAttributesFragmentDoc}`;

/**
 * __useCorporationDataWithJobIdQuery__
 *
 * To run a query within a Vue component, call `useCorporationDataWithJobIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorporationDataWithJobIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCorporationDataWithJobIdQuery({
 *   id: // value for 'id'
 *   jobId: // value for 'jobId'
 * });
 */
export function useCorporationDataWithJobIdQuery(variables: CorporationDataWithJobIdQueryVariables | VueCompositionApi.Ref<CorporationDataWithJobIdQueryVariables> | ReactiveFunction<CorporationDataWithJobIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<CorporationDataWithJobIdQuery, CorporationDataWithJobIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CorporationDataWithJobIdQuery, CorporationDataWithJobIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CorporationDataWithJobIdQuery, CorporationDataWithJobIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CorporationDataWithJobIdQuery, CorporationDataWithJobIdQueryVariables>(CorporationDataWithJobIdDocument, variables, options);
}
export type CorporationDataWithJobIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CorporationDataWithJobIdQuery, CorporationDataWithJobIdQueryVariables>;
export const PickupCorporationsDocument = gql`
    query PickupCorporations {
  pickupCorporations {
    id
    name
    logoUrl
    vision
  }
}
    `;

/**
 * __usePickupCorporationsQuery__
 *
 * To run a query within a Vue component, call `usePickupCorporationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePickupCorporationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePickupCorporationsQuery();
 */
export function usePickupCorporationsQuery(options: VueApolloComposable.UseQueryOptions<PickupCorporationsQuery, PickupCorporationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PickupCorporationsQuery, PickupCorporationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PickupCorporationsQuery, PickupCorporationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PickupCorporationsQuery, PickupCorporationsQueryVariables>(PickupCorporationsDocument, {}, options);
}
export type PickupCorporationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PickupCorporationsQuery, PickupCorporationsQueryVariables>;
export const SearchDiagnosesDocument = gql`
    query SearchDiagnoses {
  diagnoses {
    ...DiagnosisAttributes
  }
}
    ${DiagnosisAttributesFragmentDoc}`;

/**
 * __useSearchDiagnosesQuery__
 *
 * To run a query within a Vue component, call `useSearchDiagnosesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDiagnosesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchDiagnosesQuery();
 */
export function useSearchDiagnosesQuery(options: VueApolloComposable.UseQueryOptions<SearchDiagnosesQuery, SearchDiagnosesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchDiagnosesQuery, SearchDiagnosesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchDiagnosesQuery, SearchDiagnosesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchDiagnosesQuery, SearchDiagnosesQueryVariables>(SearchDiagnosesDocument, {}, options);
}
export type SearchDiagnosesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchDiagnosesQuery, SearchDiagnosesQueryVariables>;
export const MyDiagnosisDocument = gql`
    query MyDiagnosis {
  diagnosis: myDiagnosis {
    ...DiagnosisAttributes
  }
}
    ${DiagnosisAttributesFragmentDoc}`;

/**
 * __useMyDiagnosisQuery__
 *
 * To run a query within a Vue component, call `useMyDiagnosisQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyDiagnosisQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMyDiagnosisQuery();
 */
export function useMyDiagnosisQuery(options: VueApolloComposable.UseQueryOptions<MyDiagnosisQuery, MyDiagnosisQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MyDiagnosisQuery, MyDiagnosisQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MyDiagnosisQuery, MyDiagnosisQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MyDiagnosisQuery, MyDiagnosisQueryVariables>(MyDiagnosisDocument, {}, options);
}
export type MyDiagnosisQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MyDiagnosisQuery, MyDiagnosisQueryVariables>;
export const FindDiagnosisDocument = gql`
    query FindDiagnosis($userId: Int!, $other: Boolean) {
  diagnosis(id: $userId, other: $other) {
    ...DiagnosisAttributes
  }
}
    ${DiagnosisAttributesFragmentDoc}`;

/**
 * __useFindDiagnosisQuery__
 *
 * To run a query within a Vue component, call `useFindDiagnosisQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindDiagnosisQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindDiagnosisQuery({
 *   userId: // value for 'userId'
 *   other: // value for 'other'
 * });
 */
export function useFindDiagnosisQuery(variables: FindDiagnosisQueryVariables | VueCompositionApi.Ref<FindDiagnosisQueryVariables> | ReactiveFunction<FindDiagnosisQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindDiagnosisQuery, FindDiagnosisQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindDiagnosisQuery, FindDiagnosisQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindDiagnosisQuery, FindDiagnosisQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindDiagnosisQuery, FindDiagnosisQueryVariables>(FindDiagnosisDocument, variables, options);
}
export type FindDiagnosisQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindDiagnosisQuery, FindDiagnosisQueryVariables>;
export const FindRequestDiagnosisDocument = gql`
    query FindRequestDiagnosis($requestId: String!) {
  diagnosis(requestId: $requestId) {
    ...DiagnosisAttributes
  }
}
    ${DiagnosisAttributesFragmentDoc}`;

/**
 * __useFindRequestDiagnosisQuery__
 *
 * To run a query within a Vue component, call `useFindRequestDiagnosisQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindRequestDiagnosisQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindRequestDiagnosisQuery({
 *   requestId: // value for 'requestId'
 * });
 */
export function useFindRequestDiagnosisQuery(variables: FindRequestDiagnosisQueryVariables | VueCompositionApi.Ref<FindRequestDiagnosisQueryVariables> | ReactiveFunction<FindRequestDiagnosisQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindRequestDiagnosisQuery, FindRequestDiagnosisQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindRequestDiagnosisQuery, FindRequestDiagnosisQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindRequestDiagnosisQuery, FindRequestDiagnosisQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindRequestDiagnosisQuery, FindRequestDiagnosisQueryVariables>(FindRequestDiagnosisDocument, variables, options);
}
export type FindRequestDiagnosisQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindRequestDiagnosisQuery, FindRequestDiagnosisQueryVariables>;
export const CreateDiagnosisDocument = gql`
    mutation CreateDiagnosis($answers: [Int!]!, $userId: Int) {
  createDiagnosis(input: {answers: $answers, userId: $userId}) {
    diagnosis {
      ...DiagnosisAttributes
    }
    error
  }
}
    ${DiagnosisAttributesFragmentDoc}`;

/**
 * __useCreateDiagnosisMutation__
 *
 * To run a mutation, you first call `useCreateDiagnosisMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiagnosisMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDiagnosisMutation({
 *   variables: {
 *     answers: // value for 'answers'
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateDiagnosisMutation(options: VueApolloComposable.UseMutationOptions<CreateDiagnosisMutation, CreateDiagnosisMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateDiagnosisMutation, CreateDiagnosisMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateDiagnosisMutation, CreateDiagnosisMutationVariables>(CreateDiagnosisDocument, options);
}
export type CreateDiagnosisMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateDiagnosisMutation, CreateDiagnosisMutationVariables>;
export const RequestDiagnosisDocument = gql`
    mutation RequestDiagnosis($message: String!) {
  requestDiagnosis(input: {message: $message}) {
    result
    error
  }
}
    `;

/**
 * __useRequestDiagnosisMutation__
 *
 * To run a mutation, you first call `useRequestDiagnosisMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestDiagnosisMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestDiagnosisMutation({
 *   variables: {
 *     message: // value for 'message'
 *   },
 * });
 */
export function useRequestDiagnosisMutation(options: VueApolloComposable.UseMutationOptions<RequestDiagnosisMutation, RequestDiagnosisMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RequestDiagnosisMutation, RequestDiagnosisMutationVariables>>) {
  return VueApolloComposable.useMutation<RequestDiagnosisMutation, RequestDiagnosisMutationVariables>(RequestDiagnosisDocument, options);
}
export type RequestDiagnosisMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RequestDiagnosisMutation, RequestDiagnosisMutationVariables>;
export const DownloadDocument = gql`
    query Download($type: FileType!, $id: String!) {
  download(type: $type, id: $id) {
    name
    contentType
    url
    data
  }
}
    `;

/**
 * __useDownloadQuery__
 *
 * To run a query within a Vue component, call `useDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDownloadQuery({
 *   type: // value for 'type'
 *   id: // value for 'id'
 * });
 */
export function useDownloadQuery(variables: DownloadQueryVariables | VueCompositionApi.Ref<DownloadQueryVariables> | ReactiveFunction<DownloadQueryVariables>, options: VueApolloComposable.UseQueryOptions<DownloadQuery, DownloadQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DownloadQuery, DownloadQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DownloadQuery, DownloadQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DownloadQuery, DownloadQueryVariables>(DownloadDocument, variables, options);
}
export type DownloadQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DownloadQuery, DownloadQueryVariables>;
export const JobEntryDataDocument = gql`
    query JobEntryData($jobId: Int!) {
  job(id: $jobId, isEntry: true) {
    id
    offer
    locationOffices {
      ...CorporationOfficeAttributes
    }
    employmentType {
      id
      label
    }
    examination {
      id
    }
    examinationDates {
      id
      eventDate
      closingDate
    }
    examinationTimes {
      id
      from
      to
      timeText
    }
    corporation {
      id
      name
      logoUrl
    }
    sisterJobInfo {
      sisterSchoolName
      sisterSchoolNameVisible
    }
    schoolEntry
    entrySetting {
      ...EntrySettingAttributes
    }
  }
  user {
    ...UserAttributes
  }
  portfolios {
    ...PortfolioAttributes
  }
  licenses {
    ...LicenseAttributes
  }
  careers {
    ...CareerAttributes
  }
}
    ${CorporationOfficeAttributesFragmentDoc}
${EntrySettingAttributesFragmentDoc}
${UserAttributesFragmentDoc}
${PortfolioAttributesFragmentDoc}
${LicenseAttributesFragmentDoc}
${CareerAttributesFragmentDoc}`;

/**
 * __useJobEntryDataQuery__
 *
 * To run a query within a Vue component, call `useJobEntryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobEntryDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useJobEntryDataQuery({
 *   jobId: // value for 'jobId'
 * });
 */
export function useJobEntryDataQuery(variables: JobEntryDataQueryVariables | VueCompositionApi.Ref<JobEntryDataQueryVariables> | ReactiveFunction<JobEntryDataQueryVariables>, options: VueApolloComposable.UseQueryOptions<JobEntryDataQuery, JobEntryDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<JobEntryDataQuery, JobEntryDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<JobEntryDataQuery, JobEntryDataQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<JobEntryDataQuery, JobEntryDataQueryVariables>(JobEntryDataDocument, variables, options);
}
export type JobEntryDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<JobEntryDataQuery, JobEntryDataQueryVariables>;
export const CreateJobEntryDocument = gql`
    mutation CreateJobEntry($entry: JobEntryInput!) {
  createJobEntry(input: {entry: $entry}) {
    entry {
      id
      createdAt
      updatedAt
      corporation {
        id
        name
        logoUrl
      }
    }
    result
    error
  }
}
    `;

/**
 * __useCreateJobEntryMutation__
 *
 * To run a mutation, you first call `useCreateJobEntryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobEntryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateJobEntryMutation({
 *   variables: {
 *     entry: // value for 'entry'
 *   },
 * });
 */
export function useCreateJobEntryMutation(options: VueApolloComposable.UseMutationOptions<CreateJobEntryMutation, CreateJobEntryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateJobEntryMutation, CreateJobEntryMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateJobEntryMutation, CreateJobEntryMutationVariables>(CreateJobEntryDocument, options);
}
export type CreateJobEntryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateJobEntryMutation, CreateJobEntryMutationVariables>;
export const CreateCorporationVisitEntryDocument = gql`
    mutation CreateCorporationVisitEntry($input: CreateCorporationVisitEntryInput!) {
  createCorporationVisitEntry(input: $input) {
    entry {
      id
    }
    result
    error
  }
}
    `;

/**
 * __useCreateCorporationVisitEntryMutation__
 *
 * To run a mutation, you first call `useCreateCorporationVisitEntryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCorporationVisitEntryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCorporationVisitEntryMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateCorporationVisitEntryMutation(options: VueApolloComposable.UseMutationOptions<CreateCorporationVisitEntryMutation, CreateCorporationVisitEntryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateCorporationVisitEntryMutation, CreateCorporationVisitEntryMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateCorporationVisitEntryMutation, CreateCorporationVisitEntryMutationVariables>(CreateCorporationVisitEntryDocument, options);
}
export type CreateCorporationVisitEntryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateCorporationVisitEntryMutation, CreateCorporationVisitEntryMutationVariables>;
export const SearchFeedsDocument = gql`
    query SearchFeeds($conditions: SearchFeedInput!, $offset: Int!, $limit: Int!) {
  feeds(conditions: $conditions, offset: $offset, limit: $limit) {
    ...FeedAttributesWithoutContent
  }
}
    ${FeedAttributesWithoutContentFragmentDoc}`;

/**
 * __useSearchFeedsQuery__
 *
 * To run a query within a Vue component, call `useSearchFeedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFeedsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchFeedsQuery({
 *   conditions: // value for 'conditions'
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 * });
 */
export function useSearchFeedsQuery(variables: SearchFeedsQueryVariables | VueCompositionApi.Ref<SearchFeedsQueryVariables> | ReactiveFunction<SearchFeedsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchFeedsQuery, SearchFeedsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchFeedsQuery, SearchFeedsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchFeedsQuery, SearchFeedsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchFeedsQuery, SearchFeedsQueryVariables>(SearchFeedsDocument, variables, options);
}
export type SearchFeedsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchFeedsQuery, SearchFeedsQueryVariables>;
export const FeedTopDataDocument = gql`
    query FeedTopData($latestFeedsLimit: Int, $popularFeedsLimit: Int) {
  popularFeeds: feeds(conditions: {sortType: popular}, limit: $popularFeedsLimit) {
    ...FeedAttributes
  }
  latestFeeds: feeds(conditions: {sortType: latest}, limit: $latestFeedsLimit) {
    ...FeedAttributes
  }
  feedCategories {
    ...FeedCategoryAttributes
  }
}
    ${FeedAttributesFragmentDoc}
${FeedCategoryAttributesFragmentDoc}`;

/**
 * __useFeedTopDataQuery__
 *
 * To run a query within a Vue component, call `useFeedTopDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedTopDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFeedTopDataQuery({
 *   latestFeedsLimit: // value for 'latestFeedsLimit'
 *   popularFeedsLimit: // value for 'popularFeedsLimit'
 * });
 */
export function useFeedTopDataQuery(variables: FeedTopDataQueryVariables | VueCompositionApi.Ref<FeedTopDataQueryVariables> | ReactiveFunction<FeedTopDataQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<FeedTopDataQuery, FeedTopDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FeedTopDataQuery, FeedTopDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FeedTopDataQuery, FeedTopDataQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FeedTopDataQuery, FeedTopDataQueryVariables>(FeedTopDataDocument, variables, options);
}
export type FeedTopDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FeedTopDataQuery, FeedTopDataQueryVariables>;
export const FeedCertificateTopDataDocument = gql`
    query FeedCertificateTopData($latestFeedsLimit: Int, $popularFeedsLimit: Int) {
  popularCertificateFeeds: feeds(
    conditions: {sortType: popular, certificate: "certificate_only"}
    limit: $popularFeedsLimit
  ) {
    ...FeedAttributes
  }
  latestCertificateFeeds: feeds(
    conditions: {sortType: latest, certificate: "certificate_only"}
    limit: $latestFeedsLimit
  ) {
    ...FeedAttributes
  }
  feedCertificateCategories {
    ...FeedCategoryAttributes
  }
}
    ${FeedAttributesFragmentDoc}
${FeedCategoryAttributesFragmentDoc}`;

/**
 * __useFeedCertificateTopDataQuery__
 *
 * To run a query within a Vue component, call `useFeedCertificateTopDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedCertificateTopDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFeedCertificateTopDataQuery({
 *   latestFeedsLimit: // value for 'latestFeedsLimit'
 *   popularFeedsLimit: // value for 'popularFeedsLimit'
 * });
 */
export function useFeedCertificateTopDataQuery(variables: FeedCertificateTopDataQueryVariables | VueCompositionApi.Ref<FeedCertificateTopDataQueryVariables> | ReactiveFunction<FeedCertificateTopDataQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<FeedCertificateTopDataQuery, FeedCertificateTopDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FeedCertificateTopDataQuery, FeedCertificateTopDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FeedCertificateTopDataQuery, FeedCertificateTopDataQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FeedCertificateTopDataQuery, FeedCertificateTopDataQueryVariables>(FeedCertificateTopDataDocument, variables, options);
}
export type FeedCertificateTopDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FeedCertificateTopDataQuery, FeedCertificateTopDataQueryVariables>;
export const PopularCertificateFeedsDataDocument = gql`
    query PopularCertificateFeedsData($popularFeedsLimit: Int) {
  popularCertificateFeeds: feeds(
    conditions: {sortType: popular, certificate: "certificate_only"}
    limit: $popularFeedsLimit
  ) {
    id
    feedId
    title
    imageUrl
    createdAt
    bookmark
    bookmarkCount
    like
    likeCount
    readAt
    video {
      id
      videoType
      videoId
    }
    corporation {
      id
      name
      nameKana
      logoUrl
    }
  }
}
    `;

/**
 * __usePopularCertificateFeedsDataQuery__
 *
 * To run a query within a Vue component, call `usePopularCertificateFeedsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopularCertificateFeedsDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePopularCertificateFeedsDataQuery({
 *   popularFeedsLimit: // value for 'popularFeedsLimit'
 * });
 */
export function usePopularCertificateFeedsDataQuery(variables: PopularCertificateFeedsDataQueryVariables | VueCompositionApi.Ref<PopularCertificateFeedsDataQueryVariables> | ReactiveFunction<PopularCertificateFeedsDataQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<PopularCertificateFeedsDataQuery, PopularCertificateFeedsDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PopularCertificateFeedsDataQuery, PopularCertificateFeedsDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PopularCertificateFeedsDataQuery, PopularCertificateFeedsDataQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PopularCertificateFeedsDataQuery, PopularCertificateFeedsDataQueryVariables>(PopularCertificateFeedsDataDocument, variables, options);
}
export type PopularCertificateFeedsDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PopularCertificateFeedsDataQuery, PopularCertificateFeedsDataQueryVariables>;
export const FeedCorporationTopDataDocument = gql`
    query FeedCorporationTopData($latestFeedsLimit: Int, $popularFeedsLimit: Int) {
  popularCorporationFeeds: feeds(
    conditions: {sortType: popular, certificate: "corporation_jiman"}
    limit: $popularFeedsLimit
  ) {
    ...FeedAttributes
  }
  latestCorporationFeeds: feeds(
    conditions: {sortType: latest, certificate: "corporation_jiman"}
    limit: $latestFeedsLimit
  ) {
    ...FeedAttributes
  }
  feedCorporateCategories {
    ...FeedCategoryAttributes
  }
}
    ${FeedAttributesFragmentDoc}
${FeedCategoryAttributesFragmentDoc}`;

/**
 * __useFeedCorporationTopDataQuery__
 *
 * To run a query within a Vue component, call `useFeedCorporationTopDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedCorporationTopDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFeedCorporationTopDataQuery({
 *   latestFeedsLimit: // value for 'latestFeedsLimit'
 *   popularFeedsLimit: // value for 'popularFeedsLimit'
 * });
 */
export function useFeedCorporationTopDataQuery(variables: FeedCorporationTopDataQueryVariables | VueCompositionApi.Ref<FeedCorporationTopDataQueryVariables> | ReactiveFunction<FeedCorporationTopDataQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<FeedCorporationTopDataQuery, FeedCorporationTopDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FeedCorporationTopDataQuery, FeedCorporationTopDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FeedCorporationTopDataQuery, FeedCorporationTopDataQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FeedCorporationTopDataQuery, FeedCorporationTopDataQueryVariables>(FeedCorporationTopDataDocument, variables, options);
}
export type FeedCorporationTopDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FeedCorporationTopDataQuery, FeedCorporationTopDataQueryVariables>;
export const CorporationFeedsDocument = gql`
    query CorporationFeeds($id: Int!) {
  feeds(conditions: {corporationId: $id}) {
    ...FeedAttributes
  }
}
    ${FeedAttributesFragmentDoc}`;

/**
 * __useCorporationFeedsQuery__
 *
 * To run a query within a Vue component, call `useCorporationFeedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorporationFeedsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCorporationFeedsQuery({
 *   id: // value for 'id'
 * });
 */
export function useCorporationFeedsQuery(variables: CorporationFeedsQueryVariables | VueCompositionApi.Ref<CorporationFeedsQueryVariables> | ReactiveFunction<CorporationFeedsQueryVariables>, options: VueApolloComposable.UseQueryOptions<CorporationFeedsQuery, CorporationFeedsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CorporationFeedsQuery, CorporationFeedsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CorporationFeedsQuery, CorporationFeedsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CorporationFeedsQuery, CorporationFeedsQueryVariables>(CorporationFeedsDocument, variables, options);
}
export type CorporationFeedsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CorporationFeedsQuery, CorporationFeedsQueryVariables>;
export const FindFeedDocument = gql`
    query FindFeed($id: Int!) {
  feed(id: $id) {
    ...FeedAttributes
    corporation {
      members {
        id
        name
        office
        position
        imageUrl
      }
    }
  }
}
    ${FeedAttributesFragmentDoc}`;

/**
 * __useFindFeedQuery__
 *
 * To run a query within a Vue component, call `useFindFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFeedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindFeedQuery({
 *   id: // value for 'id'
 * });
 */
export function useFindFeedQuery(variables: FindFeedQueryVariables | VueCompositionApi.Ref<FindFeedQueryVariables> | ReactiveFunction<FindFeedQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindFeedQuery, FindFeedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindFeedQuery, FindFeedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindFeedQuery, FindFeedQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindFeedQuery, FindFeedQueryVariables>(FindFeedDocument, variables, options);
}
export type FindFeedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindFeedQuery, FindFeedQueryVariables>;
export const SearchFeedCategoriesDocument = gql`
    query SearchFeedCategories {
  feedCategories {
    ...FeedCategoryAttributes
  }
}
    ${FeedCategoryAttributesFragmentDoc}`;

/**
 * __useSearchFeedCategoriesQuery__
 *
 * To run a query within a Vue component, call `useSearchFeedCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFeedCategoriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchFeedCategoriesQuery();
 */
export function useSearchFeedCategoriesQuery(options: VueApolloComposable.UseQueryOptions<SearchFeedCategoriesQuery, SearchFeedCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchFeedCategoriesQuery, SearchFeedCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchFeedCategoriesQuery, SearchFeedCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchFeedCategoriesQuery, SearchFeedCategoriesQueryVariables>(SearchFeedCategoriesDocument, {}, options);
}
export type SearchFeedCategoriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchFeedCategoriesQuery, SearchFeedCategoriesQueryVariables>;
export const FindFeedCategoryDocument = gql`
    query FindFeedCategory($id: Int!) {
  feedCategory(id: $id) {
    ...FeedCategoryAttributes
  }
}
    ${FeedCategoryAttributesFragmentDoc}`;

/**
 * __useFindFeedCategoryQuery__
 *
 * To run a query within a Vue component, call `useFindFeedCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFeedCategoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindFeedCategoryQuery({
 *   id: // value for 'id'
 * });
 */
export function useFindFeedCategoryQuery(variables: FindFeedCategoryQueryVariables | VueCompositionApi.Ref<FindFeedCategoryQueryVariables> | ReactiveFunction<FindFeedCategoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindFeedCategoryQuery, FindFeedCategoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindFeedCategoryQuery, FindFeedCategoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindFeedCategoryQuery, FindFeedCategoryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindFeedCategoryQuery, FindFeedCategoryQueryVariables>(FindFeedCategoryDocument, variables, options);
}
export type FindFeedCategoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindFeedCategoryQuery, FindFeedCategoryQueryVariables>;
export const SearchPaginationFeedsDocument = gql`
    query SearchPaginationFeeds($conditions: SearchFeedInput!, $page: Int!, $limit: Int!, $isGetAggregate: Boolean) {
  paginationFeeds(
    conditions: $conditions
    page: $page
    limit: $limit
    isGetAggregate: $isGetAggregate
  ) {
    feeds {
      ...FeedAttributes
    }
    pagination {
      currentPage
      limitValue
      totalCount
      totalPages
    }
  }
}
    ${FeedAttributesFragmentDoc}`;

/**
 * __useSearchPaginationFeedsQuery__
 *
 * To run a query within a Vue component, call `useSearchPaginationFeedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPaginationFeedsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchPaginationFeedsQuery({
 *   conditions: // value for 'conditions'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 *   isGetAggregate: // value for 'isGetAggregate'
 * });
 */
export function useSearchPaginationFeedsQuery(variables: SearchPaginationFeedsQueryVariables | VueCompositionApi.Ref<SearchPaginationFeedsQueryVariables> | ReactiveFunction<SearchPaginationFeedsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchPaginationFeedsQuery, SearchPaginationFeedsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchPaginationFeedsQuery, SearchPaginationFeedsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchPaginationFeedsQuery, SearchPaginationFeedsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchPaginationFeedsQuery, SearchPaginationFeedsQueryVariables>(SearchPaginationFeedsDocument, variables, options);
}
export type SearchPaginationFeedsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchPaginationFeedsQuery, SearchPaginationFeedsQueryVariables>;
export const SearchPaginationVoiceBoardsDocument = gql`
    query SearchPaginationVoiceBoards($page: Int!, $limit: Int!, $isGetAggregate: Boolean) {
  paginationVoiceBoards(
    page: $page
    limit: $limit
    isGetAggregate: $isGetAggregate
  ) {
    voiceBoards {
      ...VoiceBoardAttributes
    }
    pagination {
      currentPage
      limitValue
      totalCount
      totalPages
    }
  }
}
    ${VoiceBoardAttributesFragmentDoc}`;

/**
 * __useSearchPaginationVoiceBoardsQuery__
 *
 * To run a query within a Vue component, call `useSearchPaginationVoiceBoardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPaginationVoiceBoardsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchPaginationVoiceBoardsQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 *   isGetAggregate: // value for 'isGetAggregate'
 * });
 */
export function useSearchPaginationVoiceBoardsQuery(variables: SearchPaginationVoiceBoardsQueryVariables | VueCompositionApi.Ref<SearchPaginationVoiceBoardsQueryVariables> | ReactiveFunction<SearchPaginationVoiceBoardsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchPaginationVoiceBoardsQuery, SearchPaginationVoiceBoardsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchPaginationVoiceBoardsQuery, SearchPaginationVoiceBoardsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchPaginationVoiceBoardsQuery, SearchPaginationVoiceBoardsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchPaginationVoiceBoardsQuery, SearchPaginationVoiceBoardsQueryVariables>(SearchPaginationVoiceBoardsDocument, variables, options);
}
export type SearchPaginationVoiceBoardsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchPaginationVoiceBoardsQuery, SearchPaginationVoiceBoardsQueryVariables>;
export const FindVoiceBoardsDocument = gql`
    query findVoiceBoards {
  voiceBoards {
    id
    title
    content
    imageUrl
    createdAt
    updatedAt
    contributor
    schoolCourse
    enteringYear
    enteringMonth
    corporationName
  }
}
    `;

/**
 * __useFindVoiceBoardsQuery__
 *
 * To run a query within a Vue component, call `useFindVoiceBoardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindVoiceBoardsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindVoiceBoardsQuery();
 */
export function useFindVoiceBoardsQuery(options: VueApolloComposable.UseQueryOptions<FindVoiceBoardsQuery, FindVoiceBoardsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindVoiceBoardsQuery, FindVoiceBoardsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindVoiceBoardsQuery, FindVoiceBoardsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindVoiceBoardsQuery, FindVoiceBoardsQueryVariables>(FindVoiceBoardsDocument, {}, options);
}
export type FindVoiceBoardsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindVoiceBoardsQuery, FindVoiceBoardsQueryVariables>;
export const FindVoiceBoardsAsVoiceDocument = gql`
    query findVoiceBoardsAsVoice($id: Int!) {
  voiceBoardsAsVoice(id: $id) {
    id
    title
    content
    imageUrl
    createdAt
    updatedAt
    contributor
    schoolCourse
    enteringYear
    enteringMonth
    corporationName
  }
}
    `;

/**
 * __useFindVoiceBoardsAsVoiceQuery__
 *
 * To run a query within a Vue component, call `useFindVoiceBoardsAsVoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindVoiceBoardsAsVoiceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindVoiceBoardsAsVoiceQuery({
 *   id: // value for 'id'
 * });
 */
export function useFindVoiceBoardsAsVoiceQuery(variables: FindVoiceBoardsAsVoiceQueryVariables | VueCompositionApi.Ref<FindVoiceBoardsAsVoiceQueryVariables> | ReactiveFunction<FindVoiceBoardsAsVoiceQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindVoiceBoardsAsVoiceQuery, FindVoiceBoardsAsVoiceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindVoiceBoardsAsVoiceQuery, FindVoiceBoardsAsVoiceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindVoiceBoardsAsVoiceQuery, FindVoiceBoardsAsVoiceQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindVoiceBoardsAsVoiceQuery, FindVoiceBoardsAsVoiceQueryVariables>(FindVoiceBoardsAsVoiceDocument, variables, options);
}
export type FindVoiceBoardsAsVoiceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindVoiceBoardsAsVoiceQuery, FindVoiceBoardsAsVoiceQueryVariables>;
export const FindVoiceBoardDocument = gql`
    query findVoiceBoard($id: Int!) {
  voiceBoard(id: $id) {
    id
    title
    content
    imageUrl
    createdAt
    updatedAt
    contributor
    schoolCourse
    enteringYear
    enteringMonth
    corporationName
  }
}
    `;

/**
 * __useFindVoiceBoardQuery__
 *
 * To run a query within a Vue component, call `useFindVoiceBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindVoiceBoardQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindVoiceBoardQuery({
 *   id: // value for 'id'
 * });
 */
export function useFindVoiceBoardQuery(variables: FindVoiceBoardQueryVariables | VueCompositionApi.Ref<FindVoiceBoardQueryVariables> | ReactiveFunction<FindVoiceBoardQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindVoiceBoardQuery, FindVoiceBoardQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindVoiceBoardQuery, FindVoiceBoardQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindVoiceBoardQuery, FindVoiceBoardQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindVoiceBoardQuery, FindVoiceBoardQueryVariables>(FindVoiceBoardDocument, variables, options);
}
export type FindVoiceBoardQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindVoiceBoardQuery, FindVoiceBoardQueryVariables>;
export const SearchInternshipsDocument = gql`
    query SearchInternships($conditions: SearchEventInput!, $offset: Int!, $limit: Int!) {
  internships(conditions: $conditions, offset: $offset, limit: $limit) {
    ...CorporationEventInternshipAttributes
    corporation {
      id
      name
      likeAll
      logoUrl
    }
  }
}
    ${CorporationEventInternshipAttributesFragmentDoc}`;

/**
 * __useSearchInternshipsQuery__
 *
 * To run a query within a Vue component, call `useSearchInternshipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchInternshipsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchInternshipsQuery({
 *   conditions: // value for 'conditions'
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 * });
 */
export function useSearchInternshipsQuery(variables: SearchInternshipsQueryVariables | VueCompositionApi.Ref<SearchInternshipsQueryVariables> | ReactiveFunction<SearchInternshipsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchInternshipsQuery, SearchInternshipsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchInternshipsQuery, SearchInternshipsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchInternshipsQuery, SearchInternshipsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchInternshipsQuery, SearchInternshipsQueryVariables>(SearchInternshipsDocument, variables, options);
}
export type SearchInternshipsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchInternshipsQuery, SearchInternshipsQueryVariables>;
export const FindInternshipDocument = gql`
    query FindInternship($id: Int!) {
  internship(id: $id) {
    ...CorporationEventInternshipAttributes
    corporation {
      ...CorporationAttributes
    }
  }
}
    ${CorporationEventInternshipAttributesFragmentDoc}
${CorporationAttributesFragmentDoc}`;

/**
 * __useFindInternshipQuery__
 *
 * To run a query within a Vue component, call `useFindInternshipQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindInternshipQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindInternshipQuery({
 *   id: // value for 'id'
 * });
 */
export function useFindInternshipQuery(variables: FindInternshipQueryVariables | VueCompositionApi.Ref<FindInternshipQueryVariables> | ReactiveFunction<FindInternshipQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindInternshipQuery, FindInternshipQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindInternshipQuery, FindInternshipQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindInternshipQuery, FindInternshipQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindInternshipQuery, FindInternshipQueryVariables>(FindInternshipDocument, variables, options);
}
export type FindInternshipQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindInternshipQuery, FindInternshipQueryVariables>;
export const FindInternshipWithNeedMoreDocument = gql`
    query FindInternshipWithNeedMore($id: Int!) {
  needMore(id: $id) {
    auth
  }
  internship(id: $id) {
    ...CorporationEventInternshipAttributes
    corporation {
      ...CorporationAttributes
    }
  }
}
    ${CorporationEventInternshipAttributesFragmentDoc}
${CorporationAttributesFragmentDoc}`;

/**
 * __useFindInternshipWithNeedMoreQuery__
 *
 * To run a query within a Vue component, call `useFindInternshipWithNeedMoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindInternshipWithNeedMoreQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindInternshipWithNeedMoreQuery({
 *   id: // value for 'id'
 * });
 */
export function useFindInternshipWithNeedMoreQuery(variables: FindInternshipWithNeedMoreQueryVariables | VueCompositionApi.Ref<FindInternshipWithNeedMoreQueryVariables> | ReactiveFunction<FindInternshipWithNeedMoreQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindInternshipWithNeedMoreQuery, FindInternshipWithNeedMoreQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindInternshipWithNeedMoreQuery, FindInternshipWithNeedMoreQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindInternshipWithNeedMoreQuery, FindInternshipWithNeedMoreQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindInternshipWithNeedMoreQuery, FindInternshipWithNeedMoreQueryVariables>(FindInternshipWithNeedMoreDocument, variables, options);
}
export type FindInternshipWithNeedMoreQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindInternshipWithNeedMoreQuery, FindInternshipWithNeedMoreQueryVariables>;
export const CreateInternshipEntryDocument = gql`
    mutation CreateInternshipEntry($entry: InternshipEntryInput!) {
  createInternshipEntry(input: {entry: $entry}) {
    entry {
      corporation {
        id
        name
        logoUrl
      }
    }
    error
  }
}
    `;

/**
 * __useCreateInternshipEntryMutation__
 *
 * To run a mutation, you first call `useCreateInternshipEntryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateInternshipEntryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateInternshipEntryMutation({
 *   variables: {
 *     entry: // value for 'entry'
 *   },
 * });
 */
export function useCreateInternshipEntryMutation(options: VueApolloComposable.UseMutationOptions<CreateInternshipEntryMutation, CreateInternshipEntryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateInternshipEntryMutation, CreateInternshipEntryMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateInternshipEntryMutation, CreateInternshipEntryMutationVariables>(CreateInternshipEntryDocument, options);
}
export type CreateInternshipEntryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateInternshipEntryMutation, CreateInternshipEntryMutationVariables>;
export const InternshipEntryDataDocument = gql`
    query InternshipEntryData($internshipId: Int!) {
  internship(id: $internshipId, isEntry: true) {
    ...CorporationEventInternshipAttributes
    entrySetting {
      ...EntrySettingAttributes
    }
    corporation {
      id
      name
      logoUrl
    }
  }
  user {
    ...UserAttributes
  }
  portfolios {
    ...PortfolioAttributes
  }
  licenses {
    ...LicenseAttributes
  }
  careers {
    ...CareerAttributes
  }
}
    ${CorporationEventInternshipAttributesFragmentDoc}
${EntrySettingAttributesFragmentDoc}
${UserAttributesFragmentDoc}
${PortfolioAttributesFragmentDoc}
${LicenseAttributesFragmentDoc}
${CareerAttributesFragmentDoc}`;

/**
 * __useInternshipEntryDataQuery__
 *
 * To run a query within a Vue component, call `useInternshipEntryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternshipEntryDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useInternshipEntryDataQuery({
 *   internshipId: // value for 'internshipId'
 * });
 */
export function useInternshipEntryDataQuery(variables: InternshipEntryDataQueryVariables | VueCompositionApi.Ref<InternshipEntryDataQueryVariables> | ReactiveFunction<InternshipEntryDataQueryVariables>, options: VueApolloComposable.UseQueryOptions<InternshipEntryDataQuery, InternshipEntryDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InternshipEntryDataQuery, InternshipEntryDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<InternshipEntryDataQuery, InternshipEntryDataQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<InternshipEntryDataQuery, InternshipEntryDataQueryVariables>(InternshipEntryDataDocument, variables, options);
}
export type InternshipEntryDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<InternshipEntryDataQuery, InternshipEntryDataQueryVariables>;
export const SearchPaginationInternshipsDocument = gql`
    query SearchPaginationInternships($conditions: SearchEventInput!, $page: Int!, $limit: Int!, $isGetAggregate: Boolean) {
  paginationInternships(
    conditions: $conditions
    page: $page
    limit: $limit
    isGetAggregate: $isGetAggregate
  ) {
    internships {
      ...CorporationEventInternshipAttributes
    }
    pagination {
      currentPage
      limitValue
      totalCount
      totalPages
    }
  }
}
    ${CorporationEventInternshipAttributesFragmentDoc}`;

/**
 * __useSearchPaginationInternshipsQuery__
 *
 * To run a query within a Vue component, call `useSearchPaginationInternshipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPaginationInternshipsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchPaginationInternshipsQuery({
 *   conditions: // value for 'conditions'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 *   isGetAggregate: // value for 'isGetAggregate'
 * });
 */
export function useSearchPaginationInternshipsQuery(variables: SearchPaginationInternshipsQueryVariables | VueCompositionApi.Ref<SearchPaginationInternshipsQueryVariables> | ReactiveFunction<SearchPaginationInternshipsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchPaginationInternshipsQuery, SearchPaginationInternshipsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchPaginationInternshipsQuery, SearchPaginationInternshipsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchPaginationInternshipsQuery, SearchPaginationInternshipsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchPaginationInternshipsQuery, SearchPaginationInternshipsQueryVariables>(SearchPaginationInternshipsDocument, variables, options);
}
export type SearchPaginationInternshipsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchPaginationInternshipsQuery, SearchPaginationInternshipsQueryVariables>;
export const SearchJobsDocument = gql`
    query SearchJobs($conditions: SearchJobInput!, $offset: Int!, $limit: Int!) {
  jobs(conditions: $conditions, offset: $offset, limit: $limit) {
    ...JobCardAttributes
  }
}
    ${JobCardAttributesFragmentDoc}`;

/**
 * __useSearchJobsQuery__
 *
 * To run a query within a Vue component, call `useSearchJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchJobsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchJobsQuery({
 *   conditions: // value for 'conditions'
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 * });
 */
export function useSearchJobsQuery(variables: SearchJobsQueryVariables | VueCompositionApi.Ref<SearchJobsQueryVariables> | ReactiveFunction<SearchJobsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchJobsQuery, SearchJobsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchJobsQuery, SearchJobsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchJobsQuery, SearchJobsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchJobsQuery, SearchJobsQueryVariables>(SearchJobsDocument, variables, options);
}
export type SearchJobsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchJobsQuery, SearchJobsQueryVariables>;
export const SearchJobsCountDocument = gql`
    query SearchJobsCount($conditions: SearchJobInput!) {
  getTotalJobCount(conditions: $conditions)
}
    `;

/**
 * __useSearchJobsCountQuery__
 *
 * To run a query within a Vue component, call `useSearchJobsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchJobsCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchJobsCountQuery({
 *   conditions: // value for 'conditions'
 * });
 */
export function useSearchJobsCountQuery(variables: SearchJobsCountQueryVariables | VueCompositionApi.Ref<SearchJobsCountQueryVariables> | ReactiveFunction<SearchJobsCountQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchJobsCountQuery, SearchJobsCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchJobsCountQuery, SearchJobsCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchJobsCountQuery, SearchJobsCountQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchJobsCountQuery, SearchJobsCountQueryVariables>(SearchJobsCountDocument, variables, options);
}
export type SearchJobsCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchJobsCountQuery, SearchJobsCountQueryVariables>;
export const SearchPickupJobsDocument = gql`
    query SearchPickupJobs($conditions: SearchJobInput!) {
  pickupJobs(conditions: $conditions) {
    ...JobCardAttributes
  }
}
    ${JobCardAttributesFragmentDoc}`;

/**
 * __useSearchPickupJobsQuery__
 *
 * To run a query within a Vue component, call `useSearchPickupJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPickupJobsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchPickupJobsQuery({
 *   conditions: // value for 'conditions'
 * });
 */
export function useSearchPickupJobsQuery(variables: SearchPickupJobsQueryVariables | VueCompositionApi.Ref<SearchPickupJobsQueryVariables> | ReactiveFunction<SearchPickupJobsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchPickupJobsQuery, SearchPickupJobsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchPickupJobsQuery, SearchPickupJobsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchPickupJobsQuery, SearchPickupJobsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchPickupJobsQuery, SearchPickupJobsQueryVariables>(SearchPickupJobsDocument, variables, options);
}
export type SearchPickupJobsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchPickupJobsQuery, SearchPickupJobsQueryVariables>;
export const SearchPaginationJobsDocument = gql`
    query SearchPaginationJobs($conditions: SearchJobInput!, $page: Int!, $limit: Int!, $isGetAggregate: Boolean, $isDevMode: Boolean) {
  paginationJobs(
    conditions: $conditions
    page: $page
    limit: $limit
    isGetAggregate: $isGetAggregate
    isDevMode: $isDevMode
  ) {
    jobs {
      ...JobCardAttributes
    }
    pagination {
      currentPage
      limitValue
      totalCount
      totalPages
    }
  }
}
    ${JobCardAttributesFragmentDoc}`;

/**
 * __useSearchPaginationJobsQuery__
 *
 * To run a query within a Vue component, call `useSearchPaginationJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPaginationJobsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchPaginationJobsQuery({
 *   conditions: // value for 'conditions'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 *   isGetAggregate: // value for 'isGetAggregate'
 *   isDevMode: // value for 'isDevMode'
 * });
 */
export function useSearchPaginationJobsQuery(variables: SearchPaginationJobsQueryVariables | VueCompositionApi.Ref<SearchPaginationJobsQueryVariables> | ReactiveFunction<SearchPaginationJobsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchPaginationJobsQuery, SearchPaginationJobsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchPaginationJobsQuery, SearchPaginationJobsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchPaginationJobsQuery, SearchPaginationJobsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchPaginationJobsQuery, SearchPaginationJobsQueryVariables>(SearchPaginationJobsDocument, variables, options);
}
export type SearchPaginationJobsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchPaginationJobsQuery, SearchPaginationJobsQueryVariables>;
export const FindJobDocument = gql`
    query FindJob($id: Int!, $isFree: Boolean!) {
  job(id: $id) {
    ...FindJobDetailAttributes
  }
}
    ${FindJobDetailAttributesFragmentDoc}`;

/**
 * __useFindJobQuery__
 *
 * To run a query within a Vue component, call `useFindJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindJobQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindJobQuery({
 *   id: // value for 'id'
 *   isFree: // value for 'isFree'
 * });
 */
export function useFindJobQuery(variables: FindJobQueryVariables | VueCompositionApi.Ref<FindJobQueryVariables> | ReactiveFunction<FindJobQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindJobQuery, FindJobQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindJobQuery, FindJobQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindJobQuery, FindJobQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindJobQuery, FindJobQueryVariables>(FindJobDocument, variables, options);
}
export type FindJobQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindJobQuery, FindJobQueryVariables>;
export const GetAnalyzeDocument = gql`
    query GetAnalyze($keyword: String!) {
  getAnalyze(keyword: $keyword)
}
    `;

/**
 * __useGetAnalyzeQuery__
 *
 * To run a query within a Vue component, call `useGetAnalyzeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyzeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAnalyzeQuery({
 *   keyword: // value for 'keyword'
 * });
 */
export function useGetAnalyzeQuery(variables: GetAnalyzeQueryVariables | VueCompositionApi.Ref<GetAnalyzeQueryVariables> | ReactiveFunction<GetAnalyzeQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAnalyzeQuery, GetAnalyzeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAnalyzeQuery, GetAnalyzeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAnalyzeQuery, GetAnalyzeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAnalyzeQuery, GetAnalyzeQueryVariables>(GetAnalyzeDocument, variables, options);
}
export type GetAnalyzeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAnalyzeQuery, GetAnalyzeQueryVariables>;
export const ToggleLikeDocument = gql`
    mutation ToggleLike($type: LikeType!, $id: Int!) {
  toggleLike(input: {type: $type, id: $id}) {
    like {
      ...LikeAttributes
    }
    error
  }
}
    ${LikeAttributesFragmentDoc}`;

/**
 * __useToggleLikeMutation__
 *
 * To run a mutation, you first call `useToggleLikeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useToggleLikeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useToggleLikeMutation({
 *   variables: {
 *     type: // value for 'type'
 *     id: // value for 'id'
 *   },
 * });
 */
export function useToggleLikeMutation(options: VueApolloComposable.UseMutationOptions<ToggleLikeMutation, ToggleLikeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ToggleLikeMutation, ToggleLikeMutationVariables>>) {
  return VueApolloComposable.useMutation<ToggleLikeMutation, ToggleLikeMutationVariables>(ToggleLikeDocument, options);
}
export type ToggleLikeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ToggleLikeMutation, ToggleLikeMutationVariables>;
export const SearchMessageRoomsDocument = gql`
    query SearchMessageRooms {
  messageRooms {
    id
    roomType
    currentMessageId
    currentMessage {
      ...MessageAttributes
    }
    userFrom {
      ...MessageUserAttributes
    }
    userTo {
      ...MessageUserAttributes
    }
  }
}
    ${MessageAttributesFragmentDoc}
${MessageUserAttributesFragmentDoc}`;

/**
 * __useSearchMessageRoomsQuery__
 *
 * To run a query within a Vue component, call `useSearchMessageRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMessageRoomsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchMessageRoomsQuery();
 */
export function useSearchMessageRoomsQuery(options: VueApolloComposable.UseQueryOptions<SearchMessageRoomsQuery, SearchMessageRoomsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchMessageRoomsQuery, SearchMessageRoomsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchMessageRoomsQuery, SearchMessageRoomsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchMessageRoomsQuery, SearchMessageRoomsQueryVariables>(SearchMessageRoomsDocument, {}, options);
}
export type SearchMessageRoomsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchMessageRoomsQuery, SearchMessageRoomsQueryVariables>;
export const FindMessageRoomDocument = gql`
    query FindMessageRoom($roomId: Int!) {
  messageRoom(roomId: $roomId) {
    id
    roomType
    currentMessageId
    currentMessage {
      ...MessageAttributes
    }
    userFrom {
      ...MessageUserAttributes
    }
    userTo {
      ...MessageUserAttributes
    }
  }
}
    ${MessageAttributesFragmentDoc}
${MessageUserAttributesFragmentDoc}`;

/**
 * __useFindMessageRoomQuery__
 *
 * To run a query within a Vue component, call `useFindMessageRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMessageRoomQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindMessageRoomQuery({
 *   roomId: // value for 'roomId'
 * });
 */
export function useFindMessageRoomQuery(variables: FindMessageRoomQueryVariables | VueCompositionApi.Ref<FindMessageRoomQueryVariables> | ReactiveFunction<FindMessageRoomQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindMessageRoomQuery, FindMessageRoomQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindMessageRoomQuery, FindMessageRoomQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindMessageRoomQuery, FindMessageRoomQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindMessageRoomQuery, FindMessageRoomQueryVariables>(FindMessageRoomDocument, variables, options);
}
export type FindMessageRoomQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindMessageRoomQuery, FindMessageRoomQueryVariables>;
export const SearchMessagesDocument = gql`
    query SearchMessages($roomId: Int!, $cursor: Int!) {
  messages(roomId: $roomId, cursor: $cursor) {
    ...MessageAttributes
  }
}
    ${MessageAttributesFragmentDoc}`;

/**
 * __useSearchMessagesQuery__
 *
 * To run a query within a Vue component, call `useSearchMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMessagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchMessagesQuery({
 *   roomId: // value for 'roomId'
 *   cursor: // value for 'cursor'
 * });
 */
export function useSearchMessagesQuery(variables: SearchMessagesQueryVariables | VueCompositionApi.Ref<SearchMessagesQueryVariables> | ReactiveFunction<SearchMessagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchMessagesQuery, SearchMessagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchMessagesQuery, SearchMessagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchMessagesQuery, SearchMessagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchMessagesQuery, SearchMessagesQueryVariables>(SearchMessagesDocument, variables, options);
}
export type SearchMessagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchMessagesQuery, SearchMessagesQueryVariables>;
export const SendMessageDocument = gql`
    mutation SendMessage($messageInput: SendMessagesInput!) {
  sendMessage(input: {messageInput: $messageInput}) {
    message {
      ...MessageAttributes
    }
    error
  }
}
    ${MessageAttributesFragmentDoc}`;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendMessageMutation({
 *   variables: {
 *     messageInput: // value for 'messageInput'
 *   },
 * });
 */
export function useSendMessageMutation(options: VueApolloComposable.UseMutationOptions<SendMessageMutation, SendMessageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendMessageMutation, SendMessageMutationVariables>>) {
  return VueApolloComposable.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
}
export type SendMessageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendMessageMutation, SendMessageMutationVariables>;
export const UpdateCurrentMessageDocument = gql`
    mutation UpdateCurrentMessage($roomId: Int!, $messageId: Int!) {
  updateCurrentMessage(input: {roomId: $roomId, messageId: $messageId}) {
    room {
      id
      roomType
      currentMessageId
      currentMessage {
        ...MessageAttributes
      }
      userFrom {
        ...MessageUserAttributes
      }
      userTo {
        ...MessageUserAttributes
      }
    }
    error
  }
}
    ${MessageAttributesFragmentDoc}
${MessageUserAttributesFragmentDoc}`;

/**
 * __useUpdateCurrentMessageMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentMessageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentMessageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCurrentMessageMutation({
 *   variables: {
 *     roomId: // value for 'roomId'
 *     messageId: // value for 'messageId'
 *   },
 * });
 */
export function useUpdateCurrentMessageMutation(options: VueApolloComposable.UseMutationOptions<UpdateCurrentMessageMutation, UpdateCurrentMessageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCurrentMessageMutation, UpdateCurrentMessageMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateCurrentMessageMutation, UpdateCurrentMessageMutationVariables>(UpdateCurrentMessageDocument, options);
}
export type UpdateCurrentMessageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCurrentMessageMutation, UpdateCurrentMessageMutationVariables>;
export const SearchPaginationMessagesDocument = gql`
    query SearchPaginationMessages($after: String, $before: String, $first: Int, $last: Int, $roomId: Int!) {
  paginationMessages(
    after: $after
    before: $before
    first: $first
    last: $last
    roomId: $roomId
  ) {
    edges {
      cursor
      node {
        ...MessageAttributes
      }
    }
    nodes {
      ...MessageAttributes
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
    totalCount
  }
}
    ${MessageAttributesFragmentDoc}`;

/**
 * __useSearchPaginationMessagesQuery__
 *
 * To run a query within a Vue component, call `useSearchPaginationMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPaginationMessagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchPaginationMessagesQuery({
 *   after: // value for 'after'
 *   before: // value for 'before'
 *   first: // value for 'first'
 *   last: // value for 'last'
 *   roomId: // value for 'roomId'
 * });
 */
export function useSearchPaginationMessagesQuery(variables: SearchPaginationMessagesQueryVariables | VueCompositionApi.Ref<SearchPaginationMessagesQueryVariables> | ReactiveFunction<SearchPaginationMessagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchPaginationMessagesQuery, SearchPaginationMessagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchPaginationMessagesQuery, SearchPaginationMessagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchPaginationMessagesQuery, SearchPaginationMessagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchPaginationMessagesQuery, SearchPaginationMessagesQueryVariables>(SearchPaginationMessagesDocument, variables, options);
}
export type SearchPaginationMessagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchPaginationMessagesQuery, SearchPaginationMessagesQueryVariables>;
export const NewMessageDocument = gql`
    subscription NewMessage($after: String, $before: String, $first: Int, $last: Int, $messageRoomId: Int!) {
  newMessage(
    after: $after
    before: $before
    first: $first
    last: $last
    messageRoomId: $messageRoomId
  ) {
    edges {
      cursor
      node {
        ...MessageAttributes
      }
    }
    nodes {
      ...MessageAttributes
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${MessageAttributesFragmentDoc}`;

/**
 * __useNewMessageSubscription__
 *
 * To run a query within a Vue component, call `useNewMessageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewMessageSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useNewMessageSubscription({
 *   after: // value for 'after'
 *   before: // value for 'before'
 *   first: // value for 'first'
 *   last: // value for 'last'
 *   messageRoomId: // value for 'messageRoomId'
 * });
 */
export function useNewMessageSubscription(variables: NewMessageSubscriptionVariables | VueCompositionApi.Ref<NewMessageSubscriptionVariables> | ReactiveFunction<NewMessageSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<NewMessageSubscription, NewMessageSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<NewMessageSubscription, NewMessageSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<NewMessageSubscription, NewMessageSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<NewMessageSubscription, NewMessageSubscriptionVariables>(NewMessageDocument, variables, options);
}
export type NewMessageSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<NewMessageSubscription, NewMessageSubscriptionVariables>;
export const SearchNewsListDocument = gql`
    query SearchNewsList($smApp: Boolean!) {
  newsList(smApp: $smApp) {
    ...NewsAttributes
  }
}
    ${NewsAttributesFragmentDoc}`;

/**
 * __useSearchNewsListQuery__
 *
 * To run a query within a Vue component, call `useSearchNewsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchNewsListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchNewsListQuery({
 *   smApp: // value for 'smApp'
 * });
 */
export function useSearchNewsListQuery(variables: SearchNewsListQueryVariables | VueCompositionApi.Ref<SearchNewsListQueryVariables> | ReactiveFunction<SearchNewsListQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchNewsListQuery, SearchNewsListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchNewsListQuery, SearchNewsListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchNewsListQuery, SearchNewsListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchNewsListQuery, SearchNewsListQueryVariables>(SearchNewsListDocument, variables, options);
}
export type SearchNewsListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchNewsListQuery, SearchNewsListQueryVariables>;
export const FindNewsDocument = gql`
    query FindNews($id: Int!, $smApp: Boolean!) {
  newsDetail(id: $id, smApp: $smApp) {
    ...NewsAttributes
  }
}
    ${NewsAttributesFragmentDoc}`;

/**
 * __useFindNewsQuery__
 *
 * To run a query within a Vue component, call `useFindNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindNewsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindNewsQuery({
 *   id: // value for 'id'
 *   smApp: // value for 'smApp'
 * });
 */
export function useFindNewsQuery(variables: FindNewsQueryVariables | VueCompositionApi.Ref<FindNewsQueryVariables> | ReactiveFunction<FindNewsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindNewsQuery, FindNewsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindNewsQuery, FindNewsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindNewsQuery, FindNewsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindNewsQuery, FindNewsQueryVariables>(FindNewsDocument, variables, options);
}
export type FindNewsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindNewsQuery, FindNewsQueryVariables>;
export const SearchNoticeBoardsDocument = gql`
    query SearchNoticeBoards {
  noticeBoards {
    ...NoticeBoardAttributes
  }
}
    ${NoticeBoardAttributesFragmentDoc}`;

/**
 * __useSearchNoticeBoardsQuery__
 *
 * To run a query within a Vue component, call `useSearchNoticeBoardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchNoticeBoardsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchNoticeBoardsQuery();
 */
export function useSearchNoticeBoardsQuery(options: VueApolloComposable.UseQueryOptions<SearchNoticeBoardsQuery, SearchNoticeBoardsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchNoticeBoardsQuery, SearchNoticeBoardsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchNoticeBoardsQuery, SearchNoticeBoardsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchNoticeBoardsQuery, SearchNoticeBoardsQueryVariables>(SearchNoticeBoardsDocument, {}, options);
}
export type SearchNoticeBoardsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchNoticeBoardsQuery, SearchNoticeBoardsQueryVariables>;
export const FindNoticeBoardDocument = gql`
    query FindNoticeBoard($id: Int!) {
  noticeBoard(id: $id) {
    ...NoticeBoardAttributes
  }
}
    ${NoticeBoardAttributesFragmentDoc}`;

/**
 * __useFindNoticeBoardQuery__
 *
 * To run a query within a Vue component, call `useFindNoticeBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindNoticeBoardQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindNoticeBoardQuery({
 *   id: // value for 'id'
 * });
 */
export function useFindNoticeBoardQuery(variables: FindNoticeBoardQueryVariables | VueCompositionApi.Ref<FindNoticeBoardQueryVariables> | ReactiveFunction<FindNoticeBoardQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindNoticeBoardQuery, FindNoticeBoardQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindNoticeBoardQuery, FindNoticeBoardQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindNoticeBoardQuery, FindNoticeBoardQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindNoticeBoardQuery, FindNoticeBoardQueryVariables>(FindNoticeBoardDocument, variables, options);
}
export type FindNoticeBoardQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindNoticeBoardQuery, FindNoticeBoardQueryVariables>;
export const SearchNotificationDocument = gql`
    query SearchNotification {
  notifications {
    ...NotificationAttributes
  }
}
    ${NotificationAttributesFragmentDoc}`;

/**
 * __useSearchNotificationQuery__
 *
 * To run a query within a Vue component, call `useSearchNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchNotificationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchNotificationQuery();
 */
export function useSearchNotificationQuery(options: VueApolloComposable.UseQueryOptions<SearchNotificationQuery, SearchNotificationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchNotificationQuery, SearchNotificationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchNotificationQuery, SearchNotificationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchNotificationQuery, SearchNotificationQueryVariables>(SearchNotificationDocument, {}, options);
}
export type SearchNotificationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchNotificationQuery, SearchNotificationQueryVariables>;
export const ClearNotificationDocument = gql`
    query ClearNotification {
  noticeAllRead {
    news
    message
    offer
    noticeBoard
    badgeCount
  }
}
    `;

/**
 * __useClearNotificationQuery__
 *
 * To run a query within a Vue component, call `useClearNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useClearNotificationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClearNotificationQuery();
 */
export function useClearNotificationQuery(options: VueApolloComposable.UseQueryOptions<ClearNotificationQuery, ClearNotificationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ClearNotificationQuery, ClearNotificationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ClearNotificationQuery, ClearNotificationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ClearNotificationQuery, ClearNotificationQueryVariables>(ClearNotificationDocument, {}, options);
}
export type ClearNotificationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ClearNotificationQuery, ClearNotificationQueryVariables>;
export const SearchOffersDocument = gql`
    query SearchOffers {
  offers {
    ...OfferAttributes
    studentResponsedAt
  }
}
    ${OfferAttributesFragmentDoc}`;

/**
 * __useSearchOffersQuery__
 *
 * To run a query within a Vue component, call `useSearchOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOffersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchOffersQuery();
 */
export function useSearchOffersQuery(options: VueApolloComposable.UseQueryOptions<SearchOffersQuery, SearchOffersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchOffersQuery, SearchOffersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchOffersQuery, SearchOffersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchOffersQuery, SearchOffersQueryVariables>(SearchOffersDocument, {}, options);
}
export type SearchOffersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchOffersQuery, SearchOffersQueryVariables>;
export const FindOfferDocument = gql`
    query FindOffer($id: Int!) {
  offer(id: $id) {
    ...OfferAttributes
    imageUrl
    movieUrl
    movieType
    presentationType
    movieUrlLong
    studentResponsedAt
  }
}
    ${OfferAttributesFragmentDoc}`;

/**
 * __useFindOfferQuery__
 *
 * To run a query within a Vue component, call `useFindOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOfferQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindOfferQuery({
 *   id: // value for 'id'
 * });
 */
export function useFindOfferQuery(variables: FindOfferQueryVariables | VueCompositionApi.Ref<FindOfferQueryVariables> | ReactiveFunction<FindOfferQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindOfferQuery, FindOfferQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindOfferQuery, FindOfferQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindOfferQuery, FindOfferQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindOfferQuery, FindOfferQueryVariables>(FindOfferDocument, variables, options);
}
export type FindOfferQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindOfferQuery, FindOfferQueryVariables>;
export const RejectOfferDocument = gql`
    mutation RejectOffer($offerId: Int!) {
  rejectOffer(input: {offerId: $offerId}) {
    offer {
      ...OfferAttributes
    }
    error
  }
}
    ${OfferAttributesFragmentDoc}`;

/**
 * __useRejectOfferMutation__
 *
 * To run a mutation, you first call `useRejectOfferMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectOfferMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectOfferMutation({
 *   variables: {
 *     offerId: // value for 'offerId'
 *   },
 * });
 */
export function useRejectOfferMutation(options: VueApolloComposable.UseMutationOptions<RejectOfferMutation, RejectOfferMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RejectOfferMutation, RejectOfferMutationVariables>>) {
  return VueApolloComposable.useMutation<RejectOfferMutation, RejectOfferMutationVariables>(RejectOfferDocument, options);
}
export type RejectOfferMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RejectOfferMutation, RejectOfferMutationVariables>;
export const SearchPortfoliosDocument = gql`
    query SearchPortfolios {
  portfolios {
    ...PortfolioAttributes
  }
}
    ${PortfolioAttributesFragmentDoc}`;

/**
 * __useSearchPortfoliosQuery__
 *
 * To run a query within a Vue component, call `useSearchPortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPortfoliosQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchPortfoliosQuery();
 */
export function useSearchPortfoliosQuery(options: VueApolloComposable.UseQueryOptions<SearchPortfoliosQuery, SearchPortfoliosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchPortfoliosQuery, SearchPortfoliosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchPortfoliosQuery, SearchPortfoliosQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchPortfoliosQuery, SearchPortfoliosQueryVariables>(SearchPortfoliosDocument, {}, options);
}
export type SearchPortfoliosQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchPortfoliosQuery, SearchPortfoliosQueryVariables>;
export const FindPortfolioDocument = gql`
    query FindPortfolio($id: Int!) {
  portfolio(id: $id) {
    ...PortfolioAttributes
  }
}
    ${PortfolioAttributesFragmentDoc}`;

/**
 * __useFindPortfolioQuery__
 *
 * To run a query within a Vue component, call `useFindPortfolioQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPortfolioQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindPortfolioQuery({
 *   id: // value for 'id'
 * });
 */
export function useFindPortfolioQuery(variables: FindPortfolioQueryVariables | VueCompositionApi.Ref<FindPortfolioQueryVariables> | ReactiveFunction<FindPortfolioQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindPortfolioQuery, FindPortfolioQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindPortfolioQuery, FindPortfolioQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindPortfolioQuery, FindPortfolioQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindPortfolioQuery, FindPortfolioQueryVariables>(FindPortfolioDocument, variables, options);
}
export type FindPortfolioQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindPortfolioQuery, FindPortfolioQueryVariables>;
export const UpdatePortfolioDocument = gql`
    mutation updatePortfolio($portfolio: PortfolioInput!) {
  updatePortfolio(input: {portfolio: $portfolio}) {
    portfolio {
      ...PortfolioAttributes
    }
    error
  }
}
    ${PortfolioAttributesFragmentDoc}`;

/**
 * __useUpdatePortfolioMutation__
 *
 * To run a mutation, you first call `useUpdatePortfolioMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortfolioMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePortfolioMutation({
 *   variables: {
 *     portfolio: // value for 'portfolio'
 *   },
 * });
 */
export function useUpdatePortfolioMutation(options: VueApolloComposable.UseMutationOptions<UpdatePortfolioMutation, UpdatePortfolioMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdatePortfolioMutation, UpdatePortfolioMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdatePortfolioMutation, UpdatePortfolioMutationVariables>(UpdatePortfolioDocument, options);
}
export type UpdatePortfolioMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdatePortfolioMutation, UpdatePortfolioMutationVariables>;
export const DeletePortfolioDocument = gql`
    mutation DeletePortfolio($id: Int!) {
  deletePortfolio(input: {id: $id}) {
    result
    error
  }
}
    `;

/**
 * __useDeletePortfolioMutation__
 *
 * To run a mutation, you first call `useDeletePortfolioMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeletePortfolioMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeletePortfolioMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeletePortfolioMutation(options: VueApolloComposable.UseMutationOptions<DeletePortfolioMutation, DeletePortfolioMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeletePortfolioMutation, DeletePortfolioMutationVariables>>) {
  return VueApolloComposable.useMutation<DeletePortfolioMutation, DeletePortfolioMutationVariables>(DeletePortfolioDocument, options);
}
export type DeletePortfolioMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeletePortfolioMutation, DeletePortfolioMutationVariables>;
export const AutocompleteSchoolListDocument = gql`
    query autocompleteSchoolList($filter: String!, $schoolType: SchoolType!, $limit: Int!) {
  schools(filter: $filter, schoolType: $schoolType, limit: $limit) {
    id
    name
    official
  }
}
    `;

/**
 * __useAutocompleteSchoolListQuery__
 *
 * To run a query within a Vue component, call `useAutocompleteSchoolListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteSchoolListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAutocompleteSchoolListQuery({
 *   filter: // value for 'filter'
 *   schoolType: // value for 'schoolType'
 *   limit: // value for 'limit'
 * });
 */
export function useAutocompleteSchoolListQuery(variables: AutocompleteSchoolListQueryVariables | VueCompositionApi.Ref<AutocompleteSchoolListQueryVariables> | ReactiveFunction<AutocompleteSchoolListQueryVariables>, options: VueApolloComposable.UseQueryOptions<AutocompleteSchoolListQuery, AutocompleteSchoolListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AutocompleteSchoolListQuery, AutocompleteSchoolListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AutocompleteSchoolListQuery, AutocompleteSchoolListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AutocompleteSchoolListQuery, AutocompleteSchoolListQueryVariables>(AutocompleteSchoolListDocument, variables, options);
}
export type AutocompleteSchoolListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AutocompleteSchoolListQuery, AutocompleteSchoolListQueryVariables>;
export const SchoolsDocument = gql`
    query schools {
  schools {
    id
    name
    official
  }
}
    `;

/**
 * __useSchoolsQuery__
 *
 * To run a query within a Vue component, call `useSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSchoolsQuery();
 */
export function useSchoolsQuery(options: VueApolloComposable.UseQueryOptions<SchoolsQuery, SchoolsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SchoolsQuery, SchoolsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SchoolsQuery, SchoolsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SchoolsQuery, SchoolsQueryVariables>(SchoolsDocument, {}, options);
}
export type SchoolsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SchoolsQuery, SchoolsQueryVariables>;
export const FindSchoolDocument = gql`
    query findSchool($id: Int!) {
  school(id: $id) {
    ...SchoolAttributes
  }
}
    ${SchoolAttributesFragmentDoc}`;

/**
 * __useFindSchoolQuery__
 *
 * To run a query within a Vue component, call `useFindSchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSchoolQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindSchoolQuery({
 *   id: // value for 'id'
 * });
 */
export function useFindSchoolQuery(variables: FindSchoolQueryVariables | VueCompositionApi.Ref<FindSchoolQueryVariables> | ReactiveFunction<FindSchoolQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindSchoolQuery, FindSchoolQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindSchoolQuery, FindSchoolQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindSchoolQuery, FindSchoolQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindSchoolQuery, FindSchoolQueryVariables>(FindSchoolDocument, variables, options);
}
export type FindSchoolQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindSchoolQuery, FindSchoolQueryVariables>;
export const SchoolByCodeDocument = gql`
    query schoolByCode($code: String!) {
  schoolByCode(code: $code) {
    id
    name
    official
    logoUrl
  }
}
    `;

/**
 * __useSchoolByCodeQuery__
 *
 * To run a query within a Vue component, call `useSchoolByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolByCodeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSchoolByCodeQuery({
 *   code: // value for 'code'
 * });
 */
export function useSchoolByCodeQuery(variables: SchoolByCodeQueryVariables | VueCompositionApi.Ref<SchoolByCodeQueryVariables> | ReactiveFunction<SchoolByCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<SchoolByCodeQuery, SchoolByCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SchoolByCodeQuery, SchoolByCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SchoolByCodeQuery, SchoolByCodeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SchoolByCodeQuery, SchoolByCodeQueryVariables>(SchoolByCodeDocument, variables, options);
}
export type SchoolByCodeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SchoolByCodeQuery, SchoolByCodeQueryVariables>;
export const SearchSeminarsDocument = gql`
    query SearchSeminars($conditions: SearchEventInput!, $offset: Int!, $limit: Int!) {
  seminars(conditions: $conditions, offset: $offset, limit: $limit) {
    ...SeminarAttributes
    corporation {
      id
      name
      likeAll
      address
      logoUrl
    }
  }
}
    ${SeminarAttributesFragmentDoc}`;

/**
 * __useSearchSeminarsQuery__
 *
 * To run a query within a Vue component, call `useSearchSeminarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSeminarsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchSeminarsQuery({
 *   conditions: // value for 'conditions'
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 * });
 */
export function useSearchSeminarsQuery(variables: SearchSeminarsQueryVariables | VueCompositionApi.Ref<SearchSeminarsQueryVariables> | ReactiveFunction<SearchSeminarsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchSeminarsQuery, SearchSeminarsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchSeminarsQuery, SearchSeminarsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchSeminarsQuery, SearchSeminarsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchSeminarsQuery, SearchSeminarsQueryVariables>(SearchSeminarsDocument, variables, options);
}
export type SearchSeminarsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchSeminarsQuery, SearchSeminarsQueryVariables>;
export const FindSeminarDocument = gql`
    query FindSeminar($id: Int!) {
  seminar(id: $id) {
    ...SeminarAttributes
    corporation {
      ...CorporationAttributes
    }
  }
}
    ${SeminarAttributesFragmentDoc}
${CorporationAttributesFragmentDoc}`;

/**
 * __useFindSeminarQuery__
 *
 * To run a query within a Vue component, call `useFindSeminarQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSeminarQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindSeminarQuery({
 *   id: // value for 'id'
 * });
 */
export function useFindSeminarQuery(variables: FindSeminarQueryVariables | VueCompositionApi.Ref<FindSeminarQueryVariables> | ReactiveFunction<FindSeminarQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindSeminarQuery, FindSeminarQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindSeminarQuery, FindSeminarQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindSeminarQuery, FindSeminarQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindSeminarQuery, FindSeminarQueryVariables>(FindSeminarDocument, variables, options);
}
export type FindSeminarQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindSeminarQuery, FindSeminarQueryVariables>;
export const FindSeminarByDateIdDocument = gql`
    query FindSeminarByDateId($id: Int!) {
  seminarByDateId(dateId: $id) {
    ...SeminarAttributes
    corporation {
      ...CorporationAttributes
    }
  }
}
    ${SeminarAttributesFragmentDoc}
${CorporationAttributesFragmentDoc}`;

/**
 * __useFindSeminarByDateIdQuery__
 *
 * To run a query within a Vue component, call `useFindSeminarByDateIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSeminarByDateIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindSeminarByDateIdQuery({
 *   id: // value for 'id'
 * });
 */
export function useFindSeminarByDateIdQuery(variables: FindSeminarByDateIdQueryVariables | VueCompositionApi.Ref<FindSeminarByDateIdQueryVariables> | ReactiveFunction<FindSeminarByDateIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindSeminarByDateIdQuery, FindSeminarByDateIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindSeminarByDateIdQuery, FindSeminarByDateIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindSeminarByDateIdQuery, FindSeminarByDateIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindSeminarByDateIdQuery, FindSeminarByDateIdQueryVariables>(FindSeminarByDateIdDocument, variables, options);
}
export type FindSeminarByDateIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindSeminarByDateIdQuery, FindSeminarByDateIdQueryVariables>;
export const CreateSeminarEntryDocument = gql`
    mutation CreateSeminarEntry($entry: SeminarEntryInput!) {
  createSeminarEntry(input: {entry: $entry}) {
    entry {
      corporation {
        id
        name
        logoUrl
      }
    }
    error
  }
}
    `;

/**
 * __useCreateSeminarEntryMutation__
 *
 * To run a mutation, you first call `useCreateSeminarEntryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSeminarEntryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSeminarEntryMutation({
 *   variables: {
 *     entry: // value for 'entry'
 *   },
 * });
 */
export function useCreateSeminarEntryMutation(options: VueApolloComposable.UseMutationOptions<CreateSeminarEntryMutation, CreateSeminarEntryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateSeminarEntryMutation, CreateSeminarEntryMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateSeminarEntryMutation, CreateSeminarEntryMutationVariables>(CreateSeminarEntryDocument, options);
}
export type CreateSeminarEntryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateSeminarEntryMutation, CreateSeminarEntryMutationVariables>;
export const SeminarEntryDataDocument = gql`
    query SeminarEntryData($seminarDateId: Int!) {
  seminar: seminarByDateId(dateId: $seminarDateId, isEntry: true) {
    ...SeminarAttributes
    entrySetting {
      ...EntrySettingAttributes
    }
    corporation {
      id
      name
      logoUrl
    }
  }
  user {
    ...UserAttributes
  }
  portfolios {
    ...PortfolioAttributes
  }
  licenses {
    ...LicenseAttributes
  }
  careers {
    ...CareerAttributes
  }
}
    ${SeminarAttributesFragmentDoc}
${EntrySettingAttributesFragmentDoc}
${UserAttributesFragmentDoc}
${PortfolioAttributesFragmentDoc}
${LicenseAttributesFragmentDoc}
${CareerAttributesFragmentDoc}`;

/**
 * __useSeminarEntryDataQuery__
 *
 * To run a query within a Vue component, call `useSeminarEntryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeminarEntryDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSeminarEntryDataQuery({
 *   seminarDateId: // value for 'seminarDateId'
 * });
 */
export function useSeminarEntryDataQuery(variables: SeminarEntryDataQueryVariables | VueCompositionApi.Ref<SeminarEntryDataQueryVariables> | ReactiveFunction<SeminarEntryDataQueryVariables>, options: VueApolloComposable.UseQueryOptions<SeminarEntryDataQuery, SeminarEntryDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SeminarEntryDataQuery, SeminarEntryDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SeminarEntryDataQuery, SeminarEntryDataQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SeminarEntryDataQuery, SeminarEntryDataQueryVariables>(SeminarEntryDataDocument, variables, options);
}
export type SeminarEntryDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SeminarEntryDataQuery, SeminarEntryDataQueryVariables>;
export const SearchPaginationSeminarsDocument = gql`
    query SearchPaginationSeminars($conditions: SearchEventInput!, $page: Int!, $limit: Int!, $isGetAggregate: Boolean) {
  paginationSeminars(
    conditions: $conditions
    page: $page
    limit: $limit
    isGetAggregate: $isGetAggregate
  ) {
    seminars {
      ...SeminarAttributes
    }
    pagination {
      currentPage
      limitValue
      totalCount
      totalPages
    }
  }
}
    ${SeminarAttributesFragmentDoc}`;

/**
 * __useSearchPaginationSeminarsQuery__
 *
 * To run a query within a Vue component, call `useSearchPaginationSeminarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPaginationSeminarsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchPaginationSeminarsQuery({
 *   conditions: // value for 'conditions'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 *   isGetAggregate: // value for 'isGetAggregate'
 * });
 */
export function useSearchPaginationSeminarsQuery(variables: SearchPaginationSeminarsQueryVariables | VueCompositionApi.Ref<SearchPaginationSeminarsQueryVariables> | ReactiveFunction<SearchPaginationSeminarsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchPaginationSeminarsQuery, SearchPaginationSeminarsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchPaginationSeminarsQuery, SearchPaginationSeminarsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchPaginationSeminarsQuery, SearchPaginationSeminarsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchPaginationSeminarsQuery, SearchPaginationSeminarsQueryVariables>(SearchPaginationSeminarsDocument, variables, options);
}
export type SearchPaginationSeminarsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchPaginationSeminarsQuery, SearchPaginationSeminarsQueryVariables>;
export const MypageUserInfoDocument = gql`
    query MypageUserInfo($schoolId: Int!, $newArrivalFrom: ISO8601DateTime, $from: ISO8601DateTime) {
  user {
    ...UserAttributes
  }
  resumeCompleteStatus {
    profile
    condition
    pr
    portfolio
    diagnosis
    diagnosisOfOthers
  }
  portfolios {
    ...PortfolioAttributes
  }
  diagnoses {
    ...DiagnosisAttributes
  }
  industries(schoolId: $schoolId) {
    ...KeyValueAttributes
  }
  categories(schoolId: $schoolId) {
    ...KeyValueAttributes
  }
  jobFeatures {
    ...KeyValueAttributes
  }
  corporationTypes {
    ...KeyValueAttributes
  }
  getTotalJobCount(
    conditions: {newArrival: true, newArrivalFrom: $newArrivalFrom}
  )
  offers(conditions: {unchecked: true, from: $from}) {
    ...OfferAttributes
  }
  pickupFeeds {
    id
    posts {
      ...FeedAttributes
    }
    updatedAt
  }
}
    ${UserAttributesFragmentDoc}
${PortfolioAttributesFragmentDoc}
${DiagnosisAttributesFragmentDoc}
${KeyValueAttributesFragmentDoc}
${OfferAttributesFragmentDoc}
${FeedAttributesFragmentDoc}`;

/**
 * __useMypageUserInfoQuery__
 *
 * To run a query within a Vue component, call `useMypageUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMypageUserInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMypageUserInfoQuery({
 *   schoolId: // value for 'schoolId'
 *   newArrivalFrom: // value for 'newArrivalFrom'
 *   from: // value for 'from'
 * });
 */
export function useMypageUserInfoQuery(variables: MypageUserInfoQueryVariables | VueCompositionApi.Ref<MypageUserInfoQueryVariables> | ReactiveFunction<MypageUserInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<MypageUserInfoQuery, MypageUserInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MypageUserInfoQuery, MypageUserInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MypageUserInfoQuery, MypageUserInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MypageUserInfoQuery, MypageUserInfoQueryVariables>(MypageUserInfoDocument, variables, options);
}
export type MypageUserInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MypageUserInfoQuery, MypageUserInfoQueryVariables>;
export const SignInUserDocument = gql`
    query SignInUser {
  user {
    ...UserAttributes
  }
}
    ${UserAttributesFragmentDoc}`;

/**
 * __useSignInUserQuery__
 *
 * To run a query within a Vue component, call `useSignInUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignInUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSignInUserQuery();
 */
export function useSignInUserQuery(options: VueApolloComposable.UseQueryOptions<SignInUserQuery, SignInUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SignInUserQuery, SignInUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SignInUserQuery, SignInUserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SignInUserQuery, SignInUserQueryVariables>(SignInUserDocument, {}, options);
}
export type SignInUserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SignInUserQuery, SignInUserQueryVariables>;
export const ConfirmAccountDocument = gql`
    query ConfirmAccount($confirmationToken: String!) {
  confirmationAccount(confirmationToken: $confirmationToken) {
    ...UserAttributes
  }
}
    ${UserAttributesFragmentDoc}`;

/**
 * __useConfirmAccountQuery__
 *
 * To run a query within a Vue component, call `useConfirmAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfirmAccountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useConfirmAccountQuery({
 *   confirmationToken: // value for 'confirmationToken'
 * });
 */
export function useConfirmAccountQuery(variables: ConfirmAccountQueryVariables | VueCompositionApi.Ref<ConfirmAccountQueryVariables> | ReactiveFunction<ConfirmAccountQueryVariables>, options: VueApolloComposable.UseQueryOptions<ConfirmAccountQuery, ConfirmAccountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ConfirmAccountQuery, ConfirmAccountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ConfirmAccountQuery, ConfirmAccountQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ConfirmAccountQuery, ConfirmAccountQueryVariables>(ConfirmAccountDocument, variables, options);
}
export type ConfirmAccountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ConfirmAccountQuery, ConfirmAccountQueryVariables>;
export const DownloadResumePdfDocument = gql`
    query DownloadResumePDF {
  resume
}
    `;

/**
 * __useDownloadResumePdfQuery__
 *
 * To run a query within a Vue component, call `useDownloadResumePdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadResumePdfQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDownloadResumePdfQuery();
 */
export function useDownloadResumePdfQuery(options: VueApolloComposable.UseQueryOptions<DownloadResumePdfQuery, DownloadResumePdfQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DownloadResumePdfQuery, DownloadResumePdfQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DownloadResumePdfQuery, DownloadResumePdfQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DownloadResumePdfQuery, DownloadResumePdfQueryVariables>(DownloadResumePdfDocument, {}, options);
}
export type DownloadResumePdfQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DownloadResumePdfQuery, DownloadResumePdfQueryVariables>;
export const UserAccessAnalyticsDocument = gql`
    query UserAccessAnalytics {
  resumeAccessLog {
    ...ChartPointAttributes
  }
  corporationFavoriteLog {
    ...ChartPointAttributes
  }
}
    ${ChartPointAttributesFragmentDoc}`;

/**
 * __useUserAccessAnalyticsQuery__
 *
 * To run a query within a Vue component, call `useUserAccessAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAccessAnalyticsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserAccessAnalyticsQuery();
 */
export function useUserAccessAnalyticsQuery(options: VueApolloComposable.UseQueryOptions<UserAccessAnalyticsQuery, UserAccessAnalyticsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAccessAnalyticsQuery, UserAccessAnalyticsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAccessAnalyticsQuery, UserAccessAnalyticsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserAccessAnalyticsQuery, UserAccessAnalyticsQueryVariables>(UserAccessAnalyticsDocument, {}, options);
}
export type UserAccessAnalyticsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserAccessAnalyticsQuery, UserAccessAnalyticsQueryVariables>;
export const UserNoticeCountDocument = gql`
    query UserNoticeCount {
  userNoticeCount {
    news
    message
    offer
    noticeBoard
  }
}
    `;

/**
 * __useUserNoticeCountQuery__
 *
 * To run a query within a Vue component, call `useUserNoticeCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNoticeCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserNoticeCountQuery();
 */
export function useUserNoticeCountQuery(options: VueApolloComposable.UseQueryOptions<UserNoticeCountQuery, UserNoticeCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserNoticeCountQuery, UserNoticeCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserNoticeCountQuery, UserNoticeCountQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserNoticeCountQuery, UserNoticeCountQueryVariables>(UserNoticeCountDocument, {}, options);
}
export type UserNoticeCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserNoticeCountQuery, UserNoticeCountQueryVariables>;
export const ResumeCompleteStatusDocument = gql`
    query ResumeCompleteStatus {
  resumeCompleteStatus {
    profile
    condition
    pr
    portfolio
    diagnosis
    diagnosisOfOthers
  }
}
    `;

/**
 * __useResumeCompleteStatusQuery__
 *
 * To run a query within a Vue component, call `useResumeCompleteStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useResumeCompleteStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResumeCompleteStatusQuery();
 */
export function useResumeCompleteStatusQuery(options: VueApolloComposable.UseQueryOptions<ResumeCompleteStatusQuery, ResumeCompleteStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResumeCompleteStatusQuery, ResumeCompleteStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResumeCompleteStatusQuery, ResumeCompleteStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ResumeCompleteStatusQuery, ResumeCompleteStatusQueryVariables>(ResumeCompleteStatusDocument, {}, options);
}
export type ResumeCompleteStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ResumeCompleteStatusQuery, ResumeCompleteStatusQueryVariables>;
export const ResumeAccessDataDocument = gql`
    query ResumeAccessData($from: ISO8601Date!, $to: ISO8601Date!) {
  resumeAccessLogBetweenDates(from: $from, to: $to) {
    ...ChartPointAttributes
  }
  corporationFavoriteLogBetweenDates(from: $from, to: $to) {
    ...ChartPointAttributes
  }
}
    ${ChartPointAttributesFragmentDoc}`;

/**
 * __useResumeAccessDataQuery__
 *
 * To run a query within a Vue component, call `useResumeAccessDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useResumeAccessDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResumeAccessDataQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 * });
 */
export function useResumeAccessDataQuery(variables: ResumeAccessDataQueryVariables | VueCompositionApi.Ref<ResumeAccessDataQueryVariables> | ReactiveFunction<ResumeAccessDataQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResumeAccessDataQuery, ResumeAccessDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResumeAccessDataQuery, ResumeAccessDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResumeAccessDataQuery, ResumeAccessDataQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ResumeAccessDataQuery, ResumeAccessDataQueryVariables>(ResumeAccessDataDocument, variables, options);
}
export type ResumeAccessDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ResumeAccessDataQuery, ResumeAccessDataQueryVariables>;
export const RegisterUserDocument = gql`
    mutation RegisterUser($user: UserInput!) {
  registerUser(input: {user: $user}) {
    user {
      id
      email
    }
    error
  }
}
    `;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRegisterUserMutation({
 *   variables: {
 *     user: // value for 'user'
 *   },
 * });
 */
export function useRegisterUserMutation(options: VueApolloComposable.UseMutationOptions<RegisterUserMutation, RegisterUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RegisterUserMutation, RegisterUserMutationVariables>>) {
  return VueApolloComposable.useMutation<RegisterUserMutation, RegisterUserMutationVariables>(RegisterUserDocument, options);
}
export type RegisterUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RegisterUserMutation, RegisterUserMutationVariables>;
export const ChangeEmailDocument = gql`
    mutation ChangeEmail($email: String!) {
  changeEmail(input: {email: $email}) {
    user {
      id
      email
    }
    error
  }
}
    `;

/**
 * __useChangeEmailMutation__
 *
 * To run a mutation, you first call `useChangeEmailMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmailMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChangeEmailMutation({
 *   variables: {
 *     email: // value for 'email'
 *   },
 * });
 */
export function useChangeEmailMutation(options: VueApolloComposable.UseMutationOptions<ChangeEmailMutation, ChangeEmailMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ChangeEmailMutation, ChangeEmailMutationVariables>>) {
  return VueApolloComposable.useMutation<ChangeEmailMutation, ChangeEmailMutationVariables>(ChangeEmailDocument, options);
}
export type ChangeEmailMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ChangeEmailMutation, ChangeEmailMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($currentPassword: String!, $password: String!) {
  changePassword(input: {currentPassword: $currentPassword, password: $password}) {
    user {
      id
      email
    }
    error
  }
}
    `;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChangePasswordMutation({
 *   variables: {
 *     currentPassword: // value for 'currentPassword'
 *     password: // value for 'password'
 *   },
 * });
 */
export function useChangePasswordMutation(options: VueApolloComposable.UseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>>) {
  return VueApolloComposable.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
}
export type ChangePasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const ChangeJobHuntingStatusDocument = gql`
    mutation ChangeJobHuntingStatus($status: Int!) {
  changeJobHuntingStatus(input: {status: $status}) {
    user {
      id
      email
    }
  }
}
    `;

/**
 * __useChangeJobHuntingStatusMutation__
 *
 * To run a mutation, you first call `useChangeJobHuntingStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChangeJobHuntingStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChangeJobHuntingStatusMutation({
 *   variables: {
 *     status: // value for 'status'
 *   },
 * });
 */
export function useChangeJobHuntingStatusMutation(options: VueApolloComposable.UseMutationOptions<ChangeJobHuntingStatusMutation, ChangeJobHuntingStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ChangeJobHuntingStatusMutation, ChangeJobHuntingStatusMutationVariables>>) {
  return VueApolloComposable.useMutation<ChangeJobHuntingStatusMutation, ChangeJobHuntingStatusMutationVariables>(ChangeJobHuntingStatusDocument, options);
}
export type ChangeJobHuntingStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ChangeJobHuntingStatusMutation, ChangeJobHuntingStatusMutationVariables>;
export const ChangeNotificationDocument = gql`
    mutation ChangeNotification($notification: NotificationInput!) {
  changeNotification(input: {notification: $notification}) {
    user {
      id
      email
    }
    error
  }
}
    `;

/**
 * __useChangeNotificationMutation__
 *
 * To run a mutation, you first call `useChangeNotificationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChangeNotificationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChangeNotificationMutation({
 *   variables: {
 *     notification: // value for 'notification'
 *   },
 * });
 */
export function useChangeNotificationMutation(options: VueApolloComposable.UseMutationOptions<ChangeNotificationMutation, ChangeNotificationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ChangeNotificationMutation, ChangeNotificationMutationVariables>>) {
  return VueApolloComposable.useMutation<ChangeNotificationMutation, ChangeNotificationMutationVariables>(ChangeNotificationDocument, options);
}
export type ChangeNotificationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ChangeNotificationMutation, ChangeNotificationMutationVariables>;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($profile: ProfileInput!) {
  updateProfile(input: {profile: $profile}) {
    user {
      ...UserAttributes
    }
    error
  }
}
    ${UserAttributesFragmentDoc}`;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateProfileMutation({
 *   variables: {
 *     profile: // value for 'profile'
 *   },
 * });
 */
export function useUpdateProfileMutation(options: VueApolloComposable.UseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
}
export type UpdateProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const UpdateProfileStatusDocument = gql`
    mutation UpdateProfileStatus($status: Boolean!) {
  updateProfileStatus(input: {status: $status}) {
    user {
      ...UserAttributes
    }
    error
  }
}
    ${UserAttributesFragmentDoc}`;

/**
 * __useUpdateProfileStatusMutation__
 *
 * To run a mutation, you first call `useUpdateProfileStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateProfileStatusMutation({
 *   variables: {
 *     status: // value for 'status'
 *   },
 * });
 */
export function useUpdateProfileStatusMutation(options: VueApolloComposable.UseMutationOptions<UpdateProfileStatusMutation, UpdateProfileStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateProfileStatusMutation, UpdateProfileStatusMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateProfileStatusMutation, UpdateProfileStatusMutationVariables>(UpdateProfileStatusDocument, options);
}
export type UpdateProfileStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateProfileStatusMutation, UpdateProfileStatusMutationVariables>;
export const UpdatePrTextDocument = gql`
    mutation UpdatePrText($pr: PrTextInput!) {
  updatePrText(input: {pr: $pr}) {
    user {
      ...UserAttributes
    }
    error
  }
}
    ${UserAttributesFragmentDoc}`;

/**
 * __useUpdatePrTextMutation__
 *
 * To run a mutation, you first call `useUpdatePrTextMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrTextMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePrTextMutation({
 *   variables: {
 *     pr: // value for 'pr'
 *   },
 * });
 */
export function useUpdatePrTextMutation(options: VueApolloComposable.UseMutationOptions<UpdatePrTextMutation, UpdatePrTextMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdatePrTextMutation, UpdatePrTextMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdatePrTextMutation, UpdatePrTextMutationVariables>(UpdatePrTextDocument, options);
}
export type UpdatePrTextMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdatePrTextMutation, UpdatePrTextMutationVariables>;
export const UpdateConditionsDocument = gql`
    mutation UpdateConditions($condition: UserConditionsInput!) {
  updateConditions(input: {condition: $condition}) {
    condition {
      ...UserConditionAttributes
    }
    error
  }
}
    ${UserConditionAttributesFragmentDoc}`;

/**
 * __useUpdateConditionsMutation__
 *
 * To run a mutation, you first call `useUpdateConditionsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConditionsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateConditionsMutation({
 *   variables: {
 *     condition: // value for 'condition'
 *   },
 * });
 */
export function useUpdateConditionsMutation(options: VueApolloComposable.UseMutationOptions<UpdateConditionsMutation, UpdateConditionsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateConditionsMutation, UpdateConditionsMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateConditionsMutation, UpdateConditionsMutationVariables>(UpdateConditionsDocument, options);
}
export type UpdateConditionsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateConditionsMutation, UpdateConditionsMutationVariables>;
export const UserNoticeDocument = gql`
    query UserNotice {
  userNotice {
    news
    message
    offer
    noticeBoard
    badgeCount
  }
}
    `;

/**
 * __useUserNoticeQuery__
 *
 * To run a query within a Vue component, call `useUserNoticeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNoticeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserNoticeQuery();
 */
export function useUserNoticeQuery(options: VueApolloComposable.UseQueryOptions<UserNoticeQuery, UserNoticeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserNoticeQuery, UserNoticeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserNoticeQuery, UserNoticeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserNoticeQuery, UserNoticeQueryVariables>(UserNoticeDocument, {}, options);
}
export type UserNoticeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserNoticeQuery, UserNoticeQueryVariables>;
export const NewNoticeDocument = gql`
    subscription NewNotice($userId: Int!) {
  newNotice(userId: $userId) {
    message
    news
    noticeBoard
    offer
  }
}
    `;

/**
 * __useNewNoticeSubscription__
 *
 * To run a query within a Vue component, call `useNewNoticeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewNoticeSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useNewNoticeSubscription({
 *   userId: // value for 'userId'
 * });
 */
export function useNewNoticeSubscription(variables: NewNoticeSubscriptionVariables | VueCompositionApi.Ref<NewNoticeSubscriptionVariables> | ReactiveFunction<NewNoticeSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<NewNoticeSubscription, NewNoticeSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<NewNoticeSubscription, NewNoticeSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<NewNoticeSubscription, NewNoticeSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<NewNoticeSubscription, NewNoticeSubscriptionVariables>(NewNoticeDocument, variables, options);
}
export type NewNoticeSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<NewNoticeSubscription, NewNoticeSubscriptionVariables>;
export const RegisterDeviceTokenDocument = gql`
    mutation registerDeviceToken($token: String!, $type: String!) {
  registerDeviceToken(input: {token: $token, type: $type}) {
    user {
      id
      email
    }
    message
  }
}
    `;

/**
 * __useRegisterDeviceTokenMutation__
 *
 * To run a mutation, you first call `useRegisterDeviceTokenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRegisterDeviceTokenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRegisterDeviceTokenMutation({
 *   variables: {
 *     token: // value for 'token'
 *     type: // value for 'type'
 *   },
 * });
 */
export function useRegisterDeviceTokenMutation(options: VueApolloComposable.UseMutationOptions<RegisterDeviceTokenMutation, RegisterDeviceTokenMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RegisterDeviceTokenMutation, RegisterDeviceTokenMutationVariables>>) {
  return VueApolloComposable.useMutation<RegisterDeviceTokenMutation, RegisterDeviceTokenMutationVariables>(RegisterDeviceTokenDocument, options);
}
export type RegisterDeviceTokenMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RegisterDeviceTokenMutation, RegisterDeviceTokenMutationVariables>;
export const UpdateReviewStatusDocument = gql`
    mutation updateReviewStatus($deviceToken: String!, $reviewStatus: ReviewStatus!, $deviceType: String) {
  updateReviewStatus(
    input: {deviceToken: $deviceToken, reviewStatus: $reviewStatus, deviceType: $deviceType}
  ) {
    user {
      id
      email
    }
    error
  }
}
    `;

/**
 * __useUpdateReviewStatusMutation__
 *
 * To run a mutation, you first call `useUpdateReviewStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReviewStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateReviewStatusMutation({
 *   variables: {
 *     deviceToken: // value for 'deviceToken'
 *     reviewStatus: // value for 'reviewStatus'
 *     deviceType: // value for 'deviceType'
 *   },
 * });
 */
export function useUpdateReviewStatusMutation(options: VueApolloComposable.UseMutationOptions<UpdateReviewStatusMutation, UpdateReviewStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateReviewStatusMutation, UpdateReviewStatusMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateReviewStatusMutation, UpdateReviewStatusMutationVariables>(UpdateReviewStatusDocument, options);
}
export type UpdateReviewStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateReviewStatusMutation, UpdateReviewStatusMutationVariables>;
export const AppInfoDocument = gql`
    query appInfo($deviceToken: String!, $deviceType: String) {
  appInfo(deviceToken: $deviceToken, deviceType: $deviceType) {
    id
    showRequestReview
  }
}
    `;

/**
 * __useAppInfoQuery__
 *
 * To run a query within a Vue component, call `useAppInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAppInfoQuery({
 *   deviceToken: // value for 'deviceToken'
 *   deviceType: // value for 'deviceType'
 * });
 */
export function useAppInfoQuery(variables: AppInfoQueryVariables | VueCompositionApi.Ref<AppInfoQueryVariables> | ReactiveFunction<AppInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<AppInfoQuery, AppInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AppInfoQuery, AppInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AppInfoQuery, AppInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AppInfoQuery, AppInfoQueryVariables>(AppInfoDocument, variables, options);
}
export type AppInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AppInfoQuery, AppInfoQueryVariables>;
export const SocialLinksDocument = gql`
    query socialLinks {
  socialLinks {
    provider
    linked
  }
}
    `;

/**
 * __useSocialLinksQuery__
 *
 * To run a query within a Vue component, call `useSocialLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialLinksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSocialLinksQuery();
 */
export function useSocialLinksQuery(options: VueApolloComposable.UseQueryOptions<SocialLinksQuery, SocialLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SocialLinksQuery, SocialLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SocialLinksQuery, SocialLinksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SocialLinksQuery, SocialLinksQueryVariables>(SocialLinksDocument, {}, options);
}
export type SocialLinksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SocialLinksQuery, SocialLinksQueryVariables>;
export const CreateSocialLinkDocument = gql`
    mutation createSocialLink($provider: SocialProvider!, $idToken: String!) {
  createSocialLink(input: {provider: $provider, idToken: $idToken}) {
    socialLink {
      provider
      linked
    }
    error
  }
}
    `;

/**
 * __useCreateSocialLinkMutation__
 *
 * To run a mutation, you first call `useCreateSocialLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSocialLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSocialLinkMutation({
 *   variables: {
 *     provider: // value for 'provider'
 *     idToken: // value for 'idToken'
 *   },
 * });
 */
export function useCreateSocialLinkMutation(options: VueApolloComposable.UseMutationOptions<CreateSocialLinkMutation, CreateSocialLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateSocialLinkMutation, CreateSocialLinkMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateSocialLinkMutation, CreateSocialLinkMutationVariables>(CreateSocialLinkDocument, options);
}
export type CreateSocialLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateSocialLinkMutation, CreateSocialLinkMutationVariables>;
export const DeleteSocialLinkDocument = gql`
    mutation deleteSocialLink($provider: SocialProvider!) {
  deleteSocialLink(input: {provider: $provider}) {
    socialLink {
      provider
      linked
    }
    error
  }
}
    `;

/**
 * __useDeleteSocialLinkMutation__
 *
 * To run a mutation, you first call `useDeleteSocialLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSocialLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSocialLinkMutation({
 *   variables: {
 *     provider: // value for 'provider'
 *   },
 * });
 */
export function useDeleteSocialLinkMutation(options: VueApolloComposable.UseMutationOptions<DeleteSocialLinkMutation, DeleteSocialLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteSocialLinkMutation, DeleteSocialLinkMutationVariables>>) {
  return VueApolloComposable.useMutation<DeleteSocialLinkMutation, DeleteSocialLinkMutationVariables>(DeleteSocialLinkDocument, options);
}
export type DeleteSocialLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteSocialLinkMutation, DeleteSocialLinkMutationVariables>;
export const SearchAddressDocument = gql`
    query SearchAddress($postalCode: String!) {
  addressFromPostalCode(postalCode: $postalCode) {
    ...AddressAttributes
  }
}
    ${AddressAttributesFragmentDoc}`;

/**
 * __useSearchAddressQuery__
 *
 * To run a query within a Vue component, call `useSearchAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAddressQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchAddressQuery({
 *   postalCode: // value for 'postalCode'
 * });
 */
export function useSearchAddressQuery(variables: SearchAddressQueryVariables | VueCompositionApi.Ref<SearchAddressQueryVariables> | ReactiveFunction<SearchAddressQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchAddressQuery, SearchAddressQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchAddressQuery, SearchAddressQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchAddressQuery, SearchAddressQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchAddressQuery, SearchAddressQueryVariables>(SearchAddressDocument, variables, options);
}
export type SearchAddressQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchAddressQuery, SearchAddressQueryVariables>;